
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dG76n", function(module, exports) {
$parcel$export(module.exports, "SearchResultsPage", function () { return $4b1dbc3aa5ecf23f$export$d52600bdf78c25ef; });

var $7VQPk = parcelRequire("7VQPk");

var $bQjAr = parcelRequire("bQjAr");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $8Agh0 = parcelRequire("8Agh0");
const $4b1dbc3aa5ecf23f$export$d52600bdf78c25ef = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "search-page",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                isShowTryNowLink: true,
                isShowSearchButton: false,
                productKey: "search"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Agh0.SearchTemplate), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("8Agh0", function(module, exports) {
$parcel$export(module.exports, "SearchTemplate", function () { return $d0a2331a186b73df$export$b55d021038bb528d; });
/* search-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $h6Fsc = parcelRequire("h6Fsc");

var $bZmYH = parcelRequire("bZmYH");

var $k9ZIM = parcelRequire("k9ZIM");

var $fJP6M = parcelRequire("fJP6M");

var $8KOLZ = parcelRequire("8KOLZ");

var $kbpa7 = parcelRequire("kbpa7");

var $gx3aw = parcelRequire("gx3aw");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");

var $cN0Nw = parcelRequire("cN0Nw");

var $hZ5Xs = parcelRequire("hZ5Xs");

var $fJkKo = parcelRequire("fJkKo");
parcelRequire("5TJaP");
var $aLBZ0 = parcelRequire("aLBZ0");
const $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3 = "www.atlassian.com.v3";
const $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 = "www.atlassian.com.v3-2";
const $d0a2331a186b73df$var$ALGOLIA_DEV_SEARCH_INDEX_V3 = "www.atlassian.com.v3_dev";
const $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY = "category";
const $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE = "locale";
const $d0a2331a186b73df$var$TITLE_ONLY_SEARCH_WORD_COUNT_THRESHOLD = 3;
const $d0a2331a186b73df$export$45f7e7a192bc5fa5 = [
    "All",
    "Articles",
    "Developer Resources",
    "Events",
    "Marketplace",
    "Purchasing FAQ"
];
const $d0a2331a186b73df$export$87e29e00b94380cb = (searchHelper, objectIds)=>{
    return searchHelper?.getObjects(objectIds);
};
const $d0a2331a186b73df$export$97f3b895db7ef4f3 = (numResults, latestSearchText, currFilter)=>{
    if (numResults === 0) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.zero",
        defaultMessage: "0 results for {latestSearchText}. Try again with a different term.",
        values: {
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else if (numResults === 1) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.one",
        defaultMessage: "{numResults} result for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.many",
        defaultMessage: "{numResults} results for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
};
const $d0a2331a186b73df$export$b55d021038bb528d = ()=>{
    const [numberOfHits, setTotalNumberOfHits] = (0, $1oC0p.useState)(0);
    const [hits, setHits] = (0, $1oC0p.useState)([]);
    const [searchText, setSearchText] = (0, $1oC0p.useState)("");
    const [latestSearchText, setLatestSearchText] = (0, $1oC0p.useState)("");
    const [searchState, setSearchState] = (0, $1oC0p.useState)(null);
    const [currFilter, setCurrFilter] = (0, $1oC0p.useState)("All");
    const [facetValues, setFacetValues] = (0, $1oC0p.useState)({});
    const searchHelper = (0, $1oC0p.useRef)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [queryId, setQueryId] = (0, $1oC0p.useState)("");
    const [isActive, setIsActive] = (0, $1oC0p.useState)(false);
    const searchInputRef = (0, $1oC0p.useRef)(null);
    const handleFocus = ()=>setIsActive(true);
    const handleBlur = ()=>setIsActive(false);
    const handleChange = (e)=>{
        setSearchText(e.target.value);
    };
    const handleClear = ()=>{
        setSearchText("");
        setIsActive(false);
    };
    const wacAISearchSummaryExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).wacAISearchSummaryV2);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    const { fireUIEvent: fireUIEvent } = (0, $8KOLZ.useFireAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    // Use ref to track current fireUIEvent to avoid recreating SearchHelper
    const fireUIEventRef = (0, $1oC0p.useRef)(fireUIEvent);
    fireUIEventRef.current = fireUIEvent;
    const isSearchIndexV3_2Enabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacSearchIndexV3_2);
    const searchIndex = isSearchIndexV3_2Enabled ? $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 : $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3;
    const facets = [
        $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY,
        $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE
    ];
    (0, $2emUn.useFeatureExposed)("wac-search-indexv3", "Test");
    (0, $1oC0p.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            eventName: "searchText",
            eventType: "track",
            action: "loaded",
            actionSubject: "searchPage",
            actionSubjectId: "searchPageForm",
            source: "searchPage",
            eventContainer: "load",
            attributes: {
                searchText: searchText,
                product: "search",
                index: {
                    searchIndex: searchIndex
                }
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        searchHelper.current = new (0, $fJkKo.SearchHelper)(searchIndex, facets);
        // TODO: fetch filter category names from Algolia instead of hard-coding
        searchHelper.current?.receiveUpdate((results)=>{
            const numberOfHits = results.nbHits;
            const localHits = results.hits.map((hit)=>{
                return {
                    ...hit,
                    queryID: results.queryID
                };
            });
            const hasNextPage = results.nbPages - 1 > results.page;
            const queryId = results.queryID;
            const facetValuesResponse = results.getFacetValues($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY, {});
            // check if this is a filtered
            const refinements = results.getRefinements() || [];
            const isUsingFilter = !!refinements.find((refinement)=>refinement.attributeName === "category");
            // don't reset filter values if an existing search is just being filtered
            if (Array.isArray(facetValuesResponse) && !isUsingFilter) {
                let newFacetValuesState = {};
                facetValuesResponse.forEach((result)=>{
                    newFacetValuesState = {
                        ...newFacetValuesState,
                        [result.name]: result.count
                    };
                });
                setFacetValues(newFacetValuesState);
            }
            if (hasNextPage) setSearchState("hasMoreResult");
            else if (localHits.length === 0) setSearchState("noResult");
            else setSearchState("hasResult");
            setTotalNumberOfHits(numberOfHits);
            setHits((prevResult)=>[
                    ...prevResult,
                    ...localHits
                ]);
            setQueryId(queryId);
            // Use ref to get the current fireUIEvent function
            fireUIEventRef.current({
                eventName: "searchResultsPopulated",
                eventType: "ui",
                action: "populated",
                actionSubject: "searchResults",
                source: "searchPage",
                eventContainer: "searchResults",
                attributes: {
                    resultsCount: numberOfHits,
                    searchQuery: results.query || latestSearchText,
                    queryId: results.queryID,
                    currentFilter: currFilter,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            });
        });
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener("popstate", ()=>{
            setSearchResults();
        });
        setSearchResults();
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setSearchResults = ()=>{
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const searchParam = params.get("q");
        const facet = params.get("f") || "";
        // if facet it present on original page load, set a facetValue so that it displays in filters
        if (facet) setFacetValues({
            [facet]: 1
        });
        if (searchParam) {
            const filter = facet ? facet : "All";
            resetState(searchParam, filter);
            triggerSearch(filter, searchParam);
            createAnalyticsEvent({
                eventName: "browserButton",
                eventType: "ui",
                action: "clicked",
                actionSubject: "browserButton",
                source: "searchPage",
                eventContainer: "browser",
                attributes: {
                    searchText: searchParam,
                    keywordSearchQuery: searchParam,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
        }
    };
    function resetState(searchParam, filter) {
        setHits([]);
        setSearchState("loading");
        setSearchText(searchParam);
        setLatestSearchText(searchParam);
        setCurrFilter(filter);
    }
    function triggerSearch(filter, searchParam) {
        searchHelper.current?.removeFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY);
        searchHelper.current?.setQuery(searchParam);
        searchHelper.current?.setFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE, intl.locale || "en");
        if (filter && filter !== "All") searchHelper.current?.setFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY, filter);
        if (isAISearchSummaryEnabled) {
            const searchWordCount = searchParam.split(" ").length;
            if (searchWordCount > $d0a2331a186b73df$var$TITLE_ONLY_SEARCH_WORD_COUNT_THRESHOLD) searchHelper.current?.setQueryParameter("restrictSearchableAttributes", [
                "title"
            ]);
            else searchHelper.current?.removeQueryParameter("restrictSearchableAttributes");
        }
        searchHelper.current?.search();
    }
    function onSearch(filter) {
        if (searchText) {
            if (!filter) filter = "All";
            resetState(searchText, filter);
            triggerSearch(filter, searchText);
            setLatestSearchText(searchText);
            if (filter && filter !== "All") window.history.pushState({}, "", `?q=${searchText}&f=${filter}`);
            else window.history.pushState({}, "", `?q=${searchText}`);
            createAnalyticsEvent({
                eventName: "searchText",
                eventType: "ui",
                action: "submitted",
                actionSubject: "searchInput",
                actionSubjectId: "searchPageForm",
                source: "searchPage",
                eventContainer: "searchInput",
                attributes: {
                    searchQuery: searchText,
                    keywordSearchQuery: searchText,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
            if (searchInputRef.current) searchInputRef.current.blur();
        }
        setIsActive(true);
    }
    const renderClearButton = ()=>{
        if (searchText) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: handleClear,
            "aria-label": "Clear search suggestions",
            "data-testid": "clear-search-button",
            className: (0, $2jatx.default)([
                "_kqswstnw _1xi24bvh _154i1ssb _t9ec1i34 _bfhk1j28 _19itglyw _syaz1hap _80omtlke _1wybf6fq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbdlk8 _4t3idlk8 _2rko1ssb"
            ]),
            style: {
                "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                label: "Clear search input",
                size: "small",
                color: "var(--ds-text, #292A2E)"
            })
        });
        return null;
    };
    function gotoNextPage() {
        searchHelper.current?.goToNextPage();
    }
    function onSearchLinkClick(objectId, position) {
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id");
        let decodedAnonymousId;
        if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
        decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
        searchHelper.current?.sendClickEvent({
            objectId: objectId,
            position: position,
            queryId: queryId,
            userToken: decodedAnonymousId
        });
    }
    const translated = {
        searchAtlassian: intl.formatMessage({
            id: "wac.search.pages.search.atlassian",
            defaultMessage: "Search Atlassian"
        }),
        submitSearch: intl.formatMessage({
            id: "wac.search.pages.submit",
            defaultMessage: "Submit"
        }),
        viewMore: intl.formatMessage({
            id: "wac.search.pages.view.more",
            defaultMessage: "View more"
        }),
        endOfResults: intl.formatMessage({
            id: "wac.search.pages.end.of.result",
            defaultMessage: "End of results"
        })
    };
    const filterTranslationMap = {
        "All": intl.formatMessage({
            id: "wac.search.pages.filter.all",
            defaultMessage: "All"
        }),
        "Articles": intl.formatMessage({
            id: "wac.search.pages.filter.developer.articles",
            defaultMessage: "Articles"
        }),
        "Developer Resources": intl.formatMessage({
            id: "wac.search.pages.filter.developer.resources",
            defaultMessage: "Developer Resources"
        }),
        "Events": intl.formatMessage({
            id: "wac.search.pages.filter.events",
            defaultMessage: "Events"
        }),
        "Marketplace": intl.formatMessage({
            id: "wac.search.pages.filter.marketplace",
            defaultMessage: "Marketplace"
        }),
        "Purchasing FAQ": intl.formatMessage({
            id: "wac.search.pages.filter.purchasing.faq",
            defaultMessage: "Purchasing FAQ"
        })
    };
    const searchStateWithResultAndIsNotLoading = (searchState)=>{
        return searchState && searchState !== "noResult" && searchState !== "loading";
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f4tsx _195g1wug _1tke8stt _1e0c1txw _o5kc1h6o",
            isAISearchSummaryEnabled && "_p12f11vz",
            "ais-InstantSearch"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rjczwfg _1bah1h6o _1bsbcv93 _1u2qftgi _1rkb1sa4",
                isAISearchSummaryEnabled && "_1bsb11vz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _kqswh2mm _1bsb1osq _195ggktf _1s4p1wug",
                        isAISearchSummaryEnabled && "_p12fcv93"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1txw _kqswh2mm _4cvr1h6o _1bsb1osq _y4ti14y2 _otyr19bv _ik7h13el _5m7p1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                value: searchText,
                                onChange: handleChange,
                                onFocus: handleFocus,
                                onBlur: handleBlur,
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") onSearch();
                                },
                                placeholder: intl.formatMessage({
                                    id: "wac.search.pages.placeholder",
                                    defaultMessage: "Search Keywords"
                                }),
                                "data-testid": "search-input",
                                className: (0, $2jatx.default)([
                                    "_19itglyw _4cvr1h6o _bfhk1hxd _1bsb1osq _2rko1ylp _1e0c1txw _vwz41x4e _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _u5f31ylp _4t3ior1b _1bah1yb4 _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _1wyb7vkz _k48p1nn1 _syaz5k8o _ect41kw7 _1n5ddoyu _13kcdlk8 _1irci2wt _dueq7vkz _1iaezwfg _1lh2gktf _858uxxzy"
                                ]),
                                style: {
                                    "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                                }
                            }),
                            renderClearButton(),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                type: "submit",
                                onClick: ()=>onSearch(),
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") onSearch();
                                },
                                "aria-label": translated.submitSearch,
                                "data-testid": "submit-search-button",
                                className: (0, $2jatx.default)([
                                    "_1wpz1h6o _bfhk1j28 _19itglyw _4t3izwfg _1bsbzwfg _1xi219bv _kqswstnw _154i1ssb _t9ec1i34 _d0altlke",
                                    isAISearchSummaryEnabled && "_vwz419bv _12l2ftgi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                                    size: "medium",
                                    label: "Submit search",
                                    color: isActive ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text, #292A2E)"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1e0c1txw _zulp7vkz _1n261g80 _n7zlglyw _n3td19bv _195ggktf _19pk14y2 _1rfm1wug",
                        !isAISearchSummaryEnabled && !!searchStateWithResultAndIsNotLoading(searchState) && "_n7zl5y0l"
                    ]),
                    style: {
                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                    },
                    children: !!searchStateWithResultAndIsNotLoading(searchState) && Object.entries(filterTranslationMap).map(([filterName, translatedFilterName])=>(facetValues.hasOwnProperty(filterName) || filterName === "All") && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            onClick: ()=>{
                                onSearch(filterName);
                            },
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _4t3i14no _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _2rko53f4 _1dqoglyw _bfhk150w _80omtlke",
                                currFilter === filterName && "_bfhk1t97"
                            ]),
                            style: {
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                            },
                            children: translatedFilterName
                        }, filterName))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_195ggktf _1q51dlk8 _1bsb1osq _1rfm1wug",
                        isAISearchSummaryEnabled && "_p12f11vz"
                    ]),
                    children: [
                        isAISearchSummaryEnabled && latestSearchText !== "" && currFilter === "All" && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZ5Xs.AISummary), {
                                    query: latestSearchText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                                    role: "presentation",
                                    className: (0, $2jatx.default)([
                                        "_1pfh1ejb _6rth1jfw _19it5y0l"
                                    ]),
                                    style: {
                                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                isAISearchSummaryEnabled && "_p12fcv93"
                            ]),
                            children: [
                                searchState && searchState !== "loading" && $d0a2331a186b73df$export$97f3b895db7ef4f3(numberOfHits, latestSearchText, currFilter),
                                hits.map(({ objectID: objectID, title: title, description: description, url: url, queryID: queryID }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLBZ0.Result), {
                                        index: index,
                                        title: title,
                                        description: description,
                                        href: url,
                                        objectId: objectID,
                                        queryId: queryID,
                                        onSearchLinkClick: onSearchLinkClick,
                                        isExperimentVariant: true
                                    }, objectID))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                !!searchState && searchState !== "loading" && (searchState === "hasMoreResult" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                    text: translated.viewMore,
                                    inputType: "button",
                                    onClick: gotoNextPage,
                                    dataEventProps: {
                                        "data-event-component": "linkButton",
                                        "data-event-container": "supportSection",
                                        "data-product-key": "search",
                                        "data-label": "view-more",
                                        "data-event": "clicked"
                                    },
                                    "aria-label": translated.viewMore,
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _2rko1ylp _bfhkjk2v _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg"
                                    ]),
                                    style: {
                                        "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                                    }
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pk10yn _y3gn1h6o"
                                    ]),
                                    children: searchState && searchState !== "noResult" && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: translated.endOfResults
                                    })
                                })),
                                searchState && searchState === "loading" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bah1h6o _1mou12am"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1x4e _4t3i1x4e _19ithovc _179r1j28 _2rko1ssb _1e0c1o8l _kqswh2mm _y44vzg4r _aetrb3bt _18postnw _eq4311qw _3mxo1v6z _13pw17la _clh31p70"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* Styles */ const $d0a2331a186b73df$var$containerCss = null;
const $d0a2331a186b73df$var$aiEnabledContainerCss = null;
const $d0a2331a186b73df$var$aiEnabledSearchContainerCss = null;
const $d0a2331a186b73df$var$aiEnabledSearchResultsContainerCss = null;
const $d0a2331a186b73df$var$searchContainerCss = null;
const $d0a2331a186b73df$var$searchBarContainerCss = null;
const $d0a2331a186b73df$var$searchInputContainerCss = null;
const $d0a2331a186b73df$var$searchInputCss = null;
const $d0a2331a186b73df$var$searchSubmitCss = null;
const $d0a2331a186b73df$var$clearButtonCss = null;
const $d0a2331a186b73df$var$spinnerContainerCss = null;
const $d0a2331a186b73df$var$rotation = null;
const $d0a2331a186b73df$var$spinnerCss = null;
const $d0a2331a186b73df$var$endOfResultCss = null;
const $d0a2331a186b73df$var$filtersContainerCss = null;
const $d0a2331a186b73df$var$filtersContainerWithResultCss = null;
const $d0a2331a186b73df$var$filterButtonsCss = null;
const $d0a2331a186b73df$var$selectedFilterCss = null;
const $d0a2331a186b73df$var$buttonCss = null;
const $d0a2331a186b73df$var$resultsContainerCss = null;
const $d0a2331a186b73df$var$aiEnabledSearchButtonCss = null;

});
parcelRegister("hZ5Xs", function(module, exports) {
$parcel$export(module.exports, "AISummary", function () { return $6f547359754881bd$export$cf24cd585162fa67; });
/* ai-summary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $awDBP = parcelRequire("awDBP");

var $iunwt = parcelRequire("iunwt");

var $diVdn = parcelRequire("diVdn");

var $lRaZ3 = parcelRequire("lRaZ3");

var $1GQzX = parcelRequire("1GQzX");
const $6f547359754881bd$var$aiSummaryLayoutStyle = null;
const $6f547359754881bd$var$aiSummaryLayoutLoadingStyle = null;
const $6f547359754881bd$var$aiSummaryBoxStyle = null;
const $6f547359754881bd$var$aiSummarySourcesPanelStyle = null;
const $6f547359754881bd$var$SOURCES_VIEWPORT_BOTTOM_GUTTER = 16;
const $6f547359754881bd$var$SOURCES_MIN_EXPANDED_HEIGHT = 120;
const $6f547359754881bd$export$cf24cd585162fa67 = ({ query: query })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iunwt.AISummaryContextProvider), {
        query: query,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6f547359754881bd$export$971d8645f5d80483, {})
    });
};
const $6f547359754881bd$export$971d8645f5d80483 = ()=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $1oC0p.useState)(true);
    const [sourcesMaxExpandedHeight, setSourcesMaxExpandedHeight] = (0, $1oC0p.useState)(249);
    const [filteredSourceIndexes, setFilteredSourceIndexes] = (0, $1oC0p.useState)(null);
    const { isLoading: isLoading, traceResponse: traceResponse, sources: sources, summary: summary } = (0, $iunwt.useAISummaryContext)();
    const aiSummaryBoxRef = (0, $1oC0p.useRef)(null);
    const sourcesPanelRef = (0, $1oC0p.useRef)(null);
    const isLoadingOrTraceResponse = Boolean(isLoading || traceResponse);
    const isSourcesLoading = !sources;
    const showSourcesPanel = !isLoadingOrTraceResponse && !!summary;
    const hasNoSources = !isSourcesLoading && sources.length === 0;
    const handleIsExpanded = (isExpanded)=>{
        setIsExpanded(isExpanded);
    };
    const handleIsTruncated = (isTruncated)=>{
        setIsTruncated(isTruncated);
    };
    const handleFilterSources = (sourceIndexes)=>{
        setFilteredSourceIndexes(sourceIndexes);
    };
    const handleClearSourceFilter = ()=>{
        setFilteredSourceIndexes(null);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (isLoadingOrTraceResponse) return;
        const updateSourcesMaxExpandedHeight = ()=>{
            const summaryHeight = aiSummaryBoxRef.current?.getBoundingClientRect().height || 249;
            const sourcesPanelTop = sourcesPanelRef.current?.getBoundingClientRect().top || 0;
            const viewportAvailableHeight = Math.max(0, window.innerHeight - sourcesPanelTop - $6f547359754881bd$var$SOURCES_VIEWPORT_BOTTOM_GUTTER);
            setSourcesMaxExpandedHeight(Math.max($6f547359754881bd$var$SOURCES_MIN_EXPANDED_HEIGHT, Math.floor(Math.min(summaryHeight, viewportAvailableHeight))));
        };
        const resizeObserver = new ResizeObserver(()=>{
            updateSourcesMaxExpandedHeight();
        });
        if (aiSummaryBoxRef.current) resizeObserver.observe(aiSummaryBoxRef.current);
        window.addEventListener("resize", updateSourcesMaxExpandedHeight);
        updateSourcesMaxExpandedHeight();
        return ()=>{
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateSourcesMaxExpandedHeight);
        };
    }, [
        isExpanded,
        isLoadingOrTraceResponse
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1y6m _4cvr1y6m _1bsb1osq _zulputpp",
            isLoadingOrTraceResponse && "_1bsbcv93"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1GQzX.AIAnswerSearchBorder), {
                isLoading: isLoadingOrTraceResponse,
                isStreaming: !!traceResponse,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: aiSummaryBoxRef,
                    className: (0, $2jatx.default)([
                        "_1yt4utpp _1bsbcv93 _p12fcv93"
                    ]),
                    children: isLoadingOrTraceResponse ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $diVdn.AISummaryLoadingAnimation), {
                        traceResponse: traceResponse
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $awDBP.AISummaryAnswer), {
                        isExpanded: isExpanded,
                        isTruncated: isTruncated,
                        onToggleExpanded: handleIsExpanded,
                        onToggleTruncated: handleIsTruncated,
                        onFilterSources: handleFilterSources,
                        isSourceFiltered: filteredSourceIndexes !== null && filteredSourceIndexes.length > 0
                    })
                })
            }),
            showSourcesPanel && !hasNoSources && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: sourcesPanelRef,
                className: (0, $2jatx.default)([
                    "_152t12cx _1e02111l _1bsb1osq _p12f1erl _kqsw1if8"
                ]),
                children: isSourcesLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lRaZ3.AISourcesPlaceholder), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lRaZ3.AISummarySources), {
                    isExpanded: isExpanded,
                    isTruncated: isTruncated,
                    maxExpandedHeight: sourcesMaxExpandedHeight,
                    filteredSourceIndexes: filteredSourceIndexes,
                    onClearSourceFilter: handleClearSourceFilter
                })
            })
        ]
    });
};

});
parcelRegister("awDBP", function(module, exports) {
$parcel$export(module.exports, "AISummaryAnswer", function () { return $2e6189477c513f3c$export$7df2d776cc7f9957; });
/* ai-summary-answer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $isBrC = parcelRequire("isBrC");

var $deg4B = parcelRequire("deg4B");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $iunwt = parcelRequire("iunwt");

var $1JAnT = parcelRequire("1JAnT");

var $6t7fC = parcelRequire("6t7fC");
const $2e6189477c513f3c$var$citationIconButtonStyle = null;
const $2e6189477c513f3c$var$linkIconStyle = null;
const $2e6189477c513f3c$var$sourceTextStyle = null;
const $2e6189477c513f3c$var$CitationIcon = ({ citations: citations, sources: sources, onFilterSources: onFilterSources, relatedSourceIndexes: relatedSourceIndexes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const identifier = citations.split(",").length;
    const sourceTitle = sources?.[identifier - 1]?.title;
    const sourceAriaLabel = sourceTitle || `Source ${identifier}`;
    const handleClick = ()=>{
        const sourceIndex = identifier - 1; // Convert 1-based citation to 0-based array index
        const sourceIndexesToFilter = relatedSourceIndexes.length > 0 ? relatedSourceIndexes : [
            sourceIndex
        ];
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "searchAiSummaryInlineSourceFilter",
            source: "searchAiSummary",
            attributes: {
                sourceIndex: sourceIndex,
                sourceIndexes: sourceIndexesToFilter,
                sourceTitle: sources?.[sourceIndex]?.title,
                sourceUrl: sources?.[sourceIndex]?.url
            }
        }).fire();
        onFilterSources(sourceIndexesToFilter);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        "aria-label": sourceAriaLabel,
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf _vwz4kb7n _4t3iv47k _p12f1ady _2rko1b66 _bfhk1ybm _syazsxyd _19itglyw _1yt41b66 _ahbq1b66 _80omtlke _kqswh2mm _154i1n1a _v564mfn2 _irr36kkz"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
            "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500")),
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($deg4B))), {
                size: "medium",
                color: "var(--ds-icon-brand, #1868DB)",
                label: "",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq _lcxvglyw _19itagmp"
                ])
            }),
            identifier > 1 && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _11c8fhey _vwz4kb7n"
                ]),
                children: [
                    "\xb7 ",
                    identifier
                ]
            })
        ]
    });
};
const $2e6189477c513f3c$var$StatusComponent = ({ text: text, sources: sources, onFilterSources: onFilterSources })=>{
    const citationNumbers = (text?.match(/\d+/g) || [
        "1"
    ]).map((value)=>parseInt(value, 10)).filter((value)=>Number.isInteger(value) && value > 0);
    const uniqueSourceIndexes = Array.from(new Set(citationNumbers.map((value)=>value - 1)));
    return /*#__PURE__*/ (0, $7VQPk.jsx)($2e6189477c513f3c$var$CitationIcon, {
        citations: text || "1",
        sources: sources,
        onFilterSources: onFilterSources,
        relatedSourceIndexes: uniqueSourceIndexes
    });
};
const $2e6189477c513f3c$var$fullContent = null;
const $2e6189477c513f3c$var$defaultContent = null;
const $2e6189477c513f3c$var$blurOverlayStyle = null;
const $2e6189477c513f3c$var$showMoreButtonStyle = null;
const $2e6189477c513f3c$var$aiSummaryHeaderStyle = null;
const $2e6189477c513f3c$var$aiSummaryIconWrapperStyle = null;
const $2e6189477c513f3c$var$markdownContainerStyle = null;
const $2e6189477c513f3c$export$7df2d776cc7f9957 = ({ isExpanded: isExpanded, isTruncated: isTruncated, onToggleExpanded: onToggleExpanded, onToggleTruncated: onToggleTruncated, onFilterSources: onFilterSources, isSourceFiltered: isSourceFiltered })=>{
    const contentRef = (0, $1oC0p.useRef)(null);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { summary: summary, sources: sources, query: query } = (0, $iunwt.useAISummaryContext)();
    const statusComponent = (0, $1oC0p.useCallback)((props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($2e6189477c513f3c$var$StatusComponent, {
            ...props,
            sources: sources,
            onFilterSources: onFilterSources
        }), [
        onFilterSources,
        sources
    ]);
    const renderMarkdownContent = (text)=>{
        // Use the search-ai approach: encodeAdf + Atlaskit renderer
        // This handles both markdown formatting and citations properly
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vt4114mp _r8atgrf3"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6t7fC.MarkdownRenderer), {
                answerString: text,
                statusComponent: statusComponent,
                query: query,
                isSourceFiltered: isSourceFiltered
            })
        });
    };
    (0, $1oC0p.useEffect)(()=>{
        if (!contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if (contentRef.current) {
                const wrapperHeight = contentRef.current.offsetHeight;
                const contentHeight = contentRef.current.scrollHeight;
                onToggleTruncated(contentHeight > wrapperHeight);
            }
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        summary
    ]);
    const handleToggleExpansion = ()=>{
        onToggleExpanded(!isExpanded);
        createAnalyticsEvent({
            eventName: isExpanded ? "searchAiSummaryReadLessClicked" : "searchAiSummaryReadMoreClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: isExpanded ? "searchAiSummaryReadLess" : "searchAiSummaryReadMore",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                labelEnglish: isExpanded ? "Read less" : "Read more"
            }
        }).fire();
    };
    const showMoreText = intl.formatMessage({
        id: "ai.summary.answer.showMoreText",
        defaultMessage: "Show more"
    });
    const aiOverviewText = intl.formatMessage({
        id: "ai.summary.answer.overview",
        defaultMessage: "AI overview"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp1b66 _6rthutpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ejb _4t3i1ejb _2rko1b66 _bfhk1s93"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isBrC))), {
                            size: "medium",
                            label: aiOverviewText,
                            color: "var(--ds-icon-brand, #1868DB)"
                        })
                    }),
                    aiOverviewText
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: contentRef,
                className: (0, $2jatx.default)([
                    "_c71l4cy5 _1reo15vq _18m915vq _kqswh2mm",
                    isExpanded && "_c71l1ns9 _85i51ejb"
                ]),
                children: [
                    renderMarkdownContent(summary),
                    isTruncated && !isExpanded && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_11q71vjt _1bsb1osq _1e0c116y _1bah1h6o _4cvr1h6o _kqswstnw _u7coidpf _85i5idpf _1q51xncg _syaz1fxt"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                            variant: "secondary",
                            onClick: handleToggleExpansion,
                            "aria-label": showMoreText,
                            className: (0, $2jatx.default)([
                                "_1e0c116y _1bah1h6o _4cvr1h6o _4t3i1jfw _1bsb1osq _p12fglyw _19it13nq _2rko1jfw _80omtlke _k48p1nn1 _1kd31nn1 _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: showMoreText
                        })
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1JAnT.AISummaryFooter), {})
        ]
    });
};

});
parcelRegister("isBrC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4df587d0c3f1832e97f8caba30d1552>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d707e33bf8a5e2bc$var$_react = $d707e33bf8a5e2bc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d707e33bf8a5e2bc$var$_baseNew = $d707e33bf8a5e2bc$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $d707e33bf8a5e2bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d707e33bf8a5e2bc$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $d707e33bf8a5e2bc$var$_react.default.createElement($d707e33bf8a5e2bc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$d707e33bf8a5e2bc$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $d707e33bf8a5e2bc$var$_default = module.exports.default = $d707e33bf8a5e2bc$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("iunwt", function(module, exports) {
$parcel$export(module.exports, "useAISummaryContext", function () { return $6765649a771fe8e1$export$5684accc31d61e95; });
$parcel$export(module.exports, "AISummaryContextProvider", function () { return $6765649a771fe8e1$export$7d671cf75e2cfb14; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");

var $2WL8B = parcelRequire("2WL8B");
const $6765649a771fe8e1$export$d9891c14af3ce883 = "https://www.atlassian.com/gateway/api";
const $6765649a771fe8e1$export$b1cc2341c8059a01 = "9957edf0-7205-4ec3-bd4d-ff871e460fea";
const $6765649a771fe8e1$export$86c50fd667fc4af5 = "b4db6a3b-6006-37db-a214-0be400970e38";
const $6765649a771fe8e1$export$b861a2d9069d580 = "ari:cloud:help::help-center/6fe401af-9648-48b0-bd2d-9e9e572f7a26/d52415c9-03cc-4853-b033-faeb1427c757";
const $6765649a771fe8e1$export$473fcebef3e703eb = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $6765649a771fe8e1$export$5684accc31d61e95 = ()=>{
    const context = (0, $1oC0p.useContext)($6765649a771fe8e1$export$473fcebef3e703eb);
    if (!context) throw new Error("useAISummaryContext must be used within a AISummaryContextProvider");
    return context;
};
const $6765649a771fe8e1$export$7d671cf75e2cfb14 = ({ query: query, children: children })=>{
    const [summary, setSummary] = (0, $1oC0p.useState)("");
    const [sources, setSources] = (0, $1oC0p.useState)();
    const [conversationId, setConversationId] = (0, $1oC0p.useState)("");
    const [messageId, setMessageId] = (0, $1oC0p.useState)("");
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(true);
    const [traceResponse, setTraceResponse] = (0, $1oC0p.useState)(undefined);
    const [anonAuthToken, setAnonAuthToken] = (0, $1oC0p.useState)("");
    const abortControllerRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const processLine = (0, $1oC0p.useCallback)(// eslint-disable-next-line complexity
    (line)=>{
        try {
            const parsed = JSON.parse(line);
            if (parsed.type === "TRACE" && parsed.message?.content) {
                // TRACE contains the initial loading messages
                let traceContent = parsed.message.content;
                if (traceContent.includes(": ")) traceContent = traceContent.split(": ")[1];
                if (traceContent.endsWith(".")) traceContent = traceContent.slice(0, -1);
                setTraceResponse(traceContent);
            } else if (parsed.type === "FINAL_RESPONSE" && (parsed.message?.sources || parsed.message?.message.sources)) {
                // FINAL_RESPONSE contains the entire summary, sources, and additional info LLM info
                const sourcesData = parsed.message?.sources || parsed.message?.message?.sources;
                if (!sourcesData || sourcesData.length === 0) createAnalyticsEvent({
                    eventName: "searchAiSummaryNoSources",
                    eventType: "track",
                    action: "failed",
                    actionSubject: "searchAiSummary",
                    actionSubjectId: "searchAiSummaryFinalResponseLoaded",
                    source: "searchPage",
                    attributes: {
                        query: query,
                        conversationId: conversationId
                    }
                }).fire();
                console.log("parsed", parsed);
                if (parsed.message?.message?.id) setMessageId(parsed.message?.message?.id);
                setSources(sourcesData);
                setTraceResponse(undefined);
            } else if (parsed.type === "ANSWER_PART" && parsed.message?.content) {
                setSummary((prev)=>prev + parsed.message.content);
                setTraceResponse(undefined);
            }
        } catch (error) {
            console.warn("Failed to parse line as JSON:", line);
            setSummary((prev)=>prev + "\n" + line);
        }
    }, [
        createAnalyticsEvent,
        query,
        conversationId
    ]);
    // eslint-disable-next-line complexity
    const fetchAISummary = (0, $1oC0p.useCallback)(async ()=>{
        setIsLoading(true);
        setTraceResponse(undefined);
        setSources(undefined);
        setSummary("");
        setMessageId("");
        abortControllerRef.current?.abort();
        abortControllerRef.current = new AbortController();
        // Generate a new conversation ID for each new query
        const newConversationId = (0, $fuLgT.default)();
        setConversationId(newConversationId);
        const userContext = {
            user_locale: intl.locale || "en",
            current_time: new Date().toISOString()
        };
        const queryWithUserContext = `${query} \n ${JSON.stringify(userContext)}`;
        let reader = null;
        try {
            const response = await fetch(`${$6765649a771fe8e1$export$d9891c14af3ce883}/assist/csm/v2/chat/channel/${newConversationId}/message/stream`, {
                method: "POST",
                credentials: "omit",
                signal: abortControllerRef.current?.signal,
                headers: {
                    "x-cloudid": $6765649a771fe8e1$export$b1cc2341c8059a01,
                    "x-product": "csm",
                    "x-experience-id": "csm-ai",
                    "x-anonymous-auth": anonAuthToken,
                    "content-type": "application/json;charset=UTF-8"
                },
                body: JSON.stringify({
                    content: {
                        version: 1,
                        type: "doc",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: queryWithUserContext
                                    }
                                ]
                            }
                        ]
                    },
                    recipient_agent_named_id: "atlassian_wac_agent",
                    agent_id: $6765649a771fe8e1$export$86c50fd667fc4af5,
                    mimeType: "text/adf",
                    store_message: false,
                    citations_enabled: true
                })
            });
            createAnalyticsEvent({
                eventName: "aiSummary",
                eventType: "track",
                action: "loaded",
                actionSubject: "searchAiSummary",
                actionSubjectId: "searchAiSummaryLoaded",
                source: "searchPage",
                eventContainer: "load",
                attributes: {
                    responseCode: response.status,
                    responseBodyAvailable: response.body ? true : false
                }
            }).fire();
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            if (!response.body) throw new Error("Response body is not available for streaming");
            reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) {
                    if (buffer.trim()) {
                        processLine(buffer.trim());
                        setIsLoading(false);
                    }
                    break;
                }
                const chunk = decoder.decode(value, {
                    stream: true
                });
                buffer += chunk;
                const lines = buffer.split("\n");
                buffer = lines.pop() || "";
                for (const line of lines){
                    const trimmedLine = line.trim();
                    if (trimmedLine) {
                        processLine(trimmedLine);
                        setIsLoading(false);
                    }
                }
            }
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") return;
            console.error("Error processing AI summary stream:", error);
            setSummary((prev)=>prev + "\nAtlassian Intelligence can't provide a response right now.");
        } finally{
            reader?.releaseLock();
            setIsLoading(false);
        }
    }, [
        processLine,
        anonAuthToken,
        query,
        intl.locale,
        createAnalyticsEvent
    ]);
    const getAnonAuthToken = async ()=>{
        const response = await fetch(`${$6765649a771fe8e1$export$d9891c14af3ce883}/assist/csm/v2/widgets/access?helpCenterAri=${$6765649a771fe8e1$export$b861a2d9069d580}`, {
            method: "GET",
            credentials: "omit",
            headers: {
                "x-cloudid": $6765649a771fe8e1$export$b1cc2341c8059a01,
                "x-product": "csm",
                "x-experience-id": "csm-ai",
                "content-type": "application/json;charset=UTF-8"
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        if (!data.hasAccess) throw new Error("User does not have access to the help center");
        setAnonAuthToken(data.anonAuthToken);
    };
    const sendFeedback = (0, $1oC0p.useCallback)((feedbackState)=>{
        return async ()=>{
            if (!anonAuthToken || !messageId || !conversationId) return;
            fetch(`${$6765649a771fe8e1$export$d9891c14af3ce883}/assist/csm/v2/chat/channel/${conversationId}/message/${messageId}/feedback`, {
                method: "PUT",
                credentials: "omit",
                headers: {
                    "Content-Type": "application/json",
                    "x-cloudid": $6765649a771fe8e1$export$b1cc2341c8059a01,
                    "x-product": "csm",
                    "x-experience-id": "csm-ai",
                    "x-anonymous-auth": anonAuthToken
                },
                body: JSON.stringify({
                    feedback_value: feedbackState,
                    message_id: messageId,
                    conversation_channel_id: conversationId
                })
            }).catch((error)=>{
                console.error("Failed to send feedback:", error);
            });
        };
    }, [
        anonAuthToken,
        messageId,
        conversationId
    ]);
    (0, $1oC0p.useEffect)(()=>{
        getAnonAuthToken().catch((error)=>{
            console.error("Error getting anonymous auth token:", error);
        });
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (anonAuthToken) fetchAISummary().catch((error)=>{
            console.error("Error fetching AI summary:", error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        anonAuthToken
    ]);
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            summary: summary,
            sources: sources,
            conversationId: conversationId,
            messageId: messageId,
            isLoading: isLoading,
            traceResponse: traceResponse,
            likeFeedback: sendFeedback("LIKE"),
            dislikeFeedback: sendFeedback("DISLIKE"),
            isRovoEnabledCohort: isRovoEnabledCohort,
            query: query
        }), [
        summary,
        sources,
        conversationId,
        messageId,
        isLoading,
        traceResponse,
        sendFeedback,
        isRovoEnabledCohort,
        query
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6765649a771fe8e1$export$473fcebef3e703eb.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRegister("1JAnT", function(module, exports) {
$parcel$export(module.exports, "AISummaryFooter", function () { return $23969be416fb3377$export$409c83e49353f3fb; });
/* ai-summary-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $4WS03 = parcelRequire("4WS03");

var $3pbl1 = parcelRequire("3pbl1");

var $LlYs2 = parcelRequire("LlYs2");

var $eGGys = parcelRequire("eGGys");

var $82rWc = parcelRequire("82rWc");

var $7ZMp9 = parcelRequire("7ZMp9");

var $92PV0 = parcelRequire("92PV0");

var $kooLp = parcelRequire("kooLp");

var $iunwt = parcelRequire("iunwt");
const $23969be416fb3377$var$aiSummaryFooterStyle = null;
const $23969be416fb3377$var$aiSummaryFooterSectionStyle = null;
const $23969be416fb3377$var$aiFeedbackSectionStyle = null;
const $23969be416fb3377$var$disclaimerTextStyle = null;
const $23969be416fb3377$var$subtleLinkOverrideStyle = null;
const $23969be416fb3377$var$FeedbackThumpsUpIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82rWc))), {
        ...iconProps,
        color: feedbackState === "thumbsUp" ? "var(--ds-icon-selected, #1868DB)" : undefined
    });
};
const $23969be416fb3377$var$FeedbackThumpsDownIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGGys))), {
        ...iconProps,
        color: feedbackState === "thumbsDown" ? "var(--ds-icon-selected, #1868DB)" : undefined
    });
};
const $23969be416fb3377$export$409c83e49353f3fb = ()=>{
    const [feedbackState, setFeedbackState] = (0, $1oC0p.useState)(null);
    const intl = (0, $8e22h.default)();
    const aiHref = (0, $kooLp.useLocalizedHref)("/trust/atlassian-intelligence");
    const policyHref = (0, $kooLp.useLocalizedHref)("/legal/acceptable-use-policy");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { summary: summary, likeFeedback: likeFeedback, dislikeFeedback: dislikeFeedback } = (0, $iunwt.useAISummaryContext)();
    (0, $1oC0p.useEffect)(()=>{
        (0, $92PV0.Tracking).autoTrackLinks(true);
    }, []);
    const handleCopy = async ()=>{
        try {
            // Remove citation markers like [1], [2], etc. from the text
            const textToCopy = summary.replace(/\[\d+\]/g, "").trim();
            await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };
    const handleFeedbackClick = (event, state)=>{
        event.preventDefault();
        setFeedbackState(state);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "feedbackButton",
            actionSubjectId: "searchAiSummaryFeedbackClicked",
            source: "searchAiSummary",
            attributes: {
                feedback: state
            }
        }).fire();
        if (state === "thumbsUp") likeFeedback();
        else dislikeFeedback();
    };
    const aiDisclaimerText = intl.formatMessage({
        id: "ai.summary.answer.footer.disclaimer",
        defaultMessage: "Uses AI. Verify results."
    });
    const aiPolicyText = intl.formatMessage({
        id: "ai.summary.answer.footer.policy",
        defaultMessage: "Subject to Atlassian Acceptable Use Policy"
    });
    const thumbsUpText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsUp",
        defaultMessage: "Good response"
    });
    const thumbsDownText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsDown",
        defaultMessage: "Bad response"
    });
    const copyText = intl.formatMessage({
        id: "ai.summary.answer.footer.copy",
        defaultMessage: "Copy"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _1yt41b66 _6rthmgjw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _4cvr1h6o _zulppxbi _1wyb1crf _vwz4pxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulp1b66",
                            "_43ds1rpy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LlYs2))), {
                                color: "var(--ds-icon-subtlest, #6B6E76)",
                                size: "medium",
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                                href: aiHref,
                                "aria-label": aiDisclaimerText,
                                target: "_blank",
                                appearance: "subtle",
                                "data-event": {
                                    "data-product-key": "search",
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "searchAiSummary",
                                    "data-label-english": "Uses AI"
                                },
                                children: aiDisclaimerText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_43ds1rpy"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                            href: policyHref,
                            "aria-label": aiPolicyText,
                            target: "_blank",
                            appearance: "subtle",
                            "data-event": {
                                "data-product-key": "search",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "searchAiSummary",
                                "data-label-english": "Subject to Atlassian Acceptable Use Policy"
                            },
                            children: aiPolicyText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _4cvresu3"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$23969be416fb3377$var$FeedbackThumpsUpIcon(iconProps, feedbackState),
                        label: thumbsUpText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsUp"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$23969be416fb3377$var$FeedbackThumpsDownIcon(iconProps, feedbackState),
                        label: thumbsDownText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsDown"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pbl1))),
                        label: copyText,
                        onClick: handleCopy,
                        isTooltipDisabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("3pbl1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27ac80630eac5da7$var$_react = $27ac80630eac5da7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $27ac80630eac5da7$var$_baseNew = $27ac80630eac5da7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $27ac80630eac5da7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27ac80630eac5da7$var$CopyIcon = (props)=>/*#__PURE__*/ $27ac80630eac5da7$var$_react.default.createElement($27ac80630eac5da7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$27ac80630eac5da7$var$CopyIcon.displayName = 'CopyIcon';
var $27ac80630eac5da7$var$_default = module.exports.default = $27ac80630eac5da7$var$CopyIcon;

});


parcelRegister("6t7fC", function(module, exports) {
$parcel$export(module.exports, "MarkdownRenderer", function () { return $5eb21ac4763f1e08$export$22c2c977437cf477; });
/* markdown-renderer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $iunwt = parcelRequire("iunwt");

var $aaxHj = parcelRequire("aaxHj");

const $5eb21ac4763f1e08$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("g1Xew")).then(({ ReactRenderer: ReactRenderer })=>({
            default: ReactRenderer
        })));
const $5eb21ac4763f1e08$var$MediaComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {});
const $5eb21ac4763f1e08$var$MediaSingleComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {});
const $5eb21ac4763f1e08$var$buttonWrapperStyle = null;
const $5eb21ac4763f1e08$var$rovoButtonWrapperStyle = null;
const $5eb21ac4763f1e08$var$rovoButtonStyle = null;
const $5eb21ac4763f1e08$var$HIGHLIGHT_NAME = "wac-citation-highlight";
/**
 * Checks whether the CSS Custom Highlight API is available in the browser.
 */ function $5eb21ac4763f1e08$var$supportsHighlightAPI() {
    return typeof globalThis.CSS !== "undefined" && "highlights" in globalThis.CSS;
}
/**
 * Collects Range objects covering content nodes that immediately precede
 * a citation marker element, stopping at the previous marker or the start
 * of the parent. Trims leading sentence-ending punctuation (e.g. ". ")
 * from the earliest node so the previous sentence's period isn't highlighted.
 */ function $5eb21ac4763f1e08$var$collectPrecedingRanges(marker) {
    const parent = marker.parentNode;
    if (!parent) return [];
    const ranges = [];
    let sibling = marker.previousSibling;
    while(sibling){
        if (sibling instanceof HTMLElement && sibling.hasAttribute("data-citation-marker")) break;
        if ((sibling.textContent || "").trim().length > 0) {
            const range = new Range();
            range.selectNodeContents(sibling);
            ranges.push(range);
        }
        sibling = sibling.previousSibling;
    }
    // The last range in the array is the earliest (furthest-back) node.
    // Trim any leading sentence-ending punctuation so e.g. ". Some text"
    // starts the highlight at "Some" instead of at the period.
    if (ranges.length > 0) {
        const earliest = ranges[ranges.length - 1];
        const node = earliest?.startContainer;
        if (node?.nodeType === Node.TEXT_NODE) {
            const text = node.textContent || "";
            const match = /^[.!?;:,\s]+/.exec(text);
            if (match) earliest?.setStart(node, match[0].length);
        }
    }
    return ranges;
}
const $5eb21ac4763f1e08$var$getRovoChatUrl = (query)=>{
    const chatUrl = new URL("https://home.atlassian.com/chat");
    chatUrl.searchParams.set("rovoChatPathway", "chat");
    chatUrl.searchParams.set("rovoChatPrompt", query);
    const loginUrl = `https://id.atlassian.com/login?continue=${encodeURIComponent(chatUrl.toString())}`;
    return loginUrl;
};
const $5eb21ac4763f1e08$var$RovoButton = ({ text: text, href: href })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2fk4i.Button), {
        variant: "secondary",
        colorAgainst: "white",
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulp19bv _1bsb1osq _p12fglyw _4t3igktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "mark",
                appearance: "brand",
                width: 20,
                height: 20
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            })
        ]
    });
const $5eb21ac4763f1e08$var$ButtonComponent = ({ text: text, buttonType: buttonType, href: href })=>{
    if (buttonType === "navigation") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        href: href,
        type: "primary",
        "aria-label": `${text}button`,
        text: text
    });
    if (buttonType === "rovo") return /*#__PURE__*/ (0, $7VQPk.jsx)($5eb21ac4763f1e08$var$RovoButton, {
        text: text,
        href: href
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        variant: "primary_alt",
        size: "small",
        colorAgainst: "white",
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: text
    });
};
const $5eb21ac4763f1e08$var$createCtaButtonExtensionHandler = (isRovoEnabledCohort, query)=>({
        "com.atlassian.wac": (ext)=>{
            const { extensionKey: extensionKey, parameters: parameters } = ext;
            if (extensionKey === "cta-button" && parameters) {
                const { text: text, buttonType: buttonType, href: href } = parameters;
                const isRovoButton = buttonType === "rovo";
                const resolvedText = isRovoButton && isRovoEnabledCohort ? "Send this to Rovo" : text;
                const resolvedHref = isRovoButton && isRovoEnabledCohort ? $5eb21ac4763f1e08$var$getRovoChatUrl(query || "") : href;
                // Wrap in span to ensure inline rendering
                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1o8l _1pfhu2gc _12l2u2gc",
                        isRovoButton && "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _1pfhpxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($5eb21ac4763f1e08$var$ButtonComponent, {
                        text: resolvedText,
                        buttonType: buttonType,
                        href: resolvedHref
                    })
                });
            }
            return null;
        }
    });
const $5eb21ac4763f1e08$export$22c2c977437cf477 = ({ answerString: answerString, statusComponent: statusComponent, query: query, isSourceFiltered: isSourceFiltered })=>{
    const { isRovoEnabledCohort: isRovoEnabledCohort } = (0, $iunwt.useAISummaryContext)();
    const containerRef = (0, $1oC0p.useRef)(null);
    const docContent = (0, $1oC0p.useMemo)(()=>(0, $aaxHj.encodeAdf)(answerString, false), [
        answerString
    ]);
    const ctaButtonExtensionHandler = (0, $1oC0p.useMemo)(()=>$5eb21ac4763f1e08$var$createCtaButtonExtensionHandler(Boolean(isRovoEnabledCohort), query), [
        isRovoEnabledCohort,
        query
    ]);
    // Wrap status component in a marker span so we can locate it in the DOM
    const wrappedStatusComponent = (0, $1oC0p.useCallback)((props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            "data-citation-marker": "",
            children: statusComponent(props)
        }), [
        statusComponent
    ]);
    // Inject a ::highlight() style rule for the CSS Custom Highlight API
    (0, $1oC0p.useEffect)(()=>{
        if (!$5eb21ac4763f1e08$var$supportsHighlightAPI()) return;
        const style = document.createElement("style");
        style.textContent = `::highlight(${$5eb21ac4763f1e08$var$HIGHLIGHT_NAME}) { background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"}; }`;
        document.head.appendChild(style);
        return ()=>{
            document.head.removeChild(style);
        };
    }, []);
    // Clear the highlight when the source filter is dismissed
    (0, $1oC0p.useEffect)(()=>{
        if (!isSourceFiltered && $5eb21ac4763f1e08$var$supportsHighlightAPI()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        CSS.highlights.delete($5eb21ac4763f1e08$var$HIGHLIGHT_NAME);
    }, [
        isSourceFiltered
    ]);
    // Event delegation: clicking a citation highlights its preceding text
    // via the CSS Highlight API (no DOM mutation, so no React conflicts)
    (0, $1oC0p.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !$5eb21ac4763f1e08$var$supportsHighlightAPI()) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const highlights = CSS.highlights;
        const handler = (e)=>{
            const target = e.target;
            const marker = target.closest("[data-citation-marker]");
            if (!marker) return;
            // Clear previous highlight before applying new one
            highlights.delete($5eb21ac4763f1e08$var$HIGHLIGHT_NAME);
            const ranges = $5eb21ac4763f1e08$var$collectPrecedingRanges(marker);
            if (ranges.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                const highlight = new globalThis.Highlight(...ranges);
                highlights.set($5eb21ac4763f1e08$var$HIGHLIGHT_NAME, highlight);
            }
        };
        container.addEventListener("click", handler);
        return ()=>container.removeEventListener("click", handler);
    }, []);
    const config = {
        // @ts-expect-error - DocNode type unavailable, fallback to unknown
        document: docContent,
        nodeComponents: {
            status: wrappedStatusComponent,
            media: $5eb21ac4763f1e08$var$MediaComponent,
            mediaSingle: $5eb21ac4763f1e08$var$MediaSingleComponent
        },
        extensionHandlers: ctaButtonExtensionHandler,
        smartLinks: {
            ssr: true
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
            fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {}),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($5eb21ac4763f1e08$var$AkReactRenderer, {
                ...config
            })
        })
    });
};

});
parcelRegister("aaxHj", function(module, exports) {
$parcel$export(module.exports, "encodeAdf", function () { return $a5268bf7b8cf8e18$export$53ded0b846f45216; });

var $hY9jm = parcelRequire("hY9jm");

var $doB2u = parcelRequire("doB2u");

var $ghfnZ = parcelRequire("ghfnZ");

var $9nLCM = parcelRequire("9nLCM");

var $cnLy7 = parcelRequire("cnLy7");

var $7WR9R = parcelRequire("7WR9R");
// Button node spec - inline atom node with attributes
const $a5268bf7b8cf8e18$var$buttonNodeSpec = {
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        text: {
            default: ""
        },
        type: {
            default: ""
        },
        href: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: "span[data-button]",
            getAttrs: (dom)=>{
                const el = dom;
                return {
                    text: el.getAttribute("data-text") || "",
                    type: el.getAttribute("data-type") || "",
                    href: el.getAttribute("data-href") || ""
                };
            }
        }
    ],
    toDOM: (node)=>[
            "span",
            {
                "data-button": "",
                "data-text": node.attrs["text"],
                "data-type": node.attrs["type"],
                "data-href": node.attrs["href"]
            }
        ]
};
// Extend the default schema with custom node specs
const $a5268bf7b8cf8e18$var$customSchema = (0, $hY9jm.createSchema)({
    ...(0, $doB2u.defaultSchemaConfig),
    customNodeSpecs: {
        ...(0, $doB2u.defaultSchemaConfig).customNodeSpecs,
        button: $a5268bf7b8cf8e18$var$buttonNodeSpec
    }
});
// Regex to match :button[text]{key="value" ...} syntax
const $a5268bf7b8cf8e18$var$BUTTON_DIRECTIVE_REGEX = /:button\[([^\]]*)\]\{([^}]*)\}/g;
// Parse attributes from {key="value" key2="value2"} format
function $a5268bf7b8cf8e18$var$parseDirectiveAttrs(attrsString) {
    const attrs = {};
    const attrRegex = /(\w+)="([^"]*)"/g;
    let match;
    while((match = attrRegex.exec(attrsString)) !== null){
        const key = match[1];
        const value = match[2];
        if (key !== undefined) attrs[key] = value ?? "";
    }
    return attrs;
}
// Process a single text node, splitting it if it contains button directives
// Returns null if no changes were made, allowing parent to preserve references
function $a5268bf7b8cf8e18$var$processTextNode(textNode) {
    if (!textNode.text) return null;
    // Quick check: if no button directive exists, return null to indicate no changes
    $a5268bf7b8cf8e18$var$BUTTON_DIRECTIVE_REGEX.lastIndex = 0;
    if (!$a5268bf7b8cf8e18$var$BUTTON_DIRECTIVE_REGEX.test(textNode.text)) return null;
    const result = [];
    let lastIndex = 0;
    let match;
    $a5268bf7b8cf8e18$var$BUTTON_DIRECTIVE_REGEX.lastIndex = 0;
    while((match = $a5268bf7b8cf8e18$var$BUTTON_DIRECTIVE_REGEX.exec(textNode.text)) !== null){
        // Add text before the match
        if (match.index > lastIndex) {
            const node = {
                type: "text",
                text: textNode.text.slice(lastIndex, match.index)
            };
            if (textNode.marks) node.marks = textNode.marks;
            result.push(node);
        }
        // Parse the directive
        const buttonText = match[1] ?? "";
        const attrsString = match[2] ?? "";
        const attrs = $a5268bf7b8cf8e18$var$parseDirectiveAttrs(attrsString);
        // Use inlineExtension - the proper ADF mechanism for custom inline content
        result.push({
            type: "inlineExtension",
            attrs: {
                extensionType: "com.atlassian.wac",
                extensionKey: "cta-button",
                parameters: {
                    text: buttonText,
                    buttonType: attrs["type"] ?? "",
                    href: attrs["href"] ?? ""
                }
            }
        });
        lastIndex = match.index + match[0].length;
    }
    // Add remaining text after last match
    if (lastIndex < textNode.text.length) {
        const node = {
            type: "text",
            text: textNode.text.slice(lastIndex)
        };
        if (textNode.marks) node.marks = textNode.marks;
        result.push(node);
    }
    return result;
}
// Recursively process ADF nodes to find and replace button directives
// Returns the original node reference if no changes were made
function $a5268bf7b8cf8e18$var$processAdfNode(node) {
    if (node.type === "text") // Text nodes are handled by the parent's content processing
    return node;
    if (!node.content) return node;
    // Process content array, expanding text nodes that contain directives
    // Track whether any changes were made to preserve references
    let hasChanges = false;
    const newContent = [];
    for (const child of node.content)if (child.type === "text") {
        const processed = $a5268bf7b8cf8e18$var$processTextNode(child);
        if (processed !== null) {
            hasChanges = true;
            newContent.push(...processed);
        } else newContent.push(child);
    } else {
        const processed = $a5268bf7b8cf8e18$var$processAdfNode(child);
        if (processed !== child) hasChanges = true;
        newContent.push(processed);
    }
    // Return original node if nothing changed
    if (!hasChanges) return node;
    return {
        ...node,
        content: newContent
    };
}
// Post-process ADF to convert :button[text]{attrs} to button nodes
function $a5268bf7b8cf8e18$var$processButtonDirectives(doc) {
    return $a5268bf7b8cf8e18$var$processAdfNode(doc);
}
function $a5268bf7b8cf8e18$var$trimTextNodeIfBeforeStatus(nodes, idx) {
    const current = nodes[idx];
    const previous = nodes[idx - 1];
    if (current?.type !== "status" || previous?.type !== "text" || typeof previous.text !== "string") return null;
    const trimmed = previous.text.replace(/\s+$/u, "");
    return trimmed !== previous.text ? {
        ...previous,
        text: trimmed
    } : null;
}
function $a5268bf7b8cf8e18$var$processChildNode(nodes, idx) {
    const child = nodes[idx];
    if (!child?.content) return {
        node: child ?? {
            type: "text"
        },
        changed: false
    };
    const processed = $a5268bf7b8cf8e18$var$trimWhitespaceBeforeStatusNodes(child);
    return {
        node: processed,
        changed: processed !== child
    };
}
// Recursively trims trailing whitespace from text nodes that directly precede
// status nodes so citation markers don't inherit end-of-sentence gaps.
function $a5268bf7b8cf8e18$var$trimWhitespaceBeforeStatusNodes(node) {
    if (!node.content || node.content.length === 0) return node;
    let hasChanges = false;
    const newContent = [
        ...node.content
    ];
    for(let i = 0; i < newContent.length; i += 1){
        if (i > 0) {
            const trimmedPrev = $a5268bf7b8cf8e18$var$trimTextNodeIfBeforeStatus(newContent, i);
            if (trimmedPrev) {
                hasChanges = true;
                newContent[i - 1] = trimmedPrev;
            }
        }
        const { node: processedChild, changed: changed } = $a5268bf7b8cf8e18$var$processChildNode(newContent, i);
        if (changed) {
            hasChanges = true;
            newContent[i] = processedChild;
        }
    }
    return hasChanges ? {
        ...node,
        content: newContent
    } : node;
}
function $a5268bf7b8cf8e18$var$processCitationWhitespace(doc) {
    return $a5268bf7b8cf8e18$var$trimWhitespaceBeforeStatusNodes(doc);
}
const $a5268bf7b8cf8e18$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== "string" && "type" in content && content.type === "doc";
    } catch  {
        return false;
    }
};
const $a5268bf7b8cf8e18$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($a5268bf7b8cf8e18$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: "paragraph",
            content: [
                {
                    type: "text",
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $a5268bf7b8cf8e18$var$pluginConfig = {
    linkify: {
        findFilepaths: $ghfnZ.findFilepaths,
        isLinkInMatches: $ghfnZ.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $a5268bf7b8cf8e18$export$3374c63d7715b4ce = new (0, $9nLCM.ADFEncoder)(()=>{
    return new (0, $7WR9R.default)($a5268bf7b8cf8e18$var$customSchema, $a5268bf7b8cf8e18$var$pluginConfig, false);
});
const $a5268bf7b8cf8e18$var$streamingAdfEncoder = new (0, $9nLCM.ADFEncoder)(()=>{
    return new (0, $cnLy7.AiMateMarkdownTransformer)($a5268bf7b8cf8e18$var$customSchema, $a5268bf7b8cf8e18$var$pluginConfig, true);
});
const $a5268bf7b8cf8e18$export$53ded0b846f45216 = (content, streaming)=>{
    if ($a5268bf7b8cf8e18$export$d801201dc544181(content)) return $a5268bf7b8cf8e18$var$processCitationWhitespace($a5268bf7b8cf8e18$var$processButtonDirectives(content));
    const encoded = streaming ? $a5268bf7b8cf8e18$var$streamingAdfEncoder.encode(content) : $a5268bf7b8cf8e18$export$3374c63d7715b4ce.encode(content);
    return $a5268bf7b8cf8e18$var$processCitationWhitespace($a5268bf7b8cf8e18$var$processButtonDirectives(encoded));
};

});
parcelRegister("9nLCM", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", function () { return $6d4b3448934f1576$export$bcf771b83128eae7; });
$parcel$export(module.exports, "getText", function () { return $6d4b3448934f1576$export$c72d34660a162238; });
$parcel$export(module.exports, "getEventHandler", function () { return $6d4b3448934f1576$export$eee20638634729b3; });
$parcel$export(module.exports, "findInTree", function () { return $6d4b3448934f1576$export$38b61ebf4950cd39; });

var $2871N = parcelRequire("2871N");

var $hiPA7 = parcelRequire("hiPA7");

var $doB2u = parcelRequire("doB2u");

var $kjsd0 = parcelRequire("kjsd0");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6d4b3448934f1576$var$createEncoder(parser, encoder) {
    return function(value) {
        return encoder.encode(parser.parse(value));
    };
}
var $6d4b3448934f1576$export$bcf771b83128eae7 = /*#__PURE__*/ (0, $2871N.default)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ADFEncoder(createTransformerWithSchema) {
    (0, $hiPA7.default)(this, ADFEncoder);
    var transformer = createTransformerWithSchema((0, $doB2u.defaultSchema));
    this.encode = $6d4b3448934f1576$var$createEncoder(transformer, new (0, $kjsd0.JSONTransformer)());
});
var $6d4b3448934f1576$export$c72d34660a162238 = function getText(node) {
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || "[".concat(typeof node.type === 'string' ? node.type : node.type.name, "]");
};
var $6d4b3448934f1576$export$eee20638634729b3 = function getEventHandler(eventHandlers, type) {
    var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onClick';
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $6d4b3448934f1576$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $6d4b3448934f1576$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("2871N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18d1c7bf07f60d01$export$2e2bcd8739ae039; });

var $9ScEq = parcelRequire("9ScEq");
function $18d1c7bf07f60d01$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9ScEq.default)(o.key), o);
    }
}
function $18d1c7bf07f60d01$export$2e2bcd8739ae039(e, r, t) {
    return r && $18d1c7bf07f60d01$var$_defineProperties(e.prototype, r), t && $18d1c7bf07f60d01$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("9ScEq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $01dae2f96ee3289f$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");

var $2HOZo = parcelRequire("2HOZo");
function $01dae2f96ee3289f$export$2e2bcd8739ae039(t) {
    var i = (0, $2HOZo.default)(t, "string");
    return "symbol" == (0, $85tTb.default)(i) ? i : i + "";
}

});
parcelRegister("85tTb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e35f9b71e172d69$export$2e2bcd8739ae039; });
function $5e35f9b71e172d69$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5e35f9b71e172d69$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e35f9b71e172d69$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2HOZo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f87264d484fc126$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");
function $1f87264d484fc126$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $85tTb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $85tTb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hiPA7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c98c21262ecf70fb$export$2e2bcd8739ae039; });
function $c98c21262ecf70fb$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kjsd0", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", function () { return $ec9b76a92812d9f7$export$98cb1d9308d0944d; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $85tTb = parcelRequire("85tTb");

var $6Kejc = parcelRequire("6Kejc");

var $lUar6 = parcelRequire("lUar6");

var $NCs1g = parcelRequire("NCs1g");

var $fyWnE = parcelRequire("fyWnE");
var $9IIGI = parcelRequire("9IIGI");
var $3DDez = parcelRequire("3DDez");
var $2fgwX = parcelRequire("2fgwX");
var $iq9Qk = parcelRequire("iq9Qk");
var $ePmJY = parcelRequire("ePmJY");
var $4LvHO = parcelRequire("4LvHO");
var $1H3wm = parcelRequire("1H3wm");
var $4wcds = parcelRequire("4wcds");

var $kbSWt = parcelRequire("kbSWt");

var $2r7Em = parcelRequire("2r7Em");

var $4Piq1 = parcelRequire("4Piq1");
function $ec9b76a92812d9f7$var$_toPropertyKey(t) {
    var i = $ec9b76a92812d9f7$var$_toPrimitive(t, "string");
    return "symbol" == (0, $85tTb.default)(i) ? i : i + "";
}
function $ec9b76a92812d9f7$var$_toPrimitive(t, r) {
    if ("object" != (0, $85tTb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $85tTb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec9b76a92812d9f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec9b76a92812d9f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec9b76a92812d9f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec9b76a92812d9f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec9b76a92812d9f7$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
var $ec9b76a92812d9f7$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $ec9b76a92812d9f7$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
var $ec9b76a92812d9f7$var$isCodeBlock = $ec9b76a92812d9f7$var$isType('codeBlock');
var $ec9b76a92812d9f7$var$isMediaNode = $ec9b76a92812d9f7$var$isType('media');
var $ec9b76a92812d9f7$var$isMediaInline = $ec9b76a92812d9f7$var$isType('mediaInline');
var $ec9b76a92812d9f7$var$isMediaSingleNode = $ec9b76a92812d9f7$var$isType('mediaSingle');
var $ec9b76a92812d9f7$var$isMentionNode = $ec9b76a92812d9f7$var$isType('mention');
var $ec9b76a92812d9f7$var$isParagraph = $ec9b76a92812d9f7$var$isType('paragraph');
var $ec9b76a92812d9f7$var$isHeading = $ec9b76a92812d9f7$var$isType('heading');
var $ec9b76a92812d9f7$var$isTable = $ec9b76a92812d9f7$var$isType('table');
var $ec9b76a92812d9f7$var$isTableCell = $ec9b76a92812d9f7$var$isType('tableCell');
var $ec9b76a92812d9f7$var$isTableHeader = $ec9b76a92812d9f7$var$isType('tableHeader');
var $ec9b76a92812d9f7$var$isLinkMark = $ec9b76a92812d9f7$var$isType('link');
var $ec9b76a92812d9f7$var$isUnsupportedMark = $ec9b76a92812d9f7$var$isType('unsupportedMark');
var $ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark = $ec9b76a92812d9f7$var$isType('unsupportedNodeAttribute');
var $ec9b76a92812d9f7$var$isExpand = $ec9b76a92812d9f7$var$isType('expand');
var $ec9b76a92812d9f7$var$isNestedExpand = $ec9b76a92812d9f7$var$isType('nestedExpand');
var $ec9b76a92812d9f7$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $ec9b76a92812d9f7$var$isType('unsupportedBlock')(node) || $ec9b76a92812d9f7$var$isType('unsupportedInline')(node);
};
var $ec9b76a92812d9f7$var$isDataConsumer = $ec9b76a92812d9f7$var$isType('dataConsumer');
var $ec9b76a92812d9f7$var$isFragmentMark = $ec9b76a92812d9f7$var$isType('fragment');
var $ec9b76a92812d9f7$var$isHardBreak = $ec9b76a92812d9f7$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $ec9b76a92812d9f7$var$_filterNull = function filterNull(subject) {
    var output = $ec9b76a92812d9f7$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, $6Kejc.default)(_output, [
                key
            ].map($ec9b76a92812d9f7$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, $85tTb.default)(current) === 'object' && !Array.isArray(current)) output[key] = $ec9b76a92812d9f7$var$_filterNull(current);
    }
    return output;
};
var $ec9b76a92812d9f7$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
var $ec9b76a92812d9f7$var$emptyDoc = $ec9b76a92812d9f7$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $ec9b76a92812d9f7$export$3a858d3babd60825 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($ec9b76a92812d9f7$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($ec9b76a92812d9f7$var$isMediaNode(node)) obj.attrs = (0, $4LvHO.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMediaSingleNode(node)) obj.attrs = (0, $ePmJY.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMediaInline(node)) obj.attrs = (0, $4LvHO.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMentionNode(node)) obj.attrs = (0, $1H3wm.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isCodeBlock(node)) obj.attrs = (0, $fyWnE.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTable(node)) obj.attrs = (0, $4wcds.tableToJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTableCell(node)) obj.attrs = (0, $4wcds.toJSONTableCell)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTableHeader(node)) obj.attrs = (0, $4wcds.toJSONTableHeader)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isExpand(node) || $ec9b76a92812d9f7$var$isNestedExpand(node)) obj.attrs = (0, $3DDez.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $ec9b76a92812d9f7$var$_filterNull(obj.attrs);
    if ($ec9b76a92812d9f7$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : '';
        obj.attrs = $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($ec9b76a92812d9f7$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $ec9b76a92812d9f7$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($ec9b76a92812d9f7$export$3a858d3babd60825(child, mentionMap));
    });
    if ($ec9b76a92812d9f7$var$isParagraph(node) || $ec9b76a92812d9f7$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($ec9b76a92812d9f7$var$isUnsupportedMark(mark)) return $ec9b76a92812d9f7$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($ec9b76a92812d9f7$var$isLinkMark(mark)) return (0, $iq9Qk.toJSON)(mark);
            else if ($ec9b76a92812d9f7$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $9IIGI.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($ec9b76a92812d9f7$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $2fgwX.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $ec9b76a92812d9f7$var$_objectSpread({}, $ec9b76a92812d9f7$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};
var $ec9b76a92812d9f7$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $2r7Em.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $ec9b76a92812d9f7$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, attributes), {}, (0, $lUar6.default)({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
var $ec9b76a92812d9f7$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $kbSWt.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, $hiPA7.default)(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, $2871N.default)(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $4Piq1.sanitizeNode)($ec9b76a92812d9f7$export$3a858d3babd60825(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($NCs1g)))(content, $ec9b76a92812d9f7$var$emptyDoc.content)) return $ec9b76a92812d9f7$var$createDocFromContent([]);
                return $ec9b76a92812d9f7$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
                var schema = !!stage ? (0, $kbSWt.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($ec9b76a92812d9f7$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                return (0, $4Piq1.sanitizeNode)($ec9b76a92812d9f7$export$3a858d3babd60825(node, this.mentionMap));
            }
        }
    ]);
}();

});
parcelRegister("6Kejc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e9223591d1e1083$export$2e2bcd8739ae039; });

var $4enAD = parcelRequire("4enAD");
function $4e9223591d1e1083$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $4enAD.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("4enAD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $314ac4ad2de85031$export$2e2bcd8739ae039; });
function $314ac4ad2de85031$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lUar6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff26ec52ed7d8ef0$export$2e2bcd8739ae039; });

var $9ScEq = parcelRequire("9ScEq");
function $ff26ec52ed7d8ef0$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9ScEq.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("fyWnE", function(module, exports) {
$parcel$export(module.exports, "codeBlock", function () { return $b54751280e524823$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $b54751280e524823$export$54fd2c36b5cc6731; });

var $bttvD = parcelRequire("bttvD");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $b54751280e524823$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $b54751280e524823$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $b54751280e524823$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $b54751280e524823$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $b54751280e524823$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var languageRegex = /(?:^|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])language-((?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $b54751280e524823$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $b54751280e524823$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $b54751280e524823$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $b54751280e524823$export$7bb0d5c671655cc4 = (0, $kBUhU.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b54751280e524823$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b54751280e524823$var$getLanguageFromEditorStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $b54751280e524823$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $b54751280e524823$var$parseCodeFromHtml(domNode);
                return code ? (0, $bttvD.Fragment).from(schema.text(code)) : (0, $bttvD.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $b54751280e524823$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $b54751280e524823$export$3f75de798a0b5356 = (0, $kBUhU.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b54751280e524823$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b54751280e524823$var$getLanguageFromEditorStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $b54751280e524823$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $b54751280e524823$var$parseCodeFromHtml(domNode);
                return code ? (0, $bttvD.Fragment).from(schema.text(code)) : (0, $bttvD.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {};
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});
parcelRegister("bttvD", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $85a94b0c57c3c03b$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $85a94b0c57c3c03b$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $85a94b0c57c3c03b$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $85a94b0c57c3c03b$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $85a94b0c57c3c03b$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $85a94b0c57c3c03b$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $85a94b0c57c3c03b$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $85a94b0c57c3c03b$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $85a94b0c57c3c03b$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $85a94b0c57c3c03b$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $85a94b0c57c3c03b$var$retIndex(0, pos);
        if (pos == this.size) return $85a94b0c57c3c03b$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $85a94b0c57c3c03b$var$retIndex(i + 1, end);
                return $85a94b0c57c3c03b$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $85a94b0c57c3c03b$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $85a94b0c57c3c03b$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $85a94b0c57c3c03b$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $85a94b0c57c3c03b$export$ffb0004e005737fa.empty;
        if (nodes instanceof $85a94b0c57c3c03b$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $85a94b0c57c3c03b$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $85a94b0c57c3c03b$export$ffb0004e005737fa.empty = new $85a94b0c57c3c03b$export$ffb0004e005737fa([], 0);
const $85a94b0c57c3c03b$var$found = {
    index: 0,
    offset: 0
};
function $85a94b0c57c3c03b$var$retIndex(index, offset) {
    $85a94b0c57c3c03b$var$found.index = index;
    $85a94b0c57c3c03b$var$found.offset = offset;
    return $85a94b0c57c3c03b$var$found;
}
function $85a94b0c57c3c03b$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$85a94b0c57c3c03b$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$85a94b0c57c3c03b$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $85a94b0c57c3c03b$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $85a94b0c57c3c03b$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
        if (marks instanceof $85a94b0c57c3c03b$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $85a94b0c57c3c03b$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $85a94b0c57c3c03b$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e($85a94b0c57c3c03b$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e($85a94b0c57c3c03b$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e.empty = new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e($85a94b0c57c3c03b$export$ffb0004e005737fa.empty, 0, 0);
function $85a94b0c57c3c03b$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($85a94b0c57c3c03b$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $85a94b0c57c3c03b$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $85a94b0c57c3c03b$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $85a94b0c57c3c03b$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $85a94b0c57c3c03b$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $85a94b0c57c3c03b$export$6de0e778727af3f2("Inconsistent open depths");
    return $85a94b0c57c3c03b$var$replaceOuter($from, $to, slice, 0);
}
function $85a94b0c57c3c03b$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $85a94b0c57c3c03b$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $85a94b0c57c3c03b$var$close(node, $85a94b0c57c3c03b$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $85a94b0c57c3c03b$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $85a94b0c57c3c03b$var$prepareSliceForReplace(slice, $from);
        return $85a94b0c57c3c03b$var$close(node, $85a94b0c57c3c03b$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $85a94b0c57c3c03b$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $85a94b0c57c3c03b$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $85a94b0c57c3c03b$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $85a94b0c57c3c03b$var$checkJoin(node, $after.node(depth));
    return node;
}
function $85a94b0c57c3c03b$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $85a94b0c57c3c03b$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $85a94b0c57c3c03b$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$85a94b0c57c3c03b$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $85a94b0c57c3c03b$var$addNode($end.nodeBefore, target);
}
function $85a94b0c57c3c03b$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $85a94b0c57c3c03b$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $85a94b0c57c3c03b$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $85a94b0c57c3c03b$var$joinable($end, $to, depth + 1);
    let content = [];
    $85a94b0c57c3c03b$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $85a94b0c57c3c03b$var$checkJoin(openStart, openEnd);
        $85a94b0c57c3c03b$var$addNode($85a94b0c57c3c03b$var$close(openStart, $85a94b0c57c3c03b$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $85a94b0c57c3c03b$var$addNode($85a94b0c57c3c03b$var$close(openStart, $85a94b0c57c3c03b$var$replaceTwoWay($from, $start, depth + 1)), content);
        $85a94b0c57c3c03b$var$addRange($start, $end, depth, content);
        if (openEnd) $85a94b0c57c3c03b$var$addNode($85a94b0c57c3c03b$var$close(openEnd, $85a94b0c57c3c03b$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $85a94b0c57c3c03b$var$addRange($to, null, depth, content);
    return new $85a94b0c57c3c03b$export$ffb0004e005737fa(content);
}
function $85a94b0c57c3c03b$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $85a94b0c57c3c03b$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $85a94b0c57c3c03b$var$joinable($from, $to, depth + 1);
        $85a94b0c57c3c03b$var$addNode($85a94b0c57c3c03b$var$close(type, $85a94b0c57c3c03b$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $85a94b0c57c3c03b$var$addRange($to, null, depth, content);
    return new $85a94b0c57c3c03b$export$ffb0004e005737fa(content);
}
function $85a94b0c57c3c03b$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($85a94b0c57c3c03b$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $85a94b0c57c3c03b$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $85a94b0c57c3c03b$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $85a94b0c57c3c03b$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $85a94b0c57c3c03b$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $85a94b0c57c3c03b$var$resolveCache.set(doc, cache = new $85a94b0c57c3c03b$var$ResolveCache);
        let result = cache.elts[cache.i] = $85a94b0c57c3c03b$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $85a94b0c57c3c03b$var$resolveCacheSize;
        return result;
    }
}
class $85a94b0c57c3c03b$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $85a94b0c57c3c03b$var$resolveCacheSize = 12, $85a94b0c57c3c03b$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $85a94b0c57c3c03b$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $85a94b0c57c3c03b$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $85a94b0c57c3c03b$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $85a94b0c57c3c03b$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $85a94b0c57c3c03b$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $85a94b0c57c3c03b$var$emptyAttrs) && $85a94b0c57c3c03b$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $85a94b0c57c3c03b$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $85a94b0c57c3c03b$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $85a94b0c57c3c03b$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $85a94b0c57c3c03b$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $85a94b0c57c3c03b$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $85a94b0c57c3c03b$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $85a94b0c57c3c03b$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$85a94b0c57c3c03b$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $85a94b0c57c3c03b$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$85a94b0c57c3c03b$export$85c928794f8d04d4.prototype.text = undefined;
class $85a94b0c57c3c03b$var$TextNode extends $85a94b0c57c3c03b$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $85a94b0c57c3c03b$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $85a94b0c57c3c03b$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $85a94b0c57c3c03b$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $85a94b0c57c3c03b$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $85a94b0c57c3c03b$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $85a94b0c57c3c03b$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $85a94b0c57c3c03b$export$364ed450558d7ec4.empty;
        let expr = $85a94b0c57c3c03b$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $85a94b0c57c3c03b$var$dfa($85a94b0c57c3c03b$var$nfa(expr));
        $85a94b0c57c3c03b$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $85a94b0c57c3c03b$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $85a94b0c57c3c03b$export$364ed450558d7ec4.empty = new $85a94b0c57c3c03b$export$364ed450558d7ec4(true);
class $85a94b0c57c3c03b$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $85a94b0c57c3c03b$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($85a94b0c57c3c03b$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $85a94b0c57c3c03b$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($85a94b0c57c3c03b$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $85a94b0c57c3c03b$var$parseExprSubscript(stream) {
    let expr = $85a94b0c57c3c03b$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $85a94b0c57c3c03b$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $85a94b0c57c3c03b$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $85a94b0c57c3c03b$var$parseExprRange(stream, expr) {
    let min = $85a94b0c57c3c03b$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $85a94b0c57c3c03b$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $85a94b0c57c3c03b$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $85a94b0c57c3c03b$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $85a94b0c57c3c03b$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $85a94b0c57c3c03b$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $85a94b0c57c3c03b$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $85a94b0c57c3c03b$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $85a94b0c57c3c03b$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($85a94b0c57c3c03b$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $85a94b0c57c3c03b$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($85a94b0c57c3c03b$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $85a94b0c57c3c03b$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $85a94b0c57c3c03b$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($85a94b0c57c3c03b$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $85a94b0c57c3c03b$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $85a94b0c57c3c03b$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $85a94b0c57c3c03b$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $85a94b0c57c3c03b$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $85a94b0c57c3c03b$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $85a94b0c57c3c03b$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $85a94b0c57c3c03b$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $85a94b0c57c3c03b$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $85a94b0c57c3c03b$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $85a94b0c57c3c03b$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $85a94b0c57c3c03b$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $85a94b0c57c3c03b$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $85a94b0c57c3c03b$export$ffb0004e005737fa.from(content), $85a94b0c57c3c03b$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $85a94b0c57c3c03b$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $85a94b0c57c3c03b$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $85a94b0c57c3c03b$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($85a94b0c57c3c03b$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $85a94b0c57c3c03b$export$85c928794f8d04d4(this, attrs, content.append(after), $85a94b0c57c3c03b$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $85a94b0c57c3c03b$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $85a94b0c57c3c03b$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $85a94b0c57c3c03b$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $85a94b0c57c3c03b$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $85a94b0c57c3c03b$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $85a94b0c57c3c03b$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $85a94b0c57c3c03b$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $85a94b0c57c3c03b$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $85a94b0c57c3c03b$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $85a94b0c57c3c03b$export$c9d15bcfc6d42044(this, $85a94b0c57c3c03b$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $85a94b0c57c3c03b$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $85a94b0c57c3c03b$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $85a94b0c57c3c03b$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $85a94b0c57c3c03b$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $85a94b0c57c3c03b$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $85a94b0c57c3c03b$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $85a94b0c57c3c03b$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $85a94b0c57c3c03b$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$85a94b0c57c3c03b$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$85a94b0c57c3c03b$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $85a94b0c57c3c03b$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $85a94b0c57c3c03b$var$TextNode(type, type.defaultAttrs, text, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $85a94b0c57c3c03b$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $85a94b0c57c3c03b$var$isTagRule(rule) {
    return rule.tag != null;
}
function $85a94b0c57c3c03b$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $85a94b0c57c3c03b$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($85a94b0c57c3c03b$var$isTagRule(rule)) this.tags.push(rule);
            else if ($85a94b0c57c3c03b$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $85a94b0c57c3c03b$var$ParseContext(this, options, false);
        context.addAll(dom, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $85a94b0c57c3c03b$var$ParseContext(this, options, true);
        context.addAll(dom, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $85a94b0c57c3c03b$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($85a94b0c57c3c03b$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $85a94b0c57c3c03b$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $85a94b0c57c3c03b$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $85a94b0c57c3c03b$export$1059c6e7d2ce5669(schema, $85a94b0c57c3c03b$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $85a94b0c57c3c03b$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $85a94b0c57c3c03b$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $85a94b0c57c3c03b$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $85a94b0c57c3c03b$var$OPT_PRESERVE_WS = 1, $85a94b0c57c3c03b$var$OPT_PRESERVE_WS_FULL = 2, $85a94b0c57c3c03b$var$OPT_OPEN_LEFT = 4;
function $85a94b0c57c3c03b$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $85a94b0c57c3c03b$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $85a94b0c57c3c03b$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $85a94b0c57c3c03b$var$OPT_PRESERVE_WS | $85a94b0c57c3c03b$var$OPT_PRESERVE_WS_FULL : base & ~$85a94b0c57c3c03b$var$OPT_OPEN_LEFT;
}
class $85a94b0c57c3c03b$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $85a94b0c57c3c03b$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($85a94b0c57c3c03b$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $85a94b0c57c3c03b$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $85a94b0c57c3c03b$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($85a94b0c57c3c03b$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$85a94b0c57c3c03b$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $85a94b0c57c3c03b$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $85a94b0c57c3c03b$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $85a94b0c57c3c03b$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $85a94b0c57c3c03b$var$NodeContext(topNode.type, topNode.attrs, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $85a94b0c57c3c03b$var$NodeContext(null, null, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $85a94b0c57c3c03b$var$NodeContext(parser.schema.topNodeType, null, $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $85a94b0c57c3c03b$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $85a94b0c57c3c03b$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($85a94b0c57c3c03b$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $85a94b0c57c3c03b$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $85a94b0c57c3c03b$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($85a94b0c57c3c03b$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $85a94b0c57c3c03b$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $85a94b0c57c3c03b$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $85a94b0c57c3c03b$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $85a94b0c57c3c03b$var$OPT_OPEN_LEFT;
        let applyMarks = $85a94b0c57c3c03b$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $85a94b0c57c3c03b$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $85a94b0c57c3c03b$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $85a94b0c57c3c03b$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $85a94b0c57c3c03b$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $85a94b0c57c3c03b$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $85a94b0c57c3c03b$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $85a94b0c57c3c03b$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $85a94b0c57c3c03b$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $85a94b0c57c3c03b$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $85a94b0c57c3c03b$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $85a94b0c57c3c03b$var$renderSpec($85a94b0c57c3c03b$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $85a94b0c57c3c03b$var$renderSpec($85a94b0c57c3c03b$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $85a94b0c57c3c03b$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $85a94b0c57c3c03b$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $85a94b0c57c3c03b$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $85a94b0c57c3c03b$var$gatherToDOM(schema.marks);
    }
}
function $85a94b0c57c3c03b$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $85a94b0c57c3c03b$var$doc(options) {
    return options.document || window.document;
}
const $85a94b0c57c3c03b$var$suspiciousAttributeCache = new WeakMap();
function $85a94b0c57c3c03b$var$suspiciousAttributes(attrs) {
    let value = $85a94b0c57c3c03b$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $85a94b0c57c3c03b$var$suspiciousAttributeCache.set(attrs, value = $85a94b0c57c3c03b$var$suspiciousAttributesInner(attrs));
    return value;
}
function $85a94b0c57c3c03b$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $85a94b0c57c3c03b$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $85a94b0c57c3c03b$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $85a94b0c57c3c03b$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("kBUhU", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $f012ecf75ebad503$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $f012ecf75ebad503$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $f012ecf75ebad503$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $f012ecf75ebad503$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $f012ecf75ebad503$export$27903d543b563e39; });
$parcel$export(module.exports, "bodiedSyncBlock", function () { return $f012ecf75ebad503$export$e92c7e4302dd4371; });
$parcel$export(module.exports, "bulletList", function () { return $f012ecf75ebad503$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $f012ecf75ebad503$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $f012ecf75ebad503$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $f012ecf75ebad503$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $f012ecf75ebad503$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $f012ecf75ebad503$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $f012ecf75ebad503$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $f012ecf75ebad503$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $f012ecf75ebad503$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $f012ecf75ebad503$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $f012ecf75ebad503$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $f012ecf75ebad503$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $f012ecf75ebad503$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $f012ecf75ebad503$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $f012ecf75ebad503$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $f012ecf75ebad503$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $f012ecf75ebad503$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $f012ecf75ebad503$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $f012ecf75ebad503$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $f012ecf75ebad503$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $f012ecf75ebad503$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $f012ecf75ebad503$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $f012ecf75ebad503$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $f012ecf75ebad503$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $f012ecf75ebad503$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $f012ecf75ebad503$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $f012ecf75ebad503$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $f012ecf75ebad503$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $f012ecf75ebad503$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $f012ecf75ebad503$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $f012ecf75ebad503$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $f012ecf75ebad503$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $f012ecf75ebad503$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $f012ecf75ebad503$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $f012ecf75ebad503$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $f012ecf75ebad503$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $f012ecf75ebad503$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $f012ecf75ebad503$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $f012ecf75ebad503$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $f012ecf75ebad503$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $f012ecf75ebad503$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $f012ecf75ebad503$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlock", function () { return $f012ecf75ebad503$export$faab0ca9701d7048; });
$parcel$export(module.exports, "table", function () { return $f012ecf75ebad503$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $f012ecf75ebad503$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $f012ecf75ebad503$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $f012ecf75ebad503$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $f012ecf75ebad503$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $f012ecf75ebad503$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $f012ecf75ebad503$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $f012ecf75ebad503$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $f012ecf75ebad503$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $f012ecf75ebad503$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $f012ecf75ebad503$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $f012ecf75ebad503$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $f012ecf75ebad503$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $5OqWX = parcelRequire("5OqWX");
var $f012ecf75ebad503$export$c4c2f833baaebdb8 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$67dc04e652a298ca = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $f012ecf75ebad503$export$199922e5af8e9a6 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $f012ecf75ebad503$export$16018c61064a18df = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$27903d543b563e39 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $f012ecf75ebad503$export$e7320d153c538837 = (0, $5OqWX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $f012ecf75ebad503$export$e92c7e4302dd4371 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$a140c94e5ea26bee = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$8e3c2dfdc4f0453d = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $f012ecf75ebad503$export$7bb0d5c671655cc4 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $f012ecf75ebad503$export$e4f1c66d84049f8b = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $f012ecf75ebad503$export$daf889beb5092f95 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$e6e4878f43c27cab = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$3e6d667072febc87 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$324d90190a8b822a = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$47988d68fe575725 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$6959e16eeff859b4 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $f012ecf75ebad503$export$62d45a65fb43d95e = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$2a111da947c407d2 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $f012ecf75ebad503$export$be4283d9a1cb1ff6 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$a19185d1233fc4b2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$f5574b5d45fc2112 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9f77e0932fb78f72 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$7e3788972005cc72 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$1b45514b112dd749 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$a8baf338431a691 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b555be60c7703afb = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $f012ecf75ebad503$export$371da9dd35aba193 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $f012ecf75ebad503$export$46e4a324ac90507f = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$1b0c1557b234fa00 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$85461f751c457cc2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$2b380a0f7e250af1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$5c452ff88e35e47d = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $f012ecf75ebad503$export$cbf8224b64e0d942 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$2f4e72b9459914ad = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$16b353b2649bd8d9 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b3b1e36c2105006d = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$ab76e7c03cd6f650 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $f012ecf75ebad503$export$b3b6a70a7fa4a5be = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$cdae19acb0a520fd = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$206007566ca0aca5 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$76c7e83ecc9cdf05 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$df876f0305235056 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$987d49ffe1b0900f = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$2855e964765eac9 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $f012ecf75ebad503$export$38bab695e3f720f1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$969fe3781ca15058 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $f012ecf75ebad503$export$8d067f22dc2d1254 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$7e767666f2ce108a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$4bd9a38995f6bf50 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$db83999c14438df4 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$46f790bd65f760d0 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$750e45819f66d9d0 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $f012ecf75ebad503$export$63cadbf5f4296627 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$f03786aa6312d1e4 = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$a5dc81035676e7a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$21f42ab9b6679f44 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9c206ddddb32a9b = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$4f98472e6dc14293 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$ea332b61641b0588 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$a1f41dc4901771f8 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$c7187bbd1a7a9244 = (0, $5OqWX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$fbeb3a3956e8a3c7 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$471f7ae5c4103ae1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b6ce52be8d7a261 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$faab0ca9701d7048 = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9852986a3ec5f6a0 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $f012ecf75ebad503$export$ce086a560a1d05f5 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $f012ecf75ebad503$export$e1e720e5f4603e6a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $f012ecf75ebad503$export$abf39ca178940ff3 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $f012ecf75ebad503$export$48884d2a5190dc73 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $f012ecf75ebad503$export$2a5a518232fa1a97 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $f012ecf75ebad503$export$ce666bf02318c957 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $f012ecf75ebad503$export$7d657479499397 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $f012ecf75ebad503$export$6d8b0ef52e2e6390 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$375b6afcc5f4d291 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$6f093cfa640b7166 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$5ea06bc686c59dc2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$93256a4c17b33a82 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$a12828d0f14a2762 = (0, $5OqWX.createPMNodeSpecFactory)({});
var $f012ecf75ebad503$export$44b79b0979d0f0f7 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$310ebe0d80122e9b = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("5OqWX", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $43b686f475d0f954$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $43b686f475d0f954$export$cf5823ed4e9f4c6f; });

var $lUar6 = parcelRequire("lUar6");
function $43b686f475d0f954$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43b686f475d0f954$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43b686f475d0f954$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43b686f475d0f954$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43b686f475d0f954$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        // @ts-ignore
        return $43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $43b686f475d0f954$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        // @ts-ignore
        return $43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("6BQ2f", function(module, exports) {
$parcel$export(module.exports, "uuid", function () { return $4cfe8fe52a28aa8c$export$31b40729666a4ae0; });
var $4cfe8fe52a28aa8c$export$1c3aefb711c3a4cc = function generateUuid() {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    }));
};
var $4cfe8fe52a28aa8c$var$staticValue = false;
var $4cfe8fe52a28aa8c$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $4cfe8fe52a28aa8c$var$staticValue = value;
    },
    generate: function generate() {
        return $4cfe8fe52a28aa8c$var$staticValue || $4cfe8fe52a28aa8c$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("9IIGI", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", function () { return $713ae338c10ff4b6$export$3024f02c495408d6; });
$parcel$export(module.exports, "toJSON", function () { return $713ae338c10ff4b6$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $OQ9bg = parcelRequire("OQ9bg");

var $ekJ59 = parcelRequire("ekJ59");
function $713ae338c10ff4b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $713ae338c10ff4b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $713ae338c10ff4b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $713ae338c10ff4b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $713ae338c10ff4b6$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $ekJ59.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $713ae338c10ff4b6$export$3024f02c495408d6 = (0, $OQ9bg.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $713ae338c10ff4b6$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $713ae338c10ff4b6$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $713ae338c10ff4b6$var$_objectSpread($713ae338c10ff4b6$var$_objectSpread({}, acc), {}, (0, $lUar6.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("OQ9bg", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $098d1ef316bf0b72$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $098d1ef316bf0b72$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $098d1ef316bf0b72$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $098d1ef316bf0b72$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $098d1ef316bf0b72$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $098d1ef316bf0b72$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $098d1ef316bf0b72$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $098d1ef316bf0b72$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $098d1ef316bf0b72$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $098d1ef316bf0b72$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $098d1ef316bf0b72$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $098d1ef316bf0b72$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $098d1ef316bf0b72$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $098d1ef316bf0b72$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $098d1ef316bf0b72$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $098d1ef316bf0b72$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $098d1ef316bf0b72$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $098d1ef316bf0b72$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $098d1ef316bf0b72$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $098d1ef316bf0b72$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $5OqWX = parcelRequire("5OqWX");
var $098d1ef316bf0b72$export$8e53000a4ec837 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $098d1ef316bf0b72$export$8512c9afa7b24c3b = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $098d1ef316bf0b72$export$8c5a050822fd698c = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $098d1ef316bf0b72$export$1edee58a52776cd9 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $098d1ef316bf0b72$export$89015c65f1c75e3f = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $098d1ef316bf0b72$export$6565f9f03506010b = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $098d1ef316bf0b72$export$f3b72f8fc4684ecd = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $098d1ef316bf0b72$export$3024f02c495408d6 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $098d1ef316bf0b72$export$c63c6f932822f543 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$f00aeb236b6f05af = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $098d1ef316bf0b72$export$480c699bd4ec0d86 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $098d1ef316bf0b72$export$9c30223ca0a664fb = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $098d1ef316bf0b72$export$4899a95d70ec5056 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$59ae2c325a998f89 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$b3401ee80eb31041 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$32f78bffcd82ff28 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $098d1ef316bf0b72$export$20af3dabbb5538df = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $098d1ef316bf0b72$export$425327af25286e5e = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$30d78d5eb6719bb8 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $098d1ef316bf0b72$export$a316dc07ff5182a2 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});

parcelRegister("ekJ59", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", function () { return $a6f5e748c5f5e438$export$c296e2d4365c37a5; });
var $a6f5e748c5f5e438$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("3DDez", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $2a6372b14246c485$export$7b80cba28d10b2c1; });
$parcel$export(module.exports, "toJSON", function () { return $2a6372b14246c485$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $2a6372b14246c485$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a6372b14246c485$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a6372b14246c485$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a6372b14246c485$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $2a6372b14246c485$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $2a6372b14246c485$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $2a6372b14246c485$export$7b80cba28d10b2c1 = (0, $kBUhU.expand)($2a6372b14246c485$var$nodeSpecOptions);
var $2a6372b14246c485$export$2ae5e7565ff9ffa6 = (0, $kBUhU.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $2a6372b14246c485$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, obj), {}, (0, $lUar6.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("2fgwX", function(module, exports) {
$parcel$export(module.exports, "fragment", function () { return $1a29ce1fd691cb99$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "toJSON", function () { return $1a29ce1fd691cb99$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $OQ9bg = parcelRequire("OQ9bg");

var $ekJ59 = parcelRequire("ekJ59");
function $1a29ce1fd691cb99$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a29ce1fd691cb99$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a29ce1fd691cb99$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a29ce1fd691cb99$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $1a29ce1fd691cb99$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $ekJ59.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $1a29ce1fd691cb99$export$f00aeb236b6f05af = (0, $OQ9bg.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $1a29ce1fd691cb99$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $1a29ce1fd691cb99$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $1a29ce1fd691cb99$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("iq9Qk", function(module, exports) {
$parcel$export(module.exports, "link", function () { return $d6924a4e79658fd3$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "toJSON", function () { return $d6924a4e79658fd3$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $OQ9bg = parcelRequire("OQ9bg");

var $cX1iO = parcelRequire("cX1iO");
function $d6924a4e79658fd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6924a4e79658fd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6924a4e79658fd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6924a4e79658fd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d6924a4e79658fd3$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $cX1iO.isSafeUrl)(href)) return false;
        if ((0, $cX1iO.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $cX1iO.normalizeUrl)(href);
        return attrs;
    };
};
var $d6924a4e79658fd3$export$9c30223ca0a664fb = (0, $OQ9bg.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $d6924a4e79658fd3$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $d6924a4e79658fd3$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $cX1iO.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $d6924a4e79658fd3$var$_objectSpread($d6924a4e79658fd3$var$_objectSpread({}, attrs), {}, (0, $lUar6.default)((0, $lUar6.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $d6924a4e79658fd3$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $d6924a4e79658fd3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($d6924a4e79658fd3$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("cX1iO", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", function () { return $96dc015bc0129d10$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $96dc015bc0129d10$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $96dc015bc0129d10$export$23579274a7a24f7b; });
// @ts-nocheck
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $l2qL1 = parcelRequire("l2qL1");
var $96dc015bc0129d10$var$whitelistedURLPatterns = [
    /^http[s\u017F]?:\/\//im,
    /^ftp[s\u017F]?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^[s\u017F]mb:\/\//im,
    /^dynamic[s\u017F]nav:\/\//im,
    /^jamf[s\u017F]elf[s\u017F]ervice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^[s\u017F][k\u212A]ype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^new[s\u017F]:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cv[s\u017F]:/im,
    /^[s\u017F]vn:/im,
    /^mvn:/im,
    /^[s\u017F][s\u017F]h:/im,
    /^[s\u017F]cp:\/\//im,
    /^[s\u017F]ftp:\/\//im,
    /^itm[s\u017F]:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^note[s\u017F]:/im,
    /^note[s\u017F]:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^[s\u017F]ourcetree:/im,
    /^[s\u017F]ourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^what[s\u017F]app:/im,
    /^[s\u017F]lac[k\u212A]:/im,
    /^[s\u017F]ip[s\u017F]?:/im,
    /^magnet:/im,
    /^#/im
];
var $96dc015bc0129d10$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $96dc015bc0129d10$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $96dc015bc0129d10$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($l2qL1)))();
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $96dc015bc0129d10$var$urlWithoutSpacesValidator = {
    validate: /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('tel:', $96dc015bc0129d10$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('file:', $96dc015bc0129d10$var$urlWithoutSpacesValidator);
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $96dc015bc0129d10$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $96dc015bc0129d10$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$96dc015bc0129d10$var$tlds.push($96dc015bc0129d10$var$tlds2Char);
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.tlds($96dc015bc0129d10$var$tlds, false);
var $96dc015bc0129d10$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
var $96dc015bc0129d10$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$96dc015bc0129d10$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    substr = text.substr(startpos);
    while(substr){
        var link = (substr.match($96dc015bc0129d10$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($96dc015bc0129d10$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $96dc015bc0129d10$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $96dc015bc0129d10$export$6f7d7761b97f967(str);
    if (!match.length) match = $96dc015bc0129d10$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $96dc015bc0129d10$export$6535eb414fa2c8b6(url) {
    var match = $96dc015bc0129d10$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $96dc015bc0129d10$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});


parcelRegister("ePmJY", function(module, exports) {
$parcel$export(module.exports, "mediaSingleFull", function () { return $acb777e037a21462$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $acb777e037a21462$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $gOR5u = parcelRequire("gOR5u");

var $ekJ59 = parcelRequire("ekJ59");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $acb777e037a21462$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acb777e037a21462$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acb777e037a21462$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acb777e037a21462$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $acb777e037a21462$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $acb777e037a21462$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $ekJ59.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $6BQ2f.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $gOR5u.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $acb777e037a21462$var$_objectSpread($acb777e037a21462$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $gOR5u.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $kBUhU.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $kBUhU.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $kBUhU.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $kBUhU.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $acb777e037a21462$export$969fe3781ca15058 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $acb777e037a21462$export$d35e6c006d4abdfb = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $acb777e037a21462$export$9c58e19811ce4cf5 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $acb777e037a21462$export$7e767666f2ce108a = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $acb777e037a21462$export$75376a385837c942 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $acb777e037a21462$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("gOR5u", function(module, exports) {
$parcel$export(module.exports, "WidthType", function () { return $c3ea7ef3206b0fe7$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $c3ea7ef3206b0fe7$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("4LvHO", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", function () { return $3784254fee0de50f$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $3784254fee0de50f$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $3784254fee0de50f$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $aZMvy = parcelRequire("aZMvy");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $3784254fee0de50f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3784254fee0de50f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3784254fee0de50f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3784254fee0de50f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3784254fee0de50f$export$bb3fe706be61f640 = (0, $kBUhU.media)({}).attrs;
var $3784254fee0de50f$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/((?:[\0-@\[-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    }));
};
var $3784254fee0de50f$export$111130fa8968d741 = function copyPrivateAttributes(from, to, attributes, map) {
    var attrs = attributes || {};
    Object.keys(attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
var $3784254fee0de50f$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                    var key = $3784254fee0de50f$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $6BQ2f.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $aZMvy.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $3784254fee0de50f$export$111130fa8968d741(node.attrs, attrs, attributes, function(key) {
            return "data-".concat($3784254fee0de50f$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $kBUhU.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $kBUhU.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $6BQ2f.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $3784254fee0de50f$export$987d49ffe1b0900f = $3784254fee0de50f$export$35bdbf5bc8caa677($3784254fee0de50f$export$bb3fe706be61f640, false, false);
var $3784254fee0de50f$export$8446e47a4c7fd000 = $3784254fee0de50f$export$35bdbf5bc8caa677($3784254fee0de50f$var$_objectSpread($3784254fee0de50f$var$_objectSpread({}, $3784254fee0de50f$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $6BQ2f.uuid).generate()
    }
}), false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $3784254fee0de50f$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $3784254fee0de50f$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $3784254fee0de50f$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $3784254fee0de50f$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($3784254fee0de50f$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("aZMvy", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $80153a9129a945ba$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $80153a9129a945ba$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $80153a9129a945ba$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $80153a9129a945ba$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $80153a9129a945ba$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $80153a9129a945ba$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $80153a9129a945ba$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $80153a9129a945ba$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $80153a9129a945ba$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $80153a9129a945ba$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $80153a9129a945ba$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $80153a9129a945ba$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $80153a9129a945ba$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $80153a9129a945ba$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $80153a9129a945ba$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $80153a9129a945ba$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $80153a9129a945ba$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $80153a9129a945ba$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $80153a9129a945ba$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $80153a9129a945ba$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $80153a9129a945ba$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $80153a9129a945ba$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $80153a9129a945ba$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $80153a9129a945ba$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $80153a9129a945ba$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $80153a9129a945ba$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $80153a9129a945ba$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $80153a9129a945ba$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $80153a9129a945ba$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $80153a9129a945ba$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $80153a9129a945ba$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $80153a9129a945ba$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $80153a9129a945ba$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $80153a9129a945ba$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $80153a9129a945ba$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $80153a9129a945ba$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $80153a9129a945ba$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $80153a9129a945ba$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $80153a9129a945ba$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $80153a9129a945ba$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $80153a9129a945ba$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $80153a9129a945ba$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $80153a9129a945ba$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $80153a9129a945ba$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $80153a9129a945ba$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $80153a9129a945ba$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $80153a9129a945ba$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $80153a9129a945ba$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $80153a9129a945ba$export$9665a07d9187b414; });

var $f2kyT = parcelRequire("f2kyT");

var $ksCOI = parcelRequire("ksCOI");
var $80153a9129a945ba$export$4b84fd0e2c617bd = '#FFEBE6';
var $80153a9129a945ba$export$b34b069eff244586 = '#FFBDAD';
var $80153a9129a945ba$export$be802dd0d8b57f35 = '#FF8F73';
var $80153a9129a945ba$export$4a7404f376229999 = '#FF5630';
var $80153a9129a945ba$export$2010d0fb4295b346 = '#DE350B';
var $80153a9129a945ba$export$2837b5a1a71d5c02 = '#BF2600';
var $80153a9129a945ba$export$8d9596b529bbb9cf = '#FFFAE6';
var $80153a9129a945ba$export$41060a744ab0b7ae = '#FFF0B3';
var $80153a9129a945ba$export$5aae31392d72caaa = '#FFC400';
var $80153a9129a945ba$export$fc857b6f8771648a = '#F8E6A0';
var $80153a9129a945ba$export$59619663aa6500fb = '#FF991F';
var $80153a9129a945ba$export$874739ea9e379ab6 = '#FF8B00';
var $80153a9129a945ba$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $80153a9129a945ba$export$69a3bf21b9686c2b = '#ABF5D1';
var $80153a9129a945ba$export$747d86715d4175de = '#57D9A3';
var $80153a9129a945ba$export$940e1f69e873f202 = '#36B37E';
var $80153a9129a945ba$export$a49394138f7b8e85 = '#00875A';
var $80153a9129a945ba$export$6fa04827ac68a4fb = '#006644';
var $80153a9129a945ba$export$226de0355ed012f8 = '#DEEBFF';
var $80153a9129a945ba$export$8c13c2ee36917869 = '#B3D4FF';
var $80153a9129a945ba$export$ecfc1dff386a3e7a = '#4C9AFF';
var $80153a9129a945ba$export$b3de0ae08da2ce64 = '#0052CC';
var $80153a9129a945ba$export$a6ee3d71bc067634 = '#0747A6';
var $80153a9129a945ba$export$f72948ef771f6f15 = '#D3F1A7';
var $80153a9129a945ba$export$29a4f05edc054374 = '#FFFFFF';
var $80153a9129a945ba$export$9fdfb749e33cdf97 = '#F4F5F7';
var $80153a9129a945ba$export$3e51e8f1440314ba = '#EBECF0';
var $80153a9129a945ba$export$1ce2d1575d444ceb = '#DFE1E6';
var $80153a9129a945ba$export$8754fc7e6d8b3000 = '#C1C7D0';
var $80153a9129a945ba$export$c2e91cbeada39b8b = '#B3BAC5';
var $80153a9129a945ba$export$eaa8c8a70ac22806 = '#97A0AF';
var $80153a9129a945ba$export$7c87d337fb91a97d = '#8993A4';
var $80153a9129a945ba$export$f563ee71e9ee74cd = '#6B778C';
var $80153a9129a945ba$export$e2ef2124cf4024b1 = '#5E6C84';
var $80153a9129a945ba$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $80153a9129a945ba$export$13609db0e6812ab8 = '#091E4224';
var $80153a9129a945ba$export$c39c0fe0f26207ae = '#42526E';
var $80153a9129a945ba$export$7090862dc3038a9f = '#758195';
var $80153a9129a945ba$export$7d61b15e0da132af = '#172B4D';
var $80153a9129a945ba$export$f78789c8b01753cd = '#172B4D';
var $80153a9129a945ba$export$a19f0c33186f7767 = '#FDD0EC';
var $80153a9129a945ba$export$51716a84e62e022c = '#FEDEC8';
var $80153a9129a945ba$export$363e4475840015bb = '#EAE6FF';
var $80153a9129a945ba$export$4b0a4417ed59760f = '#C0B6F2';
var $80153a9129a945ba$export$6011520a64d9a187 = '#998DD9';
var $80153a9129a945ba$export$a7175d4e9206bc80 = '#DFD8FD';
var $80153a9129a945ba$export$b48405b95304b5a1 = '#6554C0';
var $80153a9129a945ba$export$c71e4279dd54a18d = '#5243AA';
var $80153a9129a945ba$export$147899de772240ec = '#403294';
var $80153a9129a945ba$export$2cf711fe14c66f06 = '#E6FCFF';
var $80153a9129a945ba$export$7a8f4d33f6f9772c = '#B3F5FF';
var $80153a9129a945ba$export$776c9c497ef08533 = '#79E2F2';
var $80153a9129a945ba$export$69cb3ca10c1e330e = '#C6EDFB';
var $80153a9129a945ba$export$9dc1ef0f3f48059b = '#00B8D9';
var $80153a9129a945ba$export$6036577f95c3877e = '#008DA6';
function $80153a9129a945ba$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($80153a9129a945ba$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($80153a9129a945ba$export$e698776ec826343(color)) return $80153a9129a945ba$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $ksCOI.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $ksCOI.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $ksCOI.default[color];
        else if ($ksCOI && $ksCOI[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $ksCOI[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $80153a9129a945ba$export$5a544e13ad4e1fa5(color) {
    if (!$80153a9129a945ba$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $80153a9129a945ba$export$9665a07d9187b414(rawColor, alpha) {
    var color = $80153a9129a945ba$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[0-9a-z\u017F\u212A]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $80153a9129a945ba$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var matches = value.match(/(0?\.?[0-9]{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $f2kyT.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
function $80153a9129a945ba$export$e698776ec826343(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /rgba?\(/.test(color);
}
function $80153a9129a945ba$export$8a9b6341a7c96bc(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /^#([0-9A-Fa-f]{3}){1,2}$/.test(color);
}

});
parcelRegister("f2kyT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af26fe103670f62b$export$2e2bcd8739ae039; });

var $kBeVR = parcelRequire("kBeVR");

var $jlHGM = parcelRequire("jlHGM");

var $2M5HD = parcelRequire("2M5HD");

var $92XDN = parcelRequire("92XDN");
function $af26fe103670f62b$export$2e2bcd8739ae039(r, e) {
    return (0, $kBeVR.default)(r) || (0, $jlHGM.default)(r, e) || (0, $2M5HD.default)(r, e) || (0, $92XDN.default)();
}

});
parcelRegister("kBeVR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eff2d8968c4f471d$export$2e2bcd8739ae039; });
function $eff2d8968c4f471d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jlHGM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e161de30762dcde2$export$2e2bcd8739ae039; });
function $e161de30762dcde2$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("2M5HD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20547cedec03f08c$export$2e2bcd8739ae039; });

var $cqWE6 = parcelRequire("cqWE6");
function $20547cedec03f08c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cqWE6.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cqWE6.default)(r, a) : void 0;
    }
}

});
parcelRegister("cqWE6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90d5678f7efec50f$export$2e2bcd8739ae039; });
function $90d5678f7efec50f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("92XDN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69629069d75fe9b5$export$2e2bcd8739ae039; });
function $69629069d75fe9b5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("1H3wm", function(module, exports) {
$parcel$export(module.exports, "mention", function () { return $13bc89c433dbe0f6$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $13bc89c433dbe0f6$export$54fd2c36b5cc6731; });

var $lUar6 = parcelRequire("lUar6");

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
function $13bc89c433dbe0f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13bc89c433dbe0f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13bc89c433dbe0f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13bc89c433dbe0f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $13bc89c433dbe0f6$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $13bc89c433dbe0f6$export$db83999c14438df4 = (0, $kBUhU.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($13bc89c433dbe0f6$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $13bc89c433dbe0f6$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $13bc89c433dbe0f6$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($13bc89c433dbe0f6$var$isOptional(key) && !node.attrs[key]) return obj;
            return $13bc89c433dbe0f6$var$_objectSpread($13bc89c433dbe0f6$var$_objectSpread({}, obj), {}, (0, $lUar6.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("4wcds", function(module, exports) {
$parcel$export(module.exports, "table", function () { return $34a3a0721ccc3dd1$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableToJSON", function () { return $34a3a0721ccc3dd1$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $34a3a0721ccc3dd1$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $34a3a0721ccc3dd1$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $34a3a0721ccc3dd1$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $34a3a0721ccc3dd1$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $34a3a0721ccc3dd1$export$2af48797a1010bb1; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $34a3a0721ccc3dd1$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $34a3a0721ccc3dd1$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $34a3a0721ccc3dd1$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $34a3a0721ccc3dd1$export$2a5a518232fa1a97; });

var $f2kyT = parcelRequire("f2kyT");

var $lUar6 = parcelRequire("lUar6");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $6BQ2f = parcelRequire("6BQ2f");

var $lLlF4 = parcelRequire("lLlF4");

var $kBUhU = parcelRequire("kBUhU");
function $34a3a0721ccc3dd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34a3a0721ccc3dd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34a3a0721ccc3dd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34a3a0721ccc3dd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $34a3a0721ccc3dd1$export$9cfceb893b24742a = 'pm-table';
var $34a3a0721ccc3dd1$export$69cb4c3f80383763 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-content-wrap");
var $34a3a0721ccc3dd1$export$7b07d37d879c957f = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-header-content-wrap");
var $34a3a0721ccc3dd1$export$8dd42a84cd52da07 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $34a3a0721ccc3dd1$export$5e26a5c19f0865d8 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $aZMvy.N20).toLocaleLowerCase();
var $34a3a0721ccc3dd1$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    widthAttr && /^[0-9]+(,[0-9]+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $aZMvy.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $aZMvy.isRgb)(backgroundColor)) {
        var result = (0, $aZMvy.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $34a3a0721ccc3dd1$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $34a3a0721ccc3dd1$var$testGlobalTheme;
var $34a3a0721ccc3dd1$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $34a3a0721ccc3dd1$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $34a3a0721ccc3dd1$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($34a3a0721ccc3dd1$var$testGlobalTheme) return {
        colorMode: $34a3a0721ccc3dd1$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
var $34a3a0721ccc3dd1$var$cssVariablePattern = /^var\(--(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\)$/;
var $34a3a0721ccc3dd1$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $aZMvy.isRgb)(background) && (0, $aZMvy.rgbToHex)(background) ? (0, $aZMvy.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $2UMkY.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $34a3a0721ccc3dd1$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($34a3a0721ccc3dd1$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $lLlF4.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $34a3a0721ccc3dd1$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $34a3a0721ccc3dd1$export$7b07d37d879c957f;
    else attrs.class = $34a3a0721ccc3dd1$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $34a3a0721ccc3dd1$export$219b7f492ad209f8 = new Map();
var $34a3a0721ccc3dd1$export$95e9c925fbf01d1c = (0, $aZMvy.hexToRgba)((0, $aZMvy.N800), 0.12) || (0, $aZMvy.N0);
var $34a3a0721ccc3dd1$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $aZMvy.N0),
        'White'
    ],
    [
        (0, $aZMvy.B50),
        'Light blue'
    ],
    [
        (0, $aZMvy.T50),
        'Light teal'
    ],
    [
        (0, $aZMvy.G50),
        'Light green'
    ],
    [
        (0, $aZMvy.Y50),
        'Light yellow'
    ],
    [
        (0, $aZMvy.R50),
        'Light red'
    ],
    [
        (0, $aZMvy.P50),
        'Light purple'
    ],
    [
        (0, $aZMvy.N20),
        'Light gray'
    ],
    [
        (0, $aZMvy.B75),
        'Blue'
    ],
    [
        (0, $aZMvy.T75),
        'Teal'
    ],
    [
        (0, $aZMvy.G75),
        'Green'
    ],
    [
        (0, $aZMvy.Y75),
        'Yellow'
    ],
    [
        (0, $aZMvy.R75),
        'Red'
    ],
    [
        (0, $aZMvy.P75),
        'Purple'
    ],
    [
        (0, $aZMvy.N60),
        'Gray'
    ],
    [
        (0, $aZMvy.B100),
        'Dark blue'
    ],
    [
        (0, $aZMvy.T100),
        'Dark teal'
    ],
    [
        (0, $aZMvy.G200),
        'Dark green'
    ],
    [
        (0, $aZMvy.Y200),
        'Dark yellow'
    ],
    [
        (0, $aZMvy.R100),
        'Dark red'
    ],
    [
        (0, $aZMvy.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $f2kyT.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $34a3a0721ccc3dd1$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $34a3a0721ccc3dd1$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $6BQ2f.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
var $34a3a0721ccc3dd1$var$createTableSpec = function createTableSpec() {
    return (0, $kBUhU.table)($34a3a0721ccc3dd1$var$tableNodeSpecOptions);
};
var $34a3a0721ccc3dd1$export$9852986a3ec5f6a0 = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$export$90e634fbace1f0c4 = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$export$3862de5c8c9098cf = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $34a3a0721ccc3dd1$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $34a3a0721ccc3dd1$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $34a3a0721ccc3dd1$var$_objectSpread($34a3a0721ccc3dd1$var$_objectSpread({}, obj), {}, (0, $lUar6.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $34a3a0721ccc3dd1$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$ce666bf02318c957 = (0, $kBUhU.tableRow)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptions);
var $34a3a0721ccc3dd1$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $34a3a0721ccc3dd1$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(dom) {
                return $34a3a0721ccc3dd1$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$e1e720e5f4603e6a = (0, $kBUhU.tableCell)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($34a3a0721ccc3dd1$var$cellAttrs[key] && $34a3a0721ccc3dd1$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    background: $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$48884d2a5190dc73 = (0, $kBUhU.tableHeader)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2af48797a1010bb1 = $34a3a0721ccc3dd1$export$2ac34c099660f1a8;
var $34a3a0721ccc3dd1$export$ce086a560a1d05f5 = (0, $kBUhU.tableWithNestedTable)($34a3a0721ccc3dd1$var$tableNodeSpecOptions);
var $34a3a0721ccc3dd1$export$7d657479499397 = (0, $kBUhU.tableRowWithNestedTable)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptions);
var $34a3a0721ccc3dd1$export$abf39ca178940ff3 = (0, $kBUhU.tableCellWithNestedTable)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2a5a518232fa1a97 = (0, $kBUhU.tableHeaderWithNestedTable)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$c8f0853ac97552c9 = (0, $kBUhU.tableRow)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    localId: (0, $6BQ2f.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$db76cfd28a574029 = (0, $kBUhU.tableCell)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    background: $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $6BQ2f.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$b82d2b1d8824143d = (0, $kBUhU.tableHeader)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$27926e30c8a74147 = (0, $kBUhU.tableRowWithNestedTable)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$e9fd700fafee293a = (0, $kBUhU.tableCellWithNestedTable)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$7928c3aeb4cd2213 = (0, $kBUhU.tableHeaderWithNestedTable)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("2UMkY", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $21f64e82aeeb03f5$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $21f64e82aeeb03f5$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $21f64e82aeeb03f5$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $21f64e82aeeb03f5$export$a270511a0e7fd61a; });
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $21f64e82aeeb03f5$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $21f64e82aeeb03f5$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $21f64e82aeeb03f5$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $21f64e82aeeb03f5$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $21f64e82aeeb03f5$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $21f64e82aeeb03f5$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $21f64e82aeeb03f5$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = hexColor ? $21f64e82aeeb03f5$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $21f64e82aeeb03f5$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("lLlF4", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $fd7eca4049a3fec7$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $fd7eca4049a3fec7$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $fd7eca4049a3fec7$var$expandShorthandHex = function expandShorthandHex(input) {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    input.replace(/^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    }));
};
var $fd7eca4049a3fec7$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $fd7eca4049a3fec7$var$expandShorthandHex(input);
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var result = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $fd7eca4049a3fec7$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $fd7eca4049a3fec7$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $fd7eca4049a3fec7$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $fd7eca4049a3fec7$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $fd7eca4049a3fec7$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $fd7eca4049a3fec7$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $fd7eca4049a3fec7$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $fd7eca4049a3fec7$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $fd7eca4049a3fec7$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $fd7eca4049a3fec7$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $fd7eca4049a3fec7$var$rgbToLch = function rgbToLch(rgb) {
    return $fd7eca4049a3fec7$var$labToLch($fd7eca4049a3fec7$var$xyzToLab($fd7eca4049a3fec7$var$rgbToXyz(rgb)));
};
var $fd7eca4049a3fec7$var$lchToRgb = function lchToRgb(lch) {
    return $fd7eca4049a3fec7$var$xyzToRgb($fd7eca4049a3fec7$var$labToXyz($fd7eca4049a3fec7$var$lchToLab(lch)));
};
var $fd7eca4049a3fec7$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $fd7eca4049a3fec7$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $fd7eca4049a3fec7$var$rgbToLch(rgb);
    lch.l = $fd7eca4049a3fec7$var$clamp(newPercent, 0, 100);
    return $fd7eca4049a3fec7$var$rgbToHex($fd7eca4049a3fec7$var$lchToRgb(lch));
};
var $fd7eca4049a3fec7$var$getLightness = function getLightness(color) {
    var rgb = $fd7eca4049a3fec7$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $fd7eca4049a3fec7$var$rgbToLch(rgb);
    return lch.l;
};
var $fd7eca4049a3fec7$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $fd7eca4049a3fec7$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $fd7eca4049a3fec7$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kbSWt", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $eb2f74121992e86c$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $eb2f74121992e86c$export$1db618b7b2275ea1; });

var $dWJ7u = parcelRequire("dWJ7u");

var $3DDez = parcelRequire("3DDez");
var $eLCEH = parcelRequire("eLCEH");
var $eHCHz = parcelRequire("eHCHz");
var $6YP3g = parcelRequire("6YP3g");
var $4wcds = parcelRequire("4wcds");

var $k7PLp = parcelRequire("k7PLp");
var $eb2f74121992e86c$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $eb2f74121992e86c$export$e4e3ac1fa64862db = $eb2f74121992e86c$var$getDefaultSchemaConfig();
var $eb2f74121992e86c$export$fd147e7d448dea03 = (0, $dWJ7u.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $eb2f74121992e86c$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $eHCHz.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $eLCEH.multiBodiedExtension),
        extensionFrame: (0, $eLCEH.extensionFrame),
        expand: (0, $3DDez.expandWithNestedExpand),
        listItem: (0, $6YP3g.listItemWithDecisionStage0),
        table: (0, $4wcds.tableWithNestedTable),
        tableRow: (0, $4wcds.tableRowWithNestedTable),
        tableCell: (0, $4wcds.tableCellWithNestedTable),
        tableHeader: (0, $4wcds.tableHeaderWithNestedTable)
    };
    return (0, $k7PLp.createSchema)(defaultSchemaConfig);
});
var $eb2f74121992e86c$export$1db618b7b2275ea1 = $eb2f74121992e86c$export$fd147e7d448dea03();

});
parcelRegister("eLCEH", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", function () { return $ac0370a394496a48$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $ac0370a394496a48$export$c3c04d555a8b9013; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $ac0370a394496a48$export$4fdcae991fd743e7 = (0, $kBUhU.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ac0370a394496a48$export$c3c04d555a8b9013 = (0, $kBUhU.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("2GR0h", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", function () { return $1f589e6c6e605bbe$export$1765e2758fc47004; });
var $1f589e6c6e605bbe$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $1f589e6c6e605bbe$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $1f589e6c6e605bbe$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("eHCHz", function(module, exports) {
$parcel$export(module.exports, "layoutSection", function () { return $ab431a2eeda26515$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $ab431a2eeda26515$export$4f9d8f623ff17117; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $ab431a2eeda26515$export$b3b6a70a7fa4a5be = (0, $kBUhU.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$cdae19acb0a520fd = (0, $kBUhU.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$4f9d8f623ff17117 = (0, $kBUhU.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$d9d3c69a64270b13 = (0, $kBUhU.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $6BQ2f.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$64facded20dfd85c = (0, $kBUhU.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $6BQ2f.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6YP3g", function(module, exports) {
$parcel$export(module.exports, "listItem", function () { return $514ff277bc4bfcb0$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $514ff277bc4bfcb0$export$b2cd54d5ce935ddb; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $514ff277bc4bfcb0$export$76c7e83ecc9cdf05 = (0, $kBUhU.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$483d52f09158e61c = (0, $kBUhU.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$b2cd54d5ce935ddb = (0, $kBUhU.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$394466eb252d967a = (0, $kBUhU.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("k7PLp", function(module, exports) {
$parcel$export(module.exports, "createSchema", function () { return $ea6c9d424e7ad31d$export$5f4ce795563f4211; });

var $bttvD = parcelRequire("bttvD");

var $8nxpJ = parcelRequire("8nxpJ");

var $qsOOQ = parcelRequire("qsOOQ");

var $lViup = parcelRequire("lViup");
var $eqTLo = parcelRequire("eqTLo");
var $eDSjJ = parcelRequire("eDSjJ");
var $aeCl0 = parcelRequire("aeCl0");
var $katgg = parcelRequire("katgg");
var $jFxRM = parcelRequire("jFxRM");
var $lKBoM = parcelRequire("lKBoM");
var $9IIGI = parcelRequire("9IIGI");
var $149IY = parcelRequire("149IY");
var $2fgwX = parcelRequire("2fgwX");
var $8fG3I = parcelRequire("8fG3I");
var $iq9Qk = parcelRequire("iq9Qk");
var $ePva4 = parcelRequire("ePva4");
var $lRUiz = parcelRequire("lRUiz");
var $39DbY = parcelRequire("39DbY");
var $Zlz1l = parcelRequire("Zlz1l");
var $1dh1S = parcelRequire("1dh1S");
var $de0jf = parcelRequire("de0jf");
var $lJr9t = parcelRequire("lJr9t");
var $eLNZQ = parcelRequire("eLNZQ");

var $jfFQb = parcelRequire("jfFQb");
var $dHPQp = parcelRequire("dHPQp");
var $dBvx2 = parcelRequire("dBvx2");
var $fQxiN = parcelRequire("fQxiN");
var $grATT = parcelRequire("grATT");
var $wMi1h = parcelRequire("wMi1h");
var $fyWnE = parcelRequire("fyWnE");
var $5I8NU = parcelRequire("5I8NU");
var $cKqLv = parcelRequire("cKqLv");
var $dpTXx = parcelRequire("dpTXx");
var $2KJuI = parcelRequire("2KJuI");
var $aZXDV = parcelRequire("aZXDV");
var $2q06n = parcelRequire("2q06n");
var $3Jgg7 = parcelRequire("3Jgg7");
var $6fNob = parcelRequire("6fNob");
var $dHtch = parcelRequire("dHtch");
var $3DDez = parcelRequire("3DDez");
var $aR5Ot = parcelRequire("aR5Ot");
var $lda36 = parcelRequire("lda36");
var $4yVpE = parcelRequire("4yVpE");
var $eLCEH = parcelRequire("eLCEH");
var $l33q8 = parcelRequire("l33q8");
var $aTrNU = parcelRequire("aTrNU");
var $7VNHO = parcelRequire("7VNHO");
var $dBZQS = parcelRequire("dBZQS");
var $3Xv5B = parcelRequire("3Xv5B");
var $aVWaY = parcelRequire("aVWaY");
var $eHCHz = parcelRequire("eHCHz");
var $6YP3g = parcelRequire("6YP3g");
var $4LvHO = parcelRequire("4LvHO");
var $3VwoG = parcelRequire("3VwoG");
var $2QkN1 = parcelRequire("2QkN1");
var $ePmJY = parcelRequire("ePmJY");
var $1H3wm = parcelRequire("1H3wm");
var $8J4kG = parcelRequire("8J4kG");
var $jPLYd = parcelRequire("jPLYd");
var $cpq1I = parcelRequire("cpq1I");
var $78PuG = parcelRequire("78PuG");
var $hgqzw = parcelRequire("hgqzw");
var $39Ojv = parcelRequire("39Ojv");
var $cJpLB = parcelRequire("cJpLB");
var $4wcds = parcelRequire("4wcds");
var $b9bGn = parcelRequire("b9bGn");
var $g9gj0 = parcelRequire("g9gj0");
var $5ilw1 = parcelRequire("5ilw1");
var $eeCoC = parcelRequire("eeCoC");
var $73gy7 = parcelRequire("73gy7");
function $ea6c9d424e7ad31d$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ea6c9d424e7ad31d$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $ea6c9d424e7ad31d$var$markGroupDeclarations = [
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.COLOR)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.FONT_STYLE)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.SEARCH_QUERY)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.LINK))
];
var $ea6c9d424e7ad31d$var$markGroupDeclarationsNames = $ea6c9d424e7ad31d$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $ea6c9d424e7ad31d$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $3Jgg7.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $cpq1I.paragraph)
    },
    {
        name: 'text',
        spec: (0, $g9gj0.text)
    },
    {
        name: 'bulletList',
        spec: (0, $grATT.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $jPLYd.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $6YP3g.listItem)
    },
    {
        name: 'heading',
        spec: (0, $aTrNU.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aR5Ot.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $fyWnE.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $lda36.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $hgqzw.rule)
    },
    {
        name: 'image',
        spec: (0, $7VNHO.image)
    },
    {
        name: 'mention',
        spec: (0, $1H3wm.mention)
    },
    {
        name: 'caption',
        spec: (0, $wMi1h.caption)
    },
    {
        name: 'media',
        spec: (0, $4LvHO.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $3VwoG.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $ePmJY.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $2QkN1.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $78PuG.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $eHCHz.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $aVWaY.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $l33q8.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $dHtch.emoji)
    },
    {
        name: 'table',
        spec: (0, $4wcds.table)
    },
    {
        name: 'tableCell',
        spec: (0, $4wcds.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $4wcds.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $4wcds.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $5I8NU.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $dpTXx.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $cKqLv.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $2q06n.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $aZXDV.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $b9bGn.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $dHPQp.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $dHPQp.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $2KJuI.date)
    },
    {
        name: 'status',
        spec: (0, $39Ojv.status)
    },
    {
        name: 'expand',
        spec: (0, $3DDez.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $8J4kG.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $4yVpE.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $3Xv5B.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $dBvx2.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $eLCEH.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $eLCEH.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $dBZQS.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $jfFQb.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $6fNob.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $cJpLB.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $fQxiN.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $5ilw1.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $eeCoC.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $73gy7.unsupportedInline)
    }
];
var $ea6c9d424e7ad31d$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $iq9Qk.link)
    },
    {
        name: 'em',
        spec: (0, $149IY.em)
    },
    {
        name: 'strong',
        spec: (0, $lRUiz.strong)
    },
    {
        name: 'textColor',
        spec: (0, $Zlz1l.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $eDSjJ.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $ePva4.strike)
    },
    {
        name: 'subsup',
        spec: (0, $39DbY.subsup)
    },
    {
        name: 'underline',
        spec: (0, $de0jf.underline)
    },
    {
        name: 'code',
        spec: (0, $jFxRM.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $1dh1S.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $lViup.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $eqTLo.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $lKBoM.confluenceInlineComment)
    }
].concat($ea6c9d424e7ad31d$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $katgg.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $9IIGI.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $2fgwX.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $8fG3I.indentation)
    },
    {
        name: 'border',
        spec: (0, $aeCl0.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $lJr9t.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $eLNZQ.unsupportedNodeAttribute)
    }
]);
function $ea6c9d424e7ad31d$export$2d0c32a809131488() {
    var nodes = $ea6c9d424e7ad31d$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $ea6c9d424e7ad31d$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ea6c9d424e7ad31d$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ea6c9d424e7ad31d$var$markGroupDeclarationsNames);
    var nodes = $ea6c9d424e7ad31d$var$addItems($ea6c9d424e7ad31d$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $ea6c9d424e7ad31d$var$addItems($ea6c9d424e7ad31d$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $qsOOQ.sanitizeNodes)(nodes, marks);
    return new (0, $bttvD.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $ea6c9d424e7ad31d$export$c77b6d30da5276a1 = true;

});
parcelRegister("8nxpJ", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", function () { return $619a640b0a576b28$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $619a640b0a576b28$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $619a640b0a576b28$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $619a640b0a576b28$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $619a640b0a576b28$export$4498a6080fed604c = 'fontStyle';
var $619a640b0a576b28$export$f8e8a5f34f6ea725 = 'searchQuery';
var $619a640b0a576b28$export$b395009ca7f092c7 = 'link';
var $619a640b0a576b28$export$9b982809044276a6 = 'color';
var $619a640b0a576b28$export$470d0905851e47a1 = 'alignment';
var $619a640b0a576b28$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("qsOOQ", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", function () { return $04f8c89bec75d36a$export$daf54fed04c8fb77; });

var $lUar6 = parcelRequire("lUar6");
function $04f8c89bec75d36a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04f8c89bec75d36a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04f8c89bec75d36a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04f8c89bec75d36a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04f8c89bec75d36a$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $04f8c89bec75d36a$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $04f8c89bec75d36a$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $04f8c89bec75d36a$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var content = rawContent.replace(/(?:[\0-\/:-@\[-\^`\{-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$04f8c89bec75d36a$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $04f8c89bec75d36a$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $04f8c89bec75d36a$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    if (!content || !content.match(/[0-9A-Z_a-z]/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $04f8c89bec75d36a$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("lViup", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $ff5d4378310d3090$export$8e53000a4ec837; });

var $OQ9bg = parcelRequire("OQ9bg");
var $ff5d4378310d3090$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $ff5d4378310d3090$export$8e53000a4ec837 = (0, $OQ9bg.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("eqTLo", function(module, exports) {
$parcel$export(module.exports, "annotation", function () { return $a81ebfd802732664$export$8512c9afa7b24c3b; });

var $lUar6 = parcelRequire("lUar6");

var $OQ9bg = parcelRequire("OQ9bg");
function $a81ebfd802732664$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a81ebfd802732664$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a81ebfd802732664$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a81ebfd802732664$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a81ebfd802732664$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $a81ebfd802732664$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $a81ebfd802732664$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $a81ebfd802732664$var$_objectSpread($a81ebfd802732664$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $a81ebfd802732664$export$8512c9afa7b24c3b = (0, $OQ9bg.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            $a81ebfd802732664$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $a81ebfd802732664$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("eDSjJ", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", function () { return $aa8ed7783527849f$export$8c5a050822fd698c; });

var $lUar6 = parcelRequire("lUar6");

var $f2kyT = parcelRequire("f2kyT");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $Zlz1l = parcelRequire("Zlz1l");

var $lLlF4 = parcelRequire("lLlF4");
/**
 * @name backgroundColor_mark
 */ var $aa8ed7783527849f$var$colorArrayPalette = [
    [
        (0, $aZMvy.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $aZMvy.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $aZMvy.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $aZMvy.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $aZMvy.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $aZMvy.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $aZMvy.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $aa8ed7783527849f$export$14ec3f21a268e497 = new Map();
$aa8ed7783527849f$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $f2kyT.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $aa8ed7783527849f$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $aa8ed7783527849f$export$8c5a050822fd698c = (0, $OQ9bg.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/i)) hexColor = (0, $aZMvy.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $aa8ed7783527849f$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $aa8ed7783527849f$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $2UMkY.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $Zlz1l.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lLlF4.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $lUar6.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("Zlz1l", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $0b866cc042f3effc$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $0b866cc042f3effc$export$32f78bffcd82ff28; });

var $lUar6 = parcelRequire("lUar6");

var $f2kyT = parcelRequire("f2kyT");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $lLlF4 = parcelRequire("lLlF4");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $0b866cc042f3effc$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $aZMvy.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $aZMvy.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $aZMvy.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $aZMvy.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $aZMvy.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $aZMvy.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $aZMvy.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $aZMvy.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $aZMvy.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $aZMvy.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $aZMvy.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $aZMvy.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $aZMvy.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $aZMvy.N0),
        'White'
    ],
    [
        (0, $aZMvy.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $aZMvy.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $aZMvy.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $aZMvy.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $aZMvy.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $aZMvy.P50),
        'Light purple'
    ] // Lavender secret
];
var $0b866cc042f3effc$export$569885e57444f84a = new Map();
var $0b866cc042f3effc$export$81e5ed9e84fe2e28 = $0b866cc042f3effc$export$569885e57444f84a;
$0b866cc042f3effc$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $f2kyT.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $0b866cc042f3effc$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $0b866cc042f3effc$var$testGlobalTheme;
var $0b866cc042f3effc$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $0b866cc042f3effc$var$testGlobalTheme = theme;
};
var $0b866cc042f3effc$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($0b866cc042f3effc$var$testGlobalTheme) return {
        colorMode: $0b866cc042f3effc$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $0b866cc042f3effc$export$32f78bffcd82ff28 = (0, $OQ9bg.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/i)) hexColor = (0, $aZMvy.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $0b866cc042f3effc$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $0b866cc042f3effc$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $2UMkY.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($0b866cc042f3effc$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lLlF4.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $lUar6.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("aeCl0", function(module, exports) {
$parcel$export(module.exports, "border", function () { return $7738f34574ff31cd$export$1edee58a52776cd9; });

var $f2kyT = parcelRequire("f2kyT");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $7738f34574ff31cd$var$borderColorArrayPalette = [
    [
        (0, $aZMvy.N300A),
        'Subtle gray'
    ],
    [
        (0, $aZMvy.N600),
        'Gray'
    ],
    [
        (0, $aZMvy.N1000),
        'Bold gray'
    ]
];
var $7738f34574ff31cd$export$e4e044c989c86ca7 = new Map();
$7738f34574ff31cd$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $f2kyT.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $7738f34574ff31cd$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $7738f34574ff31cd$export$1edee58a52776cd9 = (0, $OQ9bg.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $7738f34574ff31cd$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $2UMkY.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("katgg", function(module, exports) {
$parcel$export(module.exports, "breakout", function () { return $eaeb7080edf270d8$export$89015c65f1c75e3f; });

var $OQ9bg = parcelRequire("OQ9bg");
var $eaeb7080edf270d8$var$allowedTypes = [
    'wide',
    'full-width'
];
var $eaeb7080edf270d8$export$89015c65f1c75e3f = (0, $OQ9bg.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var width = dom.getAttribute('data-width');
                return {
                    mode: $eaeb7080edf270d8$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("jFxRM", function(module, exports) {
$parcel$export(module.exports, "code", function () { return $e51c1dd89f868438$export$6565f9f03506010b; });

var $OQ9bg = parcelRequire("OQ9bg");
var $e51c1dd89f868438$export$6565f9f03506010b = (0, $OQ9bg.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("lKBoM", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", function () { return $fd5ae774e492cbd0$export$f3b72f8fc4684ecd; });

var $OQ9bg = parcelRequire("OQ9bg");
var $fd5ae774e492cbd0$export$f3b72f8fc4684ecd = (0, $OQ9bg.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("149IY", function(module, exports) {
$parcel$export(module.exports, "em", function () { return $0c6db53f9b172194$export$c63c6f932822f543; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name em_mark
 */ var $0c6db53f9b172194$var$emDOM = [
    'em'
];
var $0c6db53f9b172194$export$c63c6f932822f543 = (0, $OQ9bg.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $0c6db53f9b172194$var$emDOM;
    }
});

});

parcelRegister("8fG3I", function(module, exports) {
$parcel$export(module.exports, "indentation", function () { return $60205976bca5c29c$export$480c699bd4ec0d86; });

var $OQ9bg = parcelRequire("OQ9bg");
var $60205976bca5c29c$export$480c699bd4ec0d86 = (0, $OQ9bg.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("ePva4", function(module, exports) {
$parcel$export(module.exports, "strike", function () { return $acbe001eb860a86f$export$4899a95d70ec5056; });

var $OQ9bg = parcelRequire("OQ9bg");
var $acbe001eb860a86f$export$4899a95d70ec5056 = (0, $OQ9bg.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("lRUiz", function(module, exports) {
$parcel$export(module.exports, "strong", function () { return $feba37ec3f8aad5d$export$59ae2c325a998f89; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name strong_mark
 */ var $feba37ec3f8aad5d$var$strongDOM = [
    'strong'
];
var $feba37ec3f8aad5d$export$59ae2c325a998f89 = (0, $OQ9bg.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                /^(bold(er)?|[5-9][0-9]{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $feba37ec3f8aad5d$var$strongDOM;
    }
});

});

parcelRegister("39DbY", function(module, exports) {
$parcel$export(module.exports, "subsup", function () { return $24c09d1d6ea6d075$export$b3401ee80eb31041; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name subsup_mark
 */ function $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $24c09d1d6ea6d075$export$b3401ee80eb31041 = (0, $OQ9bg.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("1dh1S", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", function () { return $0e2437049c3b0f36$export$20af3dabbb5538df; });

var $OQ9bg = parcelRequire("OQ9bg");

var $aZMvy = parcelRequire("aZMvy");
var $0e2437049c3b0f36$export$20af3dabbb5538df = (0, $OQ9bg.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $aZMvy.B400))
            }
        ];
    }
});

});

parcelRegister("de0jf", function(module, exports) {
$parcel$export(module.exports, "underline", function () { return $9a0cd29a25afdc99$export$425327af25286e5e; });

var $OQ9bg = parcelRequire("OQ9bg");
var $9a0cd29a25afdc99$export$425327af25286e5e = (0, $OQ9bg.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("lJr9t", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", function () { return $fd22dcbfd05bcd11$export$30d78d5eb6719bb8; });

var $OQ9bg = parcelRequire("OQ9bg");
var $fd22dcbfd05bcd11$export$30d78d5eb6719bb8 = (0, $OQ9bg.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("eLNZQ", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $ac0c3cb7d961af14$export$a316dc07ff5182a2; });

var $OQ9bg = parcelRequire("OQ9bg");
var $ac0c3cb7d961af14$export$a316dc07ff5182a2 = (0, $OQ9bg.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("jfFQb", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $e03fdfbd636871f3$export$c4c2f833baaebdb8; });

var $lUar6 = parcelRequire("lUar6");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $e03fdfbd636871f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e03fdfbd636871f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e03fdfbd636871f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e03fdfbd636871f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $e03fdfbd636871f3$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $e03fdfbd636871f3$export$c4c2f833baaebdb8 = (0, $kBUhU.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $e03fdfbd636871f3$export$9894f24949f094e5 = (0, $kBUhU.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread($e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread($e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("dHPQp", function(module, exports) {
$parcel$export(module.exports, "taskItem", function () { return $9fa781b495273e5b$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $9fa781b495273e5b$export$16018c61064a18df; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $9fa781b495273e5b$export$6d8b0ef52e2e6390 = (0, $kBUhU.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $9fa781b495273e5b$export$16018c61064a18df = (0, $kBUhU.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("dBvx2", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", function () { return $9e7730a4b2106468$export$27903d543b563e39; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $9e7730a4b2106468$export$27903d543b563e39 = (0, $kBUhU.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("fQxiN", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", function () { return $b8958b758a1b7049$export$e92c7e4302dd4371; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $b8958b758a1b7049$export$e92c7e4302dd4371 = (0, $kBUhU.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $6BQ2f.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("grATT", function(module, exports) {
$parcel$export(module.exports, "bulletList", function () { return $bf8bca9abf8d97db$export$a140c94e5ea26bee; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $bf8bca9abf8d97db$export$5f25a39efab3b58b = '.ak-ul';
var $bf8bca9abf8d97db$export$a140c94e5ea26bee = (0, $kBUhU.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $bf8bca9abf8d97db$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $bf8bca9abf8d97db$export$dfd406053b2bab40 = (0, $kBUhU.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $bf8bca9abf8d97db$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("wMi1h", function(module, exports) {
$parcel$export(module.exports, "caption", function () { return $06287297074aca32$export$8e3c2dfdc4f0453d; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $06287297074aca32$export$8e3c2dfdc4f0453d = (0, $kBUhU.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $06287297074aca32$export$b5d01ee303c467aa = (0, $kBUhU.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5I8NU", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $4287e418276ba27e$export$daf889beb5092f95; });

var $kBUhU = parcelRequire("kBUhU");
var $4287e418276ba27e$var$name = 'confluenceJiraIssue';
var $4287e418276ba27e$export$daf889beb5092f95 = (0, $kBUhU.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($4287e418276ba27e$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $4287e418276ba27e$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("cKqLv", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $947e8aef475ca4d4$export$e6e4878f43c27cab; });

var $kBUhU = parcelRequire("kBUhU");
var $947e8aef475ca4d4$var$name = 'confluenceUnsupportedBlock';
var $947e8aef475ca4d4$export$e6e4878f43c27cab = (0, $kBUhU.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $947e8aef475ca4d4$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($947e8aef475ca4d4$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("dpTXx", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $9c49048265b07d88$export$3e6d667072febc87; });

var $kBUhU = parcelRequire("kBUhU");
var $9c49048265b07d88$var$name = 'confluenceUnsupportedInline';
var $9c49048265b07d88$export$3e6d667072febc87 = (0, $kBUhU.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $9c49048265b07d88$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($9c49048265b07d88$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("2KJuI", function(module, exports) {
$parcel$export(module.exports, "date", function () { return $20132aea72923886$export$324d90190a8b822a; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $20132aea72923886$export$324d90190a8b822a = (0, $kBUhU.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $20132aea72923886$export$a6a035390e3921b2 = (0, $kBUhU.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("aZXDV", function(module, exports) {
$parcel$export(module.exports, "decisionItem", function () { return $801dddbb6e0d9d35$export$6959e16eeff859b4; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $801dddbb6e0d9d35$export$6959e16eeff859b4 = (0, $kBUhU.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2q06n", function(module, exports) {
$parcel$export(module.exports, "decisionList", function () { return $1c2e16afbd841b4f$export$62d45a65fb43d95e; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name decisionList_node
 */ var $1c2e16afbd841b4f$var$name = 'decisionList';
var $1c2e16afbd841b4f$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($1c2e16afbd841b4f$var$name, "\"]");
var $1c2e16afbd841b4f$export$62d45a65fb43d95e = (0, $kBUhU.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($1c2e16afbd841b4f$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $1c2e16afbd841b4f$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3Jgg7", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return $2b722fc6cb2eb975$export$2a111da947c407d2; });

var $kBUhU = parcelRequire("kBUhU");
var $2b722fc6cb2eb975$export$2a111da947c407d2 = (0, $kBUhU.doc)({});

});

parcelRegister("6fNob", function(module, exports) {
$parcel$export(module.exports, "embedCard", function () { return $48da746e37eea934$export$be4283d9a1cb1ff6; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $48da746e37eea934$export$be4283d9a1cb1ff6 = (0, $kBUhU.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $48da746e37eea934$export$36734475a7f6fd3e = (0, $kBUhU.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("dHtch", function(module, exports) {
$parcel$export(module.exports, "emoji", function () { return $9f95f07164466464$export$a19185d1233fc4b2; });

var $lUar6 = parcelRequire("lUar6");

var $axSHw = parcelRequire("axSHw");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $9f95f07164466464$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f95f07164466464$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f95f07164466464$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f95f07164466464$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f95f07164466464$export$a19185d1233fc4b2 = (0, $kBUhU.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: function getAttrs(dom) {
                return (0, $axSHw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: function getAttrs(dom) {
                return (0, $axSHw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $9f95f07164466464$export$ebb3b3c7a0ac9936 = (0, $kBUhU.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var attrs = (0, $axSHw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return $9f95f07164466464$var$_objectSpread($9f95f07164466464$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var attrs = (0, $axSHw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return $9f95f07164466464$var$_objectSpread($9f95f07164466464$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("axSHw", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", function () { return $7ad76af1549a6439$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $7ad76af1549a6439$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $7ad76af1549a6439$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $7ad76af1549a6439$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $7ad76af1549a6439$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $7ad76af1549a6439$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $7ad76af1549a6439$export$f61e93bda2a8b420(acName) {
    var emojiData = $7ad76af1549a6439$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $7ad76af1549a6439$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $7ad76af1549a6439$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $7ad76af1549a6439$var$acNameToEmojiMap[acName] ? $7ad76af1549a6439$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($7ad76af1549a6439$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $7ad76af1549a6439$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($7ad76af1549a6439$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $7ad76af1549a6439$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $7ad76af1549a6439$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($7ad76af1549a6439$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $7ad76af1549a6439$var$getAcNameFromShortName(shortName);
        if (possibleName in $7ad76af1549a6439$var$acNameToEmojiMap) return possibleName;
    }
    return $7ad76af1549a6439$export$bc94e44ec0e7bd82(id) || $7ad76af1549a6439$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aR5Ot", function(module, exports) {
$parcel$export(module.exports, "extendedBlockquote", function () { return $7e735cffb94e92ad$export$70a64939da3e8455; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name blockquote_node
 */ var $7e735cffb94e92ad$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $7e735cffb94e92ad$export$67dc04e652a298ca = (0, $kBUhU.blockquoteLegacy)($7e735cffb94e92ad$var$nodeSpecOptions);
var $7e735cffb94e92ad$export$70a64939da3e8455 = (0, $kBUhU.blockquote)($7e735cffb94e92ad$var$nodeSpecOptions);
var $7e735cffb94e92ad$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $7e735cffb94e92ad$export$950ebf43f3364a0f = (0, $kBUhU.blockquote)($7e735cffb94e92ad$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("lda36", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", function () { return $f7129b68d5729e85$export$ce20b13564211141; });

var $lUar6 = parcelRequire("lUar6");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $f7129b68d5729e85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7129b68d5729e85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7129b68d5729e85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7129b68d5729e85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7129b68d5729e85$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $f7129b68d5729e85$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $f7129b68d5729e85$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $6BQ2f.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $f7129b68d5729e85$var$_objectSpread($f7129b68d5729e85$var$_objectSpread({}, parseDOMAttrs), {}, {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $f7129b68d5729e85$export$969277cf61e5a7aa.CUSTOM ? $f7129b68d5729e85$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $f7129b68d5729e85$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $f7129b68d5729e85$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $f7129b68d5729e85$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $f7129b68d5729e85$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $kBUhU.panel)($f7129b68d5729e85$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $f7129b68d5729e85$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $kBUhU.panel)($f7129b68d5729e85$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("4yVpE", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $3526df607b0b4ee6$export$1b45514b112dd749; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $3526df607b0b4ee6$export$1b45514b112dd749 = (0, $kBUhU.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("l33q8", function(module, exports) {
$parcel$export(module.exports, "hardBreak", function () { return $f52c880409f7bf31$export$371da9dd35aba193; });

var $kBUhU = parcelRequire("kBUhU");
var $f52c880409f7bf31$export$371da9dd35aba193 = (0, $kBUhU.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("aTrNU", function(module, exports) {
$parcel$export(module.exports, "heading", function () { return $7ee49bb676798a43$export$46e4a324ac90507f; });

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $7ee49bb676798a43$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        return {
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        };
    };
};
var $7ee49bb676798a43$export$46e4a324ac90507f = (0, $kBUhU.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $7ee49bb676798a43$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $7ee49bb676798a43$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $7ee49bb676798a43$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $7ee49bb676798a43$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $7ee49bb676798a43$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $7ee49bb676798a43$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("7VNHO", function(module, exports) {
$parcel$export(module.exports, "image", function () { return $5c6469c2f55f0d70$export$5c452ff88e35e47d; });

var $kBUhU = parcelRequire("kBUhU");
var $5c6469c2f55f0d70$export$5c452ff88e35e47d = (0, $kBUhU.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("dBZQS", function(module, exports) {
$parcel$export(module.exports, "inlineCard", function () { return $9e8eb58be9f16dec$export$cbf8224b64e0d942; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $9e8eb58be9f16dec$export$cbf8224b64e0d942 = (0, $kBUhU.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $9e8eb58be9f16dec$export$7ed775fc743eadd1 = (0, $kBUhU.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("3Xv5B", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", function () { return $2e1eff7ccb57379f$export$16b353b2649bd8d9; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $2e1eff7ccb57379f$export$16b353b2649bd8d9 = (0, $kBUhU.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("aVWaY", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", function () { return $7f5c5acfbe01ff0f$export$ab76e7c03cd6f650; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $7f5c5acfbe01ff0f$export$ab76e7c03cd6f650 = (0, $kBUhU.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $7f5c5acfbe01ff0f$export$b2e27d292505bac2 = (0, $kBUhU.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true'
        };
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("3VwoG", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", function () { return $2dbfd35fc907caf1$export$2855e964765eac9; });

var $kBUhU = parcelRequire("kBUhU");
var $2dbfd35fc907caf1$export$2855e964765eac9 = (0, $kBUhU.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("2QkN1", function(module, exports) {
$parcel$export(module.exports, "mediaInline", function () { return $21209080a47eb4ea$export$38bab695e3f720f1; });

var $lUar6 = parcelRequire("lUar6");

var $4LvHO = parcelRequire("4LvHO");

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
function $21209080a47eb4ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21209080a47eb4ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21209080a47eb4ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21209080a47eb4ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $21209080a47eb4ea$export$38bab695e3f720f1 = (0, $4LvHO.createMediaSpec)((0, $kBUhU.mediaInline)({}).attrs, true);
var $21209080a47eb4ea$export$aea8e9c496505c61 = (0, $4LvHO.createMediaSpec)($21209080a47eb4ea$var$_objectSpread($21209080a47eb4ea$var$_objectSpread({}, (0, $kBUhU.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $6BQ2f.uuid).generate()
    }
}), true, true);

});

parcelRegister("8J4kG", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", function () { return $65a5e3155290e500$export$63cadbf5f4296627; });

var $26Q8o = parcelRequire("26Q8o");

var $lUar6 = parcelRequire("lUar6");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $65a5e3155290e500$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65a5e3155290e500$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65a5e3155290e500$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65a5e3155290e500$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $65a5e3155290e500$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $6BQ2f.uuid).generate() : undefined
    };
}
var $65a5e3155290e500$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $65a5e3155290e500$export$63cadbf5f4296627 = (0, $kBUhU.nestedExpand)($65a5e3155290e500$var$nestedExpandFactoryOptions);
var $65a5e3155290e500$export$b854197485aa1fa0 = (0, $kBUhU.nestedExpand)($65a5e3155290e500$var$_objectSpread($65a5e3155290e500$var$_objectSpread({}, $65a5e3155290e500$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $26Q8o.default)($65a5e3155290e500$var$nestedExpandFactoryOptions.parseDOM || []), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("26Q8o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1894951b6eb74323$export$2e2bcd8739ae039; });

var $c2r4Q = parcelRequire("c2r4Q");

var $7WwP8 = parcelRequire("7WwP8");

var $2M5HD = parcelRequire("2M5HD");

var $6hUGC = parcelRequire("6hUGC");
function $1894951b6eb74323$export$2e2bcd8739ae039(r) {
    return (0, $c2r4Q.default)(r) || (0, $7WwP8.default)(r) || (0, $2M5HD.default)(r) || (0, $6hUGC.default)();
}

});
parcelRegister("c2r4Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8c3aace49f77f5d6$export$2e2bcd8739ae039; });

var $cqWE6 = parcelRequire("cqWE6");
function $8c3aace49f77f5d6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $cqWE6.default)(r);
}

});

parcelRegister("7WwP8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c87694b8503e30b$export$2e2bcd8739ae039; });
function $5c87694b8503e30b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6hUGC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49404d5d9b61c436$export$2e2bcd8739ae039; });
function $49404d5d9b61c436$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("jPLYd", function(module, exports) {
$parcel$export(module.exports, "orderedListWithOrder", function () { return $e707fda66fee1b79$export$b9ab759e8298198f; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $e707fda66fee1b79$export$4e7125c7ff595be5 = '.ak-ol';
var $e707fda66fee1b79$export$a5dc81035676e7a = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $e707fda66fee1b79$export$8157adc5747ec436 = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $e707fda66fee1b79$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $e707fda66fee1b79$export$b9ab759e8298198f = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $e707fda66fee1b79$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $e707fda66fee1b79$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $e707fda66fee1b79$export$2ea3505d41d7525d = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $6BQ2f.uuid).generate();
                if (startDOMAttr) {
                    var start = $e707fda66fee1b79$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $e707fda66fee1b79$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("cpq1I", function(module, exports) {
$parcel$export(module.exports, "paragraph", function () { return $908c022e683468b3$export$9c206ddddb32a9b; });

var $kBUhU = parcelRequire("kBUhU");
var $908c022e683468b3$export$9c206ddddb32a9b = (0, $kBUhU.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $908c022e683468b3$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("78PuG", function(module, exports) {
$parcel$export(module.exports, "placeholder", function () { return $5331395b952df92f$export$c7187bbd1a7a9244; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $5331395b952df92f$export$c7187bbd1a7a9244 = (0, $kBUhU.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || $5331395b952df92f$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $5331395b952df92f$export$6205248609a8f7a0 = (0, $kBUhU.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || $5331395b952df92f$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("hgqzw", function(module, exports) {
$parcel$export(module.exports, "rule", function () { return $c9188ae87aa1e1ed$export$fbeb3a3956e8a3c7; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name rule_node
 */ var $c9188ae87aa1e1ed$var$hrDOM = [
    'hr'
];
var $c9188ae87aa1e1ed$export$fbeb3a3956e8a3c7 = (0, $kBUhU.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $c9188ae87aa1e1ed$var$hrDOM;
    }
});
var $c9188ae87aa1e1ed$export$bf3ef6fb6ad90e7 = (0, $kBUhU.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("39Ojv", function(module, exports) {
$parcel$export(module.exports, "status", function () { return $24c93d9e61f3e2b6$export$471f7ae5c4103ae1; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");

var $1XrTG = parcelRequire("1XrTG");
var $24c93d9e61f3e2b6$export$471f7ae5c4103ae1 = (0, $kBUhU.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var textContent = dom.textContent.replace(/\n/, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                var text = (0, $1XrTG.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? dom.getAttribute('data-text') || textContent : textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $6BQ2f.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("1XrTG", function(module, exports) {
$parcel$export(module.exports, "expValEquals", function () { return $16d0f0e8434b1851$export$45abdb3f977b5b14; });

var $eDuxg = parcelRequire("eDuxg");
function $16d0f0e8434b1851$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $eDuxg.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("eDuxg", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", function () { return $aa7c64ecb9e67994$export$58e581060588c6bb; });

var $aRlul = parcelRequire("aRlul");

var $1W1pt = parcelRequire("1W1pt");

var $j9e9C = parcelRequire("j9e9C");
function $aa7c64ecb9e67994$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $j9e9C._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $j9e9C._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $aRlul.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $aRlul.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $aRlul.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $1W1pt.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("aRlul", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e7f85c6646e117d$export$2e2bcd8739ae039; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $jGiq0 = parcelRequire("jGiq0");

var $eO4ro = parcelRequire("eO4ro");



var $7e7f85c6646e117d$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $7e7f85c6646e117d$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $hiPA7.default)(this, FeatureGates);
    }
    return (0, $2871N.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$7e7f85c6646e117d$var$_FeatureGates = $7e7f85c6646e117d$var$FeatureGates;
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "client", new (0, $jGiq0.Client)());
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7e7f85c6646e117d$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $7e7f85c6646e117d$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $7e7f85c6646e117d$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7e7f85c6646e117d$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $7e7f85c6646e117d$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $7e7f85c6646e117d$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "initializeCalled", $7e7f85c6646e117d$var$_FeatureGates.client.initializeCalled.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "initializeCompleted", $7e7f85c6646e117d$var$_FeatureGates.client.initializeCompleted.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "initialize", $7e7f85c6646e117d$var$_FeatureGates.client.initialize.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "initializeWithProvider", $7e7f85c6646e117d$var$_FeatureGates.client.initializeWithProvider.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "initializeFromValues", $7e7f85c6646e117d$var$_FeatureGates.client.initializeFromValues.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "manuallyLogGateExposure", $7e7f85c6646e117d$var$_FeatureGates.client.manuallyLogGateExposure.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getExperiment", $7e7f85c6646e117d$var$_FeatureGates.client.getExperiment.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "manuallyLogExperimentExposure", $7e7f85c6646e117d$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "manuallyLogLayerExposure", $7e7f85c6646e117d$var$_FeatureGates.client.manuallyLogLayerExposure.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "shutdownStatsig", $7e7f85c6646e117d$var$_FeatureGates.client.shutdownStatsig.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "overrideGate", $7e7f85c6646e117d$var$_FeatureGates.client.overrideGate.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "clearGateOverride", $7e7f85c6646e117d$var$_FeatureGates.client.clearGateOverride.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "overrideConfig", $7e7f85c6646e117d$var$_FeatureGates.client.overrideConfig.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "clearConfigOverride", $7e7f85c6646e117d$var$_FeatureGates.client.clearConfigOverride.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "setOverrides", $7e7f85c6646e117d$var$_FeatureGates.client.setOverrides.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getOverrides", $7e7f85c6646e117d$var$_FeatureGates.client.getOverrides.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "clearAllOverrides", $7e7f85c6646e117d$var$_FeatureGates.client.clearAllOverrides.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "isCurrentUser", $7e7f85c6646e117d$var$_FeatureGates.client.isCurrentUser.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "onGateUpdated", $7e7f85c6646e117d$var$_FeatureGates.client.onGateUpdated.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "onExperimentValueUpdated", $7e7f85c6646e117d$var$_FeatureGates.client.onExperimentValueUpdated.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "onAnyUpdated", $7e7f85c6646e117d$var$_FeatureGates.client.onAnyUpdated.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "updateUser", $7e7f85c6646e117d$var$_FeatureGates.client.updateUser.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "updateUserWithProvider", $7e7f85c6646e117d$var$_FeatureGates.client.updateUserWithProvider.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "updateUserWithValues", $7e7f85c6646e117d$var$_FeatureGates.client.updateUserWithValues.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getPackageVersion", $7e7f85c6646e117d$var$_FeatureGates.client.getPackageVersion.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getLayer", $7e7f85c6646e117d$var$_FeatureGates.client.getLayer.bind($7e7f85c6646e117d$var$_FeatureGates.client));
(0, $lUar6.default)($7e7f85c6646e117d$var$FeatureGates, "getLayerValue", $7e7f85c6646e117d$var$_FeatureGates.client.getLayerValue.bind($7e7f85c6646e117d$var$_FeatureGates.client));
var $7e7f85c6646e117d$var$boundFGJS = $7e7f85c6646e117d$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $7e7f85c6646e117d$var$FeatureGates;
    else {
        var $7e7f85c6646e117d$var$_boundFGJS, $7e7f85c6646e117d$var$_boundFGJS$getPackage;
        $7e7f85c6646e117d$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $7e7f85c6646e117d$var$boundVersion = (($7e7f85c6646e117d$var$_boundFGJS = $7e7f85c6646e117d$var$boundFGJS) === null || $7e7f85c6646e117d$var$_boundFGJS === void 0 || ($7e7f85c6646e117d$var$_boundFGJS$getPackage = $7e7f85c6646e117d$var$_boundFGJS.getPackageVersion) === null || $7e7f85c6646e117d$var$_boundFGJS$getPackage === void 0 ? void 0 : $7e7f85c6646e117d$var$_boundFGJS$getPackage.call($7e7f85c6646e117d$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($7e7f85c6646e117d$var$boundVersion !== (0, $eO4ro.CLIENT_VERSION)) {
            var $7e7f85c6646e117d$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($7e7f85c6646e117d$var$boundVersion, " when module version ").concat((0, $eO4ro.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($7e7f85c6646e117d$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $7e7f85c6646e117d$export$2e2bcd8739ae039 = $7e7f85c6646e117d$var$boundFGJS;

});
parcelRegister("jGiq0", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $e5403a117872cc4c$export$1f2bb630327ac4b6; });

var $6Kejc = parcelRequire("6Kejc");

var $f2kyT = parcelRequire("f2kyT");

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $dzfsB = parcelRequire("dzfsB");

var $ec1qE = parcelRequire("ec1qE");

var $3wivl = parcelRequire("3wivl");

var $73uBa = parcelRequire("73uBa");

var $8V5O6 = parcelRequire("8V5O6");

var $69CE8 = parcelRequire("69CE8");

var $cm3nx = parcelRequire("cm3nx");

var $getgH = parcelRequire("getgH");

var $9sXHr = parcelRequire("9sXHr");

var $gDt5H = parcelRequire("gDt5H");

var $8AAcC = parcelRequire("8AAcC");

var $eO4ro = parcelRequire("eO4ro");
var $e5403a117872cc4c$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $e5403a117872cc4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5403a117872cc4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5403a117872cc4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5403a117872cc4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5403a117872cc4c$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $e5403a117872cc4c$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $e5403a117872cc4c$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9sXHr.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $hiPA7.default)(this, Client);
        (0, $lUar6.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $lUar6.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $lUar6.default)(this, "initWithDefaults", false);
        (0, $lUar6.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $lUar6.default)(this, "subscriptions", new (0, $3wivl.default)());
        (0, $lUar6.default)(this, "dataAdapter", new (0, $getgH.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $lUar6.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9sXHr.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $2871N.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8AAcC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $8AAcC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8AAcC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $8AAcC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $eO4ro.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $e5403a117872cc4c$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $eO4ro.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $gDt5H.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $8AAcC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $8AAcC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $8AAcC.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $cm3nx.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $73uBa.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $73uBa.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $69CE8.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $8AAcC.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $8AAcC.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $e5403a117872cc4c$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $cm3nx.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $cm3nx.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $f2kyT.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $e5403a117872cc4c$var$_objectSpread($e5403a117872cc4c$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $f2kyT.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $8AAcC.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $e5403a117872cc4c$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $e5403a117872cc4c$var$_objectSpread($e5403a117872cc4c$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $e5403a117872cc4c$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $gDt5H.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $6Kejc.default)(newClientOptions, $e5403a117872cc4c$var$_excluded);
                                this.user = (0, $8AAcC.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $e5403a117872cc4c$var$_objectSpread($e5403a117872cc4c$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($e5403a117872cc4c$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $8AAcC.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $eO4ro.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $8V5O6.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $8V5O6.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ge1fS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcfeed5cbec78347$export$2e2bcd8739ae039; });
function $bcfeed5cbec78347$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $bcfeed5cbec78347$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $bcfeed5cbec78347$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $bcfeed5cbec78347$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("dzfsB", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $9e0a895d86dc2395$var$runtime = (parcelRequire("jlUXe"))();
module.exports = $9e0a895d86dc2395$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $9e0a895d86dc2395$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9e0a895d86dc2395$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9e0a895d86dc2395$var$runtime);
}

});
parcelRegister("jlUXe", function(module, exports) {

var $fJpb9 = parcelRequire("fJpb9");

var $goRxu = parcelRequire("goRxu");

var $fySxU = parcelRequire("fySxU");

var $9ELAt = parcelRequire("9ELAt");

var $9CEVB = parcelRequire("9CEVB");

var $eZmDG = parcelRequire("eZmDG");

var $jHXhS = parcelRequire("jHXhS");
function $e16c2870a04a80f9$var$_regeneratorRuntime() {
    "use strict";
    var r = $goRxu(), e = r.m($e16c2870a04a80f9$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $jHXhS(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $e16c2870a04a80f9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $fJpb9(r, e);
            },
            AsyncIterator: $9CEVB,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $9ELAt : $fySxU)(a(r), e, t, o, u);
            },
            keys: $eZmDG,
            values: $jHXhS
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e16c2870a04a80f9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fJpb9", function(module, exports) {
function $b73e96f5c6b722ef$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $b73e96f5c6b722ef$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("goRxu", function(module, exports) {

var $k6G5y = parcelRequire("k6G5y");
function $bf086afb3eac6dc3$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $k6G5y(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($k6G5y(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $k6G5y(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $k6G5y(u, "constructor", GeneratorFunctionPrototype), $k6G5y(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $k6G5y(GeneratorFunctionPrototype, o, "GeneratorFunction"), $k6G5y(u), $k6G5y(u, o, "Generator"), $k6G5y(u, n, function() {
        return this;
    }), $k6G5y(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $bf086afb3eac6dc3$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $bf086afb3eac6dc3$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k6G5y", function(module, exports) {
function $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $ea350415f6bf7cd5$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $ea350415f6bf7cd5$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fySxU", function(module, exports) {

var $9ELAt = parcelRequire("9ELAt");
function $b54457b0db388a89$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $9ELAt(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $b54457b0db388a89$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9ELAt", function(module, exports) {

var $goRxu = parcelRequire("goRxu");

var $9CEVB = parcelRequire("9CEVB");
function $707cc354f6251de6$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $9CEVB($goRxu().w(r, e, t, o), n || Promise);
}
module.exports = $707cc354f6251de6$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9CEVB", function(module, exports) {

var $fJpb9 = parcelRequire("fJpb9");

var $k6G5y = parcelRequire("k6G5y");
function $701769208f379329$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $fJpb9 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($k6G5y($701769208f379329$var$AsyncIterator.prototype), $k6G5y($701769208f379329$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $k6G5y(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $701769208f379329$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("eZmDG", function(module, exports) {
function $ae9852d1d6b9b699$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $ae9852d1d6b9b699$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jHXhS", function(module, exports) {

var $d8DOY = parcelRequire("d8DOY");
var $e59005b646517804$var$_typeof = $d8DOY.default;
function $e59005b646517804$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($e59005b646517804$var$_typeof(e) + " is not iterable");
}
module.exports = $e59005b646517804$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("d8DOY", function(module, exports) {
function $990ae9622de09a2f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $990ae9622de09a2f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $990ae9622de09a2f$var$_typeof(o);
}
module.exports = $990ae9622de09a2f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("3wivl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2902b6d9e90aef18$export$2e2bcd8739ae039; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $f72YL = parcelRequire("f72YL");
function $2902b6d9e90aef18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2902b6d9e90aef18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2902b6d9e90aef18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2902b6d9e90aef18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2902b6d9e90aef18$export$a66cbd9b2289cd78 = '@all-features';
var $2902b6d9e90aef18$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $hiPA7.default)(this, Subscriptions);
        (0, $lUar6.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $2871N.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $2902b6d9e90aef18$var$_objectSpread($2902b6d9e90aef18$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $2902b6d9e90aef18$var$_objectSpread($2902b6d9e90aef18$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $2902b6d9e90aef18$var$_objectSpread($2902b6d9e90aef18$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $2902b6d9e90aef18$var$_objectSpread($2902b6d9e90aef18$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($2902b6d9e90aef18$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($2902b6d9e90aef18$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($2902b6d9e90aef18$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $2902b6d9e90aef18$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("73uBa", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $52308c7114cdc03f$export$6dc24881a3d96325; });

var $85tTb = parcelRequire("85tTb");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $8AAcC = parcelRequire("8AAcC");
var $52308c7114cdc03f$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $hiPA7.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $2871N.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $85tTb.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $85tTb.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $8AAcC.migrateEvaluationDetails)(experiment.details), (0, $8AAcC.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("8AAcC", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $640dc49c50b7f3c9$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $640dc49c50b7f3c9$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $640dc49c50b7f3c9$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $640dc49c50b7f3c9$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $640dc49c50b7f3c9$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $640dc49c50b7f3c9$export$55fd683752d01e67; });

var $6Kejc = parcelRequire("6Kejc");

var $f2kyT = parcelRequire("f2kyT");

var $lUar6 = parcelRequire("lUar6");

var $e9p07 = parcelRequire("e9p07");

var $69CE8 = parcelRequire("69CE8");

var $gDt5H = parcelRequire("gDt5H");
var $640dc49c50b7f3c9$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $640dc49c50b7f3c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $640dc49c50b7f3c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $640dc49c50b7f3c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $640dc49c50b7f3c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $640dc49c50b7f3c9$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $640dc49c50b7f3c9$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $e9p07.isFedRamp)() ? (0, $gDt5H.PerimeterType).FEDRAMP_MODERATE : (0, $gDt5H.PerimeterType).COMMERCIAL
    }, options);
};
var $640dc49c50b7f3c9$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $f2kyT.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $f2kyT.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $f2kyT.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $f2kyT.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $640dc49c50b7f3c9$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $640dc49c50b7f3c9$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $6Kejc.default)(options, $640dc49c50b7f3c9$var$_excluded);
    return $640dc49c50b7f3c9$var$_objectSpread($640dc49c50b7f3c9$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $640dc49c50b7f3c9$var$evaluationReasonMappings = Object.entries((0, $69CE8.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $f2kyT.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $640dc49c50b7f3c9$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $640dc49c50b7f3c9$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $f2kyT.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $69CE8.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $640dc49c50b7f3c9$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("e9p07", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $a4d54c9a1898a667$export$64d6499adf9b2e51; });

var $5Fas5 = parcelRequire("5Fas5");
function $a4d54c9a1898a667$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $5Fas5.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("5Fas5", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $41f8e39ffe3a449f$export$ce553301d55c2fd8; });
var $41f8e39ffe3a449f$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $41f8e39ffe3a449f$export$f005e2e9f707cb5f = 'commercial';
var $41f8e39ffe3a449f$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $41f8e39ffe3a449f$export$a739cd5aac835909 = 'stg';
var $41f8e39ffe3a449f$export$42dd0cdd351a4a9 = 'prod';
var $41f8e39ffe3a449f$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("69CE8", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $47b18faf6502a02e$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $47b18faf6502a02e$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("gDt5H", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $c1c6dab666eb86c1$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $c1c6dab666eb86c1$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c1c6dab666eb86c1$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $c1c6dab666eb86c1$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $c1c6dab666eb86c1$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("8V5O6", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $67e826bf618a521f$export$936d0764594b6eb3; });

var $85tTb = parcelRequire("85tTb");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $8AAcC = parcelRequire("8AAcC");
var $67e826bf618a521f$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $hiPA7.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $2871N.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $85tTb.default)(val) === (0, $85tTb.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $8AAcC.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $8AAcC.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $8AAcC.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("cm3nx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fea29045f9ae5d0$export$2e2bcd8739ae039; });

var $lUar6 = parcelRequire("lUar6");

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $dzfsB = parcelRequire("dzfsB");

var $gDt5H = parcelRequire("gDt5H");

var $eO4ro = parcelRequire("eO4ro");

var $k3Ty3 = parcelRequire("k3Ty3");
function $8fea29045f9ae5d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fea29045f9ae5d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fea29045f9ae5d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fea29045f9ae5d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8fea29045f9ae5d0$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $8fea29045f9ae5d0$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $8fea29045f9ae5d0$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $8fea29045f9ae5d0$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $8fea29045f9ae5d0$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $8fea29045f9ae5d0$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $8fea29045f9ae5d0$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $8fea29045f9ae5d0$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $8fea29045f9ae5d0$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $8fea29045f9ae5d0$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $8fea29045f9ae5d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $hiPA7.default)(this, Fetcher);
    }
    return (0, $2871N.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $k3Ty3.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $k3Ty3.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $8fea29045f9ae5d0$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $gDt5H.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $gDt5H.FeatureGateEnvironment).Production:
                        return $8fea29045f9ae5d0$export$18c93900db9358a4;
                    case (0, $gDt5H.FeatureGateEnvironment).Staging:
                        return $8fea29045f9ae5d0$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $gDt5H.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $gDt5H.FeatureGateEnvironment).Development:
                        return $8fea29045f9ae5d0$export$f058dbf75c3bc647;
                    case (0, $gDt5H.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $8fea29045f9ae5d0$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $8fea29045f9ae5d0$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $8fea29045f9ae5d0$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $8fea29045f9ae5d0$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $eO4ro.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $8fea29045f9ae5d0$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($8fea29045f9ae5d0$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($8fea29045f9ae5d0$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("eO4ro", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $ac792e125e1a20f3$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $ac792e125e1a20f3$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("k3Ty3", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $e9af2d3360055255$export$286baf652d0b1206; });

var $2871N = parcelRequire("2871N");

var $hiPA7 = parcelRequire("hiPA7");

var $eDhqJ = parcelRequire("eDhqJ");

var $aDM8J = parcelRequire("aDM8J");

var $cxyvF = parcelRequire("cxyvF");

var $3rO3z = parcelRequire("3rO3z");
function $e9af2d3360055255$var$_callSuper(t, o, e) {
    return o = (0, $aDM8J.default)(o), (0, $eDhqJ.default)(t, $e9af2d3360055255$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aDM8J.default)(t).constructor) : o.apply(t, e));
}
function $e9af2d3360055255$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e9af2d3360055255$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e9af2d3360055255$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $hiPA7.default)(this, ResponseError);
        return $e9af2d3360055255$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $cxyvF.default)(ResponseError, _Error);
    return (0, $2871N.default)(ResponseError);
}(/*#__PURE__*/ (0, $3rO3z.default)(Error));

});
parcelRegister("eDhqJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa723a79c340cf69$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");

var $df1RQ = parcelRequire("df1RQ");
function $aa723a79c340cf69$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $85tTb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $df1RQ.default)(t);
}

});
parcelRegister("df1RQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a3e1fe85263c1c2$export$2e2bcd8739ae039; });
function $9a3e1fe85263c1c2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("aDM8J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bf2e37c237558d2$export$2e2bcd8739ae039; });
function $7bf2e37c237558d2$export$2e2bcd8739ae039(t) {
    return $7bf2e37c237558d2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7bf2e37c237558d2$export$2e2bcd8739ae039(t);
}

});

parcelRegister("cxyvF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9213560266a1a270$export$2e2bcd8739ae039; });

var $17qyB = parcelRequire("17qyB");
function $9213560266a1a270$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $17qyB.default)(t, e);
}

});
parcelRegister("17qyB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d0b0b914deee1c5$export$2e2bcd8739ae039; });
function $0d0b0b914deee1c5$export$2e2bcd8739ae039(t, e) {
    return $0d0b0b914deee1c5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0d0b0b914deee1c5$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("3rO3z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $282ab8eca1b5028a$export$2e2bcd8739ae039; });

var $aDM8J = parcelRequire("aDM8J");

var $17qyB = parcelRequire("17qyB");

var $8ifhb = parcelRequire("8ifhb");

var $3c9AN = parcelRequire("3c9AN");
function $282ab8eca1b5028a$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $282ab8eca1b5028a$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $8ifhb.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3c9AN.default)(t, arguments, (0, $aDM8J.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $17qyB.default)(Wrapper, t);
    }, $282ab8eca1b5028a$export$2e2bcd8739ae039(t);
}

});
parcelRegister("8ifhb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $609bdaacd5967278$export$2e2bcd8739ae039; });
function $609bdaacd5967278$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("3c9AN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2539eef062e954d6$export$2e2bcd8739ae039; });

var $lr0kd = parcelRequire("lr0kd");

var $17qyB = parcelRequire("17qyB");
function $2539eef062e954d6$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $lr0kd.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $17qyB.default)(p, r.prototype), p;
}

});
parcelRegister("lr0kd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9ac5f1f2daedc35$export$2e2bcd8739ae039; });
function $f9ac5f1f2daedc35$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f9ac5f1f2daedc35$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("getgH", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $bd14a835bc4dbb5f$export$55fffef3474104af; });

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $eDhqJ = parcelRequire("eDhqJ");

var $aDM8J = parcelRequire("aDM8J");

var $hql6f = parcelRequire("hql6f");

var $cxyvF = parcelRequire("cxyvF");

var $lUar6 = parcelRequire("lUar6");

var $dzfsB = parcelRequire("dzfsB");

var $ec1qE = parcelRequire("ec1qE");
function $bd14a835bc4dbb5f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd14a835bc4dbb5f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd14a835bc4dbb5f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd14a835bc4dbb5f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bd14a835bc4dbb5f$var$_callSuper(t, o, e) {
    return o = (0, $aDM8J.default)(o), (0, $eDhqJ.default)(t, $bd14a835bc4dbb5f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aDM8J.default)(t).constructor) : o.apply(t, e));
}
function $bd14a835bc4dbb5f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd14a835bc4dbb5f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bd14a835bc4dbb5f$var$_superPropGet(t, o, e, r) {
    var p = (0, $hql6f.default)((0, $aDM8J.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bd14a835bc4dbb5f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $hiPA7.default)(this, NoFetchDataAdapter);
        _this = $bd14a835bc4dbb5f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $lUar6.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $cxyvF.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $2871N.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $bd14a835bc4dbb5f$var$_objectSpread($bd14a835bc4dbb5f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $bd14a835bc4dbb5f$var$_objectSpread($bd14a835bc4dbb5f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $bd14a835bc4dbb5f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $bd14a835bc4dbb5f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});
parcelRegister("hql6f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $034605161834b266$export$2e2bcd8739ae039; });

var $7DtDI = parcelRequire("7DtDI");
function $034605161834b266$export$2e2bcd8739ae039() {
    return $034605161834b266$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $7DtDI.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $034605161834b266$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("7DtDI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f32abf1a4b899b$export$2e2bcd8739ae039; });

var $aDM8J = parcelRequire("aDM8J");
function $58f32abf1a4b899b$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $aDM8J.default)(t)););
    return t;
}

});



parcelRegister("9sXHr", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $6e4509ae47411606$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $6e4509ae47411606$export$bcb28fbac1def494; });

var $lUar6 = parcelRequire("lUar6");

var $f2kyT = parcelRequire("f2kyT");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $3wfvf = parcelRequire("3wfvf");
function $6e4509ae47411606$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e4509ae47411606$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e4509ae47411606$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e4509ae47411606$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6e4509ae47411606$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6e4509ae47411606$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6e4509ae47411606$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6e4509ae47411606$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6e4509ae47411606$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6e4509ae47411606$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6e4509ae47411606$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6e4509ae47411606$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6e4509ae47411606$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6e4509ae47411606$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6e4509ae47411606$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6e4509ae47411606$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $hiPA7.default)(this, PersistentOverrideAdapter);
        this._overrides = $6e4509ae47411606$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $2871N.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6e4509ae47411606$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6e4509ae47411606$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6e4509ae47411606$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $f2kyT.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $f2kyT.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $f2kyT.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6e4509ae47411606$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6e4509ae47411606$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6e4509ae47411606$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, $6e4509ae47411606$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $f2kyT.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $f2kyT.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6e4509ae47411606$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current.details), {}, {
                        reason: $6e4509ae47411606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6e4509ae47411606$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6e4509ae47411606$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6e4509ae47411606$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current.details), {}, {
                        reason: $6e4509ae47411606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6e4509ae47411606$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $6e4509ae47411606$var$_objectSpread($6e4509ae47411606$var$_objectSpread({}, current.details), {}, {
                        reason: $6e4509ae47411606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("1W1pt", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagAccessed", function () { return $168c4d2c9a812429$export$47fade9662f71000; });

var $7IFVc = parcelRequire("7IFVc");
var $168c4d2c9a812429$export$5b78c989c8db2561 = new Map();
var $168c4d2c9a812429$export$2a5c8df26bb89760 = new Map();
function $168c4d2c9a812429$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $7IFVc.redactValue)(featureFlagValue);
    $168c4d2c9a812429$export$5b78c989c8db2561.set(featureFlagName, value);
    $168c4d2c9a812429$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("7IFVc", function(module, exports) {
$parcel$export(module.exports, "redactValue", function () { return $59ed293a8632d255$export$fcc03ee4c944962f; });

var $85tTb = parcelRequire("85tTb");

var $5oWpB = parcelRequire("5oWpB");
function $59ed293a8632d255$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $59ed293a8632d255$var$isObject(value) {
    return value && (0, $85tTb.default)(value) === 'object' && value.constructor === Object;
}
function $59ed293a8632d255$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $59ed293a8632d255$export$7b4abba432e57989(value) {
    return $59ed293a8632d255$var$isString(value) && $59ed293a8632d255$var$startsAsObject(value) || $59ed293a8632d255$var$isObject(value);
}
function $59ed293a8632d255$export$fcc03ee4c944962f(featureFlagValue) {
    return $59ed293a8632d255$export$7b4abba432e57989(featureFlagValue) ? (0, $5oWpB.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("5oWpB", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $3eec810b316fcd82$export$42f4885608027d0c; });
var $3eec810b316fcd82$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("j9e9C", function(module, exports) {
$parcel$export(module.exports, "_overrides", function () { return $df09d647fd6f5d11$export$e5d73bf4f8e2ae96; });

var $lUar6 = parcelRequire("lUar6");

var $f2kyT = parcelRequire("f2kyT");

var $fX417 = parcelRequire("fX417");

var $3uPZ6 = parcelRequire("3uPZ6");
function $df09d647fd6f5d11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df09d647fd6f5d11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df09d647fd6f5d11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df09d647fd6f5d11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $df09d647fd6f5d11$export$e5d73bf4f8e2ae96 = {};
var $df09d647fd6f5d11$export$4e849416bb5c5b52 = {};
var $df09d647fd6f5d11$export$cf7305fc65acbf0d;
function $df09d647fd6f5d11$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, $f2kyT.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $fX417.editorExperimentsConfig)[key];
            if (config) acc = $df09d647fd6f5d11$var$_objectSpread($df09d647fd6f5d11$var$_objectSpread({}, acc), {}, (0, $lUar6.default)({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $df09d647fd6f5d11$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $fX417.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, $f2kyT.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $3uPZ6.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $3uPZ6.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $df09d647fd6f5d11$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $df09d647fd6f5d11$export$cf7305fc65acbf0d = product;
    $df09d647fd6f5d11$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("fX417", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", function () { return $b9cf7b6d86ffe2c1$export$6cbb856f286b07ef; });
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $a3aXX = parcelRequire("a3aXX");
var $b9cf7b6d86ffe2c1$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 22-12-2025
    confluence_load_editor_title_on_transition: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_load_editor_title_on_transition'
        },
        param: 'contentPlaceholder',
        defaultValue: false
    }),
    // Added 20-01-2026
    cc_editor_lcm_readonly_initial: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_lcm_readonly_initial'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    confluence_max_width_breakout_extension_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_breakout_extension_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-12-09
    cc_editor_hover_link_overlay_css_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_hover_link_overlay_css_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-7
    platform_editor_table_sticky_header_patch_10: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_10'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-26
    platform_editor_ai_create_use_new_parser: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_create_use_new_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    company_hub_deprecate_atlaskit_onboarding: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_deprecate_atlaskit_onboarding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_ssr_renderer: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_renderer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-01
    platform_editor_no_state_plugin_injection_api: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_state_plugin_injection_api'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-17
    editor_fix_embed_width_expand: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_fix_embed_width_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_disable_query_command_supported: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_query_command_supported'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-05
    platform_editor_table_update_table_ref: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_update_table_ref'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-10
    platform_editor_task_item_styles: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_task_item_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    cc_editor_limited_mode_expanded: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_expanded'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_table_toolbar_perf_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_perf_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-04
    confluence_compact_text_format: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_compact_text_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_ai_update_set_attrs_selection: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_update_set_attrs_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-28-01
    platform_editor_primary_toolbar_early_exit: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_primary_toolbar_early_exit',
            jira: 'platform_editor_primary_toolbar_early_exit'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_fix_emoji_paste_html: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_emoji_paste_html'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-18
    platform_editor_blockquote_zero_padding: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_zero_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $a3aXX.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    platform_editor_remove_ncsstepmetrics_plugin: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_ncsstepmetrics_plugin'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-18
    platform_editor_wait_for_space_after_ascii_emoji: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wait_for_space_after_ascii_emoji'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_use_pmr_for_collab_presence_non_ic: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_pmr_for_collab_presence_non_ic',
            jira: 'platform_editor_use_pmr_for_collab_presence_non_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_use_pmr_for_collab_presence_in_ic: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_pmr_for_collab_presence_in_ic',
            jira: 'platform_editor_use_pmr_for_collab_presence_in_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-23
    platform_editor_to_use_pmr_for_collab_edit_none_ic: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_to_use_pmr_for_collab_edit_none_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-12
    platform_editor_toolbar_delay_render_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_delay_render_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_nested_media_selection_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_media_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-15
    platform_editor_ai_exp_inline_date_year_refresh: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_exp_inline_date_year_refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-15
    platform_editor_ai_exp_suggestion_date_comma_delim: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_exp_suggestion_date_comma_delim'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_sel_toolbar_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sel_toolbar_fix',
            jira: 'platform_editor_sel_toolbar_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-30
    platform_editor_table_sticky_header_patch_9: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_9'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_localid_ime_composition_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_localid_ime_composition_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_sample_renderer_rendered_event: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sample_renderer_rendered_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-12
    platform_editor_table_sticky_header_patch_11: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_11'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    platform_editor_fix_advanced_codeblocks_crlf: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_advanced_codeblocks_crlf'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_focus_on_chromeless_editor: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_focus_on_chromeless_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-15
    platform_editor_table_toolbar_icon_ext_fix_exp: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_icon_ext_fix_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-14
    platform_editor_context_context_types_migration: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_context_context_types_migration',
            jira: 'platform_editor_context_context_types_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-16
    platform_editor_ai_edit_unsupported_content: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_unsupported_content'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    platform_editor_copy_paste_issue_fix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_paste_issue_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-20
    platform_editor_aifc_remove_duplicate_role: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_remove_duplicate_role',
            jira: 'platform_editor_aifc_remove_duplicate_role'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_ai_loading_responsive_width: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_loading_responsive_width',
            jira: 'platform_editor_ai_loading_responsive_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_nested_drag_handle_icon: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_drag_handle_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-23
    collab_bypass_out_of_sync_period_experiment: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'collab_bypass_out_of_sync_period_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-26
    platform_editor_ai_fix_streaming_json_escape: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_streaming_json_escape'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_cell_colour_change: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_cell_colour_change'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_inline_insert_excerpt_width_bugfix: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_insert_excerpt_width_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-29
    platform_editor_renderer_toolbar_updates: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_toolbar_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_insert_excerpt_inline_vertical_align: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_insert_excerpt_inline_vertical_align'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $a3aXX.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("a3aXX", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", function () { return $01e365f2d77d0013$export$456f1587c9c92021; });
$parcel$export(module.exports, "createMultivariateExperiment", function () { return $01e365f2d77d0013$export$fb89e8a786694d1; });

var $26Q8o = parcelRequire("26Q8o");

var $lUar6 = parcelRequire("lUar6");

var $6bXKi = parcelRequire("6bXKi");
function $01e365f2d77d0013$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01e365f2d77d0013$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01e365f2d77d0013$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01e365f2d77d0013$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $01e365f2d77d0013$export$456f1587c9c92021(config) {
    return $01e365f2d77d0013$var$_objectSpread($01e365f2d77d0013$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $6bXKi.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $01e365f2d77d0013$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $01e365f2d77d0013$var$_objectSpread($01e365f2d77d0013$var$_objectSpread({}, config), {}, {
        values: (0, $26Q8o.default)(values),
        // Maintains the tuple
        typeGuard: (0, $6bXKi.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("6bXKi", function(module, exports) {
$parcel$export(module.exports, "isBoolean", function () { return $48221d6d611b3c8c$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "oneOf", function () { return $48221d6d611b3c8c$export$a9a18ae5ba42aeab; });

var $7t0tI = parcelRequire("7t0tI");
var $48221d6d611b3c8c$var$_process, $48221d6d611b3c8c$var$_process2;
function $48221d6d611b3c8c$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $48221d6d611b3c8c$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($48221d6d611b3c8c$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $48221d6d611b3c8c$var$IS_TESTING_ENV = typeof $7t0tI !== 'undefined' && ((($48221d6d611b3c8c$var$_process = $7t0tI) === null || $48221d6d611b3c8c$var$_process === void 0 || ($48221d6d611b3c8c$var$_process = $48221d6d611b3c8c$var$_process.env) === null || $48221d6d611b3c8c$var$_process === void 0 ? void 0 : $48221d6d611b3c8c$var$_process.NODE_ENV) === 'test' || (($48221d6d611b3c8c$var$_process2 = $7t0tI) === null || $48221d6d611b3c8c$var$_process2 === void 0 || ($48221d6d611b3c8c$var$_process2 = $48221d6d611b3c8c$var$_process2.env) === null || $48221d6d611b3c8c$var$_process2 === void 0 ? void 0 : $48221d6d611b3c8c$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("3uPZ6", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", function () { return $28bc7f82638b0b0b$export$7e849a84a00ffd1c; });
$parcel$export(module.exports, "testBooleanOverrides", function () { return $28bc7f82638b0b0b$export$54960937bb713f97; });
var $28bc7f82638b0b0b$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    platform_sl_3p_unauth_paste_as_block_card: 'control'
};
var $28bc7f82638b0b0b$export$54960937bb713f97 = {
    cc_editor_hover_link_overlay_css_fix: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    platform_editor_text_highlight_padding: false,
    confluence_compact_text_format: false
};

});





parcelRegister("cJpLB", function(module, exports) {
$parcel$export(module.exports, "syncBlock", function () { return $944dacbe1a0675eb$export$faab0ca9701d7048; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $944dacbe1a0675eb$export$faab0ca9701d7048 = (0, $kBUhU.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $6BQ2f.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("b9bGn", function(module, exports) {
$parcel$export(module.exports, "taskList", function () { return $81d998e1d172348e$export$375b6afcc5f4d291; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name taskList_node
 */ var $81d998e1d172348e$var$name = 'actionList';
var $81d998e1d172348e$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($81d998e1d172348e$var$name, "\"]");
var $81d998e1d172348e$export$375b6afcc5f4d291 = (0, $kBUhU.taskList)({
    parseDOM: [
        {
            tag: "div".concat($81d998e1d172348e$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $81d998e1d172348e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("g9gj0", function(module, exports) {
$parcel$export(module.exports, "text", function () { return $bc1a228e1703a1bb$export$6f093cfa640b7166; });

var $kBUhU = parcelRequire("kBUhU");
var $bc1a228e1703a1bb$export$6f093cfa640b7166 = (0, $kBUhU.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("5ilw1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3daf52bbf5da6047$export$2e2bcd8739ae039; });
var $3daf52bbf5da6047$var$name = 'unknownBlock';
var $3daf52bbf5da6047$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $3daf52bbf5da6047$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($3daf52bbf5da6047$var$name, "\"]")
        }
    ]
};

});

parcelRegister("eeCoC", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", function () { return $a5d0282d12e1d6da$export$44b79b0979d0f0f7; });

var $kBUhU = parcelRequire("kBUhU");
var $a5d0282d12e1d6da$export$44b79b0979d0f0f7 = (0, $kBUhU.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("73gy7", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", function () { return $5225a68da8c45c4b$export$310ebe0d80122e9b; });

var $kBUhU = parcelRequire("kBUhU");
var $5225a68da8c45c4b$export$310ebe0d80122e9b = (0, $kBUhU.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("2r7Em", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", function () { return $1c6409831f371e87$export$28e4e3c024cce988; });
var $1c6409831f371e87$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $1c6409831f371e87$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $1c6409831f371e87$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $1c6409831f371e87$var$defaultAllowOverrideBehaviour;
        default:
            return $1c6409831f371e87$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("4Piq1", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", function () { return $383a366aac9dc2cb$export$48b382180baf8e88; });

var $lUar6 = parcelRequire("lUar6");

var $avMzD = parcelRequire("avMzD");

var $ewSiU = parcelRequire("ewSiU");

var $fdwQ2 = parcelRequire("fdwQ2");
function $383a366aac9dc2cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $383a366aac9dc2cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $383a366aac9dc2cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $383a366aac9dc2cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $383a366aac9dc2cb$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === 'table';
    });
};
function $383a366aac9dc2cb$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $ewSiU.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $383a366aac9dc2cb$var$_objectSpread($383a366aac9dc2cb$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== 'typeAheadQuery';
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $fdwQ2.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($383a366aac9dc2cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $avMzD.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($383a366aac9dc2cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $avMzD.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $fdwQ2.removeNonAnnotationMarks),
        mention: (0, $fdwQ2.removeNonAnnotationMarks),
        date: (0, $fdwQ2.removeNonAnnotationMarks),
        hardBreak: (0, $fdwQ2.removeMarks),
        inlineCard: (0, $fdwQ2.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("fdwQ2", function(module, exports) {
$parcel$export(module.exports, "removeMarks", function () { return $b1418aed8c93afe7$export$9bf001d8ef76e497; });
$parcel$export(module.exports, "removeNonAnnotationMarks", function () { return $b1418aed8c93afe7$export$8cae9126fc577085; });

var $lUar6 = parcelRequire("lUar6");
function $b1418aed8c93afe7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1418aed8c93afe7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1418aed8c93afe7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1418aed8c93afe7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b1418aed8c93afe7$export$9bf001d8ef76e497(node) {
    var newNode = $b1418aed8c93afe7$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}
function $b1418aed8c93afe7$export$8cae9126fc577085(node) {
    var newNode = $b1418aed8c93afe7$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === 'annotation';
    });
    return newNode;
}

});




parcelRegister("cnLy7", function(module, exports) {
$parcel$export(module.exports, "AiMateMarkdownTransformer", function () { return $903c84572a6a35e9$export$614853bf2169db97; });

var $eVBqw = parcelRequire("eVBqw");

var $aHrBh = parcelRequire("aHrBh");

var $i9V20 = parcelRequire("i9V20");

var $hCepl = parcelRequire("hCepl");

var $37Imi = parcelRequire("37Imi");

var $b60TI = parcelRequire("b60TI");

var $8DNPl = parcelRequire("8DNPl");

var $2CJiD = parcelRequire("2CJiD");

var $2S3V5 = parcelRequire("2S3V5");

var $9ZwyL = parcelRequire("9ZwyL");

var $39c3M = parcelRequire("39c3M");

var $d6iF4 = parcelRequire("d6iF4");

var $l1YGC = parcelRequire("l1YGC");

var $1o1tc = parcelRequire("1o1tc");

var $hubVA = parcelRequire("hubVA");

var $lNotn = parcelRequire("lNotn");

var $9Pv4k = parcelRequire("9Pv4k");

var $6oSt6 = parcelRequire("6oSt6");

var $eDDZa = parcelRequire("eDDZa");
function $903c84572a6a35e9$var$_callSuper(t, o, e) {
    return o = (0, $hCepl.default)(o), (0, $i9V20.default)(t, $903c84572a6a35e9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hCepl.default)(t).constructor) : o.apply(t, e));
}
function $903c84572a6a35e9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($903c84572a6a35e9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $903c84572a6a35e9$export$614853bf2169db97 = /*#__PURE__*/ function(_MarkdownTransformer) {
    function AiMateMarkdownTransformer(schema, pluginConfig, streaming) {
        var _this;
        (0, $eVBqw.default)(this, AiMateMarkdownTransformer);
        _this = $903c84572a6a35e9$var$_callSuper(this, AiMateMarkdownTransformer);
        var md = (0, (/*@__PURE__*/$parcel$interopDefault($b60TI)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $eDDZa.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $1o1tc.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $d6iF4.default));
        if ((0, $39c3M.fg)('rovo_enable_data_sculptor')) md.use((0, $l1YGC.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $9Pv4k.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $lNotn.default));
        // Table support
        if (schema.nodes.table) md.use((0, $8DNPl.markdownItTable));
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $hubVA.default));
        var filter = (0, $eDDZa.filterSchemaMapping)(schema, (0, $6oSt6.mdToPmSchema));
        _this.parser = new (0, $2S3V5.MarkdownParser)(schema, md, filter);
        return _this;
    }
    (0, $37Imi.default)(AiMateMarkdownTransformer, _MarkdownTransformer);
    return (0, $aHrBh.default)(AiMateMarkdownTransformer, [
        {
            key: "parse",
            value: function parse(content) {
                var node = this.parser.parse(content);
                if (!node) return new (0, $9ZwyL.Node)();
                return node;
            }
        }
    ]);
}((0, $2CJiD.MarkdownTransformer));

});
parcelRegister("eVBqw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ade36bb8c9fd99cd$export$2e2bcd8739ae039; });
function $ade36bb8c9fd99cd$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aHrBh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ca3546604f73913$export$2e2bcd8739ae039; });

var $8L8Rk = parcelRequire("8L8Rk");
function $7ca3546604f73913$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $8L8Rk.default)(o.key), o);
    }
}
function $7ca3546604f73913$export$2e2bcd8739ae039(e, r, t) {
    return r && $7ca3546604f73913$var$_defineProperties(e.prototype, r), t && $7ca3546604f73913$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("8L8Rk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $660995c46c15179a$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");

var $6iSLq = parcelRequire("6iSLq");
function $660995c46c15179a$export$2e2bcd8739ae039(t) {
    var i = (0, $6iSLq.default)(t, "string");
    return "symbol" == (0, $i6sgL.default)(i) ? i : i + "";
}

});
parcelRegister("i6sgL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0366b0600e45ee3d$export$2e2bcd8739ae039; });
function $0366b0600e45ee3d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0366b0600e45ee3d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0366b0600e45ee3d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6iSLq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $496ee777f5e42e54$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");
function $496ee777f5e42e54$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $i6sgL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $i6sgL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("i9V20", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3854e8286ab50a6$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");

var $gytk3 = parcelRequire("gytk3");
function $d3854e8286ab50a6$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $i6sgL.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gytk3.default)(t);
}

});
parcelRegister("gytk3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0d6912a0f1b6a39$export$2e2bcd8739ae039; });
function $c0d6912a0f1b6a39$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hCepl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd312958d817112b$export$2e2bcd8739ae039; });
function $cd312958d817112b$export$2e2bcd8739ae039(t) {
    return $cd312958d817112b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cd312958d817112b$export$2e2bcd8739ae039(t);
}

});

parcelRegister("37Imi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24646f37efb338b9$export$2e2bcd8739ae039; });

var $1drQo = parcelRequire("1drQo");
function $24646f37efb338b9$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1drQo.default)(t, e);
}

});
parcelRegister("1drQo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e2c9a9c14a7502e$export$2e2bcd8739ae039; });
function $0e2c9a9c14a7502e$export$2e2bcd8739ae039(t, e) {
    return $0e2c9a9c14a7502e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0e2c9a9c14a7502e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("2CJiD", function(module, exports) {
$parcel$export(module.exports, "MarkdownTransformer", function () { return $1e9244ea0a7c6336$export$267fd7ead7cc4561; });

var $eVBqw = parcelRequire("eVBqw");

var $aHrBh = parcelRequire("aHrBh");

var $3Oe51 = parcelRequire("3Oe51");

var $b60TI = parcelRequire("b60TI");

var $8DNPl = parcelRequire("8DNPl");

var $7h1bJ = parcelRequire("7h1bJ");

var $cl834 = parcelRequire("cl834");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e9244ea0a7c6336$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
var $1e9244ea0a7c6336$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
var $1e9244ea0a7c6336$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            };
        }
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            };
        }
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                language: tok.info && tok.info.trim() || null
            };
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                shortName: ":".concat(tok.markup, ":"),
                text: tok.content
            };
        }
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    }
};
var $1e9244ea0a7c6336$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($b60TI)))('zero', {
    html: false
});
$1e9244ea0a7c6336$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
var $1e9244ea0a7c6336$export$267fd7ead7cc4561 = /*#__PURE__*/ function() {
    function MarkdownTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $3Oe51.defaultSchema);
        var tokenizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e9244ea0a7c6336$var$md;
        (0, $eVBqw.default)(this, MarkdownTransformer);
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach(function(key) {
            for(var idx in $1e9244ea0a7c6336$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($1e9244ea0a7c6336$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $8DNPl.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $cl834.markdownItMedia));
        this.markdownParser = new (0, $7h1bJ.MarkdownParser)(schema, tokenizer, $1e9244ea0a7c6336$var$filterMdToPmSchemaMapping(schema, $1e9244ea0a7c6336$var$mdToPmMapping));
    }
    return (0, $aHrBh.default)(MarkdownTransformer, [
        {
            key: "encode",
            value: function encode(_node) {
                throw new Error('This is not implemented yet');
            }
        },
        {
            key: "parse",
            value: function parse(content) {
                return this.markdownParser.parse(content);
            }
        }
    ]);
}();

});
parcelRegister("3Oe51", function(module, exports) {
$parcel$export(module.exports, "defaultSchema", function () { return $2c60f6a0499aab60$export$1db618b7b2275ea1; });

var $dWJ7u = parcelRequire("dWJ7u");

var $9xf1B = parcelRequire("9xf1B");
var $3054C = parcelRequire("3054C");
var $ksaMs = parcelRequire("ksaMs");
var $apXau = parcelRequire("apXau");
var $hrTcF = parcelRequire("hrTcF");
var $3FYQW = parcelRequire("3FYQW");

var $5Lxm0 = parcelRequire("5Lxm0");
var $2c60f6a0499aab60$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $2c60f6a0499aab60$export$e4e3ac1fa64862db = $2c60f6a0499aab60$var$getDefaultSchemaConfig();
var $2c60f6a0499aab60$export$fd147e7d448dea03 = (0, $dWJ7u.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $2c60f6a0499aab60$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $ksaMs.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $3054C.multiBodiedExtension),
        extensionFrame: (0, $3054C.extensionFrame),
        expand: (0, $9xf1B.expandWithNestedExpand),
        listItem: (0, $apXau.listItemWithDecisionStage0),
        table: (0, $3FYQW.tableWithNestedTable),
        tableRow: (0, $3FYQW.tableRowWithNestedTable),
        tableCell: (0, $3FYQW.tableCellWithNestedTable),
        tableHeader: (0, $3FYQW.tableHeaderWithNestedTable),
        syncBlock: (0, $hrTcF.syncBlock)
    };
    return (0, $5Lxm0.createSchema)(defaultSchemaConfig);
});
var $2c60f6a0499aab60$export$1db618b7b2275ea1 = $2c60f6a0499aab60$export$fd147e7d448dea03();

});
parcelRegister("9xf1B", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $6f12d9bf1a28622e$export$7b80cba28d10b2c1; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $6f12d9bf1a28622e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f12d9bf1a28622e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f12d9bf1a28622e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f12d9bf1a28622e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $6f12d9bf1a28622e$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $6f12d9bf1a28622e$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $6f12d9bf1a28622e$export$7b80cba28d10b2c1 = (0, $35i9Y.expand)($6f12d9bf1a28622e$var$nodeSpecOptions);
var $6f12d9bf1a28622e$export$2ae5e7565ff9ffa6 = (0, $35i9Y.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $6f12d9bf1a28622e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("1YMOy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17114290c3c2ce63$export$2e2bcd8739ae039; });

var $gNNM1 = parcelRequire("gNNM1");
function $17114290c3c2ce63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gNNM1.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gNNM1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c3b7d4eb62afc6d0$export$2e2bcd8739ae039; });

var $cRu6R = parcelRequire("cRu6R");

var $kpKm5 = parcelRequire("kpKm5");
function $c3b7d4eb62afc6d0$export$2e2bcd8739ae039(t) {
    var i = (0, $kpKm5.default)(t, "string");
    return "symbol" == (0, $cRu6R.default)(i) ? i : i + "";
}

});
parcelRegister("cRu6R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $95d1ca6ae7d094db$export$2e2bcd8739ae039; });
function $95d1ca6ae7d094db$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $95d1ca6ae7d094db$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95d1ca6ae7d094db$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kpKm5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edca199bb1be9b55$export$2e2bcd8739ae039; });

var $cRu6R = parcelRequire("cRu6R");
function $edca199bb1be9b55$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $cRu6R.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $cRu6R.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("35i9Y", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $23efece627ba86e3$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $23efece627ba86e3$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $23efece627ba86e3$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $23efece627ba86e3$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $23efece627ba86e3$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $23efece627ba86e3$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $23efece627ba86e3$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $23efece627ba86e3$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $23efece627ba86e3$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $23efece627ba86e3$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $23efece627ba86e3$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $23efece627ba86e3$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $23efece627ba86e3$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $23efece627ba86e3$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $23efece627ba86e3$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $23efece627ba86e3$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $23efece627ba86e3$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $23efece627ba86e3$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $23efece627ba86e3$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $23efece627ba86e3$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $23efece627ba86e3$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $23efece627ba86e3$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $23efece627ba86e3$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $23efece627ba86e3$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $23efece627ba86e3$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $23efece627ba86e3$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $23efece627ba86e3$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $23efece627ba86e3$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $23efece627ba86e3$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $23efece627ba86e3$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $23efece627ba86e3$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $23efece627ba86e3$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $23efece627ba86e3$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $23efece627ba86e3$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $23efece627ba86e3$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $23efece627ba86e3$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $23efece627ba86e3$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $23efece627ba86e3$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $23efece627ba86e3$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $23efece627ba86e3$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $23efece627ba86e3$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $23efece627ba86e3$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $23efece627ba86e3$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $23efece627ba86e3$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $23efece627ba86e3$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $23efece627ba86e3$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $23efece627ba86e3$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlockStage0", function () { return $23efece627ba86e3$export$3782866d5d058412; });
$parcel$export(module.exports, "table", function () { return $23efece627ba86e3$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $23efece627ba86e3$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $23efece627ba86e3$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $23efece627ba86e3$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $23efece627ba86e3$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $23efece627ba86e3$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $23efece627ba86e3$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $23efece627ba86e3$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $23efece627ba86e3$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $23efece627ba86e3$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $23efece627ba86e3$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $23efece627ba86e3$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $23efece627ba86e3$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $31mbR = parcelRequire("31mbR");
var $23efece627ba86e3$export$c4c2f833baaebdb8 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$67dc04e652a298ca = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $23efece627ba86e3$export$199922e5af8e9a6 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $23efece627ba86e3$export$16018c61064a18df = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$27903d543b563e39 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $23efece627ba86e3$export$e7320d153c538837 = (0, $31mbR.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $23efece627ba86e3$export$a140c94e5ea26bee = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$8e3c2dfdc4f0453d = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $23efece627ba86e3$export$7bb0d5c671655cc4 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $23efece627ba86e3$export$e4f1c66d84049f8b = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $23efece627ba86e3$export$daf889beb5092f95 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$e6e4878f43c27cab = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$3e6d667072febc87 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$324d90190a8b822a = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$47988d68fe575725 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$6959e16eeff859b4 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $23efece627ba86e3$export$62d45a65fb43d95e = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$2a111da947c407d2 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $23efece627ba86e3$export$be4283d9a1cb1ff6 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$a19185d1233fc4b2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$f5574b5d45fc2112 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9f77e0932fb78f72 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$7e3788972005cc72 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$1b45514b112dd749 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$a8baf338431a691 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b555be60c7703afb = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $23efece627ba86e3$export$371da9dd35aba193 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $23efece627ba86e3$export$46e4a324ac90507f = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$1b0c1557b234fa00 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$85461f751c457cc2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$2b380a0f7e250af1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$5c452ff88e35e47d = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $23efece627ba86e3$export$cbf8224b64e0d942 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$2f4e72b9459914ad = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$16b353b2649bd8d9 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b3b1e36c2105006d = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$ab76e7c03cd6f650 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $23efece627ba86e3$export$b3b6a70a7fa4a5be = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$cdae19acb0a520fd = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$206007566ca0aca5 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$76c7e83ecc9cdf05 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$df876f0305235056 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$987d49ffe1b0900f = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$2855e964765eac9 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $23efece627ba86e3$export$38bab695e3f720f1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$969fe3781ca15058 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $23efece627ba86e3$export$8d067f22dc2d1254 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$7e767666f2ce108a = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$4bd9a38995f6bf50 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$db83999c14438df4 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$46f790bd65f760d0 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$750e45819f66d9d0 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $23efece627ba86e3$export$63cadbf5f4296627 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$f03786aa6312d1e4 = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$a5dc81035676e7a = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$21f42ab9b6679f44 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9c206ddddb32a9b = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$4f98472e6dc14293 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$ea332b61641b0588 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$a1f41dc4901771f8 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$c7187bbd1a7a9244 = (0, $31mbR.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$fbeb3a3956e8a3c7 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$471f7ae5c4103ae1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b6ce52be8d7a261 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$3782866d5d058412 = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9852986a3ec5f6a0 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $23efece627ba86e3$export$ce086a560a1d05f5 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $23efece627ba86e3$export$e1e720e5f4603e6a = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $23efece627ba86e3$export$abf39ca178940ff3 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $23efece627ba86e3$export$48884d2a5190dc73 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $23efece627ba86e3$export$2a5a518232fa1a97 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $23efece627ba86e3$export$ce666bf02318c957 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $23efece627ba86e3$export$7d657479499397 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $23efece627ba86e3$export$6d8b0ef52e2e6390 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$375b6afcc5f4d291 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$6f093cfa640b7166 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$5ea06bc686c59dc2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$93256a4c17b33a82 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$a12828d0f14a2762 = (0, $31mbR.createPMNodeSpecFactory)({});
var $23efece627ba86e3$export$44b79b0979d0f0f7 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$310ebe0d80122e9b = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("31mbR", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $2332ada103068f8a$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $2332ada103068f8a$export$cf5823ed4e9f4c6f; });

var $1YMOy = parcelRequire("1YMOy");
function $2332ada103068f8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2332ada103068f8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2332ada103068f8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2332ada103068f8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2332ada103068f8a$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $2332ada103068f8a$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("dS3bo", function(module, exports) {
$parcel$export(module.exports, "uuid", function () { return $a192c98d694ef953$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $a192c98d694ef953$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $a192c98d694ef953$var$staticValue = false;
var $a192c98d694ef953$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $a192c98d694ef953$var$staticValue = value;
    },
    generate: function generate() {
        return $a192c98d694ef953$var$staticValue || $a192c98d694ef953$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("3054C", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", function () { return $22f54eaf8db333c9$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $22f54eaf8db333c9$export$c3c04d555a8b9013; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $22f54eaf8db333c9$export$4fdcae991fd743e7 = (0, $35i9Y.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $22f54eaf8db333c9$export$c3c04d555a8b9013 = (0, $35i9Y.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("dAkqA", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", function () { return $9e3e7bab9459f5d1$export$1765e2758fc47004; });
var $9e3e7bab9459f5d1$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $9e3e7bab9459f5d1$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $9e3e7bab9459f5d1$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("ksaMs", function(module, exports) {
$parcel$export(module.exports, "layoutSection", function () { return $ee3ec8fb99054185$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $ee3ec8fb99054185$export$4f9d8f623ff17117; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $ee3ec8fb99054185$export$b3b6a70a7fa4a5be = (0, $35i9Y.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$cdae19acb0a520fd = (0, $35i9Y.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$4f9d8f623ff17117 = (0, $35i9Y.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$d9d3c69a64270b13 = (0, $35i9Y.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $dS3bo.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$64facded20dfd85c = (0, $35i9Y.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $dS3bo.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("apXau", function(module, exports) {
$parcel$export(module.exports, "listItem", function () { return $795a22c358c656bf$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $795a22c358c656bf$export$b2cd54d5ce935ddb; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $795a22c358c656bf$export$76c7e83ecc9cdf05 = (0, $35i9Y.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $795a22c358c656bf$export$483d52f09158e61c = (0, $35i9Y.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $795a22c358c656bf$export$b2cd54d5ce935ddb = (0, $35i9Y.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $795a22c358c656bf$export$394466eb252d967a = (0, $35i9Y.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("hrTcF", function(module, exports) {
$parcel$export(module.exports, "syncBlock", function () { return $cb3fc77d09e387b2$export$faab0ca9701d7048; });

var $35i9Y = parcelRequire("35i9Y");
var $cb3fc77d09e387b2$export$faab0ca9701d7048 = (0, $35i9Y.syncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || '',
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("3FYQW", function(module, exports) {
$parcel$export(module.exports, "table", function () { return $2ad467912c49affd$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableRow", function () { return $2ad467912c49affd$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $2ad467912c49affd$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableHeader", function () { return $2ad467912c49affd$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $2ad467912c49affd$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $2ad467912c49affd$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $2ad467912c49affd$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $2ad467912c49affd$export$2a5a518232fa1a97; });

var $a8Fwx = parcelRequire("a8Fwx");

var $1YMOy = parcelRequire("1YMOy");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $dS3bo = parcelRequire("dS3bo");

var $7VJss = parcelRequire("7VJss");

var $35i9Y = parcelRequire("35i9Y");
function $2ad467912c49affd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ad467912c49affd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ad467912c49affd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ad467912c49affd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ad467912c49affd$export$9cfceb893b24742a = 'pm-table';
var $2ad467912c49affd$export$69cb4c3f80383763 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-content-wrap");
var $2ad467912c49affd$export$7b07d37d879c957f = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-header-content-wrap");
var $2ad467912c49affd$export$8dd42a84cd52da07 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $2ad467912c49affd$export$5e26a5c19f0865d8 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $3G1IB.N20).toLocaleLowerCase();
var $2ad467912c49affd$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $3G1IB.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $3G1IB.isRgb)(backgroundColor)) {
        var result = (0, $3G1IB.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $2ad467912c49affd$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $2ad467912c49affd$var$testGlobalTheme;
var $2ad467912c49affd$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $2ad467912c49affd$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $2ad467912c49affd$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($2ad467912c49affd$var$testGlobalTheme) return {
        colorMode: $2ad467912c49affd$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $2ad467912c49affd$var$cssVariablePattern = /^var\(--.*\)$/;
var $2ad467912c49affd$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $2ad467912c49affd$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $2ad467912c49affd$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $3G1IB.isRgb)(background) && (0, $3G1IB.rgbToHex)(background) ? (0, $3G1IB.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $kgm12.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $2ad467912c49affd$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($2ad467912c49affd$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $7VJss.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $2ad467912c49affd$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $2ad467912c49affd$export$7b07d37d879c957f;
    else attrs.class = $2ad467912c49affd$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $2ad467912c49affd$export$219b7f492ad209f8 = new Map();
var $2ad467912c49affd$export$95e9c925fbf01d1c = (0, $3G1IB.hexToRgba)((0, $3G1IB.N800), 0.12) || (0, $3G1IB.N0);
var $2ad467912c49affd$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $3G1IB.N0),
        'White'
    ],
    [
        (0, $3G1IB.B50),
        'Light blue'
    ],
    [
        (0, $3G1IB.T50),
        'Light teal'
    ],
    [
        (0, $3G1IB.G50),
        'Light green'
    ],
    [
        (0, $3G1IB.Y50),
        'Light yellow'
    ],
    [
        (0, $3G1IB.R50),
        'Light red'
    ],
    [
        (0, $3G1IB.P50),
        'Light purple'
    ],
    [
        (0, $3G1IB.N20),
        'Light gray'
    ],
    [
        (0, $3G1IB.B75),
        'Blue'
    ],
    [
        (0, $3G1IB.T75),
        'Teal'
    ],
    [
        (0, $3G1IB.G75),
        'Green'
    ],
    [
        (0, $3G1IB.Y75),
        'Yellow'
    ],
    [
        (0, $3G1IB.R75),
        'Red'
    ],
    [
        (0, $3G1IB.P75),
        'Purple'
    ],
    [
        (0, $3G1IB.N60),
        'Gray'
    ],
    [
        (0, $3G1IB.B100),
        'Dark blue'
    ],
    [
        (0, $3G1IB.T100),
        'Dark teal'
    ],
    [
        (0, $3G1IB.G200),
        'Dark green'
    ],
    [
        (0, $3G1IB.Y200),
        'Dark yellow'
    ],
    [
        (0, $3G1IB.R100),
        'Dark red'
    ],
    [
        (0, $3G1IB.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $2ad467912c49affd$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $2ad467912c49affd$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $2ad467912c49affd$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $dS3bo.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $2ad467912c49affd$var$createTableSpec = function createTableSpec() {
    return (0, $35i9Y.table)($2ad467912c49affd$var$tableNodeSpecOptions);
};
var $2ad467912c49affd$export$9852986a3ec5f6a0 = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$export$90e634fbace1f0c4 = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$export$3862de5c8c9098cf = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $2ad467912c49affd$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $2ad467912c49affd$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $2ad467912c49affd$var$_objectSpread($2ad467912c49affd$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $2ad467912c49affd$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $2ad467912c49affd$export$ce666bf02318c957 = (0, $35i9Y.tableRow)($2ad467912c49affd$var$tableRowNodeSpecOptions);
var $2ad467912c49affd$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $2ad467912c49affd$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$e1e720e5f4603e6a = (0, $35i9Y.tableCell)($2ad467912c49affd$var$tableCellNodeSpecOptions);
var $2ad467912c49affd$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($2ad467912c49affd$var$cellAttrs[key] && $2ad467912c49affd$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $2ad467912c49affd$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    background: $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$48884d2a5190dc73 = (0, $35i9Y.tableHeader)($2ad467912c49affd$var$tableHeaderNodeSpecOptions);
var $2ad467912c49affd$export$2af48797a1010bb1 = $2ad467912c49affd$export$2ac34c099660f1a8;
var $2ad467912c49affd$export$ce086a560a1d05f5 = (0, $35i9Y.tableWithNestedTable)($2ad467912c49affd$var$tableNodeSpecOptions);
var $2ad467912c49affd$export$7d657479499397 = (0, $35i9Y.tableRowWithNestedTable)($2ad467912c49affd$var$tableRowNodeSpecOptions);
var $2ad467912c49affd$export$abf39ca178940ff3 = (0, $35i9Y.tableCellWithNestedTable)($2ad467912c49affd$var$tableCellNodeSpecOptions);
var $2ad467912c49affd$export$2a5a518232fa1a97 = (0, $35i9Y.tableHeaderWithNestedTable)($2ad467912c49affd$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $2ad467912c49affd$export$c8f0853ac97552c9 = (0, $35i9Y.tableRow)($2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$db76cfd28a574029 = (0, $35i9Y.tableCell)($2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    background: $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$b82d2b1d8824143d = (0, $35i9Y.tableHeader)($2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$27926e30c8a74147 = (0, $35i9Y.tableRowWithNestedTable)($2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$e9fd700fafee293a = (0, $35i9Y.tableCellWithNestedTable)($2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$7928c3aeb4cd2213 = (0, $35i9Y.tableHeaderWithNestedTable)($2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("a8Fwx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $761adc7af991f88e$export$2e2bcd8739ae039; });

var $6TIGk = parcelRequire("6TIGk");

var $h4oTR = parcelRequire("h4oTR");

var $aDOnL = parcelRequire("aDOnL");

var $IMZcM = parcelRequire("IMZcM");
function $761adc7af991f88e$export$2e2bcd8739ae039(r, e) {
    return (0, $6TIGk.default)(r) || (0, $h4oTR.default)(r, e) || (0, $aDOnL.default)(r, e) || (0, $IMZcM.default)();
}

});
parcelRegister("6TIGk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $505a89fc679046e7$export$2e2bcd8739ae039; });
function $505a89fc679046e7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("h4oTR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c6d62003dce8e1d7$export$2e2bcd8739ae039; });
function $c6d62003dce8e1d7$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("aDOnL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bf4a0c19a8656b6$export$2e2bcd8739ae039; });

var $adcIJ = parcelRequire("adcIJ");
function $7bf4a0c19a8656b6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $adcIJ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $adcIJ.default)(r, a) : void 0;
    }
}

});
parcelRegister("adcIJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76f4fc4ff68fc185$export$2e2bcd8739ae039; });
function $76f4fc4ff68fc185$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("IMZcM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $086a1bcf86769106$export$2e2bcd8739ae039; });
function $086a1bcf86769106$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kgm12", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $ec06612857ba08d1$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $ec06612857ba08d1$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $ec06612857ba08d1$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $ec06612857ba08d1$export$a270511a0e7fd61a; });

var $3L8ZR = parcelRequire("3L8ZR");
function $ec06612857ba08d1$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $ec06612857ba08d1$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $ec06612857ba08d1$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $3L8ZR.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $ec06612857ba08d1$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $ec06612857ba08d1$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $ec06612857ba08d1$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $ec06612857ba08d1$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("3G1IB", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $2ad6a09437b3da0a$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $2ad6a09437b3da0a$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $2ad6a09437b3da0a$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $2ad6a09437b3da0a$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $2ad6a09437b3da0a$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $2ad6a09437b3da0a$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $2ad6a09437b3da0a$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $2ad6a09437b3da0a$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $2ad6a09437b3da0a$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $2ad6a09437b3da0a$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $2ad6a09437b3da0a$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $2ad6a09437b3da0a$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $2ad6a09437b3da0a$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $2ad6a09437b3da0a$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $2ad6a09437b3da0a$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $2ad6a09437b3da0a$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $2ad6a09437b3da0a$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $2ad6a09437b3da0a$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $2ad6a09437b3da0a$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $2ad6a09437b3da0a$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $2ad6a09437b3da0a$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $2ad6a09437b3da0a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $2ad6a09437b3da0a$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $2ad6a09437b3da0a$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $2ad6a09437b3da0a$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $2ad6a09437b3da0a$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $2ad6a09437b3da0a$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $2ad6a09437b3da0a$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $2ad6a09437b3da0a$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $2ad6a09437b3da0a$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $2ad6a09437b3da0a$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $2ad6a09437b3da0a$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $2ad6a09437b3da0a$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $2ad6a09437b3da0a$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $2ad6a09437b3da0a$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $2ad6a09437b3da0a$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $2ad6a09437b3da0a$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $2ad6a09437b3da0a$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $2ad6a09437b3da0a$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $2ad6a09437b3da0a$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $2ad6a09437b3da0a$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $2ad6a09437b3da0a$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $2ad6a09437b3da0a$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $2ad6a09437b3da0a$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $2ad6a09437b3da0a$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $2ad6a09437b3da0a$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $2ad6a09437b3da0a$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $2ad6a09437b3da0a$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $2ad6a09437b3da0a$export$9665a07d9187b414; });

var $a8Fwx = parcelRequire("a8Fwx");

var $ksCOI = parcelRequire("ksCOI");
var $2ad6a09437b3da0a$export$4b84fd0e2c617bd = '#FFEBE6';
var $2ad6a09437b3da0a$export$b34b069eff244586 = '#FFBDAD';
var $2ad6a09437b3da0a$export$be802dd0d8b57f35 = '#FF8F73';
var $2ad6a09437b3da0a$export$4a7404f376229999 = '#FF5630';
var $2ad6a09437b3da0a$export$2010d0fb4295b346 = '#DE350B';
var $2ad6a09437b3da0a$export$2837b5a1a71d5c02 = '#BF2600';
var $2ad6a09437b3da0a$export$8d9596b529bbb9cf = '#FFFAE6';
var $2ad6a09437b3da0a$export$41060a744ab0b7ae = '#FFF0B3';
var $2ad6a09437b3da0a$export$5aae31392d72caaa = '#FFC400';
var $2ad6a09437b3da0a$export$fc857b6f8771648a = '#F8E6A0';
var $2ad6a09437b3da0a$export$59619663aa6500fb = '#FF991F';
var $2ad6a09437b3da0a$export$874739ea9e379ab6 = '#FF8B00';
var $2ad6a09437b3da0a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $2ad6a09437b3da0a$export$69a3bf21b9686c2b = '#ABF5D1';
var $2ad6a09437b3da0a$export$747d86715d4175de = '#57D9A3';
var $2ad6a09437b3da0a$export$940e1f69e873f202 = '#36B37E';
var $2ad6a09437b3da0a$export$a49394138f7b8e85 = '#00875A';
var $2ad6a09437b3da0a$export$6fa04827ac68a4fb = '#006644';
var $2ad6a09437b3da0a$export$226de0355ed012f8 = '#DEEBFF';
var $2ad6a09437b3da0a$export$8c13c2ee36917869 = '#B3D4FF';
var $2ad6a09437b3da0a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $2ad6a09437b3da0a$export$b3de0ae08da2ce64 = '#0052CC';
var $2ad6a09437b3da0a$export$a6ee3d71bc067634 = '#0747A6';
var $2ad6a09437b3da0a$export$f72948ef771f6f15 = '#D3F1A7';
var $2ad6a09437b3da0a$export$29a4f05edc054374 = '#FFFFFF';
var $2ad6a09437b3da0a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $2ad6a09437b3da0a$export$3e51e8f1440314ba = '#EBECF0';
var $2ad6a09437b3da0a$export$1ce2d1575d444ceb = '#DFE1E6';
var $2ad6a09437b3da0a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $2ad6a09437b3da0a$export$c2e91cbeada39b8b = '#B3BAC5';
var $2ad6a09437b3da0a$export$eaa8c8a70ac22806 = '#97A0AF';
var $2ad6a09437b3da0a$export$7c87d337fb91a97d = '#8993A4';
var $2ad6a09437b3da0a$export$f563ee71e9ee74cd = '#6B778C';
var $2ad6a09437b3da0a$export$e2ef2124cf4024b1 = '#5E6C84';
var $2ad6a09437b3da0a$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $2ad6a09437b3da0a$export$13609db0e6812ab8 = '#091E4224';
var $2ad6a09437b3da0a$export$c39c0fe0f26207ae = '#42526E';
var $2ad6a09437b3da0a$export$7090862dc3038a9f = '#758195';
var $2ad6a09437b3da0a$export$7d61b15e0da132af = '#172B4D';
var $2ad6a09437b3da0a$export$f78789c8b01753cd = '#172B4D';
var $2ad6a09437b3da0a$export$a19f0c33186f7767 = '#FDD0EC';
var $2ad6a09437b3da0a$export$51716a84e62e022c = '#FEDEC8';
var $2ad6a09437b3da0a$export$363e4475840015bb = '#EAE6FF';
var $2ad6a09437b3da0a$export$4b0a4417ed59760f = '#C0B6F2';
var $2ad6a09437b3da0a$export$6011520a64d9a187 = '#998DD9';
var $2ad6a09437b3da0a$export$a7175d4e9206bc80 = '#DFD8FD';
var $2ad6a09437b3da0a$export$b48405b95304b5a1 = '#6554C0';
var $2ad6a09437b3da0a$export$c71e4279dd54a18d = '#5243AA';
var $2ad6a09437b3da0a$export$147899de772240ec = '#403294';
var $2ad6a09437b3da0a$export$2cf711fe14c66f06 = '#E6FCFF';
var $2ad6a09437b3da0a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $2ad6a09437b3da0a$export$776c9c497ef08533 = '#79E2F2';
var $2ad6a09437b3da0a$export$69cb3ca10c1e330e = '#C6EDFB';
var $2ad6a09437b3da0a$export$9dc1ef0f3f48059b = '#00B8D9';
var $2ad6a09437b3da0a$export$6036577f95c3877e = '#008DA6';
function $2ad6a09437b3da0a$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($2ad6a09437b3da0a$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($2ad6a09437b3da0a$export$e698776ec826343(color)) return $2ad6a09437b3da0a$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($ksCOI.default && $ksCOI.default[color]) color = $ksCOI.default[color];
        else if ($ksCOI && $ksCOI[color]) color = $ksCOI[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $2ad6a09437b3da0a$export$5a544e13ad4e1fa5(color) {
    if (!$2ad6a09437b3da0a$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $2ad6a09437b3da0a$export$9665a07d9187b414(rawColor, alpha) {
    var color = $2ad6a09437b3da0a$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $2ad6a09437b3da0a$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $a8Fwx.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $2ad6a09437b3da0a$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $2ad6a09437b3da0a$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});

parcelRegister("7VJss", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $5c611e43c5f31b88$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $5c611e43c5f31b88$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $5c611e43c5f31b88$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $5c611e43c5f31b88$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $5c611e43c5f31b88$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $5c611e43c5f31b88$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $5c611e43c5f31b88$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $5c611e43c5f31b88$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $5c611e43c5f31b88$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $5c611e43c5f31b88$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $5c611e43c5f31b88$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $5c611e43c5f31b88$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $5c611e43c5f31b88$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5c611e43c5f31b88$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5c611e43c5f31b88$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $5c611e43c5f31b88$var$rgbToLch = function rgbToLch(rgb) {
    return $5c611e43c5f31b88$var$labToLch($5c611e43c5f31b88$var$xyzToLab($5c611e43c5f31b88$var$rgbToXyz(rgb)));
};
var $5c611e43c5f31b88$var$lchToRgb = function lchToRgb(lch) {
    return $5c611e43c5f31b88$var$xyzToRgb($5c611e43c5f31b88$var$labToXyz($5c611e43c5f31b88$var$lchToLab(lch)));
};
var $5c611e43c5f31b88$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $5c611e43c5f31b88$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $5c611e43c5f31b88$var$rgbToLch(rgb);
    lch.l = $5c611e43c5f31b88$var$clamp(newPercent, 0, 100);
    return $5c611e43c5f31b88$var$rgbToHex($5c611e43c5f31b88$var$lchToRgb(lch));
};
var $5c611e43c5f31b88$var$getLightness = function getLightness(color) {
    var rgb = $5c611e43c5f31b88$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $5c611e43c5f31b88$var$rgbToLch(rgb);
    return lch.l;
};
var $5c611e43c5f31b88$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $5c611e43c5f31b88$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $5c611e43c5f31b88$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("5Lxm0", function(module, exports) {
$parcel$export(module.exports, "createSchema", function () { return $432b36f2c37c930f$export$5f4ce795563f4211; });

var $cENKH = parcelRequire("cENKH");

var $h4D0i = parcelRequire("h4D0i");

var $hZivE = parcelRequire("hZivE");

var $1cB6t = parcelRequire("1cB6t");
var $3TKhC = parcelRequire("3TKhC");
var $9kZG1 = parcelRequire("9kZG1");
var $8Y0bD = parcelRequire("8Y0bD");
var $c5ZSc = parcelRequire("c5ZSc");
var $eMlDB = parcelRequire("eMlDB");
var $jeuXu = parcelRequire("jeuXu");
var $cHw09 = parcelRequire("cHw09");
var $j0vam = parcelRequire("j0vam");
var $fU1Bq = parcelRequire("fU1Bq");
var $6d2bd = parcelRequire("6d2bd");
var $ajG4R = parcelRequire("ajG4R");
var $fKtA4 = parcelRequire("fKtA4");
var $iZbsN = parcelRequire("iZbsN");
var $f623j = parcelRequire("f623j");
var $1U0rY = parcelRequire("1U0rY");
var $dV25i = parcelRequire("dV25i");
var $5TYds = parcelRequire("5TYds");
var $5uc46 = parcelRequire("5uc46");
var $2BisJ = parcelRequire("2BisJ");

var $6mMzQ = parcelRequire("6mMzQ");
var $5sacJ = parcelRequire("5sacJ");
var $DFUIs = parcelRequire("DFUIs");
var $9RUN2 = parcelRequire("9RUN2");
var $claEk = parcelRequire("claEk");
var $8eXsH = parcelRequire("8eXsH");
var $a7fGe = parcelRequire("a7fGe");
var $dDXbH = parcelRequire("dDXbH");
var $9YFvh = parcelRequire("9YFvh");
var $7C5L2 = parcelRequire("7C5L2");
var $g4DXa = parcelRequire("g4DXa");
var $bLcwV = parcelRequire("bLcwV");
var $7NNlE = parcelRequire("7NNlE");
var $ibsHe = parcelRequire("ibsHe");
var $73CSr = parcelRequire("73CSr");
var $9xf1B = parcelRequire("9xf1B");
var $cbmTE = parcelRequire("cbmTE");
var $2cUVb = parcelRequire("2cUVb");
var $d9aBX = parcelRequire("d9aBX");
var $3054C = parcelRequire("3054C");
var $g8K3J = parcelRequire("g8K3J");
var $kF1fR = parcelRequire("kF1fR");
var $8kQDF = parcelRequire("8kQDF");
var $fRQyu = parcelRequire("fRQyu");
var $bqFdW = parcelRequire("bqFdW");
var $dfjwm = parcelRequire("dfjwm");
var $ksaMs = parcelRequire("ksaMs");
var $apXau = parcelRequire("apXau");
var $dDMCS = parcelRequire("dDMCS");
var $gDmwP = parcelRequire("gDmwP");
var $akl9R = parcelRequire("akl9R");
var $6x4c2 = parcelRequire("6x4c2");
var $jPkEj = parcelRequire("jPkEj");
var $8Cmqn = parcelRequire("8Cmqn");
var $hPlli = parcelRequire("hPlli");
var $enD9G = parcelRequire("enD9G");
var $lDmie = parcelRequire("lDmie");
var $2KjdB = parcelRequire("2KjdB");
var $9DZID = parcelRequire("9DZID");
var $hrTcF = parcelRequire("hrTcF");
var $3FYQW = parcelRequire("3FYQW");
var $iaDy5 = parcelRequire("iaDy5");
var $4VC0J = parcelRequire("4VC0J");
var $sM3wy = parcelRequire("sM3wy");
var $lztMS = parcelRequire("lztMS");
var $lbKeT = parcelRequire("lbKeT");
function $432b36f2c37c930f$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $432b36f2c37c930f$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $432b36f2c37c930f$var$markGroupDeclarations = [
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.COLOR)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.FONT_STYLE)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.SEARCH_QUERY)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.LINK))
];
var $432b36f2c37c930f$var$markGroupDeclarationsNames = $432b36f2c37c930f$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $432b36f2c37c930f$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $7NNlE.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $enD9G.paragraph)
    },
    {
        name: 'text',
        spec: (0, $4VC0J.text)
    },
    {
        name: 'bulletList',
        spec: (0, $9RUN2.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $hPlli.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $apXau.listItem)
    },
    {
        name: 'heading',
        spec: (0, $kF1fR.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $cbmTE.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8eXsH.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $2cUVb.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $2KjdB.rule)
    },
    {
        name: 'image',
        spec: (0, $8kQDF.image)
    },
    {
        name: 'mention',
        spec: (0, $jPkEj.mention)
    },
    {
        name: 'caption',
        spec: (0, $claEk.caption)
    },
    {
        name: 'media',
        spec: (0, $dDMCS.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $gDmwP.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $6x4c2.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $akl9R.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $lDmie.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $ksaMs.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $dfjwm.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $g8K3J.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $73CSr.emoji)
    },
    {
        name: 'table',
        spec: (0, $3FYQW.table)
    },
    {
        name: 'tableCell',
        spec: (0, $3FYQW.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $3FYQW.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $3FYQW.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $a7fGe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $9YFvh.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $dDXbH.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $bLcwV.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $g4DXa.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $iaDy5.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5sacJ.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $5sacJ.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $7C5L2.date)
    },
    {
        name: 'status',
        spec: (0, $9DZID.status)
    },
    {
        name: 'expand',
        spec: (0, $9xf1B.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $8Cmqn.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $d9aBX.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $bqFdW.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $DFUIs.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $3054C.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $3054C.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $fRQyu.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $6mMzQ.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $ibsHe.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $hrTcF.syncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $sM3wy.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $lztMS.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $lbKeT.unsupportedInline)
    }
];
var $432b36f2c37c930f$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $ajG4R.link)
    },
    {
        name: 'em',
        spec: (0, $j0vam.em)
    },
    {
        name: 'strong',
        spec: (0, $iZbsN.strong)
    },
    {
        name: 'textColor',
        spec: (0, $1U0rY.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $9kZG1.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $fKtA4.strike)
    },
    {
        name: 'subsup',
        spec: (0, $f623j.subsup)
    },
    {
        name: 'underline',
        spec: (0, $5TYds.underline)
    },
    {
        name: 'code',
        spec: (0, $eMlDB.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dV25i.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $1cB6t.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $3TKhC.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $jeuXu.confluenceInlineComment)
    }
].concat($432b36f2c37c930f$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $c5ZSc.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cHw09.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $fU1Bq.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $6d2bd.indentation)
    },
    {
        name: 'border',
        spec: (0, $8Y0bD.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $5uc46.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $2BisJ.unsupportedNodeAttribute)
    }
]);
function $432b36f2c37c930f$export$2d0c32a809131488() {
    var nodes = $432b36f2c37c930f$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $432b36f2c37c930f$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $432b36f2c37c930f$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($432b36f2c37c930f$var$markGroupDeclarationsNames);
    var nodes = $432b36f2c37c930f$var$addItems($432b36f2c37c930f$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $432b36f2c37c930f$var$addItems($432b36f2c37c930f$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $hZivE.sanitizeNodes)(nodes, marks);
    return new (0, $cENKH.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $432b36f2c37c930f$export$c77b6d30da5276a1 = true;

});
parcelRegister("cENKH", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $936fd032dba44608$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $936fd032dba44608$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $936fd032dba44608$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $936fd032dba44608$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $936fd032dba44608$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $936fd032dba44608$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $936fd032dba44608$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $936fd032dba44608$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $936fd032dba44608$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $936fd032dba44608$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $936fd032dba44608$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $936fd032dba44608$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $936fd032dba44608$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $936fd032dba44608$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $936fd032dba44608$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $936fd032dba44608$var$retIndex(0, pos);
        if (pos == this.size) return $936fd032dba44608$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $936fd032dba44608$var$retIndex(i + 1, end);
                return $936fd032dba44608$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $936fd032dba44608$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $936fd032dba44608$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (nodes instanceof $936fd032dba44608$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $936fd032dba44608$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $936fd032dba44608$export$ffb0004e005737fa.empty = new $936fd032dba44608$export$ffb0004e005737fa([], 0);
const $936fd032dba44608$var$found = {
    index: 0,
    offset: 0
};
function $936fd032dba44608$var$retIndex(index, offset) {
    $936fd032dba44608$var$found.index = index;
    $936fd032dba44608$var$found.offset = offset;
    return $936fd032dba44608$var$found;
}
function $936fd032dba44608$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$936fd032dba44608$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$936fd032dba44608$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $936fd032dba44608$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $936fd032dba44608$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $936fd032dba44608$export$c9d15bcfc6d42044.none;
        if (marks instanceof $936fd032dba44608$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $936fd032dba44608$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $936fd032dba44608$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $936fd032dba44608$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $936fd032dba44608$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $936fd032dba44608$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $936fd032dba44608$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $936fd032dba44608$export$b3f2e2de3a8baa1e.empty = new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$export$ffb0004e005737fa.empty, 0, 0);
function $936fd032dba44608$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($936fd032dba44608$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $936fd032dba44608$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $936fd032dba44608$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $936fd032dba44608$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $936fd032dba44608$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $936fd032dba44608$export$6de0e778727af3f2("Inconsistent open depths");
    return $936fd032dba44608$var$replaceOuter($from, $to, slice, 0);
}
function $936fd032dba44608$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $936fd032dba44608$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $936fd032dba44608$var$close(node, $936fd032dba44608$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $936fd032dba44608$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $936fd032dba44608$var$prepareSliceForReplace(slice, $from);
        return $936fd032dba44608$var$close(node, $936fd032dba44608$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $936fd032dba44608$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $936fd032dba44608$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $936fd032dba44608$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $936fd032dba44608$var$checkJoin(node, $after.node(depth));
    return node;
}
function $936fd032dba44608$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $936fd032dba44608$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $936fd032dba44608$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$936fd032dba44608$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $936fd032dba44608$var$addNode($end.nodeBefore, target);
}
function $936fd032dba44608$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $936fd032dba44608$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $936fd032dba44608$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $936fd032dba44608$var$joinable($end, $to, depth + 1);
    let content = [];
    $936fd032dba44608$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $936fd032dba44608$var$checkJoin(openStart, openEnd);
        $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openStart, $936fd032dba44608$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openStart, $936fd032dba44608$var$replaceTwoWay($from, $start, depth + 1)), content);
        $936fd032dba44608$var$addRange($start, $end, depth, content);
        if (openEnd) $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openEnd, $936fd032dba44608$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $936fd032dba44608$var$addRange($to, null, depth, content);
    return new $936fd032dba44608$export$ffb0004e005737fa(content);
}
function $936fd032dba44608$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $936fd032dba44608$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $936fd032dba44608$var$joinable($from, $to, depth + 1);
        $936fd032dba44608$var$addNode($936fd032dba44608$var$close(type, $936fd032dba44608$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $936fd032dba44608$var$addRange($to, null, depth, content);
    return new $936fd032dba44608$export$ffb0004e005737fa(content);
}
function $936fd032dba44608$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($936fd032dba44608$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $936fd032dba44608$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $936fd032dba44608$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $936fd032dba44608$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $936fd032dba44608$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $936fd032dba44608$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $936fd032dba44608$var$resolveCache.set(doc, cache = new $936fd032dba44608$var$ResolveCache);
        let result = cache.elts[cache.i] = $936fd032dba44608$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $936fd032dba44608$var$resolveCacheSize;
        return result;
    }
}
class $936fd032dba44608$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $936fd032dba44608$var$resolveCacheSize = 12, $936fd032dba44608$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $936fd032dba44608$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $936fd032dba44608$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $936fd032dba44608$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $936fd032dba44608$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $936fd032dba44608$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $936fd032dba44608$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $936fd032dba44608$var$emptyAttrs) && $936fd032dba44608$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $936fd032dba44608$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $936fd032dba44608$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $936fd032dba44608$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $936fd032dba44608$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $936fd032dba44608$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $936fd032dba44608$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $936fd032dba44608$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $936fd032dba44608$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $936fd032dba44608$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$936fd032dba44608$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $936fd032dba44608$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$936fd032dba44608$export$85c928794f8d04d4.prototype.text = undefined;
class $936fd032dba44608$var$TextNode extends $936fd032dba44608$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $936fd032dba44608$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $936fd032dba44608$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $936fd032dba44608$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $936fd032dba44608$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $936fd032dba44608$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $936fd032dba44608$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $936fd032dba44608$export$364ed450558d7ec4.empty;
        let expr = $936fd032dba44608$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $936fd032dba44608$var$dfa($936fd032dba44608$var$nfa(expr));
        $936fd032dba44608$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $936fd032dba44608$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $936fd032dba44608$export$364ed450558d7ec4.empty = new $936fd032dba44608$export$364ed450558d7ec4(true);
class $936fd032dba44608$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $936fd032dba44608$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($936fd032dba44608$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $936fd032dba44608$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($936fd032dba44608$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $936fd032dba44608$var$parseExprSubscript(stream) {
    let expr = $936fd032dba44608$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $936fd032dba44608$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $936fd032dba44608$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $936fd032dba44608$var$parseExprRange(stream, expr) {
    let min = $936fd032dba44608$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $936fd032dba44608$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $936fd032dba44608$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $936fd032dba44608$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $936fd032dba44608$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $936fd032dba44608$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $936fd032dba44608$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $936fd032dba44608$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $936fd032dba44608$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($936fd032dba44608$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $936fd032dba44608$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($936fd032dba44608$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $936fd032dba44608$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $936fd032dba44608$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($936fd032dba44608$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $936fd032dba44608$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $936fd032dba44608$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $936fd032dba44608$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $936fd032dba44608$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $936fd032dba44608$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $936fd032dba44608$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $936fd032dba44608$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $936fd032dba44608$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $936fd032dba44608$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $936fd032dba44608$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $936fd032dba44608$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $936fd032dba44608$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $936fd032dba44608$export$ffb0004e005737fa.from(content), $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $936fd032dba44608$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $936fd032dba44608$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $936fd032dba44608$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($936fd032dba44608$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $936fd032dba44608$export$85c928794f8d04d4(this, attrs, content.append(after), $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $936fd032dba44608$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $936fd032dba44608$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $936fd032dba44608$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $936fd032dba44608$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $936fd032dba44608$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $936fd032dba44608$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $936fd032dba44608$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $936fd032dba44608$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $936fd032dba44608$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $936fd032dba44608$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $936fd032dba44608$export$c9d15bcfc6d42044(this, $936fd032dba44608$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $936fd032dba44608$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $936fd032dba44608$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $936fd032dba44608$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $936fd032dba44608$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $936fd032dba44608$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $936fd032dba44608$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $936fd032dba44608$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $936fd032dba44608$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $936fd032dba44608$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $936fd032dba44608$var$TextNode(type, type.defaultAttrs, text, $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $936fd032dba44608$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $936fd032dba44608$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $936fd032dba44608$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $936fd032dba44608$var$isTagRule(rule) {
    return rule.tag != null;
}
function $936fd032dba44608$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $936fd032dba44608$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($936fd032dba44608$var$isTagRule(rule)) this.tags.push(rule);
            else if ($936fd032dba44608$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $936fd032dba44608$var$ParseContext(this, options, false);
        context.addAll(dom, $936fd032dba44608$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $936fd032dba44608$var$ParseContext(this, options, true);
        context.addAll(dom, $936fd032dba44608$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $936fd032dba44608$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($936fd032dba44608$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $936fd032dba44608$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $936fd032dba44608$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $936fd032dba44608$export$1059c6e7d2ce5669(schema, $936fd032dba44608$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $936fd032dba44608$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $936fd032dba44608$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $936fd032dba44608$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $936fd032dba44608$var$OPT_PRESERVE_WS = 1, $936fd032dba44608$var$OPT_PRESERVE_WS_FULL = 2, $936fd032dba44608$var$OPT_OPEN_LEFT = 4;
function $936fd032dba44608$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $936fd032dba44608$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $936fd032dba44608$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $936fd032dba44608$var$OPT_PRESERVE_WS | $936fd032dba44608$var$OPT_PRESERVE_WS_FULL : base & ~$936fd032dba44608$var$OPT_OPEN_LEFT;
}
class $936fd032dba44608$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $936fd032dba44608$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($936fd032dba44608$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $936fd032dba44608$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $936fd032dba44608$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($936fd032dba44608$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$936fd032dba44608$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $936fd032dba44608$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $936fd032dba44608$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $936fd032dba44608$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $936fd032dba44608$var$NodeContext(topNode.type, topNode.attrs, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $936fd032dba44608$var$NodeContext(null, null, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $936fd032dba44608$var$NodeContext(parser.schema.topNodeType, null, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $936fd032dba44608$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $936fd032dba44608$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($936fd032dba44608$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $936fd032dba44608$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $936fd032dba44608$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($936fd032dba44608$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $936fd032dba44608$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $936fd032dba44608$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $936fd032dba44608$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $936fd032dba44608$var$OPT_OPEN_LEFT;
        let applyMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $936fd032dba44608$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $936fd032dba44608$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $936fd032dba44608$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $936fd032dba44608$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $936fd032dba44608$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $936fd032dba44608$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $936fd032dba44608$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $936fd032dba44608$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $936fd032dba44608$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $936fd032dba44608$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $936fd032dba44608$var$renderSpec($936fd032dba44608$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $936fd032dba44608$var$renderSpec($936fd032dba44608$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $936fd032dba44608$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $936fd032dba44608$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $936fd032dba44608$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $936fd032dba44608$var$gatherToDOM(schema.marks);
    }
}
function $936fd032dba44608$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $936fd032dba44608$var$doc(options) {
    return options.document || window.document;
}
const $936fd032dba44608$var$suspiciousAttributeCache = new WeakMap();
function $936fd032dba44608$var$suspiciousAttributes(attrs) {
    let value = $936fd032dba44608$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $936fd032dba44608$var$suspiciousAttributeCache.set(attrs, value = $936fd032dba44608$var$suspiciousAttributesInner(attrs));
    return value;
}
function $936fd032dba44608$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $936fd032dba44608$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $936fd032dba44608$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $936fd032dba44608$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("h4D0i", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", function () { return $c6e110b7b18bfe47$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $c6e110b7b18bfe47$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $c6e110b7b18bfe47$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $c6e110b7b18bfe47$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $c6e110b7b18bfe47$export$4498a6080fed604c = 'fontStyle';
var $c6e110b7b18bfe47$export$f8e8a5f34f6ea725 = 'searchQuery';
var $c6e110b7b18bfe47$export$b395009ca7f092c7 = 'link';
var $c6e110b7b18bfe47$export$9b982809044276a6 = 'color';
var $c6e110b7b18bfe47$export$470d0905851e47a1 = 'alignment';
var $c6e110b7b18bfe47$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("hZivE", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", function () { return $d1867dc494bd6c56$export$daf54fed04c8fb77; });

var $1YMOy = parcelRequire("1YMOy");
function $d1867dc494bd6c56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1867dc494bd6c56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1867dc494bd6c56$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1867dc494bd6c56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1867dc494bd6c56$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $d1867dc494bd6c56$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $d1867dc494bd6c56$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $d1867dc494bd6c56$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$d1867dc494bd6c56$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $d1867dc494bd6c56$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $d1867dc494bd6c56$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $d1867dc494bd6c56$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("1cB6t", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $0e03b16b0c9376a4$export$8e53000a4ec837; });

var $eNjcd = parcelRequire("eNjcd");
var $0e03b16b0c9376a4$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $0e03b16b0c9376a4$export$8e53000a4ec837 = (0, $eNjcd.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("eNjcd", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $ac548837e97a5aca$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $ac548837e97a5aca$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $ac548837e97a5aca$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $ac548837e97a5aca$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $ac548837e97a5aca$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $ac548837e97a5aca$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $ac548837e97a5aca$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $ac548837e97a5aca$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $ac548837e97a5aca$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $ac548837e97a5aca$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $ac548837e97a5aca$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $ac548837e97a5aca$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $ac548837e97a5aca$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $ac548837e97a5aca$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $ac548837e97a5aca$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $ac548837e97a5aca$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $ac548837e97a5aca$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $ac548837e97a5aca$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $ac548837e97a5aca$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $ac548837e97a5aca$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $31mbR = parcelRequire("31mbR");
var $ac548837e97a5aca$export$8e53000a4ec837 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $ac548837e97a5aca$export$8512c9afa7b24c3b = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $ac548837e97a5aca$export$8c5a050822fd698c = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $ac548837e97a5aca$export$1edee58a52776cd9 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $ac548837e97a5aca$export$89015c65f1c75e3f = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $ac548837e97a5aca$export$6565f9f03506010b = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $ac548837e97a5aca$export$f3b72f8fc4684ecd = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $ac548837e97a5aca$export$3024f02c495408d6 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $ac548837e97a5aca$export$c63c6f932822f543 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$f00aeb236b6f05af = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $ac548837e97a5aca$export$480c699bd4ec0d86 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $ac548837e97a5aca$export$9c30223ca0a664fb = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $ac548837e97a5aca$export$4899a95d70ec5056 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$59ae2c325a998f89 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$b3401ee80eb31041 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$32f78bffcd82ff28 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $ac548837e97a5aca$export$20af3dabbb5538df = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $ac548837e97a5aca$export$425327af25286e5e = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$30d78d5eb6719bb8 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $ac548837e97a5aca$export$a316dc07ff5182a2 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("3TKhC", function(module, exports) {
$parcel$export(module.exports, "annotation", function () { return $2d6a690adc10bcf4$export$8512c9afa7b24c3b; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");
function $2d6a690adc10bcf4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d6a690adc10bcf4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d6a690adc10bcf4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d6a690adc10bcf4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d6a690adc10bcf4$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $2d6a690adc10bcf4$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $2d6a690adc10bcf4$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $2d6a690adc10bcf4$var$_objectSpread($2d6a690adc10bcf4$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $2d6a690adc10bcf4$export$8512c9afa7b24c3b = (0, $eNjcd.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $2d6a690adc10bcf4$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $2d6a690adc10bcf4$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("9kZG1", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", function () { return $6cc5d303e3007389$export$8c5a050822fd698c; });

var $1YMOy = parcelRequire("1YMOy");

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $1U0rY = parcelRequire("1U0rY");

var $7VJss = parcelRequire("7VJss");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $6cc5d303e3007389$var$colorArrayPalette = [
    [
        (0, $3G1IB.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3G1IB.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $3G1IB.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3G1IB.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3G1IB.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3G1IB.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $6cc5d303e3007389$var$colorArrayPaletteNext = [
    [
        (0, $3G1IB.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3G1IB.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $3G1IB.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3G1IB.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3G1IB.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $3G1IB.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3G1IB.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $6cc5d303e3007389$export$14ec3f21a268e497 = new Map();
$6cc5d303e3007389$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $6cc5d303e3007389$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $6cc5d303e3007389$export$7ab6fa38cecaeee2 = new Map();
$6cc5d303e3007389$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, $a8Fwx.default)(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $6cc5d303e3007389$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $6cc5d303e3007389$export$8c5a050822fd698c = (0, $eNjcd.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $3G1IB.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $6cc5d303e3007389$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $6cc5d303e3007389$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $kgm12.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $1U0rY.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7VJss.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1YMOy.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("1U0rY", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $162b5ecc8c87e88c$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $162b5ecc8c87e88c$export$32f78bffcd82ff28; });

var $1YMOy = parcelRequire("1YMOy");

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $7VJss = parcelRequire("7VJss");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $162b5ecc8c87e88c$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $3G1IB.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $3G1IB.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $3G1IB.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $3G1IB.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $3G1IB.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $3G1IB.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $3G1IB.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $3G1IB.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $3G1IB.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $3G1IB.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $3G1IB.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $3G1IB.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $3G1IB.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $3G1IB.N0),
        'White'
    ],
    [
        (0, $3G1IB.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $3G1IB.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $3G1IB.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $3G1IB.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $3G1IB.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $3G1IB.P50),
        'Light purple'
    ] // Lavender secret
];
var $162b5ecc8c87e88c$export$569885e57444f84a = new Map();
var $162b5ecc8c87e88c$export$81e5ed9e84fe2e28 = $162b5ecc8c87e88c$export$569885e57444f84a;
$162b5ecc8c87e88c$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $162b5ecc8c87e88c$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $162b5ecc8c87e88c$var$testGlobalTheme;
var $162b5ecc8c87e88c$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $162b5ecc8c87e88c$var$testGlobalTheme = theme;
};
var $162b5ecc8c87e88c$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($162b5ecc8c87e88c$var$testGlobalTheme) return {
        colorMode: $162b5ecc8c87e88c$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $162b5ecc8c87e88c$export$32f78bffcd82ff28 = (0, $eNjcd.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $3G1IB.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $162b5ecc8c87e88c$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $162b5ecc8c87e88c$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $kgm12.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($162b5ecc8c87e88c$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7VJss.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1YMOy.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("8Y0bD", function(module, exports) {
$parcel$export(module.exports, "border", function () { return $6874126355b0c2f4$export$1edee58a52776cd9; });

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $6874126355b0c2f4$var$borderColorArrayPalette = [
    [
        (0, $3G1IB.N300A),
        'Subtle gray'
    ],
    [
        (0, $3G1IB.N600),
        'Gray'
    ],
    [
        (0, $3G1IB.N1000),
        'Bold gray'
    ]
];
var $6874126355b0c2f4$export$e4e044c989c86ca7 = new Map();
$6874126355b0c2f4$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $6874126355b0c2f4$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $6874126355b0c2f4$export$1edee58a52776cd9 = (0, $eNjcd.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $6874126355b0c2f4$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $kgm12.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("c5ZSc", function(module, exports) {
$parcel$export(module.exports, "breakout", function () { return $8ce5f264af4bb2a2$export$89015c65f1c75e3f; });

var $eNjcd = parcelRequire("eNjcd");
var $8ce5f264af4bb2a2$var$allowedTypes = [
    'wide',
    'full-width'
];
var $8ce5f264af4bb2a2$export$89015c65f1c75e3f = (0, $eNjcd.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $8ce5f264af4bb2a2$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("eMlDB", function(module, exports) {
$parcel$export(module.exports, "code", function () { return $ac2655321a3e5a7f$export$6565f9f03506010b; });

var $eNjcd = parcelRequire("eNjcd");
var $ac2655321a3e5a7f$export$6565f9f03506010b = (0, $eNjcd.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("jeuXu", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", function () { return $e00756dd5729901d$export$f3b72f8fc4684ecd; });

var $eNjcd = parcelRequire("eNjcd");
var $e00756dd5729901d$export$f3b72f8fc4684ecd = (0, $eNjcd.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cHw09", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", function () { return $93f252fbc5d45318$export$3024f02c495408d6; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $bsB7c = parcelRequire("bsB7c");
function $93f252fbc5d45318$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93f252fbc5d45318$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93f252fbc5d45318$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93f252fbc5d45318$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $93f252fbc5d45318$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $bsB7c.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $93f252fbc5d45318$export$3024f02c495408d6 = (0, $eNjcd.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $93f252fbc5d45318$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $93f252fbc5d45318$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $93f252fbc5d45318$var$_objectSpread($93f252fbc5d45318$var$_objectSpread({}, acc), {}, (0, $1YMOy.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("bsB7c", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", function () { return $857f198744e4168b$export$c296e2d4365c37a5; });
var $857f198744e4168b$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("j0vam", function(module, exports) {
$parcel$export(module.exports, "em", function () { return $dd66315b456cacf4$export$c63c6f932822f543; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name em_mark
 */ var $dd66315b456cacf4$var$emDOM = [
    'em'
];
var $dd66315b456cacf4$export$c63c6f932822f543 = (0, $eNjcd.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $dd66315b456cacf4$var$emDOM;
    }
});

});

parcelRegister("fU1Bq", function(module, exports) {
$parcel$export(module.exports, "fragment", function () { return $b93d5436393175dd$export$f00aeb236b6f05af; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $bsB7c = parcelRequire("bsB7c");
function $b93d5436393175dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b93d5436393175dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b93d5436393175dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b93d5436393175dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $b93d5436393175dd$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $bsB7c.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $b93d5436393175dd$export$f00aeb236b6f05af = (0, $eNjcd.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $b93d5436393175dd$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $b93d5436393175dd$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $b93d5436393175dd$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("6d2bd", function(module, exports) {
$parcel$export(module.exports, "indentation", function () { return $4855a5d5320667fb$export$480c699bd4ec0d86; });

var $eNjcd = parcelRequire("eNjcd");
var $4855a5d5320667fb$export$480c699bd4ec0d86 = (0, $eNjcd.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("ajG4R", function(module, exports) {
$parcel$export(module.exports, "link", function () { return $782c516d5c6f031c$export$9c30223ca0a664fb; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $a4pR9 = parcelRequire("a4pR9");
function $782c516d5c6f031c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $782c516d5c6f031c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $782c516d5c6f031c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $782c516d5c6f031c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $782c516d5c6f031c$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $a4pR9.isSafeUrl)(href)) return false;
        if ((0, $a4pR9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $a4pR9.normalizeUrl)(href);
        return attrs;
    };
};
var $782c516d5c6f031c$export$9c30223ca0a664fb = (0, $eNjcd.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $782c516d5c6f031c$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $782c516d5c6f031c$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $a4pR9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $782c516d5c6f031c$var$_objectSpread($782c516d5c6f031c$var$_objectSpread({}, attrs), {}, (0, $1YMOy.default)((0, $1YMOy.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $782c516d5c6f031c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $782c516d5c6f031c$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($782c516d5c6f031c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("a4pR9", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", function () { return $754e559ef30256ef$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $754e559ef30256ef$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $754e559ef30256ef$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $6G09S = parcelRequire("6G09S");
var $754e559ef30256ef$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $754e559ef30256ef$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $754e559ef30256ef$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $754e559ef30256ef$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($6G09S)))();
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $754e559ef30256ef$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('tel:', $754e559ef30256ef$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('file:', $754e559ef30256ef$var$urlWithoutSpacesValidator);
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $754e559ef30256ef$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $754e559ef30256ef$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$754e559ef30256ef$var$tlds.push($754e559ef30256ef$var$tlds2Char);
$754e559ef30256ef$export$8ccbde94d5c7f8e7.tlds($754e559ef30256ef$var$tlds, false);
var $754e559ef30256ef$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $754e559ef30256ef$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$754e559ef30256ef$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($754e559ef30256ef$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($754e559ef30256ef$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $754e559ef30256ef$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $754e559ef30256ef$export$6f7d7761b97f967(str);
    if (!match.length) match = $754e559ef30256ef$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $754e559ef30256ef$export$6535eb414fa2c8b6(url) {
    var match = $754e559ef30256ef$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $754e559ef30256ef$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("6G09S", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $4dc6c9c6046af9b2$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $4dc6c9c6046af9b2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4dc6c9c6046af9b2$var$isString(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object String]';
}
function $4dc6c9c6046af9b2$var$isObject(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object Object]';
}
function $4dc6c9c6046af9b2$var$isRegExp(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object RegExp]';
}
function $4dc6c9c6046af9b2$var$isFunction(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object Function]';
}
function $4dc6c9c6046af9b2$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $4dc6c9c6046af9b2$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $4dc6c9c6046af9b2$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $4dc6c9c6046af9b2$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $4dc6c9c6046af9b2$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $4dc6c9c6046af9b2$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $4dc6c9c6046af9b2$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $4dc6c9c6046af9b2$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $4dc6c9c6046af9b2$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $4dc6c9c6046af9b2$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $4dc6c9c6046af9b2$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("lX4sA"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($4dc6c9c6046af9b2$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($4dc6c9c6046af9b2$var$isObject(val)) {
            if ($4dc6c9c6046af9b2$var$isRegExp(val.validate)) compiled.validate = $4dc6c9c6046af9b2$var$createValidator(val.validate);
            else if ($4dc6c9c6046af9b2$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($4dc6c9c6046af9b2$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $4dc6c9c6046af9b2$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($4dc6c9c6046af9b2$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $4dc6c9c6046af9b2$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($4dc6c9c6046af9b2$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $4dc6c9c6046af9b2$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $4dc6c9c6046af9b2$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $4dc6c9c6046af9b2$var$createMatch(self, shift) {
    var match = new $4dc6c9c6046af9b2$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $4dc6c9c6046af9b2$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $4dc6c9c6046af9b2$var$LinkifyIt)) return new $4dc6c9c6046af9b2$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($4dc6c9c6046af9b2$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $4dc6c9c6046af9b2$var$assign({}, $4dc6c9c6046af9b2$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $4dc6c9c6046af9b2$var$assign({}, $4dc6c9c6046af9b2$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $4dc6c9c6046af9b2$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $4dc6c9c6046af9b2$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $4dc6c9c6046af9b2$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $4dc6c9c6046af9b2$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($4dc6c9c6046af9b2$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($4dc6c9c6046af9b2$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $4dc6c9c6046af9b2$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $4dc6c9c6046af9b2$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $4dc6c9c6046af9b2$var$LinkifyIt;

});
parcelRegister("lX4sA", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("fKtA4", function(module, exports) {
$parcel$export(module.exports, "strike", function () { return $b772190722700a02$export$4899a95d70ec5056; });

var $eNjcd = parcelRequire("eNjcd");
var $b772190722700a02$export$4899a95d70ec5056 = (0, $eNjcd.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("iZbsN", function(module, exports) {
$parcel$export(module.exports, "strong", function () { return $dd26d0eba92e8259$export$59ae2c325a998f89; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name strong_mark
 */ var $dd26d0eba92e8259$var$strongDOM = [
    'strong'
];
var $dd26d0eba92e8259$export$59ae2c325a998f89 = (0, $eNjcd.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $dd26d0eba92e8259$var$strongDOM;
    }
});

});

parcelRegister("f623j", function(module, exports) {
$parcel$export(module.exports, "subsup", function () { return $afd9021b965aa1b5$export$b3401ee80eb31041; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name subsup_mark
 */ function $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $afd9021b965aa1b5$export$b3401ee80eb31041 = (0, $eNjcd.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dV25i", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", function () { return $a2223727e58f5604$export$20af3dabbb5538df; });

var $eNjcd = parcelRequire("eNjcd");

var $3G1IB = parcelRequire("3G1IB");
var $a2223727e58f5604$export$20af3dabbb5538df = (0, $eNjcd.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $3G1IB.B400))
            }
        ];
    }
});

});

parcelRegister("5TYds", function(module, exports) {
$parcel$export(module.exports, "underline", function () { return $44c0cc736738f4c1$export$425327af25286e5e; });

var $eNjcd = parcelRequire("eNjcd");
var $44c0cc736738f4c1$export$425327af25286e5e = (0, $eNjcd.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("5uc46", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", function () { return $3fe91cf72a678f19$export$30d78d5eb6719bb8; });

var $eNjcd = parcelRequire("eNjcd");
var $3fe91cf72a678f19$export$30d78d5eb6719bb8 = (0, $eNjcd.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("2BisJ", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $1e4d5bb5c5fcab67$export$a316dc07ff5182a2; });

var $eNjcd = parcelRequire("eNjcd");
var $1e4d5bb5c5fcab67$export$a316dc07ff5182a2 = (0, $eNjcd.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("6mMzQ", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $4a2a7a9409534959$export$c4c2f833baaebdb8; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $4a2a7a9409534959$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a2a7a9409534959$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a2a7a9409534959$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a2a7a9409534959$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $4a2a7a9409534959$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $4a2a7a9409534959$export$c4c2f833baaebdb8 = (0, $35i9Y.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $4a2a7a9409534959$export$9894f24949f094e5 = (0, $35i9Y.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread($4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread($4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("5sacJ", function(module, exports) {
$parcel$export(module.exports, "taskItem", function () { return $3f877ba8351ab5ec$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $3f877ba8351ab5ec$export$16018c61064a18df; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $3f877ba8351ab5ec$export$6d8b0ef52e2e6390 = (0, $35i9Y.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $3f877ba8351ab5ec$export$16018c61064a18df = (0, $35i9Y.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("DFUIs", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", function () { return $077427d5d739f894$export$27903d543b563e39; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $077427d5d739f894$export$27903d543b563e39 = (0, $35i9Y.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9RUN2", function(module, exports) {
$parcel$export(module.exports, "bulletList", function () { return $72f51d961bf3ef29$export$a140c94e5ea26bee; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $72f51d961bf3ef29$export$5f25a39efab3b58b = '.ak-ul';
var $72f51d961bf3ef29$export$a140c94e5ea26bee = (0, $35i9Y.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $72f51d961bf3ef29$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $72f51d961bf3ef29$export$dfd406053b2bab40 = (0, $35i9Y.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $72f51d961bf3ef29$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("claEk", function(module, exports) {
$parcel$export(module.exports, "caption", function () { return $8fbfb4f1a6a559d8$export$8e3c2dfdc4f0453d; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $8fbfb4f1a6a559d8$export$8e3c2dfdc4f0453d = (0, $35i9Y.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $8fbfb4f1a6a559d8$export$b5d01ee303c467aa = (0, $35i9Y.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8eXsH", function(module, exports) {
$parcel$export(module.exports, "codeBlock", function () { return $5ffdc16f21b215ff$export$7bb0d5c671655cc4; });

var $cENKH = parcelRequire("cENKH");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $5ffdc16f21b215ff$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $5ffdc16f21b215ff$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $5ffdc16f21b215ff$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $5ffdc16f21b215ff$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $5ffdc16f21b215ff$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $5ffdc16f21b215ff$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $5ffdc16f21b215ff$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $5ffdc16f21b215ff$export$7bb0d5c671655cc4 = (0, $35i9Y.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromEditorStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $5ffdc16f21b215ff$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $5ffdc16f21b215ff$var$parseCodeFromHtml(domNode);
                return code ? (0, $cENKH.Fragment).from(schema.text(code)) : (0, $cENKH.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $5ffdc16f21b215ff$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $5ffdc16f21b215ff$export$3f75de798a0b5356 = (0, $35i9Y.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromEditorStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $5ffdc16f21b215ff$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $5ffdc16f21b215ff$var$parseCodeFromHtml(domNode);
                return code ? (0, $cENKH.Fragment).from(schema.text(code)) : (0, $cENKH.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("a7fGe", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $75d6b89b18c397cd$export$daf889beb5092f95; });

var $35i9Y = parcelRequire("35i9Y");
var $75d6b89b18c397cd$var$name = 'confluenceJiraIssue';
var $75d6b89b18c397cd$export$daf889beb5092f95 = (0, $35i9Y.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($75d6b89b18c397cd$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $75d6b89b18c397cd$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("dDXbH", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $9eecd44da753db19$export$e6e4878f43c27cab; });

var $35i9Y = parcelRequire("35i9Y");
var $9eecd44da753db19$var$name = 'confluenceUnsupportedBlock';
var $9eecd44da753db19$export$e6e4878f43c27cab = (0, $35i9Y.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $9eecd44da753db19$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($9eecd44da753db19$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("9YFvh", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $7439e963684b03ca$export$3e6d667072febc87; });

var $35i9Y = parcelRequire("35i9Y");
var $7439e963684b03ca$var$name = 'confluenceUnsupportedInline';
var $7439e963684b03ca$export$3e6d667072febc87 = (0, $35i9Y.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $7439e963684b03ca$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($7439e963684b03ca$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("7C5L2", function(module, exports) {
$parcel$export(module.exports, "date", function () { return $58b08c5f85b5b872$export$324d90190a8b822a; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $58b08c5f85b5b872$export$324d90190a8b822a = (0, $35i9Y.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $58b08c5f85b5b872$export$a6a035390e3921b2 = (0, $35i9Y.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("g4DXa", function(module, exports) {
$parcel$export(module.exports, "decisionItem", function () { return $bb3c02f2190f0044$export$6959e16eeff859b4; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $bb3c02f2190f0044$export$6959e16eeff859b4 = (0, $35i9Y.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bLcwV", function(module, exports) {
$parcel$export(module.exports, "decisionList", function () { return $88fdcdb5247a3d7c$export$62d45a65fb43d95e; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name decisionList_node
 */ var $88fdcdb5247a3d7c$var$name = 'decisionList';
var $88fdcdb5247a3d7c$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($88fdcdb5247a3d7c$var$name, "\"]");
var $88fdcdb5247a3d7c$export$62d45a65fb43d95e = (0, $35i9Y.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($88fdcdb5247a3d7c$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $88fdcdb5247a3d7c$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7NNlE", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return $5ae3638b1287f2e1$export$2a111da947c407d2; });

var $35i9Y = parcelRequire("35i9Y");
var $5ae3638b1287f2e1$export$2a111da947c407d2 = (0, $35i9Y.doc)({});

});

parcelRegister("ibsHe", function(module, exports) {
$parcel$export(module.exports, "embedCard", function () { return $d3cf83934b8d3362$export$be4283d9a1cb1ff6; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $d3cf83934b8d3362$export$be4283d9a1cb1ff6 = (0, $35i9Y.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $d3cf83934b8d3362$export$36734475a7f6fd3e = (0, $35i9Y.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("73CSr", function(module, exports) {
$parcel$export(module.exports, "emoji", function () { return $5236f85f20935fc1$export$a19185d1233fc4b2; });

var $1YMOy = parcelRequire("1YMOy");

var $eHwH7 = parcelRequire("eHwH7");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $5236f85f20935fc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5236f85f20935fc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5236f85f20935fc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5236f85f20935fc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5236f85f20935fc1$export$a19185d1233fc4b2 = (0, $35i9Y.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $eHwH7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $eHwH7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $5236f85f20935fc1$export$ebb3b3c7a0ac9936 = (0, $35i9Y.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $eHwH7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return $5236f85f20935fc1$var$_objectSpread($5236f85f20935fc1$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $eHwH7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return $5236f85f20935fc1$var$_objectSpread($5236f85f20935fc1$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("eHwH7", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", function () { return $ab3e714c84617cb4$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $ab3e714c84617cb4$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $ab3e714c84617cb4$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $ab3e714c84617cb4$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $ab3e714c84617cb4$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $ab3e714c84617cb4$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $ab3e714c84617cb4$export$f61e93bda2a8b420(acName) {
    var emojiData = $ab3e714c84617cb4$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $ab3e714c84617cb4$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $ab3e714c84617cb4$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $ab3e714c84617cb4$var$acNameToEmojiMap[acName] ? $ab3e714c84617cb4$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($ab3e714c84617cb4$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $ab3e714c84617cb4$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($ab3e714c84617cb4$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $ab3e714c84617cb4$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $ab3e714c84617cb4$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($ab3e714c84617cb4$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $ab3e714c84617cb4$var$getAcNameFromShortName(shortName);
        if (possibleName in $ab3e714c84617cb4$var$acNameToEmojiMap) return possibleName;
    }
    return $ab3e714c84617cb4$export$bc94e44ec0e7bd82(id) || $ab3e714c84617cb4$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("cbmTE", function(module, exports) {
$parcel$export(module.exports, "extendedBlockquote", function () { return $8de845e3a37e9954$export$70a64939da3e8455; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name blockquote_node
 */ var $8de845e3a37e9954$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $8de845e3a37e9954$export$67dc04e652a298ca = (0, $35i9Y.blockquoteLegacy)($8de845e3a37e9954$var$nodeSpecOptions);
var $8de845e3a37e9954$export$70a64939da3e8455 = (0, $35i9Y.blockquote)($8de845e3a37e9954$var$nodeSpecOptions);
var $8de845e3a37e9954$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $8de845e3a37e9954$export$950ebf43f3364a0f = (0, $35i9Y.blockquote)($8de845e3a37e9954$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("2cUVb", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", function () { return $19b8db2a3bf05110$export$ce20b13564211141; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $19b8db2a3bf05110$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b8db2a3bf05110$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b8db2a3bf05110$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b8db2a3bf05110$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b8db2a3bf05110$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $19b8db2a3bf05110$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $19b8db2a3bf05110$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $dS3bo.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $19b8db2a3bf05110$var$_objectSpread($19b8db2a3bf05110$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $19b8db2a3bf05110$export$969277cf61e5a7aa.CUSTOM ? $19b8db2a3bf05110$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $19b8db2a3bf05110$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $19b8db2a3bf05110$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $19b8db2a3bf05110$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $19b8db2a3bf05110$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $35i9Y.panel)($19b8db2a3bf05110$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $19b8db2a3bf05110$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $35i9Y.panel)($19b8db2a3bf05110$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("d9aBX", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $992458d03bc20d69$export$1b45514b112dd749; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $992458d03bc20d69$export$1b45514b112dd749 = (0, $35i9Y.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("g8K3J", function(module, exports) {
$parcel$export(module.exports, "hardBreak", function () { return $bc011f153b1c0b0e$export$371da9dd35aba193; });

var $35i9Y = parcelRequire("35i9Y");
var $bc011f153b1c0b0e$export$371da9dd35aba193 = (0, $35i9Y.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("kF1fR", function(module, exports) {
$parcel$export(module.exports, "heading", function () { return $f0a89c2e76efee47$export$46e4a324ac90507f; });

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $f0a89c2e76efee47$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $f0a89c2e76efee47$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $f0a89c2e76efee47$export$46e4a324ac90507f = (0, $35i9Y.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("8kQDF", function(module, exports) {
$parcel$export(module.exports, "image", function () { return $611905f11179a3b7$export$5c452ff88e35e47d; });

var $35i9Y = parcelRequire("35i9Y");
var $611905f11179a3b7$export$5c452ff88e35e47d = (0, $35i9Y.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("fRQyu", function(module, exports) {
$parcel$export(module.exports, "inlineCard", function () { return $b8d492a5d8e4d913$export$cbf8224b64e0d942; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $b8d492a5d8e4d913$export$cbf8224b64e0d942 = (0, $35i9Y.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $b8d492a5d8e4d913$export$7ed775fc743eadd1 = (0, $35i9Y.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("bqFdW", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", function () { return $8522199dc9f3c632$export$16b353b2649bd8d9; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $8522199dc9f3c632$export$16b353b2649bd8d9 = (0, $35i9Y.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("dfjwm", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", function () { return $9a4bd18d8a6db577$export$ab76e7c03cd6f650; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $9a4bd18d8a6db577$export$ab76e7c03cd6f650 = (0, $35i9Y.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $9a4bd18d8a6db577$export$b2e27d292505bac2 = (0, $35i9Y.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("dDMCS", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", function () { return $9ee4a306504d16fe$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $9ee4a306504d16fe$export$987d49ffe1b0900f; });

var $1YMOy = parcelRequire("1YMOy");

var $3G1IB = parcelRequire("3G1IB");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $9ee4a306504d16fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ee4a306504d16fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ee4a306504d16fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ee4a306504d16fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ee4a306504d16fe$export$bb3fe706be61f640 = (0, $35i9Y.media)({}).attrs;
var $9ee4a306504d16fe$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $9ee4a306504d16fe$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $dS3bo.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $3G1IB.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $9ee4a306504d16fe$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($9ee4a306504d16fe$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $35i9Y.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $35i9Y.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $dS3bo.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $9ee4a306504d16fe$export$987d49ffe1b0900f = $9ee4a306504d16fe$export$35bdbf5bc8caa677($9ee4a306504d16fe$export$bb3fe706be61f640, false, false);
var $9ee4a306504d16fe$export$8446e47a4c7fd000 = $9ee4a306504d16fe$export$35bdbf5bc8caa677($9ee4a306504d16fe$var$_objectSpread($9ee4a306504d16fe$var$_objectSpread({}, $9ee4a306504d16fe$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $dS3bo.uuid).generate()
    }
}), false, true);
var $9ee4a306504d16fe$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $9ee4a306504d16fe$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($9ee4a306504d16fe$export$987d49ffe1b0900f.attrs) Object.keys($9ee4a306504d16fe$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $9ee4a306504d16fe$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $9ee4a306504d16fe$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $9ee4a306504d16fe$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $9ee4a306504d16fe$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($9ee4a306504d16fe$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("gDmwP", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", function () { return $c1c1c38dc1e45d75$export$2855e964765eac9; });

var $35i9Y = parcelRequire("35i9Y");
var $c1c1c38dc1e45d75$export$2855e964765eac9 = (0, $35i9Y.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("akl9R", function(module, exports) {
$parcel$export(module.exports, "mediaInline", function () { return $784c2f294259f8e8$export$38bab695e3f720f1; });

var $1YMOy = parcelRequire("1YMOy");

var $dDMCS = parcelRequire("dDMCS");

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
function $784c2f294259f8e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $784c2f294259f8e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $784c2f294259f8e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $784c2f294259f8e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $784c2f294259f8e8$export$38bab695e3f720f1 = (0, $dDMCS.createMediaSpec)((0, $35i9Y.mediaInline)({}).attrs, true);
var $784c2f294259f8e8$export$aea8e9c496505c61 = (0, $dDMCS.createMediaSpec)($784c2f294259f8e8$var$_objectSpread($784c2f294259f8e8$var$_objectSpread({}, (0, $35i9Y.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $dS3bo.uuid).generate()
    }
}), true, true);

});

parcelRegister("6x4c2", function(module, exports) {
$parcel$export(module.exports, "mediaSingleFull", function () { return $4c1913d77641c620$export$7e767666f2ce108a; });

var $1YMOy = parcelRequire("1YMOy");

var $5bIoc = parcelRequire("5bIoc");

var $bsB7c = parcelRequire("bsB7c");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $4c1913d77641c620$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c1913d77641c620$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c1913d77641c620$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c1913d77641c620$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c1913d77641c620$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $4c1913d77641c620$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $bsB7c.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $dS3bo.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $5bIoc.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $4c1913d77641c620$var$_objectSpread($4c1913d77641c620$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $5bIoc.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $35i9Y.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $35i9Y.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $35i9Y.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $35i9Y.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $4c1913d77641c620$export$969fe3781ca15058 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $4c1913d77641c620$export$d35e6c006d4abdfb = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $4c1913d77641c620$export$9c58e19811ce4cf5 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $4c1913d77641c620$export$7e767666f2ce108a = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $4c1913d77641c620$export$75376a385837c942 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $4c1913d77641c620$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("5bIoc", function(module, exports) {
$parcel$export(module.exports, "WidthType", function () { return $3c706999eecfd957$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $3c706999eecfd957$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("jPkEj", function(module, exports) {
$parcel$export(module.exports, "mention", function () { return $e6f2cc405ace1bdb$export$db83999c14438df4; });

var $1YMOy = parcelRequire("1YMOy");

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
function $e6f2cc405ace1bdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6f2cc405ace1bdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6f2cc405ace1bdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6f2cc405ace1bdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e6f2cc405ace1bdb$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $e6f2cc405ace1bdb$export$db83999c14438df4 = (0, $35i9Y.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($e6f2cc405ace1bdb$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $e6f2cc405ace1bdb$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $e6f2cc405ace1bdb$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($e6f2cc405ace1bdb$var$isOptional(key) && !node.attrs[key]) return obj;
            return $e6f2cc405ace1bdb$var$_objectSpread($e6f2cc405ace1bdb$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("8Cmqn", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", function () { return $646344591aea69f6$export$63cadbf5f4296627; });

var $jVI1z = parcelRequire("jVI1z");

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $646344591aea69f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $646344591aea69f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $646344591aea69f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $646344591aea69f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $646344591aea69f6$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $dS3bo.uuid).generate() : undefined
    };
}
var $646344591aea69f6$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $646344591aea69f6$export$63cadbf5f4296627 = (0, $35i9Y.nestedExpand)($646344591aea69f6$var$nestedExpandFactoryOptions);
var $646344591aea69f6$export$b854197485aa1fa0 = (0, $35i9Y.nestedExpand)($646344591aea69f6$var$_objectSpread($646344591aea69f6$var$_objectSpread({}, $646344591aea69f6$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $jVI1z.default)($646344591aea69f6$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("jVI1z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8257d8263c032c9$export$2e2bcd8739ae039; });

var $bBmTF = parcelRequire("bBmTF");

var $bfQa9 = parcelRequire("bfQa9");

var $aDOnL = parcelRequire("aDOnL");

var $ka7Ss = parcelRequire("ka7Ss");
function $e8257d8263c032c9$export$2e2bcd8739ae039(r) {
    return (0, $bBmTF.default)(r) || (0, $bfQa9.default)(r) || (0, $aDOnL.default)(r) || (0, $ka7Ss.default)();
}

});
parcelRegister("bBmTF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8724e93d75a1e517$export$2e2bcd8739ae039; });

var $adcIJ = parcelRequire("adcIJ");
function $8724e93d75a1e517$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $adcIJ.default)(r);
}

});

parcelRegister("bfQa9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83198ed64f6a54f6$export$2e2bcd8739ae039; });
function $83198ed64f6a54f6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("ka7Ss", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eadada18eb2da881$export$2e2bcd8739ae039; });
function $eadada18eb2da881$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("hPlli", function(module, exports) {
$parcel$export(module.exports, "orderedListWithOrder", function () { return $cfa7c14363a46fe0$export$b9ab759e8298198f; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $cfa7c14363a46fe0$export$4e7125c7ff595be5 = '.ak-ol';
var $cfa7c14363a46fe0$export$a5dc81035676e7a = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $cfa7c14363a46fe0$export$8157adc5747ec436 = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $cfa7c14363a46fe0$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $cfa7c14363a46fe0$export$b9ab759e8298198f = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $cfa7c14363a46fe0$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $cfa7c14363a46fe0$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $cfa7c14363a46fe0$export$2ea3505d41d7525d = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $dS3bo.uuid).generate();
                if (startDOMAttr) {
                    var start = $cfa7c14363a46fe0$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $cfa7c14363a46fe0$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("enD9G", function(module, exports) {
$parcel$export(module.exports, "paragraph", function () { return $a78196104b203737$export$9c206ddddb32a9b; });

var $35i9Y = parcelRequire("35i9Y");
var $a78196104b203737$export$9c206ddddb32a9b = (0, $35i9Y.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $a78196104b203737$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("lDmie", function(module, exports) {
$parcel$export(module.exports, "placeholder", function () { return $fbfe886ce576a491$export$c7187bbd1a7a9244; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $fbfe886ce576a491$export$c7187bbd1a7a9244 = (0, $35i9Y.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $fbfe886ce576a491$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $fbfe886ce576a491$export$6205248609a8f7a0 = (0, $35i9Y.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $fbfe886ce576a491$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("2KjdB", function(module, exports) {
$parcel$export(module.exports, "rule", function () { return $1ffec90825b7f118$export$fbeb3a3956e8a3c7; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name rule_node
 */ var $1ffec90825b7f118$var$hrDOM = [
    'hr'
];
var $1ffec90825b7f118$export$fbeb3a3956e8a3c7 = (0, $35i9Y.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $1ffec90825b7f118$var$hrDOM;
    }
});
var $1ffec90825b7f118$export$bf3ef6fb6ad90e7 = (0, $35i9Y.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("9DZID", function(module, exports) {
$parcel$export(module.exports, "status", function () { return $7057a1aab71a3024$export$471f7ae5c4103ae1; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $7057a1aab71a3024$export$471f7ae5c4103ae1 = (0, $35i9Y.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $dS3bo.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iaDy5", function(module, exports) {
$parcel$export(module.exports, "taskList", function () { return $d3a7d6ba5e7a5d98$export$375b6afcc5f4d291; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name taskList_node
 */ var $d3a7d6ba5e7a5d98$var$name = 'actionList';
var $d3a7d6ba5e7a5d98$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($d3a7d6ba5e7a5d98$var$name, "\"]");
var $d3a7d6ba5e7a5d98$export$375b6afcc5f4d291 = (0, $35i9Y.taskList)({
    parseDOM: [
        {
            tag: "div".concat($d3a7d6ba5e7a5d98$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $d3a7d6ba5e7a5d98$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("4VC0J", function(module, exports) {
$parcel$export(module.exports, "text", function () { return $3969f872877a616f$export$6f093cfa640b7166; });

var $35i9Y = parcelRequire("35i9Y");
var $3969f872877a616f$export$6f093cfa640b7166 = (0, $35i9Y.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("sM3wy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0567e4875b407b0d$export$2e2bcd8739ae039; });
var $0567e4875b407b0d$var$name = 'unknownBlock';
var $0567e4875b407b0d$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $0567e4875b407b0d$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($0567e4875b407b0d$var$name, "\"]")
        }
    ]
};

});

parcelRegister("lztMS", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", function () { return $fb43f9027f07863c$export$44b79b0979d0f0f7; });

var $35i9Y = parcelRequire("35i9Y");
var $fb43f9027f07863c$export$44b79b0979d0f0f7 = (0, $35i9Y.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("lbKeT", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", function () { return $f6ce7e325beda109$export$310ebe0d80122e9b; });

var $35i9Y = parcelRequire("35i9Y");
var $f6ce7e325beda109$export$310ebe0d80122e9b = (0, $35i9Y.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("7h1bJ", function(module, exports) {
$parcel$export(module.exports, "MarkdownParser", function () { return $54bb0ae2135af5d8$export$a64f782182dea128; });

var $gKssO = parcelRequire("gKssO");
parcelRequire("3dROR");
var $83SZT = parcelRequire("83SZT");
/**
Document schema for the data model used by CommonMark.
*/ const $54bb0ae2135af5d8$export$4902baddc787debb = new (0, $gKssO.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $54bb0ae2135af5d8$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $gKssO.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $54bb0ae2135af5d8$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $gKssO.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $54bb0ae2135af5d8$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $gKssO.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $54bb0ae2135af5d8$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $54bb0ae2135af5d8$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $54bb0ae2135af5d8$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $54bb0ae2135af5d8$var$noOp() {}
function $54bb0ae2135af5d8$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($54bb0ae2135af5d8$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $54bb0ae2135af5d8$var$attrs(spec, tok, tokens, i));
                state.addText($54bb0ae2135af5d8$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $54bb0ae2135af5d8$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $54bb0ae2135af5d8$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($54bb0ae2135af5d8$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($54bb0ae2135af5d8$var$attrs(spec, tok, tokens, i)));
                state.addText($54bb0ae2135af5d8$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($54bb0ae2135af5d8$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($54bb0ae2135af5d8$var$noCloseToken(spec, type)) handlers[type] = $54bb0ae2135af5d8$var$noOp;
            else {
                handlers[type + "_open"] = $54bb0ae2135af5d8$var$noOp;
                handlers[type + "_close"] = $54bb0ae2135af5d8$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $54bb0ae2135af5d8$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $54bb0ae2135af5d8$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $54bb0ae2135af5d8$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $54bb0ae2135af5d8$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $54bb0ae2135af5d8$export$7517583227ad0cb8 = new $54bb0ae2135af5d8$export$a64f782182dea128($54bb0ae2135af5d8$export$4902baddc787debb, (0, $83SZT.default)("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $54bb0ae2135af5d8$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $54bb0ae2135af5d8$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $54bb0ae2135af5d8$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $54bb0ae2135af5d8$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $54bb0ae2135af5d8$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $54bb0ae2135af5d8$export$f996452ca6e9a0ae = new $54bb0ae2135af5d8$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $54bb0ae2135af5d8$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $54bb0ae2135af5d8$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $54bb0ae2135af5d8$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $54bb0ae2135af5d8$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $54bb0ae2135af5d8$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $54bb0ae2135af5d8$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $54bb0ae2135af5d8$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});
parcelRegister("gKssO", function(module, exports) {
$parcel$export(module.exports, "Mark", function () { return $c3170582b0843f61$export$c9d15bcfc6d42044; });
$parcel$export(module.exports, "Schema", function () { return $c3170582b0843f61$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $c3170582b0843f61$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $c3170582b0843f61$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $c3170582b0843f61$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $c3170582b0843f61$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $c3170582b0843f61$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $c3170582b0843f61$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $c3170582b0843f61$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $c3170582b0843f61$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $c3170582b0843f61$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $c3170582b0843f61$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $c3170582b0843f61$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $c3170582b0843f61$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $c3170582b0843f61$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $c3170582b0843f61$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $c3170582b0843f61$var$retIndex(0, pos);
        if (pos == this.size) return $c3170582b0843f61$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $c3170582b0843f61$var$retIndex(i + 1, end);
                return $c3170582b0843f61$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $c3170582b0843f61$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $c3170582b0843f61$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $c3170582b0843f61$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $c3170582b0843f61$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $c3170582b0843f61$export$ffb0004e005737fa.empty;
        if (nodes instanceof $c3170582b0843f61$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $c3170582b0843f61$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $c3170582b0843f61$export$ffb0004e005737fa.empty = new $c3170582b0843f61$export$ffb0004e005737fa([], 0);
const $c3170582b0843f61$var$found = {
    index: 0,
    offset: 0
};
function $c3170582b0843f61$var$retIndex(index, offset) {
    $c3170582b0843f61$var$found.index = index;
    $c3170582b0843f61$var$found.offset = offset;
    return $c3170582b0843f61$var$found;
}
function $c3170582b0843f61$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$c3170582b0843f61$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$c3170582b0843f61$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $c3170582b0843f61$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $c3170582b0843f61$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $c3170582b0843f61$export$c9d15bcfc6d42044.none;
        if (marks instanceof $c3170582b0843f61$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $c3170582b0843f61$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $c3170582b0843f61$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $c3170582b0843f61$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $c3170582b0843f61$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $c3170582b0843f61$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $c3170582b0843f61$export$b3f2e2de3a8baa1e($c3170582b0843f61$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $c3170582b0843f61$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $c3170582b0843f61$export$b3f2e2de3a8baa1e($c3170582b0843f61$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $c3170582b0843f61$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $c3170582b0843f61$export$b3f2e2de3a8baa1e.empty = new $c3170582b0843f61$export$b3f2e2de3a8baa1e($c3170582b0843f61$export$ffb0004e005737fa.empty, 0, 0);
function $c3170582b0843f61$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($c3170582b0843f61$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $c3170582b0843f61$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $c3170582b0843f61$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $c3170582b0843f61$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $c3170582b0843f61$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $c3170582b0843f61$export$6de0e778727af3f2("Inconsistent open depths");
    return $c3170582b0843f61$var$replaceOuter($from, $to, slice, 0);
}
function $c3170582b0843f61$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $c3170582b0843f61$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $c3170582b0843f61$var$close(node, $c3170582b0843f61$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $c3170582b0843f61$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $c3170582b0843f61$var$prepareSliceForReplace(slice, $from);
        return $c3170582b0843f61$var$close(node, $c3170582b0843f61$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $c3170582b0843f61$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $c3170582b0843f61$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $c3170582b0843f61$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $c3170582b0843f61$var$checkJoin(node, $after.node(depth));
    return node;
}
function $c3170582b0843f61$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $c3170582b0843f61$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $c3170582b0843f61$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$c3170582b0843f61$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $c3170582b0843f61$var$addNode($end.nodeBefore, target);
}
function $c3170582b0843f61$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $c3170582b0843f61$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $c3170582b0843f61$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $c3170582b0843f61$var$joinable($end, $to, depth + 1);
    let content = [];
    $c3170582b0843f61$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $c3170582b0843f61$var$checkJoin(openStart, openEnd);
        $c3170582b0843f61$var$addNode($c3170582b0843f61$var$close(openStart, $c3170582b0843f61$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $c3170582b0843f61$var$addNode($c3170582b0843f61$var$close(openStart, $c3170582b0843f61$var$replaceTwoWay($from, $start, depth + 1)), content);
        $c3170582b0843f61$var$addRange($start, $end, depth, content);
        if (openEnd) $c3170582b0843f61$var$addNode($c3170582b0843f61$var$close(openEnd, $c3170582b0843f61$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $c3170582b0843f61$var$addRange($to, null, depth, content);
    return new $c3170582b0843f61$export$ffb0004e005737fa(content);
}
function $c3170582b0843f61$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $c3170582b0843f61$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $c3170582b0843f61$var$joinable($from, $to, depth + 1);
        $c3170582b0843f61$var$addNode($c3170582b0843f61$var$close(type, $c3170582b0843f61$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $c3170582b0843f61$var$addRange($to, null, depth, content);
    return new $c3170582b0843f61$export$ffb0004e005737fa(content);
}
function $c3170582b0843f61$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($c3170582b0843f61$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $c3170582b0843f61$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $c3170582b0843f61$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $c3170582b0843f61$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $c3170582b0843f61$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $c3170582b0843f61$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $c3170582b0843f61$var$resolveCache.set(doc, cache = new $c3170582b0843f61$var$ResolveCache);
        let result = cache.elts[cache.i] = $c3170582b0843f61$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $c3170582b0843f61$var$resolveCacheSize;
        return result;
    }
}
class $c3170582b0843f61$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $c3170582b0843f61$var$resolveCacheSize = 12, $c3170582b0843f61$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $c3170582b0843f61$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $c3170582b0843f61$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $c3170582b0843f61$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $c3170582b0843f61$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $c3170582b0843f61$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $c3170582b0843f61$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $c3170582b0843f61$var$emptyAttrs) && $c3170582b0843f61$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $c3170582b0843f61$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $c3170582b0843f61$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $c3170582b0843f61$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $c3170582b0843f61$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $c3170582b0843f61$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $c3170582b0843f61$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $c3170582b0843f61$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $c3170582b0843f61$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $c3170582b0843f61$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $c3170582b0843f61$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $c3170582b0843f61$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$c3170582b0843f61$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $c3170582b0843f61$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$c3170582b0843f61$export$85c928794f8d04d4.prototype.text = undefined;
class $c3170582b0843f61$var$TextNode extends $c3170582b0843f61$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $c3170582b0843f61$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $c3170582b0843f61$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $c3170582b0843f61$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $c3170582b0843f61$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $c3170582b0843f61$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $c3170582b0843f61$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $c3170582b0843f61$export$364ed450558d7ec4.empty;
        let expr = $c3170582b0843f61$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $c3170582b0843f61$var$dfa($c3170582b0843f61$var$nfa(expr));
        $c3170582b0843f61$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $c3170582b0843f61$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $c3170582b0843f61$export$364ed450558d7ec4.empty = new $c3170582b0843f61$export$364ed450558d7ec4(true);
class $c3170582b0843f61$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $c3170582b0843f61$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($c3170582b0843f61$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $c3170582b0843f61$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($c3170582b0843f61$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $c3170582b0843f61$var$parseExprSubscript(stream) {
    let expr = $c3170582b0843f61$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $c3170582b0843f61$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $c3170582b0843f61$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $c3170582b0843f61$var$parseExprRange(stream, expr) {
    let min = $c3170582b0843f61$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $c3170582b0843f61$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $c3170582b0843f61$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $c3170582b0843f61$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $c3170582b0843f61$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $c3170582b0843f61$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $c3170582b0843f61$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $c3170582b0843f61$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $c3170582b0843f61$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($c3170582b0843f61$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $c3170582b0843f61$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($c3170582b0843f61$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $c3170582b0843f61$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $c3170582b0843f61$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($c3170582b0843f61$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $c3170582b0843f61$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $c3170582b0843f61$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $c3170582b0843f61$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $c3170582b0843f61$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $c3170582b0843f61$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $c3170582b0843f61$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $c3170582b0843f61$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $c3170582b0843f61$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $c3170582b0843f61$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $c3170582b0843f61$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $c3170582b0843f61$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $c3170582b0843f61$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $c3170582b0843f61$export$ffb0004e005737fa.from(content), $c3170582b0843f61$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $c3170582b0843f61$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $c3170582b0843f61$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $c3170582b0843f61$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $c3170582b0843f61$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($c3170582b0843f61$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $c3170582b0843f61$export$85c928794f8d04d4(this, attrs, content.append(after), $c3170582b0843f61$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $c3170582b0843f61$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $c3170582b0843f61$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $c3170582b0843f61$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $c3170582b0843f61$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $c3170582b0843f61$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $c3170582b0843f61$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $c3170582b0843f61$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $c3170582b0843f61$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $c3170582b0843f61$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $c3170582b0843f61$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $c3170582b0843f61$export$c9d15bcfc6d42044(this, $c3170582b0843f61$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $c3170582b0843f61$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $c3170582b0843f61$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $c3170582b0843f61$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $c3170582b0843f61$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $c3170582b0843f61$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $c3170582b0843f61$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $c3170582b0843f61$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $c3170582b0843f61$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $c3170582b0843f61$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $c3170582b0843f61$var$TextNode(type, type.defaultAttrs, text, $c3170582b0843f61$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $c3170582b0843f61$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $c3170582b0843f61$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $c3170582b0843f61$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $c3170582b0843f61$var$isTagRule(rule) {
    return rule.tag != null;
}
function $c3170582b0843f61$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $c3170582b0843f61$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($c3170582b0843f61$var$isTagRule(rule)) this.tags.push(rule);
            else if ($c3170582b0843f61$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $c3170582b0843f61$var$ParseContext(this, options, false);
        context.addAll(dom, $c3170582b0843f61$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $c3170582b0843f61$var$ParseContext(this, options, true);
        context.addAll(dom, $c3170582b0843f61$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $c3170582b0843f61$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($c3170582b0843f61$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $c3170582b0843f61$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $c3170582b0843f61$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $c3170582b0843f61$export$1059c6e7d2ce5669(schema, $c3170582b0843f61$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $c3170582b0843f61$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $c3170582b0843f61$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $c3170582b0843f61$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $c3170582b0843f61$var$OPT_PRESERVE_WS = 1, $c3170582b0843f61$var$OPT_PRESERVE_WS_FULL = 2, $c3170582b0843f61$var$OPT_OPEN_LEFT = 4;
function $c3170582b0843f61$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $c3170582b0843f61$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $c3170582b0843f61$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $c3170582b0843f61$var$OPT_PRESERVE_WS | $c3170582b0843f61$var$OPT_PRESERVE_WS_FULL : base & ~$c3170582b0843f61$var$OPT_OPEN_LEFT;
}
class $c3170582b0843f61$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $c3170582b0843f61$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $c3170582b0843f61$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($c3170582b0843f61$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $c3170582b0843f61$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $c3170582b0843f61$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($c3170582b0843f61$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$c3170582b0843f61$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $c3170582b0843f61$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $c3170582b0843f61$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $c3170582b0843f61$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $c3170582b0843f61$var$NodeContext(topNode.type, topNode.attrs, $c3170582b0843f61$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $c3170582b0843f61$var$NodeContext(null, null, $c3170582b0843f61$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $c3170582b0843f61$var$NodeContext(parser.schema.topNodeType, null, $c3170582b0843f61$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $c3170582b0843f61$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $c3170582b0843f61$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($c3170582b0843f61$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $c3170582b0843f61$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $c3170582b0843f61$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($c3170582b0843f61$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $c3170582b0843f61$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $c3170582b0843f61$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $c3170582b0843f61$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $c3170582b0843f61$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $c3170582b0843f61$var$OPT_OPEN_LEFT;
        let applyMarks = $c3170582b0843f61$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $c3170582b0843f61$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $c3170582b0843f61$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $c3170582b0843f61$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $c3170582b0843f61$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $c3170582b0843f61$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $c3170582b0843f61$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $c3170582b0843f61$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $c3170582b0843f61$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $c3170582b0843f61$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $c3170582b0843f61$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $c3170582b0843f61$var$renderSpec($c3170582b0843f61$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $c3170582b0843f61$var$renderSpec($c3170582b0843f61$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $c3170582b0843f61$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $c3170582b0843f61$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $c3170582b0843f61$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $c3170582b0843f61$var$gatherToDOM(schema.marks);
    }
}
function $c3170582b0843f61$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $c3170582b0843f61$var$doc(options) {
    return options.document || window.document;
}
const $c3170582b0843f61$var$suspiciousAttributeCache = new WeakMap();
function $c3170582b0843f61$var$suspiciousAttributes(attrs) {
    let value = $c3170582b0843f61$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $c3170582b0843f61$var$suspiciousAttributeCache.set(attrs, value = $c3170582b0843f61$var$suspiciousAttributesInner(attrs));
    return value;
}
function $c3170582b0843f61$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $c3170582b0843f61$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $c3170582b0843f61$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $c3170582b0843f61$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("3dROR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("83SZT")).default; });

var $83SZT = parcelRequire("83SZT");

});
parcelRegister("83SZT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5de943da01717be1$export$2e2bcd8739ae039; });
// Main parser class

var $hHkmo = parcelRequire("hHkmo");

var $7tcIj = parcelRequire("7tcIj");

var $dkRwn = parcelRequire("dkRwn");

var $7ZuAa = parcelRequire("7ZuAa");

var $hS7a5 = parcelRequire("hS7a5");

var $kGOY7 = parcelRequire("kGOY7");

var $kKcoF = parcelRequire("kKcoF");

var $8afOB = parcelRequire("8afOB");

var $fEiZX = parcelRequire("fEiZX");

var $i6wfb = parcelRequire("i6wfb");

var $hoskR = parcelRequire("hoskR");

var $4JsMd = parcelRequire("4JsMd");
const $5de943da01717be1$var$config = {
    default: (0, $i6wfb.default),
    zero: (0, $hoskR.default),
    commonmark: (0, $4JsMd.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $5de943da01717be1$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $5de943da01717be1$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5de943da01717be1$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $5de943da01717be1$var$BAD_PROTO_RE.test(str) ? $5de943da01717be1$var$GOOD_DATA_RE.test(str) : true;
}
const $5de943da01717be1$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $5de943da01717be1$var$normalizeLink(url) {
    const parsed = $8afOB.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5de943da01717be1$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $8afOB.encode($8afOB.format(parsed));
}
function $5de943da01717be1$var$normalizeLinkText(url) {
    const parsed = $8afOB.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5de943da01717be1$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $8afOB.decode($8afOB.format(parsed), $8afOB.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5de943da01717be1$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5de943da01717be1$var$MarkdownIt)) return new $5de943da01717be1$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$hHkmo.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $kGOY7.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $hS7a5.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $7ZuAa.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $dkRwn.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $kKcoF.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5de943da01717be1$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5de943da01717be1$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5de943da01717be1$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $hHkmo;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $hHkmo.assign({}, $7tcIj);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.set = function(options) {
    $hHkmo.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($hHkmo.isString(presets)) {
        const presetName = presets;
        presets = $5de943da01717be1$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5de943da01717be1$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5de943da01717be1$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5de943da01717be1$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5de943da01717be1$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $5de943da01717be1$export$2e2bcd8739ae039 = $5de943da01717be1$var$MarkdownIt;

});
parcelRegister("hHkmo", function(module, exports) {
$parcel$export(module.exports, "isString", function () { return $ce263ef1fc59ec50$export$844ec244b1367d54; });
$parcel$export(module.exports, "has", function () { return $ce263ef1fc59ec50$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "assign", function () { return $ce263ef1fc59ec50$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $ce263ef1fc59ec50$export$f78478f71955b6bc; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $ce263ef1fc59ec50$export$644a8f5b13b2a36d; });
$parcel$export(module.exports, "fromCodePoint", function () { return $ce263ef1fc59ec50$export$73bfc63873071f74; });
$parcel$export(module.exports, "unescapeMd", function () { return $ce263ef1fc59ec50$export$5ccde1ea0c14bb03; });
$parcel$export(module.exports, "unescapeAll", function () { return $ce263ef1fc59ec50$export$db8a17c6655f7e2c; });
$parcel$export(module.exports, "escapeHtml", function () { return $ce263ef1fc59ec50$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeRE", function () { return $ce263ef1fc59ec50$export$bc616c8f7dc20d5d; });
$parcel$export(module.exports, "isSpace", function () { return $ce263ef1fc59ec50$export$1d5ccafae59b4926; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $ce263ef1fc59ec50$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isPunctChar", function () { return $ce263ef1fc59ec50$export$4888a643af800fc1; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $ce263ef1fc59ec50$export$829a0d33ae4e744; });
$parcel$export(module.exports, "normalizeReference", function () { return $ce263ef1fc59ec50$export$20ef46802c8744b; });
$parcel$export(module.exports, "lib", function () { return $ce263ef1fc59ec50$export$16c08b91f883959a; });
// Utilities
//

var $8afOB = parcelRequire("8afOB");
parcelRequire("jlb6C");
var $6L7UM = parcelRequire("6L7UM");
var $iLRMH = parcelRequire("iLRMH");
var $jlb6C = parcelRequire("jlb6C");

var $fyijY = parcelRequire("fyijY");
function $ce263ef1fc59ec50$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $ce263ef1fc59ec50$export$844ec244b1367d54(obj) {
    return $ce263ef1fc59ec50$var$_class(obj) === '[object String]';
}
const $ce263ef1fc59ec50$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $ce263ef1fc59ec50$export$a4f4bb6b1453fff5(object, key) {
    return $ce263ef1fc59ec50$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $ce263ef1fc59ec50$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $ce263ef1fc59ec50$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $ce263ef1fc59ec50$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $ce263ef1fc59ec50$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $ce263ef1fc59ec50$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $ce263ef1fc59ec50$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $ce263ef1fc59ec50$var$UNESCAPE_ALL_RE = new RegExp($ce263ef1fc59ec50$var$UNESCAPE_MD_RE.source + '|' + $ce263ef1fc59ec50$var$ENTITY_RE.source, 'gi');
const $ce263ef1fc59ec50$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $ce263ef1fc59ec50$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $ce263ef1fc59ec50$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($ce263ef1fc59ec50$export$644a8f5b13b2a36d(code)) return $ce263ef1fc59ec50$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $fyijY.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $ce263ef1fc59ec50$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($ce263ef1fc59ec50$var$UNESCAPE_MD_RE, '$1');
}
function $ce263ef1fc59ec50$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($ce263ef1fc59ec50$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $ce263ef1fc59ec50$var$replaceEntityPattern(match, entity);
    });
}
const $ce263ef1fc59ec50$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $ce263ef1fc59ec50$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $ce263ef1fc59ec50$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $ce263ef1fc59ec50$var$replaceUnsafeChar(ch) {
    return $ce263ef1fc59ec50$var$HTML_REPLACEMENTS[ch];
}
function $ce263ef1fc59ec50$export$4cf11838cdc2a8a8(str) {
    if ($ce263ef1fc59ec50$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($ce263ef1fc59ec50$var$HTML_ESCAPE_REPLACE_RE, $ce263ef1fc59ec50$var$replaceUnsafeChar);
    return str;
}
const $ce263ef1fc59ec50$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $ce263ef1fc59ec50$export$bc616c8f7dc20d5d(str) {
    return str.replace($ce263ef1fc59ec50$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $ce263ef1fc59ec50$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $ce263ef1fc59ec50$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $ce263ef1fc59ec50$export$4888a643af800fc1(ch) {
    return $6L7UM.default.test(ch) || $iLRMH.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $ce263ef1fc59ec50$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $ce263ef1fc59ec50$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $ce263ef1fc59ec50$export$16c08b91f883959a = {
    mdurl: $8afOB,
    ucmicro: $jlb6C
};

});
parcelRegister("jlb6C", function(module, exports) {
$parcel$export(module.exports, "Any", function () { return (parcelRequire("dtF6X")).default; });
$parcel$export(module.exports, "Cc", function () { return (parcelRequire("dWJsL")).default; });
$parcel$export(module.exports, "Cf", function () { return (parcelRequire("hafNT")).default; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("6L7UM")).default; });
$parcel$export(module.exports, "S", function () { return (parcelRequire("iLRMH")).default; });
$parcel$export(module.exports, "Z", function () { return (parcelRequire("31nOJ")).default; });

var $dtF6X = parcelRequire("dtF6X");

var $dWJsL = parcelRequire("dWJsL");

var $hafNT = parcelRequire("hafNT");

var $6L7UM = parcelRequire("6L7UM");

var $iLRMH = parcelRequire("iLRMH");

var $31nOJ = parcelRequire("31nOJ");

});
parcelRegister("dtF6X", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9cfddfa33f17da98$export$2e2bcd8739ae039; });
var $9cfddfa33f17da98$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("dWJsL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a273f521f9afa2a8$export$2e2bcd8739ae039; });
var $a273f521f9afa2a8$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("hafNT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7efa12093330e14$export$2e2bcd8739ae039; });
var $c7efa12093330e14$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("6L7UM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ebd459311603b21$export$2e2bcd8739ae039; });
var $4ebd459311603b21$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("iLRMH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $daa6564110437b9c$export$2e2bcd8739ae039; });
var $daa6564110437b9c$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("31nOJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2333f0b0e06f29e9$export$2e2bcd8739ae039; });
var $2333f0b0e06f29e9$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});



parcelRegister("7tcIj", function(module, exports) {
$parcel$export(module.exports, "parseLinkLabel", function () { return (parcelRequire("aPYut")).default; });
$parcel$export(module.exports, "parseLinkDestination", function () { return (parcelRequire("edQ6M")).default; });
$parcel$export(module.exports, "parseLinkTitle", function () { return (parcelRequire("gNmh9")).default; });
// Just a shortcut for bulk export

var $aPYut = parcelRequire("aPYut");

var $edQ6M = parcelRequire("edQ6M");

var $gNmh9 = parcelRequire("gNmh9");

});
parcelRegister("aPYut", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e3d96f11084d184$export$2e2bcd8739ae039; });
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $7e3d96f11084d184$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("edQ6M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5aab3351dbaaf86$export$2e2bcd8739ae039; });
// Parse link destination
//

var $hHkmo = parcelRequire("hHkmo");
function $a5aab3351dbaaf86$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $hHkmo.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $hHkmo.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("gNmh9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0327c843bd8b3c4f$export$2e2bcd8739ae039; });
// Parse link title
//

var $hHkmo = parcelRequire("hHkmo");
function $0327c843bd8b3c4f$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $hHkmo.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $hHkmo.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("dkRwn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b56a8d54f541c20$export$2e2bcd8739ae039; });
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $hHkmo = parcelRequire("hHkmo");
const $9b56a8d54f541c20$var$default_rules = {};
$9b56a8d54f541c20$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $hHkmo.escapeHtml)(token.content) + '</code>';
};
$9b56a8d54f541c20$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $hHkmo.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$9b56a8d54f541c20$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $hHkmo.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $hHkmo.escapeHtml)(token.content);
    else highlighted = (0, $hHkmo.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$9b56a8d54f541c20$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$9b56a8d54f541c20$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$9b56a8d54f541c20$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$9b56a8d54f541c20$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $hHkmo.escapeHtml)(tokens[idx].content);
};
$9b56a8d54f541c20$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$9b56a8d54f541c20$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $9b56a8d54f541c20$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $hHkmo.assign)({}, $9b56a8d54f541c20$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $9b56a8d54f541c20$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $hHkmo.escapeHtml)(token.attrs[i][0]) + '="' + (0, $hHkmo.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $9b56a8d54f541c20$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $9b56a8d54f541c20$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $9b56a8d54f541c20$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $9b56a8d54f541c20$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $9b56a8d54f541c20$export$2e2bcd8739ae039 = $9b56a8d54f541c20$var$Renderer;

});

parcelRegister("7ZuAa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d15f3f2c8b6689c$export$2e2bcd8739ae039; });
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $446Zj = parcelRequire("446Zj");

var $hGsTX = parcelRequire("hGsTX");

var $jcCvH = parcelRequire("jcCvH");

var $466FA = parcelRequire("466FA");

var $demjA = parcelRequire("demjA");

var $4wIpC = parcelRequire("4wIpC");

var $8HsPx = parcelRequire("8HsPx");

var $deHR5 = parcelRequire("deHR5");

var $371Ue = parcelRequire("371Ue");
const $5d15f3f2c8b6689c$var$_rules = [
    [
        'normalize',
        (0, $jcCvH.default)
    ],
    [
        'block',
        (0, $466FA.default)
    ],
    [
        'inline',
        (0, $demjA.default)
    ],
    [
        'linkify',
        (0, $4wIpC.default)
    ],
    [
        'replacements',
        (0, $8HsPx.default)
    ],
    [
        'smartquotes',
        (0, $deHR5.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $371Ue.default)
    ]
];
/**
 * new Core()
 **/ function $5d15f3f2c8b6689c$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $446Zj.default)();
    for(let i = 0; i < $5d15f3f2c8b6689c$var$_rules.length; i++)this.ruler.push($5d15f3f2c8b6689c$var$_rules[i][0], $5d15f3f2c8b6689c$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $5d15f3f2c8b6689c$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$5d15f3f2c8b6689c$var$Core.prototype.State = (0, $hGsTX.default);
var $5d15f3f2c8b6689c$export$2e2bcd8739ae039 = $5d15f3f2c8b6689c$var$Core;

});
parcelRegister("446Zj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f5cf4c9fe63ae1c$export$2e2bcd8739ae039; });
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $2f5cf4c9fe63ae1c$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$2f5cf4c9fe63ae1c$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$2f5cf4c9fe63ae1c$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $2f5cf4c9fe63ae1c$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $2f5cf4c9fe63ae1c$export$2e2bcd8739ae039 = $2f5cf4c9fe63ae1c$var$Ruler;

});

parcelRegister("hGsTX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdfcc722e1f8c09f$export$2e2bcd8739ae039; });
// Core state object
//

var $UrTTA = parcelRequire("UrTTA");
function $cdfcc722e1f8c09f$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$cdfcc722e1f8c09f$var$StateCore.prototype.Token = (0, $UrTTA.default);
var $cdfcc722e1f8c09f$export$2e2bcd8739ae039 = $cdfcc722e1f8c09f$var$StateCore;

});
parcelRegister("UrTTA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a9adf8b388f4153$export$2e2bcd8739ae039; });
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $0a9adf8b388f4153$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $0a9adf8b388f4153$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $0a9adf8b388f4153$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $0a9adf8b388f4153$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $0a9adf8b388f4153$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $0a9adf8b388f4153$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $0a9adf8b388f4153$export$2e2bcd8739ae039 = $0a9adf8b388f4153$var$Token;

});


parcelRegister("jcCvH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfad029fe181b918$export$2e2bcd8739ae039; });
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $dfad029fe181b918$var$NEWLINES_RE = /\r\n?|\n/g;
const $dfad029fe181b918$var$NULL_RE = /\0/g;
function $dfad029fe181b918$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($dfad029fe181b918$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($dfad029fe181b918$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("466FA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2fbce574e69f95d6$export$2e2bcd8739ae039; });
function $2fbce574e69f95d6$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("demjA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a1de475294a7867$export$2e2bcd8739ae039; });
function $9a1de475294a7867$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("4wIpC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34bc99e87a90d71c$export$2e2bcd8739ae039; });
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $hHkmo = parcelRequire("hHkmo");
function $34bc99e87a90d71c$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $34bc99e87a90d71c$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $34bc99e87a90d71c$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($34bc99e87a90d71c$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($34bc99e87a90d71c$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $hHkmo.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("8HsPx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6558b3f49ba798fd$export$2e2bcd8739ae039; });
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $6558b3f49ba798fd$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $6558b3f49ba798fd$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $6558b3f49ba798fd$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $6558b3f49ba798fd$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $6558b3f49ba798fd$var$replaceFn(match, name) {
    return $6558b3f49ba798fd$var$SCOPED_ABBR[name.toLowerCase()];
}
function $6558b3f49ba798fd$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($6558b3f49ba798fd$var$SCOPED_ABBR_RE, $6558b3f49ba798fd$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6558b3f49ba798fd$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($6558b3f49ba798fd$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6558b3f49ba798fd$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($6558b3f49ba798fd$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $6558b3f49ba798fd$var$replace_scoped(state.tokens[blkIdx].children);
        if ($6558b3f49ba798fd$var$RARE_RE.test(state.tokens[blkIdx].content)) $6558b3f49ba798fd$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("deHR5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a2e99e1efc44b5d$export$2e2bcd8739ae039; });
// Convert straight quotation marks to typographic ones
//

var $hHkmo = parcelRequire("hHkmo");
const $9a2e99e1efc44b5d$var$QUOTE_TEST_RE = /['"]/;
const $9a2e99e1efc44b5d$var$QUOTE_RE = /['"]/g;
const $9a2e99e1efc44b5d$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $9a2e99e1efc44b5d$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $9a2e99e1efc44b5d$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $9a2e99e1efc44b5d$var$QUOTE_RE.lastIndex = pos;
            const t = $9a2e99e1efc44b5d$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $hHkmo.isMdAsciiPunct)(lastChar) || (0, $hHkmo.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $hHkmo.isMdAsciiPunct)(nextChar) || (0, $hHkmo.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $hHkmo.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $hHkmo.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $9a2e99e1efc44b5d$var$replaceAt(token.content, t.index, $9a2e99e1efc44b5d$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $9a2e99e1efc44b5d$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $9a2e99e1efc44b5d$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $9a2e99e1efc44b5d$var$replaceAt(token.content, t.index, $9a2e99e1efc44b5d$var$APOSTROPHE);
        }
    }
}
function $9a2e99e1efc44b5d$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$9a2e99e1efc44b5d$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $9a2e99e1efc44b5d$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("371Ue", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2443810d4e53f204$export$2e2bcd8739ae039; });
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $2443810d4e53f204$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("hS7a5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d02d08f668813603$export$2e2bcd8739ae039; });
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $446Zj = parcelRequire("446Zj");

var $18xbP = parcelRequire("18xbP");

var $lu36X = parcelRequire("lu36X");

var $9ZGh5 = parcelRequire("9ZGh5");

var $kySPL = parcelRequire("kySPL");

var $b0TDY = parcelRequire("b0TDY");

var $hmsvh = parcelRequire("hmsvh");

var $jyu3i = parcelRequire("jyu3i");

var $heVOh = parcelRequire("heVOh");

var $5InNe = parcelRequire("5InNe");

var $3a2FD = parcelRequire("3a2FD");

var $7weBe = parcelRequire("7weBe");

var $c9LAp = parcelRequire("c9LAp");
const $d02d08f668813603$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $lu36X.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $9ZGh5.default)
    ],
    [
        'fence',
        (0, $kySPL.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $b0TDY.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $hmsvh.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $jyu3i.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $heVOh.default)
    ],
    [
        'html_block',
        (0, $5InNe.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $3a2FD.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $7weBe.default)
    ],
    [
        'paragraph',
        (0, $c9LAp.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $d02d08f668813603$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $446Zj.default)();
    for(let i = 0; i < $d02d08f668813603$var$_rules.length; i++)this.ruler.push($d02d08f668813603$var$_rules[i][0], $d02d08f668813603$var$_rules[i][1], {
        alt: ($d02d08f668813603$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$d02d08f668813603$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $d02d08f668813603$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$d02d08f668813603$var$ParserBlock.prototype.State = (0, $18xbP.default);
var $d02d08f668813603$export$2e2bcd8739ae039 = $d02d08f668813603$var$ParserBlock;

});
parcelRegister("18xbP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d404896b54a5c8a$export$2e2bcd8739ae039; });
// Parser state class

var $UrTTA = parcelRequire("UrTTA");

var $hHkmo = parcelRequire("hHkmo");
function $0d404896b54a5c8a$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $hHkmo.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$0d404896b54a5c8a$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $UrTTA.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$0d404896b54a5c8a$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$0d404896b54a5c8a$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$0d404896b54a5c8a$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $hHkmo.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$0d404896b54a5c8a$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $hHkmo.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$0d404896b54a5c8a$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$0d404896b54a5c8a$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$0d404896b54a5c8a$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $hHkmo.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$0d404896b54a5c8a$var$StateBlock.prototype.Token = (0, $UrTTA.default);
var $0d404896b54a5c8a$export$2e2bcd8739ae039 = $0d404896b54a5c8a$var$StateBlock;

});

parcelRegister("lu36X", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa3ed0231ae12ec4$export$2e2bcd8739ae039; });
// GFM table, https://github.github.com/gfm/#tables-extension-

var $hHkmo = parcelRequire("hHkmo");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $fa3ed0231ae12ec4$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $fa3ed0231ae12ec4$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $fa3ed0231ae12ec4$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $fa3ed0231ae12ec4$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $hHkmo.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $hHkmo.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $hHkmo.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $fa3ed0231ae12ec4$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $fa3ed0231ae12ec4$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $fa3ed0231ae12ec4$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $fa3ed0231ae12ec4$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $fa3ed0231ae12ec4$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $fa3ed0231ae12ec4$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("9ZGh5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $746a9a6e8a23fd33$export$2e2bcd8739ae039; });
// Code block (4 spaces padded)
function $746a9a6e8a23fd33$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("kySPL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef818481c0dd24a0$export$2e2bcd8739ae039; });
// fences (``` lang, ~~~ lang)
function $ef818481c0dd24a0$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("b0TDY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $804adb7b7d17c533$export$2e2bcd8739ae039; });
// Block quotes

var $hHkmo = parcelRequire("hHkmo");
function $804adb7b7d17c533$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $hHkmo.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("hmsvh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca3a99f69f16339e$export$2e2bcd8739ae039; });
// Horizontal rule

var $hHkmo = parcelRequire("hHkmo");
function $ca3a99f69f16339e$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $hHkmo.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("jyu3i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e3c8810c560c00dd$export$2e2bcd8739ae039; });
// Lists

var $hHkmo = parcelRequire("hHkmo");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $e3c8810c560c00dd$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $hHkmo.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $e3c8810c560c00dd$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $hHkmo.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $e3c8810c560c00dd$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $e3c8810c560c00dd$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $e3c8810c560c00dd$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $e3c8810c560c00dd$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $e3c8810c560c00dd$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $e3c8810c560c00dd$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $e3c8810c560c00dd$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("heVOh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8d0965070abc7f9$export$2e2bcd8739ae039; });

var $hHkmo = parcelRequire("hHkmo");
function $c8d0965070abc7f9$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $hHkmo.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $hHkmo.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $hHkmo.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $hHkmo.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $hHkmo.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("5InNe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $429384a447df8069$export$2e2bcd8739ae039; });
// HTML block

var $hgCLP = parcelRequire("hgCLP");

var $lDwOf = parcelRequire("lDwOf");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $429384a447df8069$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $hgCLP.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $lDwOf.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $429384a447df8069$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $429384a447df8069$var$HTML_SEQUENCES.length; i++){
        if ($429384a447df8069$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $429384a447df8069$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $429384a447df8069$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$429384a447df8069$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($429384a447df8069$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("hgCLP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c922014fd9d3c3b2$export$2e2bcd8739ae039; });
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $c922014fd9d3c3b2$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("lDwOf", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", function () { return $04109fc131efe9e4$export$6db61d2c3a16e419; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $04109fc131efe9e4$export$cd48660d06f74639; });
// Regexps to match html elements
const $04109fc131efe9e4$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $04109fc131efe9e4$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $04109fc131efe9e4$var$single_quoted = "'[^']*'";
const $04109fc131efe9e4$var$double_quoted = '"[^"]*"';
const $04109fc131efe9e4$var$attr_value = '(?:' + $04109fc131efe9e4$var$unquoted + '|' + $04109fc131efe9e4$var$single_quoted + '|' + $04109fc131efe9e4$var$double_quoted + ')';
const $04109fc131efe9e4$var$attribute = '(?:\\s+' + $04109fc131efe9e4$var$attr_name + '(?:\\s*=\\s*' + $04109fc131efe9e4$var$attr_value + ')?)';
const $04109fc131efe9e4$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $04109fc131efe9e4$var$attribute + '*\\s*\\/?>';
const $04109fc131efe9e4$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $04109fc131efe9e4$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $04109fc131efe9e4$var$processing = '<[?][\\s\\S]*?[?]>';
const $04109fc131efe9e4$var$declaration = '<![A-Za-z][^>]*>';
const $04109fc131efe9e4$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $04109fc131efe9e4$export$6db61d2c3a16e419 = new RegExp('^(?:' + $04109fc131efe9e4$var$open_tag + '|' + $04109fc131efe9e4$var$close_tag + '|' + $04109fc131efe9e4$var$comment + '|' + $04109fc131efe9e4$var$processing + '|' + $04109fc131efe9e4$var$declaration + '|' + $04109fc131efe9e4$var$cdata + ')');
const $04109fc131efe9e4$export$cd48660d06f74639 = new RegExp('^(?:' + $04109fc131efe9e4$var$open_tag + '|' + $04109fc131efe9e4$var$close_tag + ')');

});


parcelRegister("3a2FD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24d460918b3b88b8$export$2e2bcd8739ae039; });
// heading (#, ##, ...)

var $hHkmo = parcelRequire("hHkmo");
function $24d460918b3b88b8$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $hHkmo.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $hHkmo.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("7weBe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5796d8bb208a79b2$export$2e2bcd8739ae039; });
// lheading (---, ===)
function $5796d8bb208a79b2$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("c9LAp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d9b3cf61e45c297$export$2e2bcd8739ae039; });
// Paragraph
function $8d9b3cf61e45c297$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("kGOY7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0ff442e31afd695$export$2e2bcd8739ae039; });
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $446Zj = parcelRequire("446Zj");

var $2xUHo = parcelRequire("2xUHo");

var $2Ms7M = parcelRequire("2Ms7M");

var $1cMVC = parcelRequire("1cMVC");

var $1ZCGx = parcelRequire("1ZCGx");

var $8yKZA = parcelRequire("8yKZA");

var $2a51r = parcelRequire("2a51r");

var $eT61i = parcelRequire("eT61i");

var $IZpzy = parcelRequire("IZpzy");

var $k0g01 = parcelRequire("k0g01");

var $eTV3s = parcelRequire("eTV3s");

var $cIVAA = parcelRequire("cIVAA");

var $eLONj = parcelRequire("eLONj");

var $1Vllm = parcelRequire("1Vllm");

var $9Vv01 = parcelRequire("9Vv01");

var $lHQfJ = parcelRequire("lHQfJ");
// Parser rules
const $f0ff442e31afd695$var$_rules = [
    [
        'text',
        (0, $2Ms7M.default)
    ],
    [
        'linkify',
        (0, $1cMVC.default)
    ],
    [
        'newline',
        (0, $1ZCGx.default)
    ],
    [
        'escape',
        (0, $8yKZA.default)
    ],
    [
        'backticks',
        (0, $2a51r.default)
    ],
    [
        'strikethrough',
        (0, $eT61i.default).tokenize
    ],
    [
        'emphasis',
        (0, $IZpzy.default).tokenize
    ],
    [
        'link',
        (0, $k0g01.default)
    ],
    [
        'image',
        (0, $eTV3s.default)
    ],
    [
        'autolink',
        (0, $cIVAA.default)
    ],
    [
        'html_inline',
        (0, $eLONj.default)
    ],
    [
        'entity',
        (0, $1Vllm.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $f0ff442e31afd695$var$_rules2 = [
    [
        'balance_pairs',
        (0, $9Vv01.default)
    ],
    [
        'strikethrough',
        (0, $eT61i.default).postProcess
    ],
    [
        'emphasis',
        (0, $IZpzy.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $lHQfJ.default)
    ]
];
/**
 * new ParserInline()
 **/ function $f0ff442e31afd695$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $446Zj.default)();
    for(let i = 0; i < $f0ff442e31afd695$var$_rules.length; i++)this.ruler.push($f0ff442e31afd695$var$_rules[i][0], $f0ff442e31afd695$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $446Zj.default)();
    for(let i = 0; i < $f0ff442e31afd695$var$_rules2.length; i++)this.ruler2.push($f0ff442e31afd695$var$_rules2[i][0], $f0ff442e31afd695$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$f0ff442e31afd695$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$f0ff442e31afd695$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $f0ff442e31afd695$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$f0ff442e31afd695$var$ParserInline.prototype.State = (0, $2xUHo.default);
var $f0ff442e31afd695$export$2e2bcd8739ae039 = $f0ff442e31afd695$var$ParserInline;

});
parcelRegister("2xUHo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1daaa50d9a19a9ed$export$2e2bcd8739ae039; });
// Inline parser state

var $UrTTA = parcelRequire("UrTTA");

var $hHkmo = parcelRequire("hHkmo");
function $1daaa50d9a19a9ed$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$1daaa50d9a19a9ed$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $UrTTA.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$1daaa50d9a19a9ed$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $UrTTA.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$1daaa50d9a19a9ed$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $hHkmo.isMdAsciiPunct)(lastChar) || (0, $hHkmo.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $hHkmo.isMdAsciiPunct)(nextChar) || (0, $hHkmo.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $hHkmo.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $hHkmo.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$1daaa50d9a19a9ed$var$StateInline.prototype.Token = (0, $UrTTA.default);
var $1daaa50d9a19a9ed$export$2e2bcd8739ae039 = $1daaa50d9a19a9ed$var$StateInline;

});

parcelRegister("2Ms7M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2065e16a98d2fe02$export$2e2bcd8739ae039; });
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $2065e16a98d2fe02$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $2065e16a98d2fe02$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$2065e16a98d2fe02$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("1cMVC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e0cdd956fbf028a$export$2e2bcd8739ae039; });
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $0e0cdd956fbf028a$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $0e0cdd956fbf028a$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($0e0cdd956fbf028a$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("1ZCGx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17397efc8e106fad$export$2e2bcd8739ae039; });
// Proceess '\n'

var $hHkmo = parcelRequire("hHkmo");
function $17397efc8e106fad$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $hHkmo.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("8yKZA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63b5f369a285b48d$export$2e2bcd8739ae039; });
// Process escaped chars and hardbreaks

var $hHkmo = parcelRequire("hHkmo");
const $63b5f369a285b48d$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$63b5f369a285b48d$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $63b5f369a285b48d$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $63b5f369a285b48d$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $hHkmo.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $63b5f369a285b48d$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("2a51r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $193069430dde190c$export$2e2bcd8739ae039; });
// Parse backticks
function $193069430dde190c$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("eT61i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad6adf295ffbd15c$export$2e2bcd8739ae039; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $ad6adf295ffbd15c$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $ad6adf295ffbd15c$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $ad6adf295ffbd15c$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $ad6adf295ffbd15c$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $ad6adf295ffbd15c$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $ad6adf295ffbd15c$export$2e2bcd8739ae039 = {
    tokenize: $ad6adf295ffbd15c$var$strikethrough_tokenize,
    postProcess: $ad6adf295ffbd15c$var$strikethrough_postProcess
};

});

parcelRegister("IZpzy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0873bf365fcd5738$export$2e2bcd8739ae039; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $0873bf365fcd5738$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $0873bf365fcd5738$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $0873bf365fcd5738$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $0873bf365fcd5738$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $0873bf365fcd5738$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $0873bf365fcd5738$export$2e2bcd8739ae039 = {
    tokenize: $0873bf365fcd5738$var$emphasis_tokenize,
    postProcess: $0873bf365fcd5738$var$emphasis_post_process
};

});

parcelRegister("k0g01", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e90037da66a2ec12$export$2e2bcd8739ae039; });
// Process [link](<to> "stuff")

var $hHkmo = parcelRequire("hHkmo");
function $e90037da66a2ec12$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $hHkmo.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("eTV3s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad9275a7cdc378ea$export$2e2bcd8739ae039; });
// Process ![image](<src> "title")

var $hHkmo = parcelRequire("hHkmo");
function $ad9275a7cdc378ea$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $hHkmo.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $hHkmo.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("cIVAA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $943644124cc15659$export$2e2bcd8739ae039; });
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $943644124cc15659$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $943644124cc15659$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $943644124cc15659$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($943644124cc15659$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($943644124cc15659$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("eLONj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac0cdb3234a5554c$export$2e2bcd8739ae039; });
// Process html tags

var $lDwOf = parcelRequire("lDwOf");
function $ac0cdb3234a5554c$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $ac0cdb3234a5554c$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $ac0cdb3234a5554c$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $ac0cdb3234a5554c$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$ac0cdb3234a5554c$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $lDwOf.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($ac0cdb3234a5554c$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($ac0cdb3234a5554c$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("1Vllm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $166babb76e701598$export$2e2bcd8739ae039; });
// Process html entity - &#123;, &#xAF;, &quot;, ...

var $fyijY = parcelRequire("fyijY");

var $hHkmo = parcelRequire("hHkmo");
const $166babb76e701598$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $166babb76e701598$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $166babb76e701598$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($166babb76e701598$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $hHkmo.isValidEntityCode)(code) ? (0, $hHkmo.fromCodePoint)(code) : (0, $hHkmo.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($166babb76e701598$var$NAMED_RE);
        if (match) {
            const decoded = (0, $fyijY.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("9Vv01", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73a17bbe28ca282a$export$2e2bcd8739ae039; });
// For each opening emphasis-like marker find a matching closing one
//
function $73a17bbe28ca282a$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $73a17bbe28ca282a$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $73a17bbe28ca282a$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $73a17bbe28ca282a$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("lHQfJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fcd62569114af7bb$export$2e2bcd8739ae039; });
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $fcd62569114af7bb$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("kKcoF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1a1b8451e6f3304$export$2e2bcd8739ae039; });

var $a6YNo = parcelRequire("a6YNo");
//
// Helpers
//
// Merge objects
//
function $f1a1b8451e6f3304$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $f1a1b8451e6f3304$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $f1a1b8451e6f3304$var$isString(obj) {
    return $f1a1b8451e6f3304$var$_class(obj) === '[object String]';
}
function $f1a1b8451e6f3304$var$isObject(obj) {
    return $f1a1b8451e6f3304$var$_class(obj) === '[object Object]';
}
function $f1a1b8451e6f3304$var$isRegExp(obj) {
    return $f1a1b8451e6f3304$var$_class(obj) === '[object RegExp]';
}
function $f1a1b8451e6f3304$var$isFunction(obj) {
    return $f1a1b8451e6f3304$var$_class(obj) === '[object Function]';
}
function $f1a1b8451e6f3304$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $f1a1b8451e6f3304$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $f1a1b8451e6f3304$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $f1a1b8451e6f3304$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $f1a1b8451e6f3304$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $f1a1b8451e6f3304$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $f1a1b8451e6f3304$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $f1a1b8451e6f3304$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $f1a1b8451e6f3304$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $f1a1b8451e6f3304$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $f1a1b8451e6f3304$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $a6YNo.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($f1a1b8451e6f3304$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($f1a1b8451e6f3304$var$isObject(val)) {
            if ($f1a1b8451e6f3304$var$isRegExp(val.validate)) compiled.validate = $f1a1b8451e6f3304$var$createValidator(val.validate);
            else if ($f1a1b8451e6f3304$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($f1a1b8451e6f3304$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $f1a1b8451e6f3304$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($f1a1b8451e6f3304$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $f1a1b8451e6f3304$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($f1a1b8451e6f3304$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $f1a1b8451e6f3304$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $f1a1b8451e6f3304$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $f1a1b8451e6f3304$var$createMatch(self, shift) {
    const match = new $f1a1b8451e6f3304$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $f1a1b8451e6f3304$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $f1a1b8451e6f3304$var$LinkifyIt)) return new $f1a1b8451e6f3304$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($f1a1b8451e6f3304$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $f1a1b8451e6f3304$var$assign({}, $f1a1b8451e6f3304$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $f1a1b8451e6f3304$var$assign({}, $f1a1b8451e6f3304$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $f1a1b8451e6f3304$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $f1a1b8451e6f3304$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $f1a1b8451e6f3304$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $f1a1b8451e6f3304$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($f1a1b8451e6f3304$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($f1a1b8451e6f3304$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $f1a1b8451e6f3304$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $f1a1b8451e6f3304$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $f1a1b8451e6f3304$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $f1a1b8451e6f3304$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $f1a1b8451e6f3304$export$2e2bcd8739ae039 = $f1a1b8451e6f3304$var$LinkifyIt;

});
parcelRegister("a6YNo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75c99fb181cf68fb$export$2e2bcd8739ae039; });
parcelRequire("jlb6C");
var $dtF6X = parcelRequire("dtF6X");
var $dWJsL = parcelRequire("dWJsL");
var $6L7UM = parcelRequire("6L7UM");
var $31nOJ = parcelRequire("31nOJ");
function $75c99fb181cf68fb$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $dtF6X.default).source;
    re.src_Cc = (0, $dWJsL.default).source;
    re.src_Z = (0, $31nOJ.default).source;
    re.src_P = (0, $6L7UM.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("i6wfb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2e1cc7974cbf465$export$2e2bcd8739ae039; });
// markdown-it default options
var $d2e1cc7974cbf465$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hoskR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca9aa863d967838c$export$2e2bcd8739ae039; });
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $ca9aa863d967838c$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("4JsMd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3721afd31593007e$export$2e2bcd8739ae039; });
// Commonmark default options
var $3721afd31593007e$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});




parcelRegister("cl834", function(module, exports) {
$parcel$export(module.exports, "markdownItMedia", function () { return $8fbdb0749377b9f6$export$c8dcbd316b71f8cf; });

var $11tOd = parcelRequire("11tOd");

var $7CMz9 = parcelRequire("7CMz9");
function $8fbdb0749377b9f6$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    var validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
   * This function looks for strings that matches ![description](url) inside Inline-tokens.
   * It will then split the Inline-token with content before and after the image, example:
   *
   * Input (tokens):
   *   paragraph_open
   *   inline - content: Hello ![](image.jpg) World!
   *   paragraph_close
   * Output (tokens):
   *   paragraph_open
   *   inline - content: Hello
   *   paragraph_close
   *   media_single_open
   *   media
   *   media_single_close
   *   paragraph_open
   *   inline - content: World!
   *   paragraph_close
   *
   * This is applied before the inline content is parsed, to ensure that the formatting of
   * remaining inline content (bold, links, etc.) is kept intact!
   */ return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        var createMediaTokens = function createMediaTokens(url) {
            var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var mediaSingleOpen = new State.Token('media_single_open', '', 1);
            var media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            var mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $7CMz9.default)(openingTokens), [
                inlineBefore
            ], (0, $7CMz9.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            var matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
                }).reverse();
                var inlineContentStack = token.content;
                matchAll.forEach(function(match, j) {
                    var _match = (0, $11tOd.default)(match, 3), matchString = _match[0], alt = _match[1], url = _match[2];
                    var start = inlineContentStack.indexOf(matchString);
                    var contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $7CMz9.default)(createMediaTokens(url, alt)));
                });
                if (inlineContentStack.length) subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $7CMz9.default)(processedTokens), (0, $7CMz9.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $7CMz9.default)(tokens.slice(0, cursor)), (0, $7CMz9.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $8fbdb0749377b9f6$export$c8dcbd316b71f8cf = function markdownItMedia(md) {
    md.core.ruler.before('inline', 'media', $8fbdb0749377b9f6$var$createRule());
};

});
parcelRegister("11tOd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bed01e0e4f65b77$export$2e2bcd8739ae039; });

var $5o40i = parcelRequire("5o40i");

var $lcOPK = parcelRequire("lcOPK");

var $fnWgV = parcelRequire("fnWgV");

var $9llH1 = parcelRequire("9llH1");
function $0bed01e0e4f65b77$export$2e2bcd8739ae039(r, e) {
    return (0, $5o40i.default)(r) || (0, $lcOPK.default)(r, e) || (0, $fnWgV.default)(r, e) || (0, $9llH1.default)();
}

});
parcelRegister("5o40i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ec24cb277b59109$export$2e2bcd8739ae039; });
function $3ec24cb277b59109$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("lcOPK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7022675b2445583$export$2e2bcd8739ae039; });
function $f7022675b2445583$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("fnWgV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b336349737665a9f$export$2e2bcd8739ae039; });

var $412Hy = parcelRequire("412Hy");
function $b336349737665a9f$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $412Hy.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $412Hy.default)(r, a) : void 0;
    }
}

});
parcelRegister("412Hy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2ec959e77e1f3095$export$2e2bcd8739ae039; });
function $2ec959e77e1f3095$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9llH1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6cd6e6f78c5cfdee$export$2e2bcd8739ae039; });
function $6cd6e6f78c5cfdee$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7CMz9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58d1c138dbe56cde$export$2e2bcd8739ae039; });

var $bKzD6 = parcelRequire("bKzD6");

var $2qxSo = parcelRequire("2qxSo");

var $fnWgV = parcelRequire("fnWgV");

var $77CAJ = parcelRequire("77CAJ");
function $58d1c138dbe56cde$export$2e2bcd8739ae039(r) {
    return (0, $bKzD6.default)(r) || (0, $2qxSo.default)(r) || (0, $fnWgV.default)(r) || (0, $77CAJ.default)();
}

});
parcelRegister("bKzD6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88dfa0e6e93f3fc5$export$2e2bcd8739ae039; });

var $412Hy = parcelRequire("412Hy");
function $88dfa0e6e93f3fc5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $412Hy.default)(r);
}

});

parcelRegister("2qxSo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c48499687b52fb5$export$2e2bcd8739ae039; });
function $1c48499687b52fb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("77CAJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52f71f4dabf11089$export$2e2bcd8739ae039; });
function $52f71f4dabf11089$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("2S3V5", function(module, exports) {
$parcel$export(module.exports, "MarkdownParser", function () { return $2173aa47d974df23$export$a64f782182dea128; });

var $fkJXG = parcelRequire("fkJXG");
parcelRequire("kM3zU");
var $9oaol = parcelRequire("9oaol");
/**
Document schema for the data model used by CommonMark.
*/ const $2173aa47d974df23$export$4902baddc787debb = new (0, $fkJXG.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            code: true,
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $2173aa47d974df23$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $fkJXG.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $2173aa47d974df23$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $fkJXG.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $2173aa47d974df23$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $fkJXG.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $2173aa47d974df23$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $2173aa47d974df23$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $2173aa47d974df23$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $2173aa47d974df23$var$noOp() {}
function $2173aa47d974df23$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
                state.addText($2173aa47d974df23$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($2173aa47d974df23$var$attrs(spec, tok, tokens, i)));
                state.addText($2173aa47d974df23$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($2173aa47d974df23$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = $2173aa47d974df23$var$noOp;
            else {
                handlers[type + "_open"] = $2173aa47d974df23$var$noOp;
                handlers[type + "_close"] = $2173aa47d974df23$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $2173aa47d974df23$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $2173aa47d974df23$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $2173aa47d974df23$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $2173aa47d974df23$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $2173aa47d974df23$export$7517583227ad0cb8 = new $2173aa47d974df23$export$a64f782182dea128($2173aa47d974df23$export$4902baddc787debb, (0, $9oaol.default)("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $2173aa47d974df23$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $2173aa47d974df23$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $2173aa47d974df23$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $2173aa47d974df23$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $2173aa47d974df23$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $2173aa47d974df23$export$f996452ca6e9a0ae = new $2173aa47d974df23$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $2173aa47d974df23$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $2173aa47d974df23$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $2173aa47d974df23$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $2173aa47d974df23$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $2173aa47d974df23$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $2173aa47d974df23$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $2173aa47d974df23$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});
parcelRegister("fkJXG", function(module, exports) {
$parcel$export(module.exports, "Mark", function () { return $b29c6048411acd6f$export$c9d15bcfc6d42044; });
$parcel$export(module.exports, "Schema", function () { return $b29c6048411acd6f$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $b29c6048411acd6f$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b29c6048411acd6f$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $b29c6048411acd6f$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b29c6048411acd6f$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $b29c6048411acd6f$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $b29c6048411acd6f$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $b29c6048411acd6f$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $b29c6048411acd6f$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $b29c6048411acd6f$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $b29c6048411acd6f$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $b29c6048411acd6f$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $b29c6048411acd6f$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $b29c6048411acd6f$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $b29c6048411acd6f$var$retIndex(0, pos);
        if (pos == this.size) return $b29c6048411acd6f$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $b29c6048411acd6f$var$retIndex(i + 1, end);
                return $b29c6048411acd6f$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $b29c6048411acd6f$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $b29c6048411acd6f$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (nodes instanceof $b29c6048411acd6f$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $b29c6048411acd6f$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $b29c6048411acd6f$export$ffb0004e005737fa.empty = new $b29c6048411acd6f$export$ffb0004e005737fa([], 0);
const $b29c6048411acd6f$var$found = {
    index: 0,
    offset: 0
};
function $b29c6048411acd6f$var$retIndex(index, offset) {
    $b29c6048411acd6f$var$found.index = index;
    $b29c6048411acd6f$var$found.offset = offset;
    return $b29c6048411acd6f$var$found;
}
function $b29c6048411acd6f$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$b29c6048411acd6f$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$b29c6048411acd6f$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $b29c6048411acd6f$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $b29c6048411acd6f$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        if (marks instanceof $b29c6048411acd6f$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $b29c6048411acd6f$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $b29c6048411acd6f$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $b29c6048411acd6f$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $b29c6048411acd6f$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty = new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$export$ffb0004e005737fa.empty, 0, 0);
function $b29c6048411acd6f$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($b29c6048411acd6f$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $b29c6048411acd6f$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $b29c6048411acd6f$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $b29c6048411acd6f$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Inconsistent open depths");
    return $b29c6048411acd6f$var$replaceOuter($from, $to, slice, 0);
}
function $b29c6048411acd6f$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $b29c6048411acd6f$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $b29c6048411acd6f$var$close(node, $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $b29c6048411acd6f$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $b29c6048411acd6f$var$prepareSliceForReplace(slice, $from);
        return $b29c6048411acd6f$var$close(node, $b29c6048411acd6f$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $b29c6048411acd6f$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $b29c6048411acd6f$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $b29c6048411acd6f$var$checkJoin(node, $after.node(depth));
    return node;
}
function $b29c6048411acd6f$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $b29c6048411acd6f$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $b29c6048411acd6f$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$b29c6048411acd6f$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $b29c6048411acd6f$var$addNode($end.nodeBefore, target);
}
function $b29c6048411acd6f$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $b29c6048411acd6f$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $b29c6048411acd6f$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $b29c6048411acd6f$var$joinable($end, $to, depth + 1);
    let content = [];
    $b29c6048411acd6f$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $b29c6048411acd6f$var$checkJoin(openStart, openEnd);
        $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openStart, $b29c6048411acd6f$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openStart, $b29c6048411acd6f$var$replaceTwoWay($from, $start, depth + 1)), content);
        $b29c6048411acd6f$var$addRange($start, $end, depth, content);
        if (openEnd) $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openEnd, $b29c6048411acd6f$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $b29c6048411acd6f$var$addRange($to, null, depth, content);
    return new $b29c6048411acd6f$export$ffb0004e005737fa(content);
}
function $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $b29c6048411acd6f$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $b29c6048411acd6f$var$joinable($from, $to, depth + 1);
        $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(type, $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $b29c6048411acd6f$var$addRange($to, null, depth, content);
    return new $b29c6048411acd6f$export$ffb0004e005737fa(content);
}
function $b29c6048411acd6f$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($b29c6048411acd6f$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $b29c6048411acd6f$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $b29c6048411acd6f$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $b29c6048411acd6f$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $b29c6048411acd6f$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $b29c6048411acd6f$var$resolveCache.set(doc, cache = new $b29c6048411acd6f$var$ResolveCache);
        let result = cache.elts[cache.i] = $b29c6048411acd6f$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $b29c6048411acd6f$var$resolveCacheSize;
        return result;
    }
}
class $b29c6048411acd6f$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $b29c6048411acd6f$var$resolveCacheSize = 12, $b29c6048411acd6f$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $b29c6048411acd6f$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $b29c6048411acd6f$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $b29c6048411acd6f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $b29c6048411acd6f$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $b29c6048411acd6f$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $b29c6048411acd6f$var$emptyAttrs) && $b29c6048411acd6f$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $b29c6048411acd6f$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $b29c6048411acd6f$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $b29c6048411acd6f$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $b29c6048411acd6f$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $b29c6048411acd6f$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $b29c6048411acd6f$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $b29c6048411acd6f$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$b29c6048411acd6f$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $b29c6048411acd6f$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$b29c6048411acd6f$export$85c928794f8d04d4.prototype.text = undefined;
class $b29c6048411acd6f$var$TextNode extends $b29c6048411acd6f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $b29c6048411acd6f$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $b29c6048411acd6f$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $b29c6048411acd6f$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $b29c6048411acd6f$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $b29c6048411acd6f$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $b29c6048411acd6f$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $b29c6048411acd6f$export$364ed450558d7ec4.empty;
        let expr = $b29c6048411acd6f$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $b29c6048411acd6f$var$dfa($b29c6048411acd6f$var$nfa(expr));
        $b29c6048411acd6f$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $b29c6048411acd6f$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $b29c6048411acd6f$export$364ed450558d7ec4.empty = new $b29c6048411acd6f$export$364ed450558d7ec4(true);
class $b29c6048411acd6f$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $b29c6048411acd6f$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($b29c6048411acd6f$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $b29c6048411acd6f$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($b29c6048411acd6f$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $b29c6048411acd6f$var$parseExprSubscript(stream) {
    let expr = $b29c6048411acd6f$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $b29c6048411acd6f$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $b29c6048411acd6f$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $b29c6048411acd6f$var$parseExprRange(stream, expr) {
    let min = $b29c6048411acd6f$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $b29c6048411acd6f$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $b29c6048411acd6f$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $b29c6048411acd6f$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $b29c6048411acd6f$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $b29c6048411acd6f$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $b29c6048411acd6f$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $b29c6048411acd6f$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $b29c6048411acd6f$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($b29c6048411acd6f$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $b29c6048411acd6f$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($b29c6048411acd6f$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $b29c6048411acd6f$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $b29c6048411acd6f$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($b29c6048411acd6f$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $b29c6048411acd6f$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $b29c6048411acd6f$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $b29c6048411acd6f$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $b29c6048411acd6f$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $b29c6048411acd6f$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $b29c6048411acd6f$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $b29c6048411acd6f$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $b29c6048411acd6f$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $b29c6048411acd6f$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $b29c6048411acd6f$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $b29c6048411acd6f$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $b29c6048411acd6f$export$ffb0004e005737fa.from(content), $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $b29c6048411acd6f$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $b29c6048411acd6f$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, attrs, content.append(after), $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b29c6048411acd6f$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $b29c6048411acd6f$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $b29c6048411acd6f$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $b29c6048411acd6f$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $b29c6048411acd6f$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $b29c6048411acd6f$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $b29c6048411acd6f$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $b29c6048411acd6f$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $b29c6048411acd6f$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $b29c6048411acd6f$export$c9d15bcfc6d42044(this, $b29c6048411acd6f$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $b29c6048411acd6f$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b29c6048411acd6f$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $b29c6048411acd6f$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $b29c6048411acd6f$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $b29c6048411acd6f$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $b29c6048411acd6f$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $b29c6048411acd6f$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $b29c6048411acd6f$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$b29c6048411acd6f$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$b29c6048411acd6f$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $b29c6048411acd6f$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $b29c6048411acd6f$var$TextNode(type, type.defaultAttrs, text, $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $b29c6048411acd6f$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $b29c6048411acd6f$var$isTagRule(rule) {
    return rule.tag != null;
}
function $b29c6048411acd6f$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $b29c6048411acd6f$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($b29c6048411acd6f$var$isTagRule(rule)) this.tags.push(rule);
            else if ($b29c6048411acd6f$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $b29c6048411acd6f$var$ParseContext(this, options, false);
        context.addAll(dom, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $b29c6048411acd6f$var$ParseContext(this, options, true);
        context.addAll(dom, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($b29c6048411acd6f$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b29c6048411acd6f$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b29c6048411acd6f$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $b29c6048411acd6f$export$1059c6e7d2ce5669(schema, $b29c6048411acd6f$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $b29c6048411acd6f$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $b29c6048411acd6f$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $b29c6048411acd6f$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $b29c6048411acd6f$var$OPT_PRESERVE_WS = 1, $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL = 2, $b29c6048411acd6f$var$OPT_OPEN_LEFT = 4;
function $b29c6048411acd6f$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $b29c6048411acd6f$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $b29c6048411acd6f$var$OPT_PRESERVE_WS | $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL : base & ~$b29c6048411acd6f$var$OPT_OPEN_LEFT;
}
class $b29c6048411acd6f$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $b29c6048411acd6f$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $b29c6048411acd6f$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$b29c6048411acd6f$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $b29c6048411acd6f$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $b29c6048411acd6f$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $b29c6048411acd6f$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $b29c6048411acd6f$var$NodeContext(topNode.type, topNode.attrs, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $b29c6048411acd6f$var$NodeContext(null, null, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $b29c6048411acd6f$var$NodeContext(parser.schema.topNodeType, null, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($b29c6048411acd6f$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $b29c6048411acd6f$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $b29c6048411acd6f$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($b29c6048411acd6f$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $b29c6048411acd6f$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $b29c6048411acd6f$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $b29c6048411acd6f$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $b29c6048411acd6f$var$OPT_OPEN_LEFT;
        let applyMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $b29c6048411acd6f$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $b29c6048411acd6f$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $b29c6048411acd6f$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $b29c6048411acd6f$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $b29c6048411acd6f$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $b29c6048411acd6f$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $b29c6048411acd6f$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $b29c6048411acd6f$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $b29c6048411acd6f$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $b29c6048411acd6f$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $b29c6048411acd6f$var$renderSpec($b29c6048411acd6f$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $b29c6048411acd6f$var$renderSpec($b29c6048411acd6f$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $b29c6048411acd6f$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $b29c6048411acd6f$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $b29c6048411acd6f$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $b29c6048411acd6f$var$gatherToDOM(schema.marks);
    }
}
function $b29c6048411acd6f$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $b29c6048411acd6f$var$doc(options) {
    return options.document || window.document;
}
const $b29c6048411acd6f$var$suspiciousAttributeCache = new WeakMap();
function $b29c6048411acd6f$var$suspiciousAttributes(attrs) {
    let value = $b29c6048411acd6f$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $b29c6048411acd6f$var$suspiciousAttributeCache.set(attrs, value = $b29c6048411acd6f$var$suspiciousAttributesInner(attrs));
    return value;
}
function $b29c6048411acd6f$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $b29c6048411acd6f$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $b29c6048411acd6f$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $b29c6048411acd6f$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("kM3zU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("9oaol")).default; });

var $9oaol = parcelRequire("9oaol");

});
parcelRegister("9oaol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d5e6a7e59b40032$export$2e2bcd8739ae039; });
// Main parser class

var $jAdKh = parcelRequire("jAdKh");

var $3Y2pZ = parcelRequire("3Y2pZ");

var $dI9QD = parcelRequire("dI9QD");

var $8zulA = parcelRequire("8zulA");

var $hORCU = parcelRequire("hORCU");

var $8Bjz2 = parcelRequire("8Bjz2");

var $bikvB = parcelRequire("bikvB");

var $8afOB = parcelRequire("8afOB");

var $fEiZX = parcelRequire("fEiZX");

var $hGp75 = parcelRequire("hGp75");

var $3glcq = parcelRequire("3glcq");

var $iZlew = parcelRequire("iZlew");
const $6d5e6a7e59b40032$var$config = {
    default: (0, $hGp75.default),
    zero: (0, $3glcq.default),
    commonmark: (0, $iZlew.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $6d5e6a7e59b40032$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $6d5e6a7e59b40032$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $6d5e6a7e59b40032$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $6d5e6a7e59b40032$var$BAD_PROTO_RE.test(str) ? $6d5e6a7e59b40032$var$GOOD_DATA_RE.test(str) : true;
}
const $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $6d5e6a7e59b40032$var$normalizeLink(url) {
    const parsed = $8afOB.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $8afOB.encode($8afOB.format(parsed));
}
function $6d5e6a7e59b40032$var$normalizeLinkText(url) {
    const parsed = $8afOB.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $8afOB.decode($8afOB.format(parsed), $8afOB.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $6d5e6a7e59b40032$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $6d5e6a7e59b40032$var$MarkdownIt)) return new $6d5e6a7e59b40032$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$jAdKh.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $8Bjz2.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $hORCU.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $8zulA.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $dI9QD.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $bikvB.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $6d5e6a7e59b40032$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $6d5e6a7e59b40032$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $6d5e6a7e59b40032$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $jAdKh;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $jAdKh.assign({}, $3Y2pZ);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.set = function(options) {
    $jAdKh.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($jAdKh.isString(presets)) {
        const presetName = presets;
        presets = $6d5e6a7e59b40032$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $6d5e6a7e59b40032$export$2e2bcd8739ae039 = $6d5e6a7e59b40032$var$MarkdownIt;

});
parcelRegister("jAdKh", function(module, exports) {
$parcel$export(module.exports, "isString", function () { return $e41c0aad11182ec3$export$844ec244b1367d54; });
$parcel$export(module.exports, "has", function () { return $e41c0aad11182ec3$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "assign", function () { return $e41c0aad11182ec3$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $e41c0aad11182ec3$export$f78478f71955b6bc; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $e41c0aad11182ec3$export$644a8f5b13b2a36d; });
$parcel$export(module.exports, "fromCodePoint", function () { return $e41c0aad11182ec3$export$73bfc63873071f74; });
$parcel$export(module.exports, "unescapeMd", function () { return $e41c0aad11182ec3$export$5ccde1ea0c14bb03; });
$parcel$export(module.exports, "unescapeAll", function () { return $e41c0aad11182ec3$export$db8a17c6655f7e2c; });
$parcel$export(module.exports, "escapeHtml", function () { return $e41c0aad11182ec3$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeRE", function () { return $e41c0aad11182ec3$export$bc616c8f7dc20d5d; });
$parcel$export(module.exports, "isSpace", function () { return $e41c0aad11182ec3$export$1d5ccafae59b4926; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $e41c0aad11182ec3$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isPunctChar", function () { return $e41c0aad11182ec3$export$4888a643af800fc1; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $e41c0aad11182ec3$export$829a0d33ae4e744; });
$parcel$export(module.exports, "normalizeReference", function () { return $e41c0aad11182ec3$export$20ef46802c8744b; });
$parcel$export(module.exports, "lib", function () { return $e41c0aad11182ec3$export$16c08b91f883959a; });
// Utilities
//

var $8afOB = parcelRequire("8afOB");
parcelRequire("8djVQ");
var $9GUSE = parcelRequire("9GUSE");
var $dYwW3 = parcelRequire("dYwW3");
var $8djVQ = parcelRequire("8djVQ");

var $fyijY = parcelRequire("fyijY");
function $e41c0aad11182ec3$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $e41c0aad11182ec3$export$844ec244b1367d54(obj) {
    return $e41c0aad11182ec3$var$_class(obj) === '[object String]';
}
const $e41c0aad11182ec3$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $e41c0aad11182ec3$export$a4f4bb6b1453fff5(object, key) {
    return $e41c0aad11182ec3$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $e41c0aad11182ec3$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $e41c0aad11182ec3$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $e41c0aad11182ec3$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $e41c0aad11182ec3$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $e41c0aad11182ec3$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $e41c0aad11182ec3$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $e41c0aad11182ec3$var$UNESCAPE_ALL_RE = new RegExp($e41c0aad11182ec3$var$UNESCAPE_MD_RE.source + '|' + $e41c0aad11182ec3$var$ENTITY_RE.source, 'gi');
const $e41c0aad11182ec3$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $e41c0aad11182ec3$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $e41c0aad11182ec3$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($e41c0aad11182ec3$export$644a8f5b13b2a36d(code)) return $e41c0aad11182ec3$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $fyijY.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $e41c0aad11182ec3$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($e41c0aad11182ec3$var$UNESCAPE_MD_RE, '$1');
}
function $e41c0aad11182ec3$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($e41c0aad11182ec3$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $e41c0aad11182ec3$var$replaceEntityPattern(match, entity);
    });
}
const $e41c0aad11182ec3$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $e41c0aad11182ec3$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $e41c0aad11182ec3$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $e41c0aad11182ec3$var$replaceUnsafeChar(ch) {
    return $e41c0aad11182ec3$var$HTML_REPLACEMENTS[ch];
}
function $e41c0aad11182ec3$export$4cf11838cdc2a8a8(str) {
    if ($e41c0aad11182ec3$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($e41c0aad11182ec3$var$HTML_ESCAPE_REPLACE_RE, $e41c0aad11182ec3$var$replaceUnsafeChar);
    return str;
}
const $e41c0aad11182ec3$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $e41c0aad11182ec3$export$bc616c8f7dc20d5d(str) {
    return str.replace($e41c0aad11182ec3$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $e41c0aad11182ec3$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $e41c0aad11182ec3$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $e41c0aad11182ec3$export$4888a643af800fc1(ch) {
    return $9GUSE.default.test(ch) || $dYwW3.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $e41c0aad11182ec3$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $e41c0aad11182ec3$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $e41c0aad11182ec3$export$16c08b91f883959a = {
    mdurl: $8afOB,
    ucmicro: $8djVQ
};

});
parcelRegister("8djVQ", function(module, exports) {
$parcel$export(module.exports, "Any", function () { return (parcelRequire("ioVOV")).default; });
$parcel$export(module.exports, "Cc", function () { return (parcelRequire("7ZsNi")).default; });
$parcel$export(module.exports, "Cf", function () { return (parcelRequire("lf7tL")).default; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("9GUSE")).default; });
$parcel$export(module.exports, "S", function () { return (parcelRequire("dYwW3")).default; });
$parcel$export(module.exports, "Z", function () { return (parcelRequire("1GVtv")).default; });

var $ioVOV = parcelRequire("ioVOV");

var $7ZsNi = parcelRequire("7ZsNi");

var $lf7tL = parcelRequire("lf7tL");

var $9GUSE = parcelRequire("9GUSE");

var $dYwW3 = parcelRequire("dYwW3");

var $1GVtv = parcelRequire("1GVtv");

});
parcelRegister("ioVOV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d65751d28666c205$export$2e2bcd8739ae039; });
var $d65751d28666c205$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("7ZsNi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d1490d77285b6f9$export$2e2bcd8739ae039; });
var $5d1490d77285b6f9$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("lf7tL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f770cce01c154783$export$2e2bcd8739ae039; });
var $f770cce01c154783$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("9GUSE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70e42890993670cf$export$2e2bcd8739ae039; });
var $70e42890993670cf$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("dYwW3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a2ca6d3d33e6bf9b$export$2e2bcd8739ae039; });
var $a2ca6d3d33e6bf9b$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("1GVtv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13b64c0197223edc$export$2e2bcd8739ae039; });
var $13b64c0197223edc$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});



parcelRegister("3Y2pZ", function(module, exports) {
$parcel$export(module.exports, "parseLinkLabel", function () { return (parcelRequire("bgpoG")).default; });
$parcel$export(module.exports, "parseLinkDestination", function () { return (parcelRequire("9boXi")).default; });
$parcel$export(module.exports, "parseLinkTitle", function () { return (parcelRequire("itr7G")).default; });
// Just a shortcut for bulk export

var $bgpoG = parcelRequire("bgpoG");

var $9boXi = parcelRequire("9boXi");

var $itr7G = parcelRequire("itr7G");

});
parcelRegister("bgpoG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8334e3a97149f6e3$export$2e2bcd8739ae039; });
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $8334e3a97149f6e3$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("9boXi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6af87fc6742bfd0b$export$2e2bcd8739ae039; });
// Parse link destination
//

var $jAdKh = parcelRequire("jAdKh");
function $6af87fc6742bfd0b$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $jAdKh.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $jAdKh.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("itr7G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d72ff97d09f44719$export$2e2bcd8739ae039; });
// Parse link title
//

var $jAdKh = parcelRequire("jAdKh");
function $d72ff97d09f44719$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $jAdKh.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $jAdKh.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("dI9QD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fb7060aa906cd84$export$2e2bcd8739ae039; });
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $jAdKh = parcelRequire("jAdKh");
const $9fb7060aa906cd84$var$default_rules = {};
$9fb7060aa906cd84$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $jAdKh.escapeHtml)(token.content) + '</code>';
};
$9fb7060aa906cd84$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $jAdKh.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$9fb7060aa906cd84$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $jAdKh.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $jAdKh.escapeHtml)(token.content);
    else highlighted = (0, $jAdKh.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$9fb7060aa906cd84$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$9fb7060aa906cd84$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$9fb7060aa906cd84$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$9fb7060aa906cd84$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $jAdKh.escapeHtml)(tokens[idx].content);
};
$9fb7060aa906cd84$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$9fb7060aa906cd84$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $9fb7060aa906cd84$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $jAdKh.assign)({}, $9fb7060aa906cd84$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $jAdKh.escapeHtml)(token.attrs[i][0]) + '="' + (0, $jAdKh.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $9fb7060aa906cd84$export$2e2bcd8739ae039 = $9fb7060aa906cd84$var$Renderer;

});

parcelRegister("8zulA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63d921ebf9b2b717$export$2e2bcd8739ae039; });
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $bFfe7 = parcelRequire("bFfe7");

var $4LCm3 = parcelRequire("4LCm3");

var $44RmA = parcelRequire("44RmA");

var $gcKrt = parcelRequire("gcKrt");

var $iRT9s = parcelRequire("iRT9s");

var $1K7Ml = parcelRequire("1K7Ml");

var $k0oTp = parcelRequire("k0oTp");

var $ccuZR = parcelRequire("ccuZR");
const $63d921ebf9b2b717$var$_rules = [
    [
        'normalize',
        (0, $4LCm3.default)
    ],
    [
        'block',
        (0, $44RmA.default)
    ],
    [
        'inline',
        (0, $gcKrt.default)
    ],
    [
        'linkify',
        (0, $iRT9s.default)
    ],
    [
        'replacements',
        (0, $1K7Ml.default)
    ],
    [
        'smartquotes',
        (0, $k0oTp.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $ccuZR.default)
    ]
];
/**
 * new Core()
 **/ function $63d921ebf9b2b717$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $63d921ebf9b2b717$var$_rules.length; i++)this.ruler.push($63d921ebf9b2b717$var$_rules[i][0], $63d921ebf9b2b717$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $63d921ebf9b2b717$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$63d921ebf9b2b717$var$Core.prototype.State = (0, $bFfe7.default);
var $63d921ebf9b2b717$export$2e2bcd8739ae039 = $63d921ebf9b2b717$var$Core;

});
parcelRegister("al4Wq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $786fb2d0e5829db3$export$2e2bcd8739ae039; });
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $786fb2d0e5829db3$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$786fb2d0e5829db3$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$786fb2d0e5829db3$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $786fb2d0e5829db3$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $786fb2d0e5829db3$export$2e2bcd8739ae039 = $786fb2d0e5829db3$var$Ruler;

});

parcelRegister("bFfe7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87df55bca0c16cbc$export$2e2bcd8739ae039; });
// Core state object
//

var $a6tQs = parcelRequire("a6tQs");
function $87df55bca0c16cbc$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$87df55bca0c16cbc$var$StateCore.prototype.Token = (0, $a6tQs.default);
var $87df55bca0c16cbc$export$2e2bcd8739ae039 = $87df55bca0c16cbc$var$StateCore;

});
parcelRegister("a6tQs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75b19d8960d6bda8$export$2e2bcd8739ae039; });
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $75b19d8960d6bda8$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $75b19d8960d6bda8$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $75b19d8960d6bda8$export$2e2bcd8739ae039 = $75b19d8960d6bda8$var$Token;

});


parcelRegister("4LCm3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37894da5bf2ba83d$export$2e2bcd8739ae039; });
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $37894da5bf2ba83d$var$NEWLINES_RE = /\r\n?|\n/g;
const $37894da5bf2ba83d$var$NULL_RE = /\0/g;
function $37894da5bf2ba83d$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($37894da5bf2ba83d$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($37894da5bf2ba83d$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("44RmA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f80edf71af23fe3$export$2e2bcd8739ae039; });
function $2f80edf71af23fe3$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("gcKrt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcc1cac35092a480$export$2e2bcd8739ae039; });
function $bcc1cac35092a480$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("iRT9s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbc7f5280c6133f0$export$2e2bcd8739ae039; });
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $jAdKh = parcelRequire("jAdKh");
function $dbc7f5280c6133f0$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $dbc7f5280c6133f0$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $dbc7f5280c6133f0$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($dbc7f5280c6133f0$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($dbc7f5280c6133f0$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $jAdKh.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("1K7Ml", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14501effb43464fc$export$2e2bcd8739ae039; });
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $14501effb43464fc$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $14501effb43464fc$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $14501effb43464fc$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $14501effb43464fc$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $14501effb43464fc$var$replaceFn(match, name) {
    return $14501effb43464fc$var$SCOPED_ABBR[name.toLowerCase()];
}
function $14501effb43464fc$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($14501effb43464fc$var$SCOPED_ABBR_RE, $14501effb43464fc$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $14501effb43464fc$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($14501effb43464fc$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $14501effb43464fc$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($14501effb43464fc$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $14501effb43464fc$var$replace_scoped(state.tokens[blkIdx].children);
        if ($14501effb43464fc$var$RARE_RE.test(state.tokens[blkIdx].content)) $14501effb43464fc$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("k0oTp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9071dec3c06a879$export$2e2bcd8739ae039; });
// Convert straight quotation marks to typographic ones
//

var $jAdKh = parcelRequire("jAdKh");
const $e9071dec3c06a879$var$QUOTE_TEST_RE = /['"]/;
const $e9071dec3c06a879$var$QUOTE_RE = /['"]/g;
const $e9071dec3c06a879$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $e9071dec3c06a879$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $e9071dec3c06a879$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $e9071dec3c06a879$var$QUOTE_RE.lastIndex = pos;
            const t = $e9071dec3c06a879$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $jAdKh.isMdAsciiPunct)(lastChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $jAdKh.isMdAsciiPunct)(nextChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $jAdKh.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $jAdKh.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, $e9071dec3c06a879$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $e9071dec3c06a879$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, $e9071dec3c06a879$var$APOSTROPHE);
        }
    }
}
function $e9071dec3c06a879$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$e9071dec3c06a879$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $e9071dec3c06a879$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("ccuZR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e1ea651f2ae58bf$export$2e2bcd8739ae039; });
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $8e1ea651f2ae58bf$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("hORCU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf90b44ae926287b$export$2e2bcd8739ae039; });
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $eb7ar = parcelRequire("eb7ar");

var $fkgtP = parcelRequire("fkgtP");

var $gHn7p = parcelRequire("gHn7p");

var $khfmv = parcelRequire("khfmv");

var $7mDQh = parcelRequire("7mDQh");

var $i3g95 = parcelRequire("i3g95");

var $9oXZR = parcelRequire("9oXZR");

var $edO9T = parcelRequire("edO9T");

var $dobwY = parcelRequire("dobwY");

var $dFmyD = parcelRequire("dFmyD");

var $qndlD = parcelRequire("qndlD");

var $jqVyi = parcelRequire("jqVyi");
const $cf90b44ae926287b$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $fkgtP.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $gHn7p.default)
    ],
    [
        'fence',
        (0, $khfmv.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $7mDQh.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $i3g95.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $9oXZR.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $edO9T.default)
    ],
    [
        'html_block',
        (0, $dobwY.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $dFmyD.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $qndlD.default)
    ],
    [
        'paragraph',
        (0, $jqVyi.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $cf90b44ae926287b$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $cf90b44ae926287b$var$_rules.length; i++)this.ruler.push($cf90b44ae926287b$var$_rules[i][0], $cf90b44ae926287b$var$_rules[i][1], {
        alt: ($cf90b44ae926287b$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$cf90b44ae926287b$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $cf90b44ae926287b$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$cf90b44ae926287b$var$ParserBlock.prototype.State = (0, $eb7ar.default);
var $cf90b44ae926287b$export$2e2bcd8739ae039 = $cf90b44ae926287b$var$ParserBlock;

});
parcelRegister("eb7ar", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a527a70da5807d06$export$2e2bcd8739ae039; });
// Parser state class

var $a6tQs = parcelRequire("a6tQs");

var $jAdKh = parcelRequire("jAdKh");
function $a527a70da5807d06$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $jAdKh.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$a527a70da5807d06$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $a6tQs.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$a527a70da5807d06$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$a527a70da5807d06$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$a527a70da5807d06$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$a527a70da5807d06$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $jAdKh.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$a527a70da5807d06$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$a527a70da5807d06$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$a527a70da5807d06$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $jAdKh.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$a527a70da5807d06$var$StateBlock.prototype.Token = (0, $a6tQs.default);
var $a527a70da5807d06$export$2e2bcd8739ae039 = $a527a70da5807d06$var$StateBlock;

});

parcelRegister("fkgtP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b28581e56e6fcb61$export$2e2bcd8739ae039; });
// GFM table, https://github.github.com/gfm/#tables-extension-

var $jAdKh = parcelRequire("jAdKh");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $b28581e56e6fcb61$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $b28581e56e6fcb61$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $b28581e56e6fcb61$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $b28581e56e6fcb61$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $jAdKh.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $jAdKh.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $jAdKh.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $b28581e56e6fcb61$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $b28581e56e6fcb61$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $b28581e56e6fcb61$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $b28581e56e6fcb61$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $b28581e56e6fcb61$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $b28581e56e6fcb61$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("gHn7p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c2829857da05e0ed$export$2e2bcd8739ae039; });
// Code block (4 spaces padded)
function $c2829857da05e0ed$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("khfmv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec314fc246d8e685$export$2e2bcd8739ae039; });
// fences (``` lang, ~~~ lang)
function $ec314fc246d8e685$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("7mDQh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $55c97e4c426d244c$export$2e2bcd8739ae039; });
// Block quotes

var $jAdKh = parcelRequire("jAdKh");
function $55c97e4c426d244c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $jAdKh.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("i3g95", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d24507f4d55c87ca$export$2e2bcd8739ae039; });
// Horizontal rule

var $jAdKh = parcelRequire("jAdKh");
function $d24507f4d55c87ca$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $jAdKh.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("9oXZR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d84e50bd0e54a4c$export$2e2bcd8739ae039; });
// Lists

var $jAdKh = parcelRequire("jAdKh");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $6d84e50bd0e54a4c$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $6d84e50bd0e54a4c$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $6d84e50bd0e54a4c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $6d84e50bd0e54a4c$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $6d84e50bd0e54a4c$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $6d84e50bd0e54a4c$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("edO9T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5a9300d8488e121$export$2e2bcd8739ae039; });

var $jAdKh = parcelRequire("jAdKh");
function $a5a9300d8488e121$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jAdKh.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jAdKh.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $jAdKh.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("dobwY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bf6760f5493ee8c$export$2e2bcd8739ae039; });
// HTML block

var $c27B4 = parcelRequire("c27B4");

var $2lp07 = parcelRequire("2lp07");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $9bf6760f5493ee8c$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $c27B4.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $2lp07.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $9bf6760f5493ee8c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $9bf6760f5493ee8c$var$HTML_SEQUENCES.length; i++){
        if ($9bf6760f5493ee8c$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $9bf6760f5493ee8c$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $9bf6760f5493ee8c$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$9bf6760f5493ee8c$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($9bf6760f5493ee8c$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("c27B4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8c2b90820c8dff74$export$2e2bcd8739ae039; });
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8c2b90820c8dff74$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("2lp07", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", function () { return $1b50ef9a86b1669d$export$6db61d2c3a16e419; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $1b50ef9a86b1669d$export$cd48660d06f74639; });
// Regexps to match html elements
const $1b50ef9a86b1669d$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $1b50ef9a86b1669d$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $1b50ef9a86b1669d$var$single_quoted = "'[^']*'";
const $1b50ef9a86b1669d$var$double_quoted = '"[^"]*"';
const $1b50ef9a86b1669d$var$attr_value = '(?:' + $1b50ef9a86b1669d$var$unquoted + '|' + $1b50ef9a86b1669d$var$single_quoted + '|' + $1b50ef9a86b1669d$var$double_quoted + ')';
const $1b50ef9a86b1669d$var$attribute = '(?:\\s+' + $1b50ef9a86b1669d$var$attr_name + '(?:\\s*=\\s*' + $1b50ef9a86b1669d$var$attr_value + ')?)';
const $1b50ef9a86b1669d$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $1b50ef9a86b1669d$var$attribute + '*\\s*\\/?>';
const $1b50ef9a86b1669d$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $1b50ef9a86b1669d$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $1b50ef9a86b1669d$var$processing = '<[?][\\s\\S]*?[?]>';
const $1b50ef9a86b1669d$var$declaration = '<![A-Za-z][^>]*>';
const $1b50ef9a86b1669d$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $1b50ef9a86b1669d$export$6db61d2c3a16e419 = new RegExp('^(?:' + $1b50ef9a86b1669d$var$open_tag + '|' + $1b50ef9a86b1669d$var$close_tag + '|' + $1b50ef9a86b1669d$var$comment + '|' + $1b50ef9a86b1669d$var$processing + '|' + $1b50ef9a86b1669d$var$declaration + '|' + $1b50ef9a86b1669d$var$cdata + ')');
const $1b50ef9a86b1669d$export$cd48660d06f74639 = new RegExp('^(?:' + $1b50ef9a86b1669d$var$open_tag + '|' + $1b50ef9a86b1669d$var$close_tag + ')');

});


parcelRegister("dFmyD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f309a325f116786$export$2e2bcd8739ae039; });
// heading (#, ##, ...)

var $jAdKh = parcelRequire("jAdKh");
function $9f309a325f116786$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $jAdKh.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $jAdKh.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("qndlD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $04f46fb260a30d10$export$2e2bcd8739ae039; });
// lheading (---, ===)
function $04f46fb260a30d10$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("jqVyi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e25d16aee9b013f2$export$2e2bcd8739ae039; });
// Paragraph
function $e25d16aee9b013f2$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("8Bjz2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6430f46f7c6d4a31$export$2e2bcd8739ae039; });
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $lbaoU = parcelRequire("lbaoU");

var $3B5Ot = parcelRequire("3B5Ot");

var $5bBHA = parcelRequire("5bBHA");

var $f7JCq = parcelRequire("f7JCq");

var $31cye = parcelRequire("31cye");

var $bpHE6 = parcelRequire("bpHE6");

var $5LJFE = parcelRequire("5LJFE");

var $cfwZG = parcelRequire("cfwZG");

var $8Lj6w = parcelRequire("8Lj6w");

var $77xCG = parcelRequire("77xCG");

var $iIWcd = parcelRequire("iIWcd");

var $h9Rs1 = parcelRequire("h9Rs1");

var $1k9Pg = parcelRequire("1k9Pg");

var $cY3lM = parcelRequire("cY3lM");

var $3YBjn = parcelRequire("3YBjn");
// Parser rules
const $6430f46f7c6d4a31$var$_rules = [
    [
        'text',
        (0, $3B5Ot.default)
    ],
    [
        'linkify',
        (0, $5bBHA.default)
    ],
    [
        'newline',
        (0, $f7JCq.default)
    ],
    [
        'escape',
        (0, $31cye.default)
    ],
    [
        'backticks',
        (0, $bpHE6.default)
    ],
    [
        'strikethrough',
        (0, $5LJFE.default).tokenize
    ],
    [
        'emphasis',
        (0, $cfwZG.default).tokenize
    ],
    [
        'link',
        (0, $8Lj6w.default)
    ],
    [
        'image',
        (0, $77xCG.default)
    ],
    [
        'autolink',
        (0, $iIWcd.default)
    ],
    [
        'html_inline',
        (0, $h9Rs1.default)
    ],
    [
        'entity',
        (0, $1k9Pg.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $6430f46f7c6d4a31$var$_rules2 = [
    [
        'balance_pairs',
        (0, $cY3lM.default)
    ],
    [
        'strikethrough',
        (0, $5LJFE.default).postProcess
    ],
    [
        'emphasis',
        (0, $cfwZG.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $3YBjn.default)
    ]
];
/**
 * new ParserInline()
 **/ function $6430f46f7c6d4a31$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $6430f46f7c6d4a31$var$_rules.length; i++)this.ruler.push($6430f46f7c6d4a31$var$_rules[i][0], $6430f46f7c6d4a31$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $al4Wq.default)();
    for(let i = 0; i < $6430f46f7c6d4a31$var$_rules2.length; i++)this.ruler2.push($6430f46f7c6d4a31$var$_rules2[i][0], $6430f46f7c6d4a31$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$6430f46f7c6d4a31$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$6430f46f7c6d4a31$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $6430f46f7c6d4a31$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$6430f46f7c6d4a31$var$ParserInline.prototype.State = (0, $lbaoU.default);
var $6430f46f7c6d4a31$export$2e2bcd8739ae039 = $6430f46f7c6d4a31$var$ParserInline;

});
parcelRegister("lbaoU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6b2b172457a9c5f$export$2e2bcd8739ae039; });
// Inline parser state

var $a6tQs = parcelRequire("a6tQs");

var $jAdKh = parcelRequire("jAdKh");
function $f6b2b172457a9c5f$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$f6b2b172457a9c5f$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $a6tQs.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$f6b2b172457a9c5f$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $a6tQs.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$f6b2b172457a9c5f$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $jAdKh.isMdAsciiPunct)(lastChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $jAdKh.isMdAsciiPunct)(nextChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $jAdKh.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $jAdKh.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$f6b2b172457a9c5f$var$StateInline.prototype.Token = (0, $a6tQs.default);
var $f6b2b172457a9c5f$export$2e2bcd8739ae039 = $f6b2b172457a9c5f$var$StateInline;

});

parcelRegister("3B5Ot", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $29e95627682e68e6$export$2e2bcd8739ae039; });
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $29e95627682e68e6$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $29e95627682e68e6$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$29e95627682e68e6$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("5bBHA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c6b39aab2e4725f$export$2e2bcd8739ae039; });
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $3c6b39aab2e4725f$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $3c6b39aab2e4725f$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($3c6b39aab2e4725f$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("f7JCq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b02ae5663d7c397a$export$2e2bcd8739ae039; });
// Proceess '\n'

var $jAdKh = parcelRequire("jAdKh");
function $b02ae5663d7c397a$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $jAdKh.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("31cye", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $232b337fe1dbc147$export$2e2bcd8739ae039; });
// Process escaped chars and hardbreaks

var $jAdKh = parcelRequire("jAdKh");
const $232b337fe1dbc147$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$232b337fe1dbc147$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $232b337fe1dbc147$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $232b337fe1dbc147$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $232b337fe1dbc147$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("bpHE6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84f3e2acbb3f477b$export$2e2bcd8739ae039; });
// Parse backticks
function $84f3e2acbb3f477b$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("5LJFE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4334c4ca8a565d37$export$2e2bcd8739ae039; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $4334c4ca8a565d37$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $4334c4ca8a565d37$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $4334c4ca8a565d37$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $4334c4ca8a565d37$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $4334c4ca8a565d37$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $4334c4ca8a565d37$export$2e2bcd8739ae039 = {
    tokenize: $4334c4ca8a565d37$var$strikethrough_tokenize,
    postProcess: $4334c4ca8a565d37$var$strikethrough_postProcess
};

});

parcelRegister("cfwZG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8eb07aabc8fb87e8$export$2e2bcd8739ae039; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $8eb07aabc8fb87e8$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $8eb07aabc8fb87e8$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $8eb07aabc8fb87e8$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $8eb07aabc8fb87e8$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $8eb07aabc8fb87e8$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $8eb07aabc8fb87e8$export$2e2bcd8739ae039 = {
    tokenize: $8eb07aabc8fb87e8$var$emphasis_tokenize,
    postProcess: $8eb07aabc8fb87e8$var$emphasis_post_process
};

});

parcelRegister("8Lj6w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $661188369ea2246a$export$2e2bcd8739ae039; });
// Process [link](<to> "stuff")

var $jAdKh = parcelRequire("jAdKh");
function $661188369ea2246a$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jAdKh.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("77xCG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52f344a87a9da36b$export$2e2bcd8739ae039; });
// Process ![image](<src> "title")

var $jAdKh = parcelRequire("jAdKh");
function $52f344a87a9da36b$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jAdKh.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("iIWcd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da197a960fbf31ba$export$2e2bcd8739ae039; });
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $da197a960fbf31ba$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $da197a960fbf31ba$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $da197a960fbf31ba$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($da197a960fbf31ba$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($da197a960fbf31ba$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("h9Rs1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7dcbd307caee285$export$2e2bcd8739ae039; });
// Process html tags

var $2lp07 = parcelRequire("2lp07");
function $c7dcbd307caee285$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c7dcbd307caee285$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $c7dcbd307caee285$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $c7dcbd307caee285$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$c7dcbd307caee285$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $2lp07.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($c7dcbd307caee285$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($c7dcbd307caee285$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("1k9Pg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f6f47e5869f2b90$export$2e2bcd8739ae039; });
// Process html entity - &#123;, &#xAF;, &quot;, ...

var $fyijY = parcelRequire("fyijY");

var $jAdKh = parcelRequire("jAdKh");
const $0f6f47e5869f2b90$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $0f6f47e5869f2b90$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $0f6f47e5869f2b90$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($0f6f47e5869f2b90$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $jAdKh.isValidEntityCode)(code) ? (0, $jAdKh.fromCodePoint)(code) : (0, $jAdKh.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($0f6f47e5869f2b90$var$NAMED_RE);
        if (match) {
            const decoded = (0, $fyijY.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("cY3lM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $970dafe9fd11b3b9$export$2e2bcd8739ae039; });
// For each opening emphasis-like marker find a matching closing one
//
function $970dafe9fd11b3b9$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $970dafe9fd11b3b9$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $970dafe9fd11b3b9$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $970dafe9fd11b3b9$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("3YBjn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e53eafa15757cf6$export$2e2bcd8739ae039; });
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $2e53eafa15757cf6$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("bikvB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $839148bf738493a5$export$2e2bcd8739ae039; });

var $jQKeV = parcelRequire("jQKeV");
//
// Helpers
//
// Merge objects
//
function $839148bf738493a5$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $839148bf738493a5$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $839148bf738493a5$var$isString(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object String]';
}
function $839148bf738493a5$var$isObject(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object Object]';
}
function $839148bf738493a5$var$isRegExp(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object RegExp]';
}
function $839148bf738493a5$var$isFunction(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object Function]';
}
function $839148bf738493a5$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $839148bf738493a5$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $839148bf738493a5$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $839148bf738493a5$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $839148bf738493a5$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $839148bf738493a5$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $839148bf738493a5$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $839148bf738493a5$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $839148bf738493a5$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $839148bf738493a5$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $839148bf738493a5$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $jQKeV.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($839148bf738493a5$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($839148bf738493a5$var$isObject(val)) {
            if ($839148bf738493a5$var$isRegExp(val.validate)) compiled.validate = $839148bf738493a5$var$createValidator(val.validate);
            else if ($839148bf738493a5$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($839148bf738493a5$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $839148bf738493a5$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($839148bf738493a5$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $839148bf738493a5$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($839148bf738493a5$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $839148bf738493a5$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $839148bf738493a5$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $839148bf738493a5$var$createMatch(self, shift) {
    const match = new $839148bf738493a5$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $839148bf738493a5$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $839148bf738493a5$var$LinkifyIt)) return new $839148bf738493a5$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($839148bf738493a5$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $839148bf738493a5$var$assign({}, $839148bf738493a5$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $839148bf738493a5$var$assign({}, $839148bf738493a5$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $839148bf738493a5$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $839148bf738493a5$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $839148bf738493a5$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $839148bf738493a5$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $839148bf738493a5$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $839148bf738493a5$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($839148bf738493a5$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($839148bf738493a5$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $839148bf738493a5$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $839148bf738493a5$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $839148bf738493a5$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $839148bf738493a5$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $839148bf738493a5$export$2e2bcd8739ae039 = $839148bf738493a5$var$LinkifyIt;

});
parcelRegister("jQKeV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e736bde30bd9de04$export$2e2bcd8739ae039; });
parcelRequire("8djVQ");
var $ioVOV = parcelRequire("ioVOV");
var $7ZsNi = parcelRequire("7ZsNi");
var $9GUSE = parcelRequire("9GUSE");
var $1GVtv = parcelRequire("1GVtv");
function $e736bde30bd9de04$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $ioVOV.default).source;
    re.src_Cc = (0, $7ZsNi.default).source;
    re.src_Z = (0, $1GVtv.default).source;
    re.src_P = (0, $9GUSE.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("hGp75", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdf9d6e6ab0e2050$export$2e2bcd8739ae039; });
// markdown-it default options
var $cdf9d6e6ab0e2050$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("3glcq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26034f75d61adf8b$export$2e2bcd8739ae039; });
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $26034f75d61adf8b$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("iZlew", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd2e64f709955416$export$2e2bcd8739ae039; });
// Commonmark default options
var $dd2e64f709955416$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});




parcelRegister("d6iF4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $989a4faae6b4435d$export$2e2bcd8739ae039; });
function $989a4faae6b4435d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $989a4faae6b4435d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $989a4faae6b4435d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $989a4faae6b4435d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $989a4faae6b4435d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $989a4faae6b4435d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $989a4faae6b4435d$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ var $989a4faae6b4435d$var$citation = function citation(state) {
    var tokens = [];
    var citationIndexMap = {};
    var currentIndex = 1;
    var _iterator = $989a4faae6b4435d$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === 'text' && $989a4faae6b4435d$var$CITATION_REGEX.test(childToken.content)) {
                    /**
             * Example content: `Hello [^1^][^1^].`
             * `parts` will be ['Hello ', '1', '', '1', '.']
             */ var parts = childToken.content.split($989a4faae6b4435d$var$CITATION_REGEX);
                    var newChildren = [];
                    /**
             * we want to remove consecutive citation
             * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
             * should be transformed to `Hello 1. How are you 1 2`
             */ var lastCitation = null;
                    var isLastCitationDuplicate = false;
                    // only want to add space in the next part after citation
                    // if the last citation is valid
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            // this is a text part
                            /**
                 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
                 * So it doesn't end up rendering empty space that will end up with multi empty spaces
                 * because previous valid citation already added 1 empty space
                 *
                 * Example: For `[^1^][^1^]`
                 * it will be split into parts: ['', '1', '', '1', ''],
                 * This code will skip any rendering for the last empty string (index=4)
                 * Because the empty string at index=2 already added 1 empty space from the code below
                 */ if (isLastCitationDuplicate && part.trim() === '') return;
                            if (part.trim() !== '') /**
                   * if the text part is not an empty string, we want to reset the last citation
                   * because the text part is a valid text, and not a space between citations
                   * so that we can render citation again, even if the next number is the same as the last number
                   *
                   * Example:
                   * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                   */ lastCitation = null;
                            var textToken = new state.Token('text', '', 0);
                            if (index === parts.length - 1) textToken.content = part;
                            else textToken.content = part + ' ';
                            textToken.block = false;
                            textToken.level = childToken.level;
                            newChildren.push(textToken);
                        } else {
                            // this is a citation part
                            // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                            if (part === lastCitation) {
                                isLastCitationDuplicate = true;
                                return;
                            } else {
                                // always reset the duplicate flag
                                isLastCitationDuplicate = false;
                                lastCitation = part;
                            }
                            var citationToken = new state.Token('status', '', 0);
                            citationToken.content = '';
                            citationToken.block = false;
                            citationToken.level = childToken.level;
                            var citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                            citationToken.attrs = [
                                [
                                    'color',
                                    'blue'
                                ],
                                [
                                    'text',
                                    citationText
                                ],
                                // localId is used to identify the citation token in the DOM
                                // this overrides the uuid that is normally used
                                [
                                    'localId',
                                    "citation-".concat(citationText)
                                ]
                            ];
                            citationToken.content = citationText;
                            newChildren.push(citationToken);
                        }
                    });
                    tokenChildren.push.apply(tokenChildren, newChildren);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $989a4faae6b4435d$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('citation', $989a4faae6b4435d$var$citation);
};

});

parcelRegister("l1YGC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4f8c40cc10f1210$export$2e2bcd8739ae039; });
function $f4f8c40cc10f1210$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f4f8c40cc10f1210$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f4f8c40cc10f1210$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f4f8c40cc10f1210$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
var $f4f8c40cc10f1210$var$dataSculptor = function dataSculptor(state) {
    var tokens = [];
    var _iterator = $f4f8c40cc10f1210$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === 'text' && $f4f8c40cc10f1210$var$SCULPTOR_REGEX.test(childToken.content)) {
                    var citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'localId',
                            'data-sculptor'
                        ],
                        [
                            'text',
                            'data-sculptor'
                        ],
                        [
                            'color',
                            'blue'
                        ]
                    ];
                    var parts = childToken.content.split($f4f8c40cc10f1210$var$SCULPTOR_REGEX);
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            var textToken = new state.Token('text', '', 0);
                            textToken.content = part;
                            textToken.level = childToken.level;
                            tokenChildren.push(textToken);
                        } else tokenChildren.push(citationToken);
                    });
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $f4f8c40cc10f1210$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('data-sculptor', $f4f8c40cc10f1210$var$dataSculptor);
};

});

parcelRegister("1o1tc", function(module, exports) {
$parcel$export(module.exports, "createLinkifyPlugin", function () { return $10292c37b68bb0b4$export$763ac077c9998026; });

var $l2qL1 = parcelRequire("l2qL1");

var $cXZAA = parcelRequire("cXZAA");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
var $10292c37b68bb0b4$var$arrayReplaceAt = function arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
var $10292c37b68bb0b4$var$isLinkOpen = function isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
};
var $10292c37b68bb0b4$var$isLinkClose = function isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
};
var $10292c37b68bb0b4$export$8cd7d1ec2e6808da = function createLinkify(_ref) {
    var findFilepaths = _ref.findFilepaths, isLinkInMatches = _ref.isLinkInMatches;
    return function(state) {
        var blockTokens = state.tokens;
        var linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($l2qL1)))();
        for(var j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            var tokens = blockTokens[j].children;
            var htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(var i = tokens.length - 1; i >= 0; i--){
                var currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($10292c37b68bb0b4$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($10292c37b68bb0b4$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    var _text = currentToken.content;
                    var links = (0, $cXZAA.linkifyMatch)(_text);
                    if (!links.length) links = linkify.match(_text) || [];
                    // Now split string to nodes
                    var nodes = [];
                    var level = currentToken.level;
                    var lastPos = 0;
                    var _filepaths = findFilepaths(_text);
                    for(var ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, _filepaths)) continue;
                        var url = links[ln].url;
                        var fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        var urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        var pos = links[ln].index;
                        if (pos > lastPos) {
                            var _token = new state.Token('text', '', 0);
                            _token.content = _text.slice(lastPos, pos);
                            _token.level = level;
                            nodes.push(_token);
                        }
                        var token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < _text.length) {
                        var _token2 = new state.Token('text', '', 0);
                        _token2.content = _text.slice(lastPos);
                        _token2.level = level;
                        nodes.push(_token2);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $10292c37b68bb0b4$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
};
var $10292c37b68bb0b4$export$763ac077c9998026 = function createLinkifyPlugin(params) {
    return function(md) {
        return md.core.ruler.push('custom-linkify', $10292c37b68bb0b4$export$8cd7d1ec2e6808da(params));
    };
};

});
parcelRegister("cXZAA", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", function () { return $970ac50fdadab884$export$6f7d7761b97f967; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $9FThR = parcelRequire("9FThR");
var $970ac50fdadab884$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $970ac50fdadab884$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $970ac50fdadab884$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $970ac50fdadab884$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($9FThR)))();
$970ac50fdadab884$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$970ac50fdadab884$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $970ac50fdadab884$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$970ac50fdadab884$export$8ccbde94d5c7f8e7.add('tel:', $970ac50fdadab884$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$970ac50fdadab884$export$8ccbde94d5c7f8e7.add('file:', $970ac50fdadab884$var$urlWithoutSpacesValidator);
$970ac50fdadab884$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $970ac50fdadab884$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $970ac50fdadab884$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$970ac50fdadab884$var$tlds.push($970ac50fdadab884$var$tlds2Char);
$970ac50fdadab884$export$8ccbde94d5c7f8e7.tlds($970ac50fdadab884$var$tlds, false);
var $970ac50fdadab884$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $970ac50fdadab884$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$970ac50fdadab884$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($970ac50fdadab884$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($970ac50fdadab884$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $970ac50fdadab884$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $970ac50fdadab884$export$6f7d7761b97f967(str);
    if (!match.length) match = $970ac50fdadab884$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $970ac50fdadab884$export$6535eb414fa2c8b6(url) {
    var match = $970ac50fdadab884$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $970ac50fdadab884$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("9FThR", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $70b2d442873a38f8$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $70b2d442873a38f8$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $70b2d442873a38f8$var$isString(obj) {
    return $70b2d442873a38f8$var$_class(obj) === '[object String]';
}
function $70b2d442873a38f8$var$isObject(obj) {
    return $70b2d442873a38f8$var$_class(obj) === '[object Object]';
}
function $70b2d442873a38f8$var$isRegExp(obj) {
    return $70b2d442873a38f8$var$_class(obj) === '[object RegExp]';
}
function $70b2d442873a38f8$var$isFunction(obj) {
    return $70b2d442873a38f8$var$_class(obj) === '[object Function]';
}
function $70b2d442873a38f8$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $70b2d442873a38f8$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $70b2d442873a38f8$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $70b2d442873a38f8$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $70b2d442873a38f8$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $70b2d442873a38f8$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $70b2d442873a38f8$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $70b2d442873a38f8$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $70b2d442873a38f8$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $70b2d442873a38f8$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $70b2d442873a38f8$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("e4sDG"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($70b2d442873a38f8$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($70b2d442873a38f8$var$isObject(val)) {
            if ($70b2d442873a38f8$var$isRegExp(val.validate)) compiled.validate = $70b2d442873a38f8$var$createValidator(val.validate);
            else if ($70b2d442873a38f8$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($70b2d442873a38f8$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $70b2d442873a38f8$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($70b2d442873a38f8$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $70b2d442873a38f8$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($70b2d442873a38f8$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $70b2d442873a38f8$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $70b2d442873a38f8$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $70b2d442873a38f8$var$createMatch(self, shift) {
    var match = new $70b2d442873a38f8$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $70b2d442873a38f8$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $70b2d442873a38f8$var$LinkifyIt)) return new $70b2d442873a38f8$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($70b2d442873a38f8$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $70b2d442873a38f8$var$assign({}, $70b2d442873a38f8$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $70b2d442873a38f8$var$assign({}, $70b2d442873a38f8$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $70b2d442873a38f8$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $70b2d442873a38f8$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $70b2d442873a38f8$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $70b2d442873a38f8$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($70b2d442873a38f8$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($70b2d442873a38f8$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $70b2d442873a38f8$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $70b2d442873a38f8$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $70b2d442873a38f8$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $70b2d442873a38f8$var$LinkifyIt;

});
parcelRegister("e4sDG", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("hubVA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbae7da3cc390d23$export$2e2bcd8739ae039; });

var $7CMz9 = parcelRequire("7CMz9");
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $cbae7da3cc390d23$var$createRule() {
    // Match any images that aren't inside single backticks
    var mdImageRegex = /(?<!`)!\[[^\]]*\]\([^\)]+\)(?!`)/g;
    var validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        var createMediaTokens = function createMediaTokens(url) {
            var mediaSingleOpen = new State.Token('media_single_open', '', 1);
            var media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            var mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $7CMz9.default)(openingTokens), [
                inlineBefore
            ], (0, $7CMz9.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
                }).reverse();
                var matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                var inlineContentStack = token.content;
                matches.forEach(function(match) {
                    var start = inlineContentStack.indexOf(match);
                    var contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $7CMz9.default)(createMediaTokens(match)));
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $7CMz9.default)(processedTokens), (0, $7CMz9.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $7CMz9.default)(tokens.slice(0, cursor)), (0, $7CMz9.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $cbae7da3cc390d23$export$2e2bcd8739ae039 = function(md) {
    md.core.ruler.before('inline', 'media', $cbae7da3cc390d23$var$createRule());
};

});

parcelRegister("lNotn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fde12860f08ebfc8$export$2e2bcd8739ae039; });
function $fde12860f08ebfc8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fde12860f08ebfc8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fde12860f08ebfc8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fde12860f08ebfc8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fde12860f08ebfc8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fde12860f08ebfc8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
var $fde12860f08ebfc8$var$isPeopleLink = function isPeopleLink(url) {
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
var $fde12860f08ebfc8$var$getAccountId = function getAccountId(url) {
    var match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
var $fde12860f08ebfc8$var$mentionLinks = function mentionLinks(state) {
    var tokens = [];
    var _iterator = $fde12860f08ebfc8$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            // We're only looking for inline children
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken, i) {
                var _childToken$attrGet, _tokenChildren, _tokenChildren2;
                var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
                var discardedToken = [
                    'link_close',
                    'text'
                ].includes(childToken.type) && [
                    (_tokenChildren = tokenChildren[i - 1]) === null || _tokenChildren === void 0 ? void 0 : _tokenChildren.type,
                    (_tokenChildren2 = tokenChildren[i - 2]) === null || _tokenChildren2 === void 0 ? void 0 : _tokenChildren2.type
                ].includes('mention');
                // Discarded tokens are preserved as `null` so index
                // cross-referencing between processed and raw tokens may
                // be preserved, however null are filtered out later.
                if (discardedToken) {
                    tokenChildren.push(null);
                    return;
                }
                if (childToken.type === 'link_open' && $fde12860f08ebfc8$var$isPeopleLink(url)) {
                    var _token$children$conte, _token$children2;
                    var mentionText = (_token$children$conte = (_token$children2 = token.children) === null || _token$children2 === void 0 || (_token$children2 = _token$children2[i + 1]) === null || _token$children2 === void 0 ? void 0 : _token$children2.content) !== null && _token$children$conte !== void 0 ? _token$children$conte : '';
                    var mentionToken = new state.Token('mention', '', 0);
                    mentionToken.content = '';
                    mentionToken.block = false;
                    mentionToken.level = childToken.level;
                    mentionToken.attrSet('id', "".concat($fde12860f08ebfc8$var$getAccountId(url)));
                    if (mentionText) mentionToken.attrSet('text', "@".concat(mentionText));
                    tokenChildren.push(mentionToken);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $fde12860f08ebfc8$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('mention', $fde12860f08ebfc8$var$mentionLinks);
};

});

parcelRegister("9Pv4k", function(module, exports) {
$parcel$export(module.exports, "createSmartLinksPlugin", function () { return $7280fa1321053f92$export$9625a798761643ac; });

var $7CMz9 = parcelRequire("7CMz9");

var $9Mgjd = parcelRequire("9Mgjd");
function $7280fa1321053f92$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7280fa1321053f92$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7280fa1321053f92$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7280fa1321053f92$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7280fa1321053f92$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7280fa1321053f92$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7280fa1321053f92$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
var $7280fa1321053f92$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
var $7280fa1321053f92$var$linkRegex = {
    youtube: "".concat($7280fa1321053f92$var$linkPatternStart, "youtube\\.com").concat($7280fa1321053f92$var$linkPatternEnd),
    youtubeShortUrl: "".concat($7280fa1321053f92$var$linkPatternStart, "youtu\\.be").concat($7280fa1321053f92$var$linkPatternEnd),
    loomVideo: "".concat($7280fa1321053f92$var$linkPatternStart, "loom\\.com\\/share\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    figmaFile: "".concat($7280fa1321053f92$var$linkPatternStart, "figma\\.com\\/file\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    confluenceWhiteboard: "".concat($7280fa1321053f92$var$linkPatternStart, ".*\\/wiki\\/spaces\\/.*\\/whiteboard\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    googleDoc: "".concat($7280fa1321053f92$var$linkPatternStart, "docs\\.google\\.com\\/(document|presentation|spreadsheets)\\/d\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    googleForm: "".concat($7280fa1321053f92$var$linkPatternStart, "docs\\.google\\.com\\/forms\\/d\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    microsoftForm: "".concat($7280fa1321053f92$var$linkPatternStart, "forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=").concat($7280fa1321053f92$var$linkPatternEnd),
    analyticsChart: "\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-".concat($7280fa1321053f92$var$linkPatternEnd)
};
var $7280fa1321053f92$var$supportedEmbedProviders = Object.values($7280fa1321053f92$var$linkRegex).join('|');
var $7280fa1321053f92$var$embedRegex = new RegExp($7280fa1321053f92$var$supportedEmbedProviders, 'g');
var $7280fa1321053f92$var$embedInlineRegex = [
    "".concat($7280fa1321053f92$var$linkPatternStart, "avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+").concat($7280fa1321053f92$var$linkPatternEnd)
];
var $7280fa1321053f92$var$createSmartLinks = function createSmartLinks(_ref) {
    var regexStorage = _ref.regexStorage;
    return function(state) {
        var _embedMatches;
        var tokens = [];
        var embedTokens = [];
        var embedMatches = [];
        var filteredTokens = [];
        var _iterator = $7280fa1321053f92$var$_createForOfIteratorHelper(state.tokens), _step;
        try {
            var _loop = function _loop() {
                var _token$content;
                var token = _step.value;
                var processedTokenChildren = [];
                embedMatches = [].concat((0, $7CMz9.default)(embedMatches), (0, $7CMz9.default)(new Set((_token$content = token.content) === null || _token$content === void 0 ? void 0 : _token$content.trim().match($7280fa1321053f92$var$embedRegex))));
                // Any block or embed Smart Card links will be in an "inline" token. If
                // the current token is anything other than "inline", or there's no child tokens
                // to process, then we add it to the list of tokens to keep and move forward
                if (token.type !== 'inline' || !token.children) {
                    tokens.push(token);
                    return 1; // continue
                }
                outputToken = new state.Token('inline', '', 0);
                var tokensToAppend = [
                    outputToken
                ];
                if (token.children) {
                    var discardUntilIndex = -1;
                    token.children.forEach(function(childToken, i) {
                        var _childToken$attrGet, _token$children;
                        var discardedToken = i <= discardUntilIndex && [
                            'link_close',
                            'text'
                        ].includes(childToken.type);
                        if (discardedToken) return;
                        var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
                        var isInlineLink = url === ((_token$children = token.children) === null || _token$children === void 0 || (_token$children = _token$children[i + 1]) === null || _token$children === void 0 ? void 0 : _token$children.content);
                        if ((childToken === null || childToken === void 0 ? void 0 : childToken.type) === 'link_open' && ((0, $9Mgjd.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                            // Discard the next two tokens. We're now processing the opening node for a URL
                            // that will result in a new node that replaces it, therefore the subsequent link content and
                            // closing node are no longer needed
                            discardUntilIndex = i + 2;
                            if (token.level <= 1 && $7280fa1321053f92$var$embedInlineRegex.some(function(r) {
                                return url.match(r);
                            })) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                processedTokenChildren = [];
                                var embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', url);
                                embedToken.attrSet('layout', 'center');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                return;
                            }
                            var cardToken = new state.Token('inlineCard', '', 0);
                            cardToken.content = '';
                            cardToken.block = false;
                            cardToken.level = childToken.level;
                            cardToken.attrSet('url', url);
                            processedTokenChildren.push(cardToken);
                            return;
                        }
                        processedTokenChildren.push(childToken);
                    });
                }
                outputToken.children = processedTokenChildren;
                var blockTokensWithContent = tokensToAppend.filter(function(t) {
                    var _t$children;
                    return t.type !== 'inline' || ((_t$children = t.children) === null || _t$children === void 0 ? void 0 : _t$children.length);
                });
                tokens.push.apply(tokens, (0, $7CMz9.default)(blockTokensWithContent));
            }, outputToken;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                if (_loop()) continue;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        for(var i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        if ((_embedMatches = embedMatches) !== null && _embedMatches !== void 0 && _embedMatches.length) (0, $7CMz9.default)(new Set(embedMatches)).forEach(function(match) {
            var embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [].concat(filteredTokens, embedTokens);
        return;
    };
};
var $7280fa1321053f92$export$9625a798761643ac = function createSmartLinksPlugin(params) {
    return function(md) {
        return md.core.ruler.push('inlineCard', $7280fa1321053f92$var$createSmartLinks(params));
    };
};

});
parcelRegister("9Mgjd", function(module, exports) {
$parcel$export(module.exports, "isSupportedByLinkingPlatform", function () { return $71e53f630dc5e5af$export$4b1056d02426889c; });

var $7CMz9 = parcelRequire("7CMz9");

var $a82E7 = parcelRequire("a82E7");

var $esAUd = parcelRequire("esAUd");

var $dWJ7u = parcelRequire("dWJ7u");

var $e7G1e = parcelRequire("e7G1e");
var $71e53f630dc5e5af$export$4b1056d02426889c = function isSupportedByLinkingPlatform(url, regexStorage) {
    var cachedProviderRegex = $71e53f630dc5e5af$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    var regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
var $71e53f630dc5e5af$export$90caa0c170ea581 = function getProviderRegexFromLs(regexStorage) {
    if (regexStorage.getItem((0, $e7G1e.LS_PROVIDER_KEY))) return JSON.parse("".concat(regexStorage.getItem((0, $e7G1e.LS_PROVIDER_KEY))));
    return '';
};
var $71e53f630dc5e5af$export$5af966b3aa3b1d83 = function setProviderRegexLs(regexStorage, providerRegex) {
    regexStorage === null || regexStorage === void 0 || regexStorage.setItem((0, $e7G1e.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
var $71e53f630dc5e5af$export$d08c351b3b4e4934 = /*#__PURE__*/ function() {
    var _ref = (0, $a82E7.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).mark(function _callee(regexStorage, baseUrl) {
        var providerRegex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return $71e53f630dc5e5af$export$ab8eaff0f2d596bd(baseUrl);
                case 2:
                    providerRegex = _context.sent;
                    $71e53f630dc5e5af$export$5af966b3aa3b1d83(regexStorage, providerRegex);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function hydrateLinkingPlatformCache(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $71e53f630dc5e5af$export$b7ac97ae80c7eb5a = function reduceProviderRegex(data) {
    var sources = data.providers.reduce(function(acc, provider) {
        var providerSources = provider.patterns.map(function(pattern) {
            return pattern.source;
        });
        return [].concat((0, $7CMz9.default)(acc), (0, $7CMz9.default)(providerSources));
    }, []);
    return sources.join('|');
};
var $71e53f630dc5e5af$export$ab8eaff0f2d596bd = (0, $dWJ7u.default)(/*#__PURE__*/ (0, $a82E7.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).mark(function _callee2() {
    var baseUrl, response, data, _args2 = arguments;
    return (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).wrap(function _callee2$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                baseUrl = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
                _context2.prev = 1;
                _context2.next = 4;
                return fetch(baseUrl + (0, $e7G1e.PROVIDERS_API), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        type: 'resolve'
                    })
                });
            case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();
            case 7:
                data = _context2.sent;
                return _context2.abrupt("return", !data ? '' : $71e53f630dc5e5af$export$b7ac97ae80c7eb5a(data));
            case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", '');
            case 14:
            case "end":
                return _context2.stop();
        }
    }, _callee2, null, [
        [
            1,
            11
        ]
    ]);
})));

});
parcelRegister("a82E7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75fcb42cea8c7756$export$2e2bcd8739ae039; });
function $75fcb42cea8c7756$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $75fcb42cea8c7756$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $75fcb42cea8c7756$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $75fcb42cea8c7756$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("esAUd", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a8704eea2278a85c$var$runtime = (parcelRequire("8CTwP"))();
module.exports = $a8704eea2278a85c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a8704eea2278a85c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a8704eea2278a85c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a8704eea2278a85c$var$runtime);
}

});
parcelRegister("8CTwP", function(module, exports) {

var $aJdgT = parcelRequire("aJdgT");

var $jM7Jt = parcelRequire("jM7Jt");

var $govlt = parcelRequire("govlt");

var $4G0eq = parcelRequire("4G0eq");

var $kt5KI = parcelRequire("kt5KI");

var $1lrfx = parcelRequire("1lrfx");

var $5u4qL = parcelRequire("5u4qL");
function $647cf2218b980ae6$var$_regeneratorRuntime() {
    "use strict";
    var r = $jM7Jt(), e = r.m($647cf2218b980ae6$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $5u4qL(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $647cf2218b980ae6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $aJdgT(r, e);
            },
            AsyncIterator: $kt5KI,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $4G0eq : $govlt)(a(r), e, t, o, u);
            },
            keys: $1lrfx,
            values: $5u4qL
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $647cf2218b980ae6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aJdgT", function(module, exports) {
function $7cf866c6b89b743e$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $7cf866c6b89b743e$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jM7Jt", function(module, exports) {

var $9yZlS = parcelRequire("9yZlS");
function $03b71ad4a597dc76$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $9yZlS(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($9yZlS(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $9yZlS(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $9yZlS(u, "constructor", GeneratorFunctionPrototype), $9yZlS(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $9yZlS(GeneratorFunctionPrototype, o, "GeneratorFunction"), $9yZlS(u), $9yZlS(u, o, "Generator"), $9yZlS(u, n, function() {
        return this;
    }), $9yZlS(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $03b71ad4a597dc76$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $03b71ad4a597dc76$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9yZlS", function(module, exports) {
function $6f66e140db708363$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $6f66e140db708363$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $6f66e140db708363$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6f66e140db708363$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $6f66e140db708363$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("govlt", function(module, exports) {

var $4G0eq = parcelRequire("4G0eq");
function $bef733be7495db5a$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $4G0eq(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $bef733be7495db5a$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4G0eq", function(module, exports) {

var $jM7Jt = parcelRequire("jM7Jt");

var $kt5KI = parcelRequire("kt5KI");
function $367b43b07f5a31f2$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $kt5KI($jM7Jt().w(r, e, t, o), n || Promise);
}
module.exports = $367b43b07f5a31f2$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kt5KI", function(module, exports) {

var $aJdgT = parcelRequire("aJdgT");

var $9yZlS = parcelRequire("9yZlS");
function $ee6afa69f61191ad$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $aJdgT ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($9yZlS($ee6afa69f61191ad$var$AsyncIterator.prototype), $9yZlS($ee6afa69f61191ad$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $9yZlS(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $ee6afa69f61191ad$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("1lrfx", function(module, exports) {
function $0face3ce903781bc$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $0face3ce903781bc$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5u4qL", function(module, exports) {

var $detnK = parcelRequire("detnK");
var $3fe330e993184481$var$_typeof = $detnK.default;
function $3fe330e993184481$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($3fe330e993184481$var$_typeof(e) + " is not iterable");
}
module.exports = $3fe330e993184481$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("detnK", function(module, exports) {
function $9a235fd6667f6a4f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9a235fd6667f6a4f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9a235fd6667f6a4f$var$_typeof(o);
}
module.exports = $9a235fd6667f6a4f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("e7G1e", function(module, exports) {
$parcel$export(module.exports, "PROVIDERS_API", function () { return $a4825037d35c848c$export$57ad190cdc563df3; });
$parcel$export(module.exports, "LS_PROVIDER_KEY", function () { return $a4825037d35c848c$export$56bec2f197c16818; });
var $a4825037d35c848c$export$57ad190cdc563df3 = "/gateway/api/object-resolver/providers";
var $a4825037d35c848c$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';

});



parcelRegister("6oSt6", function(module, exports) {
$parcel$export(module.exports, "pmToMd", function () { return $4a8f3c3edb5162e4$export$cd54a56af01ba875; });
$parcel$export(module.exports, "mdToPmSchema", function () { return $4a8f3c3edb5162e4$export$eb83d753215c78a2; });
var $4a8f3c3edb5162e4$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
var $4a8f3c3edb5162e4$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            };
        }
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: function attrs(tok) {
            var order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: function attrs(tok) {
            var _tok$info;
            return {
                language: ((_tok$info = tok.info) === null || _tok$info === void 0 ? void 0 : _tok$info.trim()) || null
            };
        }
    },
    image: {
        node: 'image',
        attrs: function attrs(_tok) {
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: 'media',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: function attrs(tok) {
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: function attrs(token) {
            return {
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            };
        }
    }
};

});

parcelRegister("eDDZa", function(module, exports) {
$parcel$export(module.exports, "filterSchemaMapping", function () { return $aa83b983c3f41387$export$155749302793c60c; });
$parcel$export(module.exports, "enableSchemaPlugins", function () { return $aa83b983c3f41387$export$a1cf9d9b96e16789; });

var $6oSt6 = parcelRequire("6oSt6");
var $aa83b983c3f41387$export$155749302793c60c = function filterSchemaMapping(schema, map) {
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
};
var $aa83b983c3f41387$export$a1cf9d9b96e16789 = function enableSchemaPlugins(md, schema) {
    for(var k in 0, $6oSt6.pmToMd){
        var key = k;
        for(var i in (0, $6oSt6.pmToMd)[key]){
            var idx = i;
            if (schema[key][idx]) md.enable((0, $6oSt6.pmToMd)[key][idx]);
        }
    }
};

});


parcelRegister("7WR9R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d7163c322fc0d31f$export$2e2bcd8739ae039; });

var $cnLy7 = parcelRequire("cnLy7");

var $4DYmX = parcelRequire("4DYmX");
class $d7163c322fc0d31f$export$2e2bcd8739ae039 extends (0, $cnLy7.AiMateMarkdownTransformer) {
    constructor(schema, pluginConfig, streaming){
        super(schema, pluginConfig, streaming);
        const tokenizer = this.parser.tokenizer;
        // Override the default citation plugin to handle citations to allow grouping consecutive citations into one citation node.
        tokenizer.use((0, $4DYmX.default));
    }
    parse(content) {
        return super.parse(content);
    }
}

});
parcelRegister("4DYmX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52fadcd2cc50ffe8$export$2e2bcd8739ae039; });
const $52fadcd2cc50ffe8$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is replacing the default citation plugin to handle citations to allow
 * grouping consecutive citations into one citation node.
 * Copied from platform/packages/ai-mate/csm-chat-simulator/src/common/utils/content-transformer/md-tokenizer/md-plugin-citation/index.ts
 */ const $52fadcd2cc50ffe8$var$groupedCitation = (state)=>{
    const tokens = [];
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== "inline" || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === "text" && $52fadcd2cc50ffe8$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($52fadcd2cc50ffe8$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                let groupedCitationsToken = new state.Token("status", "", 0);
                let isGroupedCitationsTokenAdded = false;
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if (isLastCitationDuplicate && part.trim() === "") return;
                        if (part.trim() !== "") {
                            /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                            groupedCitationsToken = new state.Token("status", "", 0);
                            isGroupedCitationsTokenAdded = false;
                        }
                        const textToken = new state.Token("text", "", 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else if (part.trim() === "") // Skip adding space for empty parts between consecutive citations
                        return;
                        else textToken.content = part + " ";
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        groupedCitationsToken.block = false;
                        groupedCitationsToken.level = childToken.level;
                        const citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                        if (!citationIndexMap[part]) {
                            citationIndexMap[part] = currentIndex;
                            currentIndex++;
                        }
                        if (groupedCitationsToken.content) groupedCitationsToken.content = groupedCitationsToken.content + "," + citationText;
                        else groupedCitationsToken.content = citationText;
                        groupedCitationsToken.attrs = [
                            [
                                "color",
                                "blue"
                            ],
                            // add the citations to attrs as a comma separated list
                            [
                                "text",
                                groupedCitationsToken.content
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                "localId",
                                `citation-${groupedCitationsToken.content}`
                            ]
                        ];
                        if (!isGroupedCitationsTokenAdded) {
                            newChildren.push(groupedCitationsToken);
                            isGroupedCitationsTokenAdded = true;
                        }
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $52fadcd2cc50ffe8$export$2e2bcd8739ae039 = (md)=>md.core.ruler.at("citation", $52fadcd2cc50ffe8$var$groupedCitation);

});



parcelRegister("g1Xew", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("hCwjc"),
    $eao4m("lRMpp"),
    $eao4m("7kVZX"),
    $eao4m("9WEDO"),
    $eao4m("7Q4ht"),
    $eao4m("cnEwY")
]).then(()=>parcelRequire('7uSg7'));

});
parcelRegister("eao4m", function(module, exports) {
"use strict";

function $a504ab8c5934a050$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hwrhg")).resolve(id));
}
module.exports = $a504ab8c5934a050$var$load;

});
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});





parcelRegister("diVdn", function(module, exports) {
$parcel$export(module.exports, "AISummaryLoadingAnimation", function () { return $2d3789cef31ea748$export$3445570560693912; });
/* ai-summary-loading-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1AV7c = parcelRequire("1AV7c");

var $5qdCp = parcelRequire("5qdCp");
const $2d3789cef31ea748$export$3445570560693912 = ({ traceResponse: traceResponse })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1wybdlk8 _syazi7uo"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1AV7c.RovoIcon), {
                className: (0, $2jatx.default)([
                    "_12l2ftgi"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_vwz4gktf"
                ]),
                children: traceResponse
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qdCp.LoadingDotsAnimation), {})
        ]
    });
};
const $2d3789cef31ea748$var$aiSummaryLoadingAnimationWrapperStyle = null;

});
parcelRegister("1AV7c", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $4ecdb20147ef5aca$export$e23ae35269442b4f; });
// Copy of search-ai/src/v2/common/ui/assets/Rovo.svg

var $7VQPk = parcelRequire("7VQPk");
const $4ecdb20147ef5aca$export$e23ae35269442b4f = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L17.8968 4.16857C18.598 4.57283 19.032 5.32283 19.032 6.1308V13.8618C19.032 14.6729 18.6006 15.4196 17.8973 15.8237L12.8611 18.7293C12.8721 18.6984 12.8826 18.6672 12.8926 18.6358C12.9861 18.3462 13.0357 18.0401 13.0357 17.7272V9.99628C13.0357 8.93422 12.4704 7.95482 11.5484 7.425L10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.26173 1.27069L2.22547 4.17636C1.5222 4.5804 1.09082 5.32709 1.09082 6.13826V13.8692C1.09082 14.6772 1.52475 15.4271 2.22593 15.8314L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594L8.57469 12.5752C7.65284 12.0453 7.08715 11.0657 7.08715 10.0037V2.27277C7.08715 1.96035 7.13657 1.65469 7.2298 1.36539C7.23992 1.33362 7.25057 1.30205 7.26173 1.27069Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L2.22593 15.8314C1.52475 15.4271 1.09082 14.6772 1.09082 13.8692V6.13826C1.09082 5.32709 1.5222 4.5804 2.22547 4.17636L7.26173 1.27069C7.25057 1.30205 7.23992 1.33362 7.2298 1.36539C7.13657 1.65469 7.08715 1.96035 7.08715 2.27277V10.0037C7.08715 11.0657 7.65284 12.0453 8.57469 12.5752L9.41444 13.0594Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L10.6181 6.88854Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8968 4.16857L16.6126 3.42764L10.6181 6.88854L11.5484 7.425C12.4704 7.95482 13.0357 8.93422 13.0357 9.99628V17.7272C13.0357 18.0401 12.9861 18.3462 12.8926 18.6358C12.8826 18.6672 12.8721 18.6984 12.8611 18.7293L17.8973 15.8237C18.6006 15.4196 19.032 14.6729 19.032 13.8618V6.1308C19.032 5.32283 18.598 4.57283 17.8968 4.16857Z",
                fill: "#AF59E1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594Z",
                fill: "#6A9A23"
            })
        ]
    });
};

});

parcelRegister("5qdCp", function(module, exports) {
$parcel$export(module.exports, "LoadingDotsAnimation", function () { return $7fd063e3a7878559$export$32ef2855359d928d; });
// Copy of platform/packages/search/search-ai/src/ai-answer-dialog/ai-answer-loading/rovo-generating-animation.tsx

var $7VQPk = parcelRequire("7VQPk");
const $7fd063e3a7878559$export$32ef2855359d928d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "3",
                cy: "14",
                r: "1",
                fill: "#1F69DA",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;1;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "7",
                cy: "14",
                r: "1",
                fill: "#C16CD4",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "11",
                cy: "14",
                r: "1",
                fill: "#F5A117",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;0;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            })
        ]
    });
};

});


parcelRegister("lRaZ3", function(module, exports) {
$parcel$export(module.exports, "AISourcesPlaceholder", function () { return $dc3308e451d947f0$export$65d65ea641d2488; });
$parcel$export(module.exports, "AISummarySources", function () { return $dc3308e451d947f0$export$84667b49bad4c133; });
/* ai-summary-sources.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $4WS03 = parcelRequire("4WS03");

var $h6Fsc = parcelRequire("h6Fsc");

var $deg4B = parcelRequire("deg4B");

var $zADBD = parcelRequire("zADBD");
var $6A2DX = parcelRequire("6A2DX");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $fJkKo = parcelRequire("fJkKo");

var $iunwt = parcelRequire("iunwt");
// Placeholder skeletons for sources while loading
const $dc3308e451d947f0$var$sourcePlaceholderPulseStyle = null;
const $dc3308e451d947f0$var$sourcesIconPlaceholderStyle = null;
const $dc3308e451d947f0$var$sourceDescriptionPlaceholderStyle = null;
const $dc3308e451d947f0$var$sourceTitlePlaceholderStyle = null;
const $dc3308e451d947f0$var$AISourceDescriptionPlaceholder = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3iv47k _bfhk1ybm _2rko12b0",
                    "_kqswh2mm _1reo15vq _18m915vq _aetrb3bt _18postnw _9v7aidpf _14mj1kw7 _16r29r9m _clh3jq3t _46tsh4ux _93ujglyw"
                ]),
                style: {
                    "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3iv47k _bfhk1ybm _2rko12b0",
                    "_kqswh2mm _1reo15vq _18m915vq _aetrb3bt _18postnw _9v7aidpf _14mj1kw7 _16r29r9m _clh3jq3t _46tsh4ux _93ujglyw"
                ]),
                style: {
                    "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                }
            })
        ]
    });
const $dc3308e451d947f0$var$AISourcePlaceholder = ({ isFirst: isFirst, isLast: isLast })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1h6o _y3gn1e5h _zulpu2gc _1q51pxbi _85i5pxbi _bozgpxbi _y4tipxbi _19itglyw _179r18gv _1reo15vq _18m915vq _1bto1l2s _11q7glyw _bfhk1ybm _80omtlke _11c81kw7 _irr36kkz",
            "_80om73ad _irr31ybm",
            isFirst && "_1s1g1tm3 _5fbc1tm3",
            isLast && "_179rglyw _1yxn1tm3 _1ein1tm3"
        ]),
        style: {
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _4cvr1h6o _1bsb1osq _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsbv47k _4t3iv47k _2rko1b66 _bfhk1ybm",
                            "_kqswh2mm _1reo15vq _18m915vq _aetrb3bt _18postnw _9v7aidpf _14mj1kw7 _16r29r9m _clh3jq3t _46tsh4ux _93ujglyw"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1nrf _4t3iv47k _bfhk1ybm _2rko12b0",
                            "_kqswh2mm _1reo15vq _18m915vq _aetrb3bt _18postnw _9v7aidpf _14mj1kw7 _16r29r9m _clh3jq3t _46tsh4ux _93ujglyw"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($dc3308e451d947f0$var$AISourceDescriptionPlaceholder, {})
        ]
    });
const $dc3308e451d947f0$export$65d65ea641d2488 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp1b66 _6rthutpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ejb _4t3i1ejb _2rko1b66 _bfhk1ybm"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($deg4B))), {
                            size: "medium",
                            label: "Sources",
                            color: "var(--ds-icon-brand, #1868DB)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: "Sources"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _bfhkglyw"
                ]),
                children: Array.from({
                    length: 2
                }, (_, i)=>`placeholder-${i}`).map((key, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($dc3308e451d947f0$var$AISourcePlaceholder, {
                        isFirst: index === 0,
                        isLast: index === 1
                    }, key))
            })
        ]
    });
const $dc3308e451d947f0$var$createProductMatcher = (logo, productName)=>({
        logo: logo,
        patterns: [
            `/${productName}`,
            `/software/${productName}`
        ]
    });
const $dc3308e451d947f0$var$productLogoMatchers = [
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.BitbucketIcon), "bitbucket"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.CompassIcon), "compass"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.ConfluenceIcon), "confluence"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.GuardIcon), "guard"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.JiraProductDiscoveryIcon), "jira/product-discovery"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.JiraServiceManagementIcon), "jira/service-management"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.JiraAlignIcon), "jira/align"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.JiraIcon), "jira"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.LoomIcon), "loom"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.OpsgenieIcon), "opsgenie"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.RovoIcon), "rovo"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.RovoIcon), "rovo-dev"),
    // Using RovoIcon until RovoDevIcon is available. Packages may need updating to work.
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.StatuspageIcon), "statuspage"),
    $dc3308e451d947f0$var$createProductMatcher((0, $6A2DX.TrelloIcon), "trello")
];
const $dc3308e451d947f0$var$getSourceProductLogo = (sourceUrl)=>{
    let normalizedUrl = sourceUrl.toLowerCase();
    try {
        const parsedUrl = new URL(sourceUrl);
        normalizedUrl = `${parsedUrl.hostname}${parsedUrl.pathname}`.toLowerCase();
    } catch  {
        normalizedUrl = sourceUrl.toLowerCase();
    }
    const matchedLogo = $dc3308e451d947f0$var$productLogoMatchers.find(({ patterns: patterns })=>patterns.some((pattern)=>normalizedUrl.includes(pattern)));
    return matchedLogo?.logo || (0, $zADBD.AtlassianIcon);
};
const $dc3308e451d947f0$var$sourcesContainerStyle = null;
const $dc3308e451d947f0$var$sourcesContainerExpandedStyle = null;
const $dc3308e451d947f0$var$sourcesContainerFilteredStyle = null;
const $dc3308e451d947f0$var$sourcesStyle = null;
const $dc3308e451d947f0$var$sourcesFilteredStyle = null;
const $dc3308e451d947f0$var$sourcesExpandedScrollableStyle = null;
const $dc3308e451d947f0$var$sourcesWithButtonStyle = null;
// This is shared between the placeholder and the actual sources to prevent layout shift when loading state changes
const $dc3308e451d947f0$var$sourceStyle = null;
const $dc3308e451d947f0$var$sourceFilteredStyle = null;
const $dc3308e451d947f0$var$sourceFirstStyle = null;
const $dc3308e451d947f0$var$sourceLastWithoutButtonStyle = null;
const $dc3308e451d947f0$var$sourcePlaceholderOverrideStyle = null;
const $dc3308e451d947f0$var$sourceHeaderStyle = null;
const $dc3308e451d947f0$var$sourceTitleStyle = null;
const $dc3308e451d947f0$var$sourceDescriptionStyle = null;
const $dc3308e451d947f0$var$sourcesHeaderStyle = null;
const $dc3308e451d947f0$var$sourcesHeaderTitleStyle = null;
const $dc3308e451d947f0$var$sourcesIconWrapperStyle = null;
const $dc3308e451d947f0$var$blurOverlayStyle = null;
const $dc3308e451d947f0$var$showMoreButtonBlurOverlayStyle = null;
const $dc3308e451d947f0$var$buttonStyle = null;
// Converts a URL to an Algolia objectId following the pattern: https://www.atlassian.com/software/confluence -> www.atlassian.com-software-confluence
// Uses plain string operations instead of regex to avoid ReDoS risk from backtracking.
const $dc3308e451d947f0$var$urlToObjectId = (url)=>{
    // Strip protocol prefix (http:// or https://) without regex
    const protocolEnd = url.indexOf("://");
    let normalized = protocolEnd !== -1 ? url.slice(protocolEnd + 3) : url;
    // Strip trailing slashes
    let end = normalized.length;
    while(end > 0 && normalized[end - 1] === "/")end -= 1;
    normalized = normalized.slice(0, end);
    // Replace path separators with hyphens
    return normalized.split("/").join("-");
};
const $dc3308e451d947f0$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 = "www.atlassian.com.v3-2";
const $dc3308e451d947f0$var$ALGOLIA_DEV_SEARCH_INDEX_V3 = "www.atlassian.com.v3_dev";
const $dc3308e451d947f0$var$CrossIconComponent = (iconProps)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
        ...iconProps,
        size: "medium",
        color: "var(--ds-icon-warning-inverse, #292A2E)"
    });
};
const $dc3308e451d947f0$export$84667b49bad4c133 = ({ isExpanded: isExpanded, isTruncated: isTruncated, maxExpandedHeight: maxExpandedHeight, filteredSourceIndexes: filteredSourceIndexes, onClearSourceFilter: onClearSourceFilter })=>{
    const [isSourcesExpanded, setIsSourcesExpanded] = (0, $1oC0p.useState)(false);
    const [filteredListMaxHeight, setFilteredListMaxHeight] = (0, $1oC0p.useState)(264);
    const [isDescriptionsLoading, setIsDescriptionsLoading] = (0, $1oC0p.useState)(false);
    const [sourceDescriptions, setSourceDescriptions] = (0, $1oC0p.useState)({});
    const sourcesListRef = (0, $1oC0p.useRef)(null);
    const searchHelperRef = (0, $1oC0p.useRef)();
    const { sources: sources } = (0, $iunwt.useAISummaryContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const isFilteredMode = Boolean(filteredSourceIndexes?.length);
    const filteredSources = (sources ?? []).filter((_, index)=>(filteredSourceIndexes ?? []).includes(index));
    const visibleSources = isSourcesExpanded ? sources ?? [] : (sources ?? []).slice(0, 3);
    const displaySources = isFilteredMode ? filteredSources : visibleSources;
    const shouldShowMoreButton = !isFilteredMode && (sources?.length ?? 0) > 3;
    const isSourcesLoading = !sources;
    (0, $1oC0p.useEffect)(()=>{
        if (!isFilteredMode || !sourcesListRef.current) return;
        const firstRow = sourcesListRef.current.firstElementChild;
        if (!firstRow) return;
        setFilteredListMaxHeight(firstRow.offsetHeight * 3);
    }, [
        displaySources.length,
        isFilteredMode
    ]);
    // Fetch descriptions from Algolia using SearchHelper
    (0, $1oC0p.useEffect)(()=>{
        if (!sources || sources.length === 0) return;
        const fetchDescriptions = async ()=>{
            try {
                setIsDescriptionsLoading(true);
                // Initialize SearchHelper if not already done
                if (!searchHelperRef.current) {
                    const searchIndex = $dc3308e451d947f0$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2;
                    searchHelperRef.current = new (0, $fJkKo.SearchHelper)(searchIndex, [
                        "category",
                        "locale"
                    ]);
                }
                // Convert URLs to objectIds
                const objectIds = sources.map((source)=>$dc3308e451d947f0$var$urlToObjectId(source.url));
                // Fetch objects from Algolia
                const response = await searchHelperRef.current.getObjects(objectIds);
                // Map descriptions to source indexes
                if (response && response.results) {
                    const descriptionsMap = {};
                    response.results.forEach((result, index)=>{
                        const typedResult = result;
                        if (typedResult.description) descriptionsMap[index] = typedResult.description;
                    });
                    setSourceDescriptions(descriptionsMap);
                }
            } catch (error) {
                console.error("Failed to fetch source descriptions from Algolia:", error);
            } finally{
                setIsDescriptionsLoading(false);
            }
        };
        fetchDescriptions();
    }, [
        sources
    ]);
    const handleSourceLinkClick = (source, index)=>{
        createAnalyticsEvent({
            eventName: "searchAiSummarySourceLinkClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "searchAiSummarySourceLink",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                sourceUrl: source.url,
                sourceTitle: source.title,
                sourceIndex: index
            }
        }).fire();
        window.open(source.url, "_blank", "noopener,noreferrer");
    };
    const handleToggleSourcesExpansion = ()=>{
        setIsSourcesExpanded(!isSourcesExpanded);
        createAnalyticsEvent({
            eventName: isSourcesExpanded ? "searchAiSummarySourcesShowLessClicked" : "searchAiSummarySourcesShowMoreClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: isSourcesExpanded ? "searchAiSummarySourcesShowLess" : "searchAiSummarySourcesShowMore",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                labelEnglish: isSourcesExpanded ? "Show less" : "Show more",
                sourceCount: sources?.length ?? 0
            }
        }).fire();
    };
    const sourcesText = intl.formatMessage({
        id: "ai.summary.sources.header",
        defaultMessage: sources && sources.length > 1 ? "Sources" : "Source"
    });
    const relevantSourcesText = intl.formatMessage({
        id: "ai.summary.sources.relevant.header",
        defaultMessage: "Relevant sources"
    });
    const clearRelevantSourcesFilterText = intl.formatMessage({
        id: "ai.summary.sources.relevant.clear",
        defaultMessage: "Clear relevant sources filter"
    });
    const showMoreButtonText = intl.formatMessage({
        id: "ai.summary.sources.showMore",
        defaultMessage: isSourcesExpanded ? "Show less" : "Show more"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1reo15vq _18m915vq _kqswh2mm _4t3i4cy5 _p12f1q8v",
            isExpanded && "_4t3i1wug",
            isFilteredMode && "_19it1k0a _2rko1tm3 _bozgpxbi _y4tipxbi _1q51v47k _85i5utpp"
        ]),
        style: {
            ...!isFilteredMode && isSourcesExpanded ? {
                maxHeight: `${maxExpandedHeight}px`
            } : undefined,
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp1b66 _6rthutpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ejb _4t3i1ejb _2rko1b66 _bfhk1ybm"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($deg4B))), {
                            size: "medium",
                            label: isFilteredMode ? relevantSourcesText : sourcesText,
                            color: "var(--ds-icon-brand, #1868DB)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: isFilteredMode ? relevantSourcesText : sourcesText
                    }),
                    isFilteredMode && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$dc3308e451d947f0$var$CrossIconComponent(iconProps),
                        label: clearRelevantSourcesFilterText,
                        onClick: onClearSourceFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: sourcesListRef,
                style: isFilteredMode ? {
                    maxHeight: `${Math.min(filteredListMaxHeight, maxExpandedHeight)}px`
                } : undefined,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _bfhkglyw",
                    shouldShowMoreButton && "_85i5idpf",
                    isSourcesExpanded && "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _18m91wug",
                    isFilteredMode && "_bozgglyw _y4tiglyw _2rko1mok _zulpu2gc"
                ]),
                children: displaySources.map((source, i)=>{
                    // Get the actual index in the original sources array
                    const actualSourceIndex = (sources ?? []).findIndex((s)=>s.url === source.url);
                    const description = sourceDescriptions[actualSourceIndex] || "";
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                        tabIndex: 0,
                        "aria-label": source.title || source.url,
                        onClick: ()=>handleSourceLinkClick(source, i),
                        onKeyDown: (event)=>{
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                handleSourceLinkClick(source, i);
                            }
                        },
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1h6o _y3gn1e5h _zulpu2gc _1q51pxbi _85i5pxbi _bozgpxbi _y4tipxbi _19itglyw _179r18gv _1reo15vq _18m915vq _1bto1l2s _11q7glyw _bfhk1ybm _80omtlke _11c81kw7 _irr36kkz",
                            isFilteredMode && "_bozgpxbi _y4tipxbi _179rglyw _2rko1mok",
                            !isFilteredMode && i === 0 && "_1s1g1tm3 _5fbc1tm3",
                            !isFilteredMode && !shouldShowMoreButton && i === displaySources.length - 1 && "_179rglyw _1yxn1tm3 _1ein1tm3"
                        ]),
                        style: {
                            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bah1y6m _4cvr1h6o _1bsb1osq _zulpu2gc"
                                ]),
                                children: [
                                    (()=>{
                                        const SourceLogo = $dc3308e451d947f0$var$getSourceProductLogo(source.url);
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)(SourceLogo, {
                                            size: "small",
                                            appearance: "brand"
                                        });
                                    })(),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1ul9idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                        ]),
                                        children: source.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1e0ccj1k _1reo15vq _18m915vq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1yg0 _1wybwadc _1bto1l2s _1yyjcs5v _sudp1e54"
                                ]),
                                style: {
                                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                },
                                children: isDescriptionsLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)($dc3308e451d947f0$var$AISourceDescriptionPlaceholder, {}) : description
                            })
                        ]
                    }, source.url);
                })
            }),
            !isFilteredMode && !isExpanded && isTruncated && sources && sources.length > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71vm0 _1bsb1osq _1e0c116y _1bah1h6o _4cvr1h6o _kqswstnw _u7coidpf _1e02idpf _1q51xncg _syazi7uo"
                ]),
                style: {
                    "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                }
            }),
            !isFilteredMode && isExpanded && shouldShowMoreButton && !isSourcesLoading && !isSourcesExpanded && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q718qj _1bsb1osq _4t3ioahv _kqswstnw _1e02idpf _u7co1ex1 _lcxvglyw _1pbykb7n"
                ]),
                style: {
                    "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                }
            }),
            !isFilteredMode && shouldShowMoreButton && !isSourcesLoading && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                onClick: handleToggleSourcesExpansion,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1o9zidpf _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1ex1 _1tke1ex1 _p12fagmp _bfhk1s93 _2rkob0je _syaz1ft0 _u1mbdaj9"
                ]),
                children: showMoreButtonText
            })
        ]
    });
};

});
parcelRegister("fJkKo", function(module, exports) {
$parcel$export(module.exports, "SearchHelper", function () { return $794877e0f92b060f$export$3a4ead32446b35b2; });

var $8R4AT = parcelRequire("8R4AT");

var $l45jb = parcelRequire("l45jb");

var $1Q6XY = parcelRequire("1Q6XY");
const $794877e0f92b060f$var$ALGOLIA_APP_ID = "CU5KFWE75C";
const $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY = "8cb0497a0549da256319b1b8178e5421";
const $794877e0f92b060f$var$INSIGHTS_URL = `https://insights.algolia.io/1/events`;
const $794877e0f92b060f$var$ATLASSIAN_APPS = [
    "jira",
    "confluence",
    "loom",
    "jira service management",
    "jira product discovery",
    "trello",
    "bitbucket",
    "customer service management",
    "statuspage",
    "rovo",
    "atlas",
    "compass",
    "sourcetree",
    "guard"
];
const $794877e0f92b060f$var$ATLASSIAN_COLLECTIONS = [
    "teamwork collection",
    "strategy collection",
    "service collection",
    "software collection"
];
const $794877e0f92b060f$var$ATLASSIAN_KEYWORDS = [
    "agile",
    "kanban",
    "scrum",
    "devops",
    "it service management",
    "project management",
    "roadmap",
    "git",
    "pricing",
    "cost",
    "billing",
    "atlassian intelligence",
    "statuspage",
    "marketplace",
    "templates",
    "gantt",
    "mcp",
    "tempo"
];
class $794877e0f92b060f$export$3a4ead32446b35b2 {
    constructor(searchIndex, facets){
        this.searchIndex = searchIndex;
        const algoliaSearchClient = (0, (/*@__PURE__*/$parcel$interopDefault($8R4AT)))($794877e0f92b060f$var$ALGOLIA_APP_ID, $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY);
        const isAnalyticsEnabled = (0, $1Q6XY.shouldEnableAlgoliaAnalytics)();
        this.helper = (0, (/*@__PURE__*/$parcel$interopDefault($l45jb)))(algoliaSearchClient, this.searchIndex, {
            // @ts-ignore - facet functionality
            facets: facets,
            clickAnalytics: isAnalyticsEnabled,
            // enables click analytics
            attributesToRetrieve: [
                "url",
                "title",
                "description",
                "locale",
                "category",
                "objectID"
            ]
        });
        this.init();
    }
    init() {
        this.bindAllSearchEvents();
    }
    receiveUpdate(callback) {
        this.callback = callback;
    }
    bindAllSearchEvents() {
        const onSearchComplete = (results)=>{
            this.callback(results);
        };
        this.helper.on("result", function({ results: results }) {
            onSearchComplete(results);
        });
    }
    goToNextPage() {
        this.helper.nextPage();
        this.helper.search();
    }
    search() {
        this.helper.search();
    }
    async getObjects(objectIds) {
        try {
            const index = this.helper.getClient().initIndex(this.searchIndex);
            const response = await index.getObjects(objectIds, {
                attributesToRetrieve: [
                    "url",
                    "description",
                    "locale",
                    "objectID"
                ]
            });
            return {
                results: response.results.filter((r)=>r !== null)
            };
        } catch (error) {
            console.error("Error fetching objects from Algolia:", error);
            return {
                results: []
            };
        }
    }
    async sendClickEvent({ objectId: objectId, position: position, queryId: queryId, userToken: userToken }) {
        const eventData = {
            events: [
                {
                    eventType: "click",
                    eventName: "Result clicked after search on search page",
                    index: this.searchIndex,
                    userToken: userToken,
                    objectIDs: [
                        objectId
                    ],
                    positions: [
                        position
                    ],
                    queryID: queryId
                }
            ]
        };
        try {
            const response = await fetch($794877e0f92b060f$var$INSIGHTS_URL, {
                method: "POST",
                headers: {
                    "X-Algolia-Application-Id": $794877e0f92b060f$var$ALGOLIA_APP_ID,
                    "X-Algolia-API-Key": $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY,
                    "Content-Type": "text/plain;charset=UTF-8"
                },
                body: JSON.stringify(eventData)
            });
            if (!response.ok) throw new Error(`Error: Failed to send event to algolia : ${response.statusText}`);
        } catch (error) {
            console.error("Failed to send event to algolia:", error);
        }
    }
    removeFacet(facetKey) {
        this.helper.removeFacetRefinement(facetKey);
    }
    setFacet(facetKey, facet) {
        this.helper.removeFacetRefinement(facetKey);
        return this.helper.addFacetRefinement(facetKey, facet);
    }
    setQuery(params) {
        return this.helper.setQuery(params);
    }
    setQueryParameter(parameter, value) {
        // @ts-expect-error - restrictSearchableAttributes and other Algolia parameters
        return this.helper.setQueryParameter(parameter, value);
    }
    removeQueryParameter(parameter) {
        // @ts-expect-error - restrictSearchableAttributes and other Algolia parameters
        return this.helper.setQueryParameter(parameter, undefined);
    }
    /**
   * Get the named entity query for a specific parameter.
   * Extracts specific keywords from query if it's longer than 3 words.
   * This helps to improve search accuracy for named entities, instead of lot of filler words.
   */ getNamedEntityQuery(query) {
        const lowerCaseQuery = query.toLowerCase();
        const words = lowerCaseQuery.split(" ");
        if (words.length <= 3) return query;
        const namedEntities = [
            ...$794877e0f92b060f$var$ATLASSIAN_APPS,
            ...$794877e0f92b060f$var$ATLASSIAN_COLLECTIONS,
            ...$794877e0f92b060f$var$ATLASSIAN_KEYWORDS
        ];
        let returnQuery = undefined;
        for (const entity of namedEntities)if (lowerCaseQuery.includes(entity)) returnQuery ? returnQuery += " " + entity : returnQuery = entity;
        return returnQuery;
    }
}

});
parcelRegister("8R4AT", function(module, exports) {
/*! algoliasearch.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    function t(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = r, t;
    }
    function e(t, e) {
        var r = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var a = null != arguments[n] ? arguments[n] : {};
            n % 2 ? e(Object(a), !0).forEach(function(e) {
                t(r, e, a[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : e(Object(a)).forEach(function(t) {
                Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(a, t));
            });
        }
        return r;
    }
    function n(t, e) {
        if (null == t) return {};
        var r, n, a = function(t, e) {
            if (null == t) return {};
            var r, n, a = {}, o = Object.keys(t);
            for(n = 0; n < o.length; n++)r = o[n], e.indexOf(r) >= 0 || (a[r] = t[r]);
            return a;
        }(t, e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(t);
            for(n = 0; n < o.length; n++)r = o[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (a[r] = t[r]);
        }
        return a;
    }
    function a(t, e) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(t) || function(t, e) {
            if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
            var r = [], n = !0, a = !1, o = void 0;
            try {
                for(var i, u = t[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0);
            } catch (t) {
                a = !0, o = t;
            } finally{
                try {
                    n || null == u.return || u.return();
                } finally{
                    if (a) throw o;
                }
            }
            return r;
        }(t, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function o(t) {
        return function(t) {
            if (Array.isArray(t)) {
                for(var e = 0, r = new Array(t.length); e < t.length; e++)r[e] = t[e];
                return r;
            }
        }(t) || function(t) {
            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
        }(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function i(t) {
        var e, r = "algoliasearch-client-js-".concat(t.key), n = function() {
            return void 0 === e && (e = t.localStorage || window.localStorage), e;
        }, o = function() {
            return JSON.parse(n().getItem(r) || "{}");
        }, i = function(t) {
            n().setItem(r, JSON.stringify(t));
        }, u = function() {
            var e = t.timeToLive ? 1e3 * t.timeToLive : null, r = o(), n = Object.fromEntries(Object.entries(r).filter(function(t) {
                return void 0 !== a(t, 2)[1].timestamp;
            }));
            if (i(n), e) {
                var u = Object.fromEntries(Object.entries(n).filter(function(t) {
                    var r = a(t, 2)[1], n = (new Date).getTime();
                    return !(r.timestamp + e < n);
                }));
                i(u);
            }
        };
        return {
            get: function(t, e) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    u();
                    var e = JSON.stringify(t);
                    return o()[e];
                }).then(function(t) {
                    return Promise.all([
                        t ? t.value : e(),
                        void 0 !== t
                    ]);
                }).then(function(t) {
                    var e = a(t, 2), n = e[0], o = e[1];
                    return Promise.all([
                        n,
                        o || r.miss(n)
                    ]);
                }).then(function(t) {
                    return a(t, 1)[0];
                });
            },
            set: function(t, e) {
                return Promise.resolve().then(function() {
                    var a = o();
                    return a[JSON.stringify(t)] = {
                        timestamp: (new Date).getTime(),
                        value: e
                    }, n().setItem(r, JSON.stringify(a)), e;
                });
            },
            delete: function(t) {
                return Promise.resolve().then(function() {
                    var e = o();
                    delete e[JSON.stringify(t)], n().setItem(r, JSON.stringify(e));
                });
            },
            clear: function() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function u(t) {
        var e = o(t.caches), r = e.shift();
        return void 0 === r ? {
            get: function(t, e) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, n = e();
                return n.then(function(t) {
                    return Promise.all([
                        t,
                        r.miss(t)
                    ]);
                }).then(function(t) {
                    return a(t, 1)[0];
                });
            },
            set: function(t, e) {
                return Promise.resolve(e);
            },
            delete: function(t) {
                return Promise.resolve();
            },
            clear: function() {
                return Promise.resolve();
            }
        } : {
            get: function(t, n) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return r.get(t, n, a).catch(function() {
                    return u({
                        caches: e
                    }).get(t, n, a);
                });
            },
            set: function(t, n) {
                return r.set(t, n).catch(function() {
                    return u({
                        caches: e
                    }).set(t, n);
                });
            },
            delete: function(t) {
                return r.delete(t).catch(function() {
                    return u({
                        caches: e
                    }).delete(t);
                });
            },
            clear: function() {
                return r.clear().catch(function() {
                    return u({
                        caches: e
                    }).clear();
                });
            }
        };
    }
    function s() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, e = {};
        return {
            get: function(r, n) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, o = JSON.stringify(r);
                if (o in e) return Promise.resolve(t.serializable ? JSON.parse(e[o]) : e[o]);
                var i = n(), u = a && a.miss || function() {
                    return Promise.resolve();
                };
                return i.then(function(t) {
                    return u(t);
                }).then(function() {
                    return i;
                });
            },
            set: function(r, n) {
                return e[JSON.stringify(r)] = t.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function(t) {
                return delete e[JSON.stringify(t)], Promise.resolve();
            },
            clear: function() {
                return e = {}, Promise.resolve();
            }
        };
    }
    function c(t, e, r) {
        var n = {
            "x-algolia-api-key": r,
            "x-algolia-application-id": e
        };
        return {
            headers: function() {
                return t === m.WithinHeaders ? n : {};
            },
            queryParameters: function() {
                return t === m.WithinQueryParameters ? n : {};
            }
        };
    }
    function f(t) {
        var e = 0;
        return t(function r() {
            return e++, new Promise(function(n) {
                setTimeout(function() {
                    n(t(r));
                }, Math.min(100 * e, 1e3));
            });
        });
    }
    function d(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(t, e) {
            return Promise.resolve();
        };
        return Object.assign(t, {
            wait: function(r) {
                return d(t.then(function(t) {
                    return Promise.all([
                        e(t, r),
                        t
                    ]);
                }).then(function(t) {
                    return t[1];
                }));
            }
        });
    }
    function l(t) {
        for(var e = t.length - 1; e > 0; e--){
            var r = Math.floor(Math.random() * (e + 1)), n = t[e];
            t[e] = t[r], t[r] = n;
        }
        return t;
    }
    function h(t, e) {
        return e ? (Object.keys(e).forEach(function(r) {
            t[r] = e[r](t);
        }), t) : t;
    }
    function p(t) {
        for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
        var a = 0;
        return t.replace(/%s/g, function() {
            return encodeURIComponent(r[a++]);
        });
    }
    var m = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function y(t, e) {
        var r = t || {}, n = r.data || {};
        return Object.keys(r).forEach(function(t) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(t) && (n[t] = r[t]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || e,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var g = {
        Read: 1,
        Write: 2,
        Any: 3
    }, v = 1, b = 2, P = 3;
    function O(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v;
        return r(r({}, t), {}, {
            status: e,
            lastUpdate: Date.now()
        });
    }
    function w(t) {
        return "string" == typeof t ? {
            protocol: "https",
            url: t,
            accept: g.Any
        } : {
            protocol: t.protocol || "https",
            url: t.url,
            accept: t.accept || g.Any
        };
    }
    var I = "DELETE", x = "GET", j = "POST", D = "PUT";
    function q(t, e) {
        return Promise.all(e.map(function(e) {
            return t.get(e, function() {
                return Promise.resolve(O(e));
            });
        })).then(function(t) {
            var r = t.filter(function(t) {
                return function(t) {
                    return t.status === v || Date.now() - t.lastUpdate > 12e4;
                }(t);
            }), n = t.filter(function(t) {
                return function(t) {
                    return t.status === P && Date.now() - t.lastUpdate <= 12e4;
                }(t);
            }), a = [].concat(o(r), o(n));
            return {
                getTimeout: function(t, e) {
                    return (0 === n.length && 0 === t ? 1 : n.length + 3 + t) * e;
                },
                statelessHosts: a.length > 0 ? a.map(function(t) {
                    return w(t);
                }) : e
            };
        });
    }
    function S(t, e, n, a) {
        var i = [], u = function(t, e) {
            if (t.method === x || void 0 === t.data && void 0 === e.data) return;
            var n = Array.isArray(t.data) ? t.data : r(r({}, t.data), e.data);
            return JSON.stringify(n);
        }(n, a), s = function(t, e) {
            var n = r(r({}, t.headers), e.headers), a = {};
            return Object.keys(n).forEach(function(t) {
                var e = n[t];
                a[t.toLowerCase()] = e;
            }), a;
        }(t, a), c = n.method, f = n.method !== x ? {} : r(r({}, n.data), a.data), d = r(r(r({
            "x-algolia-agent": t.userAgent.value
        }, t.queryParameters), f), a.queryParameters), l = 0, h = function e(r, o) {
            var f = r.pop();
            if (void 0 === f) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .",
                transporterStackTrace: E(i)
            };
            var h = {
                data: u,
                headers: s,
                method: c,
                url: N(f, n.path, d),
                connectTimeout: o(l, t.timeouts.connect),
                responseTimeout: o(l, a.timeout)
            }, p = function(t) {
                var e = {
                    request: h,
                    response: t,
                    host: f,
                    triesLeft: r.length
                };
                return i.push(e), e;
            }, m = {
                onSuccess: function(t) {
                    return function(t) {
                        try {
                            return JSON.parse(t.content);
                        } catch (e) {
                            throw function(t, e) {
                                return {
                                    name: "DeserializationError",
                                    message: t,
                                    response: e
                                };
                            }(e.message, t);
                        }
                    }(t);
                },
                onRetry: function(n) {
                    var a = p(n);
                    return n.isTimedOut && l++, Promise.all([
                        t.logger.info("Retryable failure", A(a)),
                        t.hostsCache.set(f, O(f, n.isTimedOut ? P : b))
                    ]).then(function() {
                        return e(r, o);
                    });
                },
                onFail: function(t) {
                    throw p(t), function(t, e) {
                        var r = t.content, n = t.status, a = r;
                        try {
                            a = JSON.parse(r).message;
                        } catch (t) {}
                        return function(t, e, r) {
                            return {
                                name: "ApiError",
                                message: t,
                                status: e,
                                transporterStackTrace: r
                            };
                        }(a, n, e);
                    }(t, E(i));
                }
            };
            return t.requester.send(h).then(function(t) {
                return function(t, e) {
                    return function(t) {
                        var e = t.status;
                        return t.isTimedOut || function(t) {
                            var e = t.isTimedOut, r = t.status;
                            return !e && 0 == ~~r;
                        }(t) || 2 != ~~(e / 100) && 4 != ~~(e / 100);
                    }(t) ? e.onRetry(t) : 2 == ~~(t.status / 100) ? e.onSuccess(t) : e.onFail(t);
                }(t, m);
            });
        };
        return q(t.hostsCache, e).then(function(t) {
            return h(o(t.statelessHosts).reverse(), t.getTimeout);
        });
    }
    function k(t) {
        var e = t.hostsCache, r = t.logger, n = t.requester, o = t.requestsCache, i = t.responsesCache, u = t.timeouts, s = t.userAgent, c = t.hosts, f = t.queryParameters, d = {
            hostsCache: e,
            logger: r,
            requester: n,
            requestsCache: o,
            responsesCache: i,
            timeouts: u,
            userAgent: s,
            headers: t.headers,
            queryParameters: f,
            hosts: c.map(function(t) {
                return w(t);
            }),
            read: function(t, e) {
                var r = y(e, d.timeouts.read), n = function() {
                    return S(d, d.hosts.filter(function(t) {
                        return 0 != (t.accept & g.Read);
                    }), t, r);
                };
                if (!0 !== (void 0 !== r.cacheable ? r.cacheable : t.cacheable)) return n();
                var o = {
                    request: t,
                    mappedRequestOptions: r,
                    transporter: {
                        queryParameters: d.queryParameters,
                        headers: d.headers
                    }
                };
                return d.responsesCache.get(o, function() {
                    return d.requestsCache.get(o, function() {
                        return d.requestsCache.set(o, n()).then(function(t) {
                            return Promise.all([
                                d.requestsCache.delete(o),
                                t
                            ]);
                        }, function(t) {
                            return Promise.all([
                                d.requestsCache.delete(o),
                                Promise.reject(t)
                            ]);
                        }).then(function(t) {
                            var e = a(t, 2);
                            e[0];
                            return e[1];
                        });
                    });
                }, {
                    miss: function(t) {
                        return d.responsesCache.set(o, t);
                    }
                });
            },
            write: function(t, e) {
                return S(d, d.hosts.filter(function(t) {
                    return 0 != (t.accept & g.Write);
                }), t, y(e, d.timeouts.write));
            }
        };
        return d;
    }
    function T(t) {
        var e = {
            value: "Algolia for JavaScript (".concat(t, ")"),
            add: function(t) {
                var r = "; ".concat(t.segment).concat(void 0 !== t.version ? " (".concat(t.version, ")") : "");
                return -1 === e.value.indexOf(r) && (e.value = "".concat(e.value).concat(r)), e;
            }
        };
        return e;
    }
    function N(t, e, r) {
        var n = R(r), a = "".concat(t.protocol, "://").concat(t.url, "/").concat("/" === e.charAt(0) ? e.substr(1) : e);
        return n.length && (a += "?".concat(n)), a;
    }
    function R(t) {
        return Object.keys(t).map(function(e) {
            var r;
            return p("%s=%s", e, (r = t[e], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(t[e]) : t[e]));
        }).join("&");
    }
    function E(t) {
        return t.map(function(t) {
            return A(t);
        });
    }
    function A(t) {
        var e = t.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, t), {}, {
            request: r(r({}, t.request), {}, {
                headers: r(r({}, t.request.headers), e)
            })
        });
    }
    var C = function(t) {
        return function(e, r) {
            return t.transporter.write({
                method: j,
                path: "2/abtests",
                data: e
            }, r);
        };
    }, U = function(t) {
        return function(e, r) {
            return t.transporter.write({
                method: I,
                path: p("2/abtests/%s", e)
            }, r);
        };
    }, z = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("2/abtests/%s", e)
            }, r);
        };
    }, J = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "2/abtests"
            }, e);
        };
    }, F = function(t) {
        return function(e, r) {
            return t.transporter.write({
                method: j,
                path: p("2/abtests/%s/stop", e)
            }, r);
        };
    }, H = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/strategies/personalization"
            }, e);
        };
    }, M = function(t) {
        return function(e, r) {
            return t.transporter.write({
                method: j,
                path: "1/strategies/personalization",
                data: e
            }, r);
        };
    };
    function B(t) {
        return function e(r) {
            return t.request(r).then(function(n) {
                if (void 0 !== t.batch && t.batch(n.hits), !t.shouldStop(n)) return n.cursor ? e({
                    cursor: n.cursor
                }) : e({
                    page: (r.page || 0) + 1
                });
            });
        }({});
    }
    var K = function(t) {
        return function(e, a) {
            var o = a || {}, i = o.queryParameters, u = n(o, [
                "queryParameters"
            ]), s = r({
                acl: e
            }, void 0 !== i ? {
                queryParameters: i
            } : {});
            return d(t.transporter.write({
                method: j,
                path: "1/keys",
                data: s
            }, u), function(e, r) {
                return f(function(n) {
                    return tt(t)(e.key, r).catch(function(t) {
                        if (404 !== t.status) throw t;
                        return n();
                    });
                });
            });
        };
    }, W = function(t) {
        return function(e, r, n) {
            var a = y(n);
            return a.queryParameters["X-Algolia-User-ID"] = e, t.transporter.write({
                method: j,
                path: "1/clusters/mapping",
                data: {
                    cluster: r
                }
            }, a);
        };
    }, L = function(t) {
        return function(e, r, n) {
            return t.transporter.write({
                method: j,
                path: "1/clusters/mapping/batch",
                data: {
                    users: e,
                    cluster: r
                }
            }, n);
        };
    }, Q = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: j,
                path: p("/1/dictionaries/%s/batch", e),
                data: {
                    clearExistingDictionaryEntries: !0,
                    requests: {
                        action: "addEntry",
                        body: []
                    }
                }
            }, r), function(e, r) {
                return jt(t)(e.taskID, r);
            });
        };
    }, G = function(t) {
        return function(e, r, n) {
            return d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/operation", e),
                data: {
                    operation: "copy",
                    destination: r
                }
            }, n), function(r, n) {
                return ut(t)(e, {
                    methods: {
                        waitTask: de
                    }
                }).waitTask(r.taskID, n);
            });
        };
    }, V = function(t) {
        return function(e, n, a) {
            return G(t)(e, n, r(r({}, a), {}, {
                scope: [
                    he.Rules
                ]
            }));
        };
    }, _ = function(t) {
        return function(e, n, a) {
            return G(t)(e, n, r(r({}, a), {}, {
                scope: [
                    he.Settings
                ]
            }));
        };
    }, X = function(t) {
        return function(e, n, a) {
            return G(t)(e, n, r(r({}, a), {}, {
                scope: [
                    he.Synonyms
                ]
            }));
        };
    }, Y = function(t) {
        return function(e, r) {
            return e.method === x ? t.transporter.read(e, r) : t.transporter.write(e, r);
        };
    }, Z = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: I,
                path: p("1/keys/%s", e)
            }, r), function(r, n) {
                return f(function(r) {
                    return tt(t)(e, n).then(r).catch(function(t) {
                        if (404 !== t.status) throw t;
                    });
                });
            });
        };
    }, $ = function(t) {
        return function(e, r, n) {
            var a = r.map(function(t) {
                return {
                    action: "deleteEntry",
                    body: {
                        objectID: t
                    }
                };
            });
            return d(t.transporter.write({
                method: j,
                path: p("/1/dictionaries/%s/batch", e),
                data: {
                    clearExistingDictionaryEntries: !1,
                    requests: a
                }
            }, n), function(e, r) {
                return jt(t)(e.taskID, r);
            });
        };
    }, tt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/keys/%s", e)
            }, r);
        };
    }, et = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/task/%s", e.toString())
            }, r);
        };
    }, rt = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "/1/dictionaries/*/settings"
            }, e);
        };
    }, nt = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/logs"
            }, e);
        };
    }, at = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/clusters/mapping/top"
            }, e);
        };
    }, ot = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/clusters/mapping/%s", e)
            }, r);
        };
    }, it = function(t) {
        return function(e) {
            var r = e || {}, a = r.retrieveMappings, o = n(r, [
                "retrieveMappings"
            ]);
            return !0 === a && (o.getClusters = !0), t.transporter.read({
                method: x,
                path: "1/clusters/mapping/pending"
            }, o);
        };
    }, ut = function(t) {
        return function(e) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: t.transporter,
                appId: t.appId,
                indexName: e
            };
            return h(n, r.methods);
        };
    }, st = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/keys"
            }, e);
        };
    }, ct = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/clusters"
            }, e);
        };
    }, ft = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/indexes"
            }, e);
        };
    }, dt = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: "1/clusters/mapping"
            }, e);
        };
    }, lt = function(t) {
        return function(e, r, n) {
            return d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/operation", e),
                data: {
                    operation: "move",
                    destination: r
                }
            }, n), function(r, n) {
                return ut(t)(e, {
                    methods: {
                        waitTask: de
                    }
                }).waitTask(r.taskID, n);
            });
        };
    }, ht = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: j,
                path: "1/indexes/*/batch",
                data: {
                    requests: e
                }
            }, r), function(e, r) {
                return Promise.all(Object.keys(e.taskID).map(function(n) {
                    return ut(t)(n, {
                        methods: {
                            waitTask: de
                        }
                    }).waitTask(e.taskID[n], r);
                }));
            });
        };
    }, pt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/objects",
                data: {
                    requests: e
                }
            }, r);
        };
    }, mt = function(t) {
        return function(e, n) {
            var a = e.map(function(t) {
                return r(r({}, t), {}, {
                    params: R(t.params || {})
                });
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/queries",
                data: {
                    requests: a
                },
                cacheable: !0
            }, n);
        };
    }, yt = function(t) {
        return function(e, a) {
            return Promise.all(e.map(function(e) {
                var o = e.params, i = o.facetName, u = o.facetQuery, s = n(o, [
                    "facetName",
                    "facetQuery"
                ]);
                return ut(t)(e.indexName, {
                    methods: {
                        searchForFacetValues: ue
                    }
                }).searchForFacetValues(i, u, r(r({}, a), s));
            }));
        };
    }, gt = function(t) {
        return function(e, r) {
            var n = y(r);
            return n.queryParameters["X-Algolia-User-ID"] = e, t.transporter.write({
                method: I,
                path: "1/clusters/mapping"
            }, n);
        };
    }, vt = function(t) {
        return function(e, r, n) {
            var a = r.map(function(t) {
                return {
                    action: "addEntry",
                    body: t
                };
            });
            return d(t.transporter.write({
                method: j,
                path: p("/1/dictionaries/%s/batch", e),
                data: {
                    clearExistingDictionaryEntries: !0,
                    requests: a
                }
            }, n), function(e, r) {
                return jt(t)(e.taskID, r);
            });
        };
    }, bt = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: j,
                path: p("1/keys/%s/restore", e)
            }, r), function(r, n) {
                return f(function(r) {
                    return tt(t)(e, n).catch(function(t) {
                        if (404 !== t.status) throw t;
                        return r();
                    });
                });
            });
        };
    }, Pt = function(t) {
        return function(e, r, n) {
            var a = r.map(function(t) {
                return {
                    action: "addEntry",
                    body: t
                };
            });
            return d(t.transporter.write({
                method: j,
                path: p("/1/dictionaries/%s/batch", e),
                data: {
                    clearExistingDictionaryEntries: !1,
                    requests: a
                }
            }, n), function(e, r) {
                return jt(t)(e.taskID, r);
            });
        };
    }, Ot = function(t) {
        return function(e, r, n) {
            return t.transporter.read({
                method: j,
                path: p("/1/dictionaries/%s/search", e),
                data: {
                    query: r
                },
                cacheable: !0
            }, n);
        };
    }, wt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: j,
                path: "1/clusters/mapping/search",
                data: {
                    query: e
                }
            }, r);
        };
    }, It = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: D,
                path: "/1/dictionaries/*/settings",
                data: e
            }, r), function(e, r) {
                return jt(t)(e.taskID, r);
            });
        };
    }, xt = function(t) {
        return function(e, r) {
            var a = Object.assign({}, r), o = r || {}, i = o.queryParameters, u = n(o, [
                "queryParameters"
            ]), s = i ? {
                queryParameters: i
            } : {}, c = [
                "acl",
                "indexes",
                "referers",
                "restrictSources",
                "queryParameters",
                "description",
                "maxQueriesPerIPPerHour",
                "maxHitsPerQuery"
            ];
            return d(t.transporter.write({
                method: D,
                path: p("1/keys/%s", e),
                data: s
            }, u), function(r, n) {
                return f(function(r) {
                    return tt(t)(e, n).then(function(t) {
                        return function(t) {
                            return Object.keys(a).filter(function(t) {
                                return -1 !== c.indexOf(t);
                            }).every(function(e) {
                                if (Array.isArray(t[e]) && Array.isArray(a[e])) {
                                    var r = t[e];
                                    return r.length === a[e].length && r.every(function(t, r) {
                                        return t === a[e][r];
                                    });
                                }
                                return t[e] === a[e];
                            });
                        }(t) ? Promise.resolve() : r();
                    });
                });
            });
        };
    }, jt = function(t) {
        return function(e, r) {
            return f(function(n) {
                return et(t)(e, r).then(function(t) {
                    return "published" !== t.status ? n() : void 0;
                });
            });
        };
    }, Dt = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/batch", t.indexName),
                data: {
                    requests: e
                }
            }, r), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, qt = function(t) {
        return function(e) {
            return B(r(r({
                shouldStop: function(t) {
                    return void 0 === t.cursor;
                }
            }, e), {}, {
                request: function(r) {
                    return t.transporter.read({
                        method: j,
                        path: p("1/indexes/%s/browse", t.indexName),
                        data: r
                    }, e);
                }
            }));
        };
    }, St = function(t) {
        return function(e) {
            var n = r({
                hitsPerPage: 1e3
            }, e);
            return B(r(r({
                shouldStop: function(t) {
                    return t.hits.length < n.hitsPerPage;
                }
            }, n), {}, {
                request: function(e) {
                    return se(t)("", r(r({}, n), e)).then(function(t) {
                        return r(r({}, t), {}, {
                            hits: t.hits.map(function(t) {
                                return delete t._highlightResult, t;
                            })
                        });
                    });
                }
            }));
        };
    }, kt = function(t) {
        return function(e) {
            var n = r({
                hitsPerPage: 1e3
            }, e);
            return B(r(r({
                shouldStop: function(t) {
                    return t.hits.length < n.hitsPerPage;
                }
            }, n), {}, {
                request: function(e) {
                    return ce(t)("", r(r({}, n), e)).then(function(t) {
                        return r(r({}, t), {}, {
                            hits: t.hits.map(function(t) {
                                return delete t._highlightResult, t;
                            })
                        });
                    });
                }
            }));
        };
    }, Tt = function(t) {
        return function(e, r, a) {
            var o = a || {}, i = o.batchSize, u = n(o, [
                "batchSize"
            ]), s = {
                taskIDs: [],
                objectIDs: []
            };
            return d(function n() {
                var a, o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, c = [];
                for(a = o; a < e.length && (c.push(e[a]), c.length !== (i || 1e3)); a++);
                return 0 === c.length ? Promise.resolve(s) : Dt(t)(c.map(function(t) {
                    return {
                        action: r,
                        body: t
                    };
                }), u).then(function(t) {
                    return s.objectIDs = s.objectIDs.concat(t.objectIDs), s.taskIDs.push(t.taskID), a++, n(a);
                });
            }(), function(e, r) {
                return Promise.all(e.taskIDs.map(function(e) {
                    return de(t)(e, r);
                }));
            });
        };
    }, Nt = function(t) {
        return function(e) {
            return d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/clear", t.indexName)
            }, e), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Rt = function(t) {
        return function(e) {
            var r = e || {}, a = r.forwardToReplicas, o = y(n(r, [
                "forwardToReplicas"
            ]));
            return a && (o.queryParameters.forwardToReplicas = 1), d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/rules/clear", t.indexName)
            }, o), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Et = function(t) {
        return function(e) {
            var r = e || {}, a = r.forwardToReplicas, o = y(n(r, [
                "forwardToReplicas"
            ]));
            return a && (o.queryParameters.forwardToReplicas = 1), d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/synonyms/clear", t.indexName)
            }, o), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, At = function(t) {
        return function(e, r) {
            return d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/deleteByQuery", t.indexName),
                data: e
            }, r), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Ct = function(t) {
        return function(e) {
            return d(t.transporter.write({
                method: I,
                path: p("1/indexes/%s", t.indexName)
            }, e), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Ut = function(t) {
        return function(e, r) {
            return d(zt(t)([
                e
            ], r).then(function(t) {
                return {
                    taskID: t.taskIDs[0]
                };
            }), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, zt = function(t) {
        return function(e, r) {
            var n = e.map(function(t) {
                return {
                    objectID: t
                };
            });
            return Tt(t)(n, le.DeleteObject, r);
        };
    }, Jt = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.forwardToReplicas, i = y(n(a, [
                "forwardToReplicas"
            ]));
            return o && (i.queryParameters.forwardToReplicas = 1), d(t.transporter.write({
                method: I,
                path: p("1/indexes/%s/rules/%s", t.indexName, e)
            }, i), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Ft = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.forwardToReplicas, i = y(n(a, [
                "forwardToReplicas"
            ]));
            return o && (i.queryParameters.forwardToReplicas = 1), d(t.transporter.write({
                method: I,
                path: p("1/indexes/%s/synonyms/%s", t.indexName, e)
            }, i), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Ht = function(t) {
        return function(e) {
            return Gt(t)(e).then(function() {
                return !0;
            }).catch(function(t) {
                if (404 !== t.status) throw t;
                return !1;
            });
        };
    }, Mt = function(t) {
        return function(e, r, n) {
            return t.transporter.read({
                method: j,
                path: p("1/answers/%s/prediction", t.indexName),
                data: {
                    query: e,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, Bt = function(t) {
        return function(e, o) {
            var i = o || {}, u = i.query, s = i.paginate, c = n(i, [
                "query",
                "paginate"
            ]), f = 0;
            return function n() {
                return ie(t)(u || "", r(r({}, c), {}, {
                    page: f
                })).then(function(t) {
                    for(var r = 0, o = Object.entries(t.hits); r < o.length; r++){
                        var i = a(o[r], 2), u = i[0], c = i[1];
                        if (e(c)) return {
                            object: c,
                            position: parseInt(u, 10),
                            page: f
                        };
                    }
                    if (f++, !1 === s || f >= t.nbPages) throw {
                        name: "ObjectNotFoundError",
                        message: "Object not found."
                    };
                    return n();
                });
            }();
        };
    }, Kt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/indexes/%s/%s", t.indexName, e)
            }, r);
        };
    }, Wt = function() {
        return function(t, e) {
            for(var r = 0, n = Object.entries(t.hits); r < n.length; r++){
                var o = a(n[r], 2), i = o[0];
                if (o[1].objectID === e) return parseInt(i, 10);
            }
            return -1;
        };
    }, Lt = function(t) {
        return function(e, a) {
            var o = a || {}, i = o.attributesToRetrieve, u = n(o, [
                "attributesToRetrieve"
            ]), s = e.map(function(e) {
                return r({
                    indexName: t.indexName,
                    objectID: e
                }, i ? {
                    attributesToRetrieve: i
                } : {});
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/objects",
                data: {
                    requests: s
                }
            }, u);
        };
    }, Qt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/indexes/%s/rules/%s", t.indexName, e)
            }, r);
        };
    }, Gt = function(t) {
        return function(e) {
            return t.transporter.read({
                method: x,
                path: p("1/indexes/%s/settings", t.indexName),
                data: {
                    getVersion: 2
                }
            }, e);
        };
    }, Vt = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: x,
                path: p("1/indexes/%s/synonyms/%s", t.indexName, e)
            }, r);
        };
    }, _t = function(t) {
        return function(e, r) {
            return d(Xt(t)([
                e
            ], r).then(function(t) {
                return {
                    objectID: t.objectIDs[0],
                    taskID: t.taskIDs[0]
                };
            }), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, Xt = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.createIfNotExists, i = n(a, [
                "createIfNotExists"
            ]), u = o ? le.PartialUpdateObject : le.PartialUpdateObjectNoCreate;
            return Tt(t)(e, u, i);
        };
    }, Yt = function(t) {
        return function(e, i) {
            var u = i || {}, s = u.safe, c = u.autoGenerateObjectIDIfNotExist, f = u.batchSize, l = n(u, [
                "safe",
                "autoGenerateObjectIDIfNotExist",
                "batchSize"
            ]), h = function(e, r, n, a) {
                return d(t.transporter.write({
                    method: j,
                    path: p("1/indexes/%s/operation", e),
                    data: {
                        operation: n,
                        destination: r
                    }
                }, a), function(e, r) {
                    return de(t)(e.taskID, r);
                });
            }, m = Math.random().toString(36).substring(7), y = "".concat(t.indexName, "_tmp_").concat(m), g = ee({
                appId: t.appId,
                transporter: t.transporter,
                indexName: y
            }), v = [], b = h(t.indexName, y, "copy", r(r({}, l), {}, {
                scope: [
                    "settings",
                    "synonyms",
                    "rules"
                ]
            }));
            return v.push(b), d((s ? b.wait(l) : b).then(function() {
                var t = g(e, r(r({}, l), {}, {
                    autoGenerateObjectIDIfNotExist: c,
                    batchSize: f
                }));
                return v.push(t), s ? t.wait(l) : t;
            }).then(function() {
                var e = h(y, t.indexName, "move", l);
                return v.push(e), s ? e.wait(l) : e;
            }).then(function() {
                return Promise.all(v);
            }).then(function(t) {
                var e = a(t, 3), r = e[0], n = e[1], i = e[2];
                return {
                    objectIDs: n.objectIDs,
                    taskIDs: [
                        r.taskID
                    ].concat(o(n.taskIDs), [
                        i.taskID
                    ])
                };
            }), function(t, e) {
                return Promise.all(v.map(function(t) {
                    return t.wait(e);
                }));
            });
        };
    }, Zt = function(t) {
        return function(e, n) {
            return ne(t)(e, r(r({}, n), {}, {
                clearExistingRules: !0
            }));
        };
    }, $t = function(t) {
        return function(e, n) {
            return oe(t)(e, r(r({}, n), {}, {
                clearExistingSynonyms: !0
            }));
        };
    }, te = function(t) {
        return function(e, r) {
            return d(ee(t)([
                e
            ], r).then(function(t) {
                return {
                    objectID: t.objectIDs[0],
                    taskID: t.taskIDs[0]
                };
            }), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, ee = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.autoGenerateObjectIDIfNotExist, i = n(a, [
                "autoGenerateObjectIDIfNotExist"
            ]), u = o ? le.AddObject : le.UpdateObject;
            if (u === le.UpdateObject) {
                var s = !0, c = !1, f = void 0;
                try {
                    for(var l, h = e[Symbol.iterator](); !(s = (l = h.next()).done); s = !0){
                        if (void 0 === l.value.objectID) return d(Promise.reject({
                            name: "MissingObjectIDError",
                            message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."
                        }));
                    }
                } catch (t) {
                    c = !0, f = t;
                } finally{
                    try {
                        s || null == h.return || h.return();
                    } finally{
                        if (c) throw f;
                    }
                }
            }
            return Tt(t)(e, u, i);
        };
    }, re = function(t) {
        return function(e, r) {
            return ne(t)([
                e
            ], r);
        };
    }, ne = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.forwardToReplicas, i = a.clearExistingRules, u = y(n(a, [
                "forwardToReplicas",
                "clearExistingRules"
            ]));
            return o && (u.queryParameters.forwardToReplicas = 1), i && (u.queryParameters.clearExistingRules = 1), d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/rules/batch", t.indexName),
                data: e
            }, u), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, ae = function(t) {
        return function(e, r) {
            return oe(t)([
                e
            ], r);
        };
    }, oe = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.forwardToReplicas, i = a.clearExistingSynonyms, u = a.replaceExistingSynonyms, s = y(n(a, [
                "forwardToReplicas",
                "clearExistingSynonyms",
                "replaceExistingSynonyms"
            ]));
            return o && (s.queryParameters.forwardToReplicas = 1), (u || i) && (s.queryParameters.replaceExistingSynonyms = 1), d(t.transporter.write({
                method: j,
                path: p("1/indexes/%s/synonyms/batch", t.indexName),
                data: e
            }, s), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, ie = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: j,
                path: p("1/indexes/%s/query", t.indexName),
                data: {
                    query: e
                },
                cacheable: !0
            }, r);
        };
    }, ue = function(t) {
        return function(e, r, n) {
            return t.transporter.read({
                method: j,
                path: p("1/indexes/%s/facets/%s/query", t.indexName, e),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, se = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: j,
                path: p("1/indexes/%s/rules/search", t.indexName),
                data: {
                    query: e
                }
            }, r);
        };
    }, ce = function(t) {
        return function(e, r) {
            return t.transporter.read({
                method: j,
                path: p("1/indexes/%s/synonyms/search", t.indexName),
                data: {
                    query: e
                }
            }, r);
        };
    }, fe = function(t) {
        return function(e, r) {
            var a = r || {}, o = a.forwardToReplicas, i = y(n(a, [
                "forwardToReplicas"
            ]));
            return o && (i.queryParameters.forwardToReplicas = 1), d(t.transporter.write({
                method: D,
                path: p("1/indexes/%s/settings", t.indexName),
                data: e
            }, i), function(e, r) {
                return de(t)(e.taskID, r);
            });
        };
    }, de = function(t) {
        return function(e, r) {
            return f(function(n) {
                return (function(t) {
                    return function(e, r) {
                        return t.transporter.read({
                            method: x,
                            path: p("1/indexes/%s/task/%s", t.indexName, e.toString())
                        }, r);
                    };
                })(t)(e, r).then(function(t) {
                    return "published" !== t.status ? n() : void 0;
                });
            });
        };
    }, le = {
        AddObject: "addObject",
        UpdateObject: "updateObject",
        PartialUpdateObject: "partialUpdateObject",
        PartialUpdateObjectNoCreate: "partialUpdateObjectNoCreate",
        DeleteObject: "deleteObject",
        DeleteIndex: "delete",
        ClearIndex: "clear"
    }, he = {
        Settings: "settings",
        Synonyms: "synonyms",
        Rules: "rules"
    }, pe = 1, me = 2, ye = 3;
    var ge = function(t) {
        return function(e, n) {
            var a = e.map(function(t) {
                return r(r({}, t), {}, {
                    threshold: t.threshold || 0
                });
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: a
                },
                cacheable: !0
            }, n);
        };
    }, ve = function(t) {
        return function(e, n) {
            return ge(t)(e.map(function(t) {
                return r(r({}, t), {}, {
                    fallbackParameters: {},
                    model: "bought-together"
                });
            }), n);
        };
    }, be = function(t) {
        return function(e, n) {
            return ge(t)(e.map(function(t) {
                return r(r({}, t), {}, {
                    model: "related-products"
                });
            }), n);
        };
    }, Pe = function(t) {
        return function(e, n) {
            var a = e.map(function(t) {
                return r(r({}, t), {}, {
                    model: "trending-facets",
                    threshold: t.threshold || 0
                });
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: a
                },
                cacheable: !0
            }, n);
        };
    }, Oe = function(t) {
        return function(e, n) {
            var a = e.map(function(t) {
                return r(r({}, t), {}, {
                    model: "trending-items",
                    threshold: t.threshold || 0
                });
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: a
                },
                cacheable: !0
            }, n);
        };
    }, we = function(t) {
        return function(e, n) {
            return ge(t)(e.map(function(t) {
                return r(r({}, t), {}, {
                    model: "looking-similar"
                });
            }), n);
        };
    }, Ie = function(t) {
        return function(e, n) {
            var a = e.map(function(t) {
                return r(r({}, t), {}, {
                    model: "recommended-for-you",
                    threshold: t.threshold || 0
                });
            });
            return t.transporter.read({
                method: j,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: a
                },
                cacheable: !0
            }, n);
        };
    };
    function xe(t, e, n) {
        var a, o = {
            appId: t,
            apiKey: e,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function(t) {
                    return new Promise(function(e) {
                        var r = new XMLHttpRequest;
                        r.open(t.method, t.url, !0), Object.keys(t.headers).forEach(function(e) {
                            return r.setRequestHeader(e, t.headers[e]);
                        });
                        var n, a = function(t, n) {
                            return setTimeout(function() {
                                r.abort(), e({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * t);
                        }, o = a(t.connectTimeout, "Connection timeout");
                        r.onreadystatechange = function() {
                            r.readyState > r.OPENED && void 0 === n && (clearTimeout(o), n = a(t.responseTimeout, "Socket timeout"));
                        }, r.onerror = function() {
                            0 === r.status && (clearTimeout(o), clearTimeout(n), e({
                                content: r.responseText || "Network request failed",
                                status: r.status,
                                isTimedOut: !1
                            }));
                        }, r.onload = function() {
                            clearTimeout(o), clearTimeout(n), e({
                                content: r.responseText,
                                status: r.status,
                                isTimedOut: !1
                            });
                        }, r.send(t.data);
                    });
                }
            },
            logger: (a = ye, {
                debug: function(t, e) {
                    return pe >= a && console.debug(t, e), Promise.resolve();
                },
                info: function(t, e) {
                    return me >= a && console.info(t, e), Promise.resolve();
                },
                error: function(t, e) {
                    return console.error(t, e), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: u({
                caches: [
                    i({
                        key: "".concat("4.24.0", "-").concat(t)
                    }),
                    s()
                ]
            }),
            userAgent: T("4.24.0").add({
                segment: "Browser"
            })
        }, f = r(r({}, o), n), d = function() {
            return function(t) {
                return function(t) {
                    var e = t.region || "us", n = c(m.WithinHeaders, t.appId, t.apiKey), a = k(r(r({
                        hosts: [
                            {
                                url: "personalization.".concat(e, ".algolia.com")
                            }
                        ]
                    }, t), {}, {
                        headers: r(r(r({}, n.headers()), {
                            "content-type": "application/json"
                        }), t.headers),
                        queryParameters: r(r({}, n.queryParameters()), t.queryParameters)
                    }));
                    return h({
                        appId: t.appId,
                        transporter: a
                    }, t.methods);
                }(r(r(r({}, o), t), {}, {
                    methods: {
                        getPersonalizationStrategy: H,
                        setPersonalizationStrategy: M
                    }
                }));
            };
        };
        return function(t) {
            var e = t.appId, n = c(void 0 !== t.authMode ? t.authMode : m.WithinHeaders, e, t.apiKey), a = k(r(r({
                hosts: [
                    {
                        url: "".concat(e, "-dsn.algolia.net"),
                        accept: g.Read
                    },
                    {
                        url: "".concat(e, ".algolia.net"),
                        accept: g.Write
                    }
                ].concat(l([
                    {
                        url: "".concat(e, "-1.algolianet.com")
                    },
                    {
                        url: "".concat(e, "-2.algolianet.com")
                    },
                    {
                        url: "".concat(e, "-3.algolianet.com")
                    }
                ]))
            }, t), {}, {
                headers: r(r(r({}, n.headers()), {
                    "content-type": "application/x-www-form-urlencoded"
                }), t.headers),
                queryParameters: r(r({}, n.queryParameters()), t.queryParameters)
            }));
            return h({
                transporter: a,
                appId: e,
                addAlgoliaAgent: function(t, e) {
                    a.userAgent.add({
                        segment: t,
                        version: e
                    });
                },
                clearCache: function() {
                    return Promise.all([
                        a.requestsCache.clear(),
                        a.responsesCache.clear()
                    ]).then(function() {});
                }
            }, t.methods);
        }(r(r({}, f), {}, {
            methods: {
                search: mt,
                searchForFacetValues: yt,
                multipleBatch: ht,
                multipleGetObjects: pt,
                multipleQueries: mt,
                copyIndex: G,
                copySettings: _,
                copySynonyms: X,
                copyRules: V,
                moveIndex: lt,
                listIndices: ft,
                getLogs: nt,
                listClusters: ct,
                multipleSearchForFacetValues: yt,
                getApiKey: tt,
                addApiKey: K,
                listApiKeys: st,
                updateApiKey: xt,
                deleteApiKey: Z,
                restoreApiKey: bt,
                assignUserID: W,
                assignUserIDs: L,
                getUserID: ot,
                searchUserIDs: wt,
                listUserIDs: dt,
                getTopUserIDs: at,
                removeUserID: gt,
                hasPendingMappings: it,
                clearDictionaryEntries: Q,
                deleteDictionaryEntries: $,
                getDictionarySettings: rt,
                getAppTask: et,
                replaceDictionaryEntries: vt,
                saveDictionaryEntries: Pt,
                searchDictionaryEntries: Ot,
                setDictionarySettings: It,
                waitAppTask: jt,
                customRequest: Y,
                initIndex: function(t) {
                    return function(e) {
                        return ut(t)(e, {
                            methods: {
                                batch: Dt,
                                delete: Ct,
                                findAnswers: Mt,
                                getObject: Kt,
                                getObjects: Lt,
                                saveObject: te,
                                saveObjects: ee,
                                search: ie,
                                searchForFacetValues: ue,
                                waitTask: de,
                                setSettings: fe,
                                getSettings: Gt,
                                partialUpdateObject: _t,
                                partialUpdateObjects: Xt,
                                deleteObject: Ut,
                                deleteObjects: zt,
                                deleteBy: At,
                                clearObjects: Nt,
                                browseObjects: qt,
                                getObjectPosition: Wt,
                                findObject: Bt,
                                exists: Ht,
                                saveSynonym: ae,
                                saveSynonyms: oe,
                                getSynonym: Vt,
                                searchSynonyms: ce,
                                browseSynonyms: kt,
                                deleteSynonym: Ft,
                                clearSynonyms: Et,
                                replaceAllObjects: Yt,
                                replaceAllSynonyms: $t,
                                searchRules: se,
                                getRule: Qt,
                                deleteRule: Jt,
                                saveRule: re,
                                saveRules: ne,
                                replaceAllRules: Zt,
                                browseRules: St,
                                clearRules: Rt
                            }
                        });
                    };
                },
                initAnalytics: function() {
                    return function(t) {
                        return function(t) {
                            var e = t.region || "us", n = c(m.WithinHeaders, t.appId, t.apiKey), a = k(r(r({
                                hosts: [
                                    {
                                        url: "analytics.".concat(e, ".algolia.com")
                                    }
                                ]
                            }, t), {}, {
                                headers: r(r(r({}, n.headers()), {
                                    "content-type": "application/json"
                                }), t.headers),
                                queryParameters: r(r({}, n.queryParameters()), t.queryParameters)
                            }));
                            return h({
                                appId: t.appId,
                                transporter: a
                            }, t.methods);
                        }(r(r(r({}, o), t), {}, {
                            methods: {
                                addABTest: C,
                                getABTest: z,
                                getABTests: J,
                                stopABTest: F,
                                deleteABTest: U
                            }
                        }));
                    };
                },
                initPersonalization: d,
                initRecommendation: function() {
                    return function(t) {
                        return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."), d()(t);
                    };
                },
                getRecommendations: ge,
                getFrequentlyBoughtTogether: ve,
                getLookingSimilar: we,
                getRecommendedForYou: Ie,
                getRelatedProducts: be,
                getTrendingFacets: Pe,
                getTrendingItems: Oe
            }
        }));
    }
    return xe.version = "4.24.0", xe;
});

});

parcelRegister("l45jb", function(module, exports) {
'use strict';

var $3GvrD = parcelRequire("3GvrD");

var $gCDjz = parcelRequire("gCDjz");

var $BVx8G = parcelRequire("BVx8G");

var $ayZKS = parcelRequire("ayZKS");

var $iT6vY = parcelRequire("iT6vY");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $f55e16d53d740cfc$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $3GvrD(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.version = (parcelRequire("hxPkP"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.AlgoliaSearchHelper = $3GvrD;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.SearchParameters = $ayZKS;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.RecommendParameters = $gCDjz;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.SearchResults = $iT6vY;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.RecommendResults = $BVx8G;
module.exports = $f55e16d53d740cfc$var$algoliasearchHelper;

});
parcelRegister("3GvrD", function(module, exports) {
'use strict';

var $29TQK = parcelRequire("29TQK");

var $4WfaU = parcelRequire("4WfaU");

var $gAun0 = parcelRequire("gAun0");
var $2aedaf985cc91b89$require$escapeFacetValue = $gAun0.escapeFacetValue;

var $4KG3Y = parcelRequire("4KG3Y");

var $9Ycfw = parcelRequire("9Ycfw");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");

var $gCDjz = parcelRequire("gCDjz");

var $BVx8G = parcelRequire("BVx8G");

var $4kZ5r = parcelRequire("4kZ5r");

var $ayZKS = parcelRequire("ayZKS");

var $iT6vY = parcelRequire("iT6vY");

var $gktCn = parcelRequire("gktCn");

var $hxPkP = parcelRequire("hxPkP");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $2aedaf985cc91b89$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $hxPkP + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $ayZKS.make(opts);
    this.recommendState = new $gCDjz({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$4KG3Y($2aedaf985cc91b89$var$AlgoliaSearchHelper, $29TQK);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $4kZ5r._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $4kZ5r._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $iT6vY(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $iT6vY(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $9Ycfw({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $f2mrx($4kZ5r._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $4kZ5r.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $2aedaf985cc91b89$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $2aedaf985cc91b89$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setCurrentPage = $2aedaf985cc91b89$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setPage = $2aedaf985cc91b89$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $ayZKS.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $ayZKS(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($gBL4g(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $2aedaf985cc91b89$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getCurrentPage = $2aedaf985cc91b89$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getPage = $2aedaf985cc91b89$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $4kZ5r._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $4kZ5r._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit('fetch', {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $gCDjz());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit('fetch', {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('Please update algoliasearch/lite to the latest version in order to use recommend widgets.');
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $iT6vY(state, specificResults, self._searchResultsOptions);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $gktCn(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit('recommend:result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $BVx8G(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit('recommend:result', {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit('recommend:change', {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $hxPkP + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $4WfaU(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $2aedaf985cc91b89$var$AlgoliaSearchHelper;

});
parcelRegister("29TQK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $1927bea74447f76b$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $1927bea74447f76b$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$1927bea74447f76b$var$EventEmitter.prototype._events = undefined;
$1927bea74447f76b$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$1927bea74447f76b$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$1927bea74447f76b$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$1927bea74447f76b$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $1927bea74447f76b$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($1927bea74447f76b$var$isUndefined(handler)) return false;
    if ($1927bea74447f76b$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($1927bea74447f76b$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$1927bea74447f76b$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $1927bea74447f76b$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($1927bea74447f76b$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($1927bea74447f76b$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$1927bea74447f76b$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $1927bea74447f76b$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.on = $1927bea74447f76b$var$EventEmitter.prototype.addListener;
$1927bea74447f76b$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$1927bea74447f76b$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $1927bea74447f76b$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($1927bea74447f76b$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($1927bea74447f76b$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($1927bea74447f76b$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$1927bea74447f76b$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($1927bea74447f76b$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$1927bea74447f76b$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $1927bea74447f76b$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $1927bea74447f76b$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $1927bea74447f76b$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $1927bea74447f76b$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("4WfaU", function(module, exports) {
'use strict';

var $29TQK = parcelRequire("29TQK");

var $4KG3Y = parcelRequire("4KG3Y");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $3988599e4fac3619$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$4KG3Y($3988599e4fac3619$var$DerivedHelper, $29TQK);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $3988599e4fac3619$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$3988599e4fac3619$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$3988599e4fac3619$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
module.exports = $3988599e4fac3619$var$DerivedHelper;

});
parcelRegister("4KG3Y", function(module, exports) {
'use strict';
function $375c162507ddaf02$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $375c162507ddaf02$var$inherits;

});


parcelRegister("gAun0", function(module, exports) {
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $c13790fd71540d48$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $c13790fd71540d48$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
module.exports = {
    escapeFacetValue: $c13790fd71540d48$var$escapeFacetValue,
    unescapeFacetValue: $c13790fd71540d48$var$unescapeFacetValue
};

});

parcelRegister("9Ycfw", function(module, exports) {
'use strict';
function $74233823bdea52b1$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $74233823bdea52b1$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $74233823bdea52b1$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $74233823bdea52b1$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($74233823bdea52b1$var$isObjectOrArrayOrFunction(targetVal) && $74233823bdea52b1$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $74233823bdea52b1$var$_merge(targetVal, sourceVal);
        else target[key] = $74233823bdea52b1$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $74233823bdea52b1$var$merge(target) {
    if (!$74233823bdea52b1$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($74233823bdea52b1$var$isObjectOrArrayOrFunction(source)) $74233823bdea52b1$var$_merge(target, source);
    }
    return target;
}
module.exports = $74233823bdea52b1$var$merge;

});

parcelRegister("gBL4g", function(module, exports) {
'use strict';
function $c1749cb5df59652a$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $c1749cb5df59652a$var$objectHasKeys;

});

parcelRegister("f2mrx", function(module, exports) {
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $af2873aa3ca66e72$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $af2873aa3ca66e72$var$_objectWithoutPropertiesLoose;

});

parcelRegister("gCDjz", function(module, exports) {
'use strict';
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $c19eb1007683f876$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$c19eb1007683f876$var$RecommendParameters.prototype = {
    constructor: $c19eb1007683f876$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $c19eb1007683f876$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $c19eb1007683f876$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'bought-together'
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'related-products'
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-items'
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-facets'
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'looking-similar'
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName
            });
            delete query.$$id;
            return query;
        });
    }
};
module.exports = $c19eb1007683f876$var$RecommendParameters;

});

parcelRegister("BVx8G", function(module, exports) {
'use strict';
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $072015c54d94a80e$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$072015c54d94a80e$var$RecommendResults.prototype = {
    constructor: $072015c54d94a80e$var$RecommendResults
};
module.exports = $072015c54d94a80e$var$RecommendResults;

});

parcelRegister("4kZ5r", function(module, exports) {
'use strict';

var $9Ycfw = parcelRequire("9Ycfw");
function $32886a435f64afcf$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $32886a435f64afcf$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $32886a435f64afcf$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $32886a435f64afcf$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $32886a435f64afcf$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($32886a435f64afcf$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $32886a435f64afcf$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $32886a435f64afcf$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $32886a435f64afcf$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf('*') > -1 ? [
                '*'
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $32886a435f64afcf$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $32886a435f64afcf$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $32886a435f64afcf$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $32886a435f64afcf$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, $32886a435f64afcf$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $32886a435f64afcf$var$requestBuilder;

});

parcelRegister("ayZKS", function(module, exports) {
'use strict';

var $lvlO6 = parcelRequire("lvlO6");

var $6M10t = parcelRequire("6M10t");

var $1BZHe = parcelRequire("1BZHe");

var $9Ycfw = parcelRequire("9Ycfw");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");

var $cOm0i = parcelRequire("cOm0i");

var $dTPhP = parcelRequire("dTPhP");

var $9vjgU = parcelRequire("9vjgU");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $7b0cfb9bb8358820$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $7b0cfb9bb8358820$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $7b0cfb9bb8358820$var$findArray(array, searchedValue) {
    return $6M10t(array, function(currentValue) {
        return $7b0cfb9bb8358820$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $7b0cfb9bb8358820$var$SearchParameters(newParameters) {
    var params = newParameters ? $7b0cfb9bb8358820$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$dTPhP(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $7b0cfb9bb8358820$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $7b0cfb9bb8358820$var$SearchParameters.PARAMETERS = Object.keys(new $7b0cfb9bb8358820$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $7b0cfb9bb8358820$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $7b0cfb9bb8358820$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $9Ycfw(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $7b0cfb9bb8358820$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $7b0cfb9bb8358820$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $7b0cfb9bb8358820$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $gBL4g(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($gBL4g(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$7b0cfb9bb8358820$var$SearchParameters.prototype = {
    constructor: $7b0cfb9bb8358820$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $9vjgU.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $9vjgU.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $9vjgU.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $9vjgU.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $cOm0i(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $9Ycfw({}, this.numericRefinements);
        mod[attribute] = $9Ycfw({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $7b0cfb9bb8358820$var$isEqualNumericRefinement(value.val, $cOm0i(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$gBL4g(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $f2mrx(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $cOm0i(value);
        var isAttributeValueDefined = $7b0cfb9bb8358820$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $1BZHe(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $1BZHe(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $7b0cfb9bb8358820$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $7b0cfb9bb8358820$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $f2mrx(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $6M10t(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $7b0cfb9bb8358820$var$SearchParameters;

});
parcelRegister("lvlO6", function(module, exports) {
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("6M10t", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("1BZHe", function(module, exports) {
'use strict';
function $12c91abf9cec5c80$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $12c91abf9cec5c80$var$intersection;

});

parcelRegister("cOm0i", function(module, exports) {
'use strict';
function $953b39058f46ab96$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($953b39058f46ab96$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
module.exports = $953b39058f46ab96$var$valToNumber;

});

parcelRegister("dTPhP", function(module, exports) {
'use strict';
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("9vjgU", function(module, exports) {
'use strict';

var $lvlO6 = parcelRequire("lvlO6");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");
var $6eb5f54997bc1815$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($6eb5f54997bc1815$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $lvlO6({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $6eb5f54997bc1815$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $6eb5f54997bc1815$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($6eb5f54997bc1815$var$lib.isRefined(refinementList, attribute, value)) return $6eb5f54997bc1815$var$lib.removeRefinement(refinementList, attribute, value);
        return $6eb5f54997bc1815$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$gBL4g(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $f2mrx(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $6eb5f54997bc1815$var$lib;

});


parcelRegister("iT6vY", function(module, exports) {
'use strict';

var $1M9rg = parcelRequire("1M9rg");

var $lvlO6 = parcelRequire("lvlO6");

var $gAun0 = parcelRequire("gAun0");

var $6M10t = parcelRequire("6M10t");

var $3Z29k = parcelRequire("3Z29k");

var $9dcSn = parcelRequire("9dcSn");

var $9Ycfw = parcelRequire("9Ycfw");

var $99J3D = parcelRequire("99J3D");
var $dc026abaa84ecadf$var$escapeFacetValue = $gAun0.escapeFacetValue;
var $dc026abaa84ecadf$var$unescapeFacetValue = $gAun0.unescapeFacetValue;

var $hvjOY = parcelRequire("hvjOY");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $dc026abaa84ecadf$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $dc026abaa84ecadf$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $dc026abaa84ecadf$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $6M10t(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $dc026abaa84ecadf$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $9Ycfw({
        persistHierarchicalRootCount: false
    }, options);
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $dc026abaa84ecadf$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $dc026abaa84ecadf$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $dc026abaa84ecadf$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $3Z29k(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $1M9rg(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $3Z29k(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3Z29k(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $9Ycfw({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $lvlO6({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($dc026abaa84ecadf$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $3Z29k(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3Z29k(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $lvlO6(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($hvjOY(state));
    /**
   * @type {Array}
   */ this.facets = $1M9rg(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $1M9rg(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $6M10t(this.facets, predicate) || $6M10t(this.disjunctiveFacets, predicate) || $6M10t(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $dc026abaa84ecadf$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $6M10t(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $dc026abaa84ecadf$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $6M10t(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $dc026abaa84ecadf$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $6M10t(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $dc026abaa84ecadf$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $dc026abaa84ecadf$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $dc026abaa84ecadf$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $dc026abaa84ecadf$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $dc026abaa84ecadf$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $dc026abaa84ecadf$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $lvlO6({
        data: sortedChildren
    }, node);
    return newNode;
}
$dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $dc026abaa84ecadf$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $dc026abaa84ecadf$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($99J3D(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $dc026abaa84ecadf$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $dc026abaa84ecadf$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $lvlO6({}, opts, {
        sortBy: $dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $dc026abaa84ecadf$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $dc026abaa84ecadf$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $dc026abaa84ecadf$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $9dcSn(options.sortBy, $dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT);
            return $99J3D(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $dc026abaa84ecadf$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $dc026abaa84ecadf$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $dc026abaa84ecadf$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $dc026abaa84ecadf$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $6M10t(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $dc026abaa84ecadf$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $6M10t(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $dc026abaa84ecadf$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $6M10t(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $6M10t(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $dc026abaa84ecadf$var$SearchResults;

});
parcelRegister("1M9rg", function(module, exports) {
'use strict';
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("3Z29k", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("9dcSn", function(module, exports) {
'use strict';

var $6M10t = parcelRequire("6M10t");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $6M10t(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("99J3D", function(module, exports) {
'use strict';
function $6aa7e7d427fde895$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $6aa7e7d427fde895$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $6aa7e7d427fde895$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $6aa7e7d427fde895$var$orderBy;

});

parcelRegister("hvjOY", function(module, exports) {
'use strict';
module.exports = $cbe4b4fac1c4e1bf$var$generateTrees;

var $gAun0 = parcelRequire("gAun0");

var $6M10t = parcelRequire("6M10t");

var $9dcSn = parcelRequire("9dcSn");

var $99J3D = parcelRequire("99J3D");
var $cbe4b4fac1c4e1bf$var$escapeFacetValue = $gAun0.escapeFacetValue;
var $cbe4b4fac1c4e1bf$var$unescapeFacetValue = $gAun0.unescapeFacetValue;
function $cbe4b4fac1c4e1bf$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $9dcSn(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $cbe4b4fac1c4e1bf$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $cbe4b4fac1c4e1bf$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $6M10t(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $cbe4b4fac1c4e1bf$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $99J3D(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $cbe4b4fac1c4e1bf$var$format(facetCount, facetValue, hierarchicalSeparator, $cbe4b4fac1c4e1bf$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $cbe4b4fac1c4e1bf$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $cbe4b4fac1c4e1bf$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $cbe4b4fac1c4e1bf$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("gktCn", function(module, exports) {
'use strict';

var $6M10t = parcelRequire("6M10t");

var $hF4Jd = parcelRequire("hF4Jd");
function $be357d1a68401e51$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $be357d1a68401e51$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $be357d1a68401e51$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $6M10t($hF4Jd(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
module.exports = $be357d1a68401e51$var$sortAndMergeRecommendations;

});
parcelRegister("hF4Jd", function(module, exports) {
// @MAJOR: remove this function and use Array.prototype.flat
module.exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};

});


parcelRegister("hxPkP", function(module, exports) {
'use strict';
module.exports = '3.21.0';

});





parcelRegister("1GQzX", function(module, exports) {
$parcel$export(module.exports, "AIAnswerSearchBorder", function () { return $f068296f4beee1cb$export$f2207ab910ac3fa8; });
/* styled.tsx generated by @compiled/babel-plugin v0.28.8 */ // Updated with Confluence prism border (color-blocked) animation

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
// Outer wrapper for glow effect
const $f068296f4beee1cb$var$GlowWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16udoi5": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "10px" : "10px 0 0 0"),
            "--_51v2mw": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_ymerfz": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateGlow 2s linear infinite" : "none")
        },
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _2rko1b66 _1yt4k1ib _19pk14id _2hwx14id _otyr14id _18u014id _1reo15vq _18m915vq _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qqrnmq _1dbx1m5u _154p105o _aetrb3bt _18postnw _9v7aidpf _1bqq1mrw _16r21l2m _11fnglyw _1a4fagmp",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$var$BorderWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_51v2mw": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_3cn0js": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateBorder 2s linear infinite" : "none")
        },
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _2rko1b66 _bfhk1bhr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _1reo15vq _18m915vq _1pbykb7n _1bsb1osq _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qquh9c _aetrb3bt _z0ai1hup _1qdg1hup _9v7at94y _18postnw _1bqq1mrw _14mj1b66 _1hfk1bhr _1a4fagmp",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$f2207ab910ac3fa8 = ({ isLoading: isLoading, isStreaming: isStreaming, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f068296f4beee1cb$var$GlowWrapper, {
        isLoading: isLoading,
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f068296f4beee1cb$var$BorderWrapper, {
            isLoading: isLoading,
            isStreaming: isStreaming,
            children: children
        })
    });
};
const $f068296f4beee1cb$export$a550342571a01571 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _19pkpxbi _zulpu2gc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$90ec299a95f41a29 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1cfjque": (0, $6ZVlx.default)(__cmplp.width ? __cmplp.width : "100%"),
            "--_eop49q": (0, $6ZVlx.default)(__cmplp.height ? __cmplp.height : "16px")
        },
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1q4i _4t3iy8ug _2rko1mok _11q71pw5 _y44v1sal",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _4t3iucft _vchhusvi _ca0q1ejb _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$636ea4c09615ceed = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_18u0v77o _syaz1wmz _11c8fhey",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_80omtlke _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1ule _t9ec1hke",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$975a268f2c733e4 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_11q7axro _94n5idpf _1e0c1ule _4t3i1jfw _19pkidpf _2hwxt94y _otyridpf _18u0t94y _kqsw1if8",
            __cmplp.className
        ])
    });
});
const $f068296f4beee1cb$export$f243da7eac28085c = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc _ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5TJaP", function(module, exports) {
$parcel$export(module.exports, "Result", function () { return (parcelRequire("aLBZ0")).Result; });
parcelRequire("8Agh0");
parcelRequire("fJkKo");
parcelRequire("aLBZ0");

});
parcelRegister("aLBZ0", function(module, exports) {
$parcel$export(module.exports, "Result", function () { return $ecaa9cd46efbd293$export$8fdcabde73f49165; });
/* result.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $bNzAT = parcelRequire("bNzAT");
const $ecaa9cd46efbd293$export$8fdcabde73f49165 = ({ index: index, title: title, description: description, href: href, objectId: objectId, queryId: queryId, onSearchLinkClick: onSearchLinkClick, isExperimentVariant: isExperimentVariant = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const decodeHtml = (html)=>{
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleSearchResultClick = (objectId, index, linkUrl, queryId)=>{
        onSearchLinkClick(objectId, index);
        createAnalyticsEvent({
            eventName: "searchResult",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "searchResults",
            source: "searchPage",
            eventContainer: "searchResults",
            attributes: {
                product: "search",
                objectId: objectId,
                linkUrl: linkUrl,
                rank: index,
                queryId: queryId
            }
        }).fire();
    };
    const isNonVariantFirstResult = !isExperimentVariant && index === 0;
    const isNonVariantOtherResult = !isExperimentVariant && index !== 0;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isExperimentVariant && "_1bsb1osq _1rjcf6fq _1ilv7vkz _133i1crf",
            isNonVariantFirstResult && "_1rjc1ul9 _1bsb1osq _133io7ao",
            isNonVariantOtherResult && "_1rjc1ul9 _1bsb1osq _mqm2k7bd _133io7ao"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                "data-testid": `result-id-${index}`,
                href: href,
                onClick: (event)=>{
                    const relativeUrlPath = href.split("https://www.atlassian.com")[1] || href;
                    handleSearchResultClick(objectId, index + 1, href, queryId);
                    event.preventDefault();
                    window.location.href = relativeUrlPath;
                },
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _30l31ep1 _10531q5l _vlg11368",
                    !isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _15em3pt6 _1053cm6p _yoqs1a2i"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $bNzAT.default)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.blue800")),
                    "--_jv9otz": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.purple800")),
                    "--_5re7s0": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.purple900")),
                    "--_1fb7i9d": (0, $6ZVlx.default)((0, $bNzAT.default)("color.primary.purple"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        isExperimentVariant && "_1mouidpf _1wyb1tcg _1cqsgktf _1bys1ou6",
                        !isExperimentVariant && "_1mouidpf _1wyb1k92 _1cqs1j6v"
                    ]),
                    children: decodeHtml(title)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_1e0c1ule _syaz18q9 _1wyb7vkz _vwz41tcg _1mou1ynf _1cqsdlk8 _1bysgktf",
                    !isExperimentVariant && "_1e0c1ule _syaz18q9 _1wybdlk8 _vwz4gktf _1mou1ynf"
                ]),
                style: {
                    "--_nmjf06": (0, $6ZVlx.default)((0, $bNzAT.default)("color.secondary.navy"))
                },
                children: decodeHtml(description)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_1e0c1ule _syazmmjq _1wybdlk8 _vwz4gktf _slp31hna",
                    !isExperimentVariant && "_1e0c1ule _syazefi9 _1wyb1crf _vwz4gktf _sugaglyw"
                ]),
                style: {
                    "--_1ayut75": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light500")),
                    "--_19aes6n": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.dark700"))
                },
                children: href
            })
        ]
    });
};
const $ecaa9cd46efbd293$var$resultContainerCss = null;
const $ecaa9cd46efbd293$var$resultContainerTopCss = null;
const $ecaa9cd46efbd293$var$variantResultContainerCss = null;
const $ecaa9cd46efbd293$var$resultLinkCss = null;
const $ecaa9cd46efbd293$var$variantResultLinkCss = null;
const $ecaa9cd46efbd293$var$variantResultLinkTextCss = null;
const $ecaa9cd46efbd293$var$resultLinkTextCss = null;
const $ecaa9cd46efbd293$var$variantResultDescriptionCss = null;
const $ecaa9cd46efbd293$var$resultDescriptionCss = null;
const $ecaa9cd46efbd293$var$variantResultUrlCss = null;
const $ecaa9cd46efbd293$var$resultUrlCss = null;

});





//# sourceMappingURL=index.cb6f499c.js.map
